"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _classPrivateFieldLooseBase(e, t) { if (!{}.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance"); return e; }
var id = 0;
function _classPrivateFieldLooseKey(e) { return "__private_" + id++ + "_" + e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n2 = 0, F = function F() {}; return { s: F, n: function n() { return _n2 >= r.length ? { done: !0 } : { done: !1, value: r[_n2++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2023 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */

(function webpackUniversalModuleDefinition(root, factory) {
  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && (typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define("pdfjs-dist/build/pdf", [], factory);else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') exports["pdfjs-dist/build/pdf"] = factory();else root["pdfjs-dist/build/pdf"] = root.pdfjsLib = factory();
})(globalThis, function () {
  return /******/function () {
    // webpackBootstrap
    /******/
    "use strict";

    /******/
    var __webpack_modules__ = [
      /* 0 */
    , (/* 1 */
    /***/function (__unused_webpack_module, exports) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.VerbosityLevel = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.UNSUPPORTED_FEATURES = exports.TextRenderingMode = exports.RenderingIntentFlag = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.PageActionEventType = exports.OPS = exports.MissingPDFException = exports.LINE_FACTOR = exports.LINE_DESCENT_FACTOR = exports.InvalidPDFException = exports.ImageKind = exports.IDENTITY_MATRIX = exports.FormatError = exports.FeatureTest = exports.FONT_IDENTITY_MATRIX = exports.DocumentActionEventType = exports.CMapCompressionType = exports.BaseException = exports.BASELINE_FACTOR = exports.AnnotationType = exports.AnnotationStateModelType = exports.AnnotationReviewState = exports.AnnotationReplyType = exports.AnnotationMode = exports.AnnotationMarkedState = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationEditorType = exports.AnnotationEditorPrefix = exports.AnnotationEditorParamsType = exports.AnnotationBorderStyleType = exports.AnnotationActionEventType = exports.AbortException = void 0;
      exports.assert = assert;
      exports.bytesToString = bytesToString;
      exports.createPromiseCapability = createPromiseCapability;
      exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
      exports.getModificationDate = getModificationDate;
      exports.getVerbosityLevel = getVerbosityLevel;
      exports.info = info;
      exports.isArrayBuffer = isArrayBuffer;
      exports.isArrayEqual = isArrayEqual;
      exports.objectFromMap = objectFromMap;
      exports.objectSize = objectSize;
      exports.setVerbosityLevel = setVerbosityLevel;
      exports.shadow = shadow;
      exports.string32 = string32;
      exports.stringToBytes = stringToBytes;
      exports.stringToPDFString = stringToPDFString;
      exports.stringToUTF8String = stringToUTF8String;
      exports.unreachable = unreachable;
      exports.utf8StringToString = utf8StringToString;
      exports.warn = warn;
      ;
      var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
      exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
      var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
      exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
      var LINE_FACTOR = 1.35;
      exports.LINE_FACTOR = LINE_FACTOR;
      var LINE_DESCENT_FACTOR = 0.35;
      exports.LINE_DESCENT_FACTOR = LINE_DESCENT_FACTOR;
      var BASELINE_FACTOR = LINE_DESCENT_FACTOR / LINE_FACTOR;
      exports.BASELINE_FACTOR = BASELINE_FACTOR;
      var RenderingIntentFlag = {
        ANY: 0x01,
        DISPLAY: 0x02,
        PRINT: 0x04,
        SAVE: 0x08,
        ANNOTATIONS_FORMS: 0x10,
        ANNOTATIONS_STORAGE: 0x20,
        ANNOTATIONS_DISABLE: 0x40,
        OPLIST: 0x100
      };
      exports.RenderingIntentFlag = RenderingIntentFlag;
      var AnnotationMode = {
        DISABLE: 0,
        ENABLE: 1,
        ENABLE_FORMS: 2,
        ENABLE_STORAGE: 3
      };
      exports.AnnotationMode = AnnotationMode;
      var AnnotationEditorPrefix = "pdfjs_internal_editor_";
      exports.AnnotationEditorPrefix = AnnotationEditorPrefix;
      var AnnotationEditorType = {
        DISABLE: -1,
        NONE: 0,
        FREETEXT: 3,
        INK: 15
      };
      exports.AnnotationEditorType = AnnotationEditorType;
      var AnnotationEditorParamsType = {
        FREETEXT_SIZE: 1,
        FREETEXT_COLOR: 2,
        FREETEXT_OPACITY: 3,
        INK_COLOR: 11,
        INK_THICKNESS: 12,
        INK_OPACITY: 13
      };
      exports.AnnotationEditorParamsType = AnnotationEditorParamsType;
      var PermissionFlag = {
        PRINT: 0x04,
        MODIFY_CONTENTS: 0x08,
        COPY: 0x10,
        MODIFY_ANNOTATIONS: 0x20,
        FILL_INTERACTIVE_FORMS: 0x100,
        COPY_FOR_ACCESSIBILITY: 0x200,
        ASSEMBLE: 0x400,
        PRINT_HIGH_QUALITY: 0x800
      };
      exports.PermissionFlag = PermissionFlag;
      var TextRenderingMode = {
        FILL: 0,
        STROKE: 1,
        FILL_STROKE: 2,
        INVISIBLE: 3,
        FILL_ADD_TO_PATH: 4,
        STROKE_ADD_TO_PATH: 5,
        FILL_STROKE_ADD_TO_PATH: 6,
        ADD_TO_PATH: 7,
        FILL_STROKE_MASK: 3,
        ADD_TO_PATH_FLAG: 4
      };
      exports.TextRenderingMode = TextRenderingMode;
      var ImageKind = {
        GRAYSCALE_1BPP: 1,
        RGB_24BPP: 2,
        RGBA_32BPP: 3
      };
      exports.ImageKind = ImageKind;
      var AnnotationType = {
        TEXT: 1,
        LINK: 2,
        FREETEXT: 3,
        LINE: 4,
        SQUARE: 5,
        CIRCLE: 6,
        POLYGON: 7,
        POLYLINE: 8,
        HIGHLIGHT: 9,
        UNDERLINE: 10,
        SQUIGGLY: 11,
        STRIKEOUT: 12,
        STAMP: 13,
        CARET: 14,
        INK: 15,
        POPUP: 16,
        FILEATTACHMENT: 17,
        SOUND: 18,
        MOVIE: 19,
        WIDGET: 20,
        SCREEN: 21,
        PRINTERMARK: 22,
        TRAPNET: 23,
        WATERMARK: 24,
        THREED: 25,
        REDACT: 26
      };
      exports.AnnotationType = AnnotationType;
      var AnnotationStateModelType = {
        MARKED: "Marked",
        REVIEW: "Review"
      };
      exports.AnnotationStateModelType = AnnotationStateModelType;
      var AnnotationMarkedState = {
        MARKED: "Marked",
        UNMARKED: "Unmarked"
      };
      exports.AnnotationMarkedState = AnnotationMarkedState;
      var AnnotationReviewState = {
        ACCEPTED: "Accepted",
        REJECTED: "Rejected",
        CANCELLED: "Cancelled",
        COMPLETED: "Completed",
        NONE: "None"
      };
      exports.AnnotationReviewState = AnnotationReviewState;
      var AnnotationReplyType = {
        GROUP: "Group",
        REPLY: "R"
      };
      exports.AnnotationReplyType = AnnotationReplyType;
      var AnnotationFlag = {
        INVISIBLE: 0x01,
        HIDDEN: 0x02,
        PRINT: 0x04,
        NOZOOM: 0x08,
        NOROTATE: 0x10,
        NOVIEW: 0x20,
        READONLY: 0x40,
        LOCKED: 0x80,
        TOGGLENOVIEW: 0x100,
        LOCKEDCONTENTS: 0x200
      };
      exports.AnnotationFlag = AnnotationFlag;
      var AnnotationFieldFlag = {
        READONLY: 0x0000001,
        REQUIRED: 0x0000002,
        NOEXPORT: 0x0000004,
        MULTILINE: 0x0001000,
        PASSWORD: 0x0002000,
        NOTOGGLETOOFF: 0x0004000,
        RADIO: 0x0008000,
        PUSHBUTTON: 0x0010000,
        COMBO: 0x0020000,
        EDIT: 0x0040000,
        SORT: 0x0080000,
        FILESELECT: 0x0100000,
        MULTISELECT: 0x0200000,
        DONOTSPELLCHECK: 0x0400000,
        DONOTSCROLL: 0x0800000,
        COMB: 0x1000000,
        RICHTEXT: 0x2000000,
        RADIOSINUNISON: 0x2000000,
        COMMITONSELCHANGE: 0x4000000
      };
      exports.AnnotationFieldFlag = AnnotationFieldFlag;
      var AnnotationBorderStyleType = {
        SOLID: 1,
        DASHED: 2,
        BEVELED: 3,
        INSET: 4,
        UNDERLINE: 5
      };
      exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
      var AnnotationActionEventType = {
        E: "Mouse Enter",
        X: "Mouse Exit",
        D: "Mouse Down",
        U: "Mouse Up",
        Fo: "Focus",
        Bl: "Blur",
        PO: "PageOpen",
        PC: "PageClose",
        PV: "PageVisible",
        PI: "PageInvisible",
        K: "Keystroke",
        F: "Format",
        V: "Validate",
        C: "Calculate"
      };
      exports.AnnotationActionEventType = AnnotationActionEventType;
      var DocumentActionEventType = {
        WC: "WillClose",
        WS: "WillSave",
        DS: "DidSave",
        WP: "WillPrint",
        DP: "DidPrint"
      };
      exports.DocumentActionEventType = DocumentActionEventType;
      var PageActionEventType = {
        O: "PageOpen",
        C: "PageClose"
      };
      exports.PageActionEventType = PageActionEventType;
      var VerbosityLevel = {
        ERRORS: 0,
        WARNINGS: 1,
        INFOS: 5
      };
      exports.VerbosityLevel = VerbosityLevel;
      var CMapCompressionType = {
        NONE: 0,
        BINARY: 1
      };
      exports.CMapCompressionType = CMapCompressionType;
      var OPS = {
        dependency: 1,
        setLineWidth: 2,
        setLineCap: 3,
        setLineJoin: 4,
        setMiterLimit: 5,
        setDash: 6,
        setRenderingIntent: 7,
        setFlatness: 8,
        setGState: 9,
        save: 10,
        restore: 11,
        transform: 12,
        moveTo: 13,
        lineTo: 14,
        curveTo: 15,
        curveTo2: 16,
        curveTo3: 17,
        closePath: 18,
        rectangle: 19,
        stroke: 20,
        closeStroke: 21,
        fill: 22,
        eoFill: 23,
        fillStroke: 24,
        eoFillStroke: 25,
        closeFillStroke: 26,
        closeEOFillStroke: 27,
        endPath: 28,
        clip: 29,
        eoClip: 30,
        beginText: 31,
        endText: 32,
        setCharSpacing: 33,
        setWordSpacing: 34,
        setHScale: 35,
        setLeading: 36,
        setFont: 37,
        setTextRenderingMode: 38,
        setTextRise: 39,
        moveText: 40,
        setLeadingMoveText: 41,
        setTextMatrix: 42,
        nextLine: 43,
        showText: 44,
        showSpacedText: 45,
        nextLineShowText: 46,
        nextLineSetSpacingShowText: 47,
        setCharWidth: 48,
        setCharWidthAndBounds: 49,
        setStrokeColorSpace: 50,
        setFillColorSpace: 51,
        setStrokeColor: 52,
        setStrokeColorN: 53,
        setFillColor: 54,
        setFillColorN: 55,
        setStrokeGray: 56,
        setFillGray: 57,
        setStrokeRGBColor: 58,
        setFillRGBColor: 59,
        setStrokeCMYKColor: 60,
        setFillCMYKColor: 61,
        shadingFill: 62,
        beginInlineImage: 63,
        beginImageData: 64,
        endInlineImage: 65,
        paintXObject: 66,
        markPoint: 67,
        markPointProps: 68,
        beginMarkedContent: 69,
        beginMarkedContentProps: 70,
        endMarkedContent: 71,
        beginCompat: 72,
        endCompat: 73,
        paintFormXObjectBegin: 74,
        paintFormXObjectEnd: 75,
        beginGroup: 76,
        endGroup: 77,
        beginAnnotation: 80,
        endAnnotation: 81,
        paintImageMaskXObject: 83,
        paintImageMaskXObjectGroup: 84,
        paintImageXObject: 85,
        paintInlineImageXObject: 86,
        paintInlineImageXObjectGroup: 87,
        paintImageXObjectRepeat: 88,
        paintImageMaskXObjectRepeat: 89,
        paintSolidColorImageMask: 90,
        constructPath: 91
      };
      exports.OPS = OPS;
      var UNSUPPORTED_FEATURES = {
        forms: "forms",
        javaScript: "javaScript",
        signatures: "signatures",
        smask: "smask",
        shadingPattern: "shadingPattern",
        errorTilingPattern: "errorTilingPattern",
        errorExtGState: "errorExtGState",
        errorXObject: "errorXObject",
        errorFontLoadType3: "errorFontLoadType3",
        errorFontState: "errorFontState",
        errorFontMissing: "errorFontMissing",
        errorFontTranslate: "errorFontTranslate",
        errorColorSpace: "errorColorSpace",
        errorOperatorList: "errorOperatorList",
        errorFontToUnicode: "errorFontToUnicode",
        errorFontLoadNative: "errorFontLoadNative",
        errorFontBuildPath: "errorFontBuildPath",
        errorFontGetPath: "errorFontGetPath",
        errorMarkedContent: "errorMarkedContent",
        errorContentSubStream: "errorContentSubStream"
      };
      exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
      var PasswordResponses = {
        NEED_PASSWORD: 1,
        INCORRECT_PASSWORD: 2
      };
      exports.PasswordResponses = PasswordResponses;
      var verbosity = VerbosityLevel.WARNINGS;
      function setVerbosityLevel(level) {
        if (Number.isInteger(level)) {
          verbosity = level;
        }
      }
      function getVerbosityLevel() {
        return verbosity;
      }
      function info(msg) {
        if (verbosity >= VerbosityLevel.INFOS) {
          console.log("Info: ".concat(msg));
        }
      }
      function warn(msg) {
        if (verbosity >= VerbosityLevel.WARNINGS) {
          console.log("Warning: ".concat(msg));
        }
      }
      function unreachable(msg) {
        throw new Error(msg);
      }
      function assert(cond, msg) {
        if (!cond) {
          unreachable(msg);
        }
      }
      function _isValidProtocol(url) {
        if (!url) {
          return false;
        }
        switch (url.protocol) {
          case "http:":
          case "https:":
          case "ftp:":
          case "mailto:":
          case "tel:":
            return true;
          default:
            return false;
        }
      }
      function createValidAbsoluteUrl(url) {
        var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!url) {
          return null;
        }
        try {
          if (options && typeof url === "string") {
            if (options.addDefaultProtocol && url.startsWith("www.")) {
              var dots = url.match(/\./g);
              if (dots && dots.length >= 2) {
                url = "http://".concat(url);
              }
            }
            if (options.tryConvertEncoding) {
              try {
                url = stringToUTF8String(url);
              } catch (ex) {}
            }
          }
          var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
          if (_isValidProtocol(absoluteUrl)) {
            return absoluteUrl;
          }
        } catch (ex) {}
        return null;
      }
      function shadow(obj, prop, value) {
        var nonSerializable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        Object.defineProperty(obj, prop, {
          value: value,
          enumerable: !nonSerializable,
          configurable: true,
          writable: false
        });
        return value;
      }
      var BaseException = function BaseExceptionClosure() {
        function BaseException(message, name) {
          if (this.constructor === BaseException) {
            unreachable("Cannot initialize BaseException.");
          }
          this.message = message;
          this.name = name;
        }
        BaseException.prototype = new Error();
        BaseException.constructor = BaseException;
        return BaseException;
      }();
      exports.BaseException = BaseException;
      var PasswordException = /*#__PURE__*/function (_BaseException) {
        function PasswordException(msg, code) {
          var _this;
          _classCallCheck(this, PasswordException);
          _this = _callSuper(this, PasswordException, [msg, "PasswordException"]);
          _this.code = code;
          return _this;
        }
        _inherits(PasswordException, _BaseException);
        return _createClass(PasswordException);
      }(BaseException);
      exports.PasswordException = PasswordException;
      var UnknownErrorException = /*#__PURE__*/function (_BaseException2) {
        function UnknownErrorException(msg, details) {
          var _this2;
          _classCallCheck(this, UnknownErrorException);
          _this2 = _callSuper(this, UnknownErrorException, [msg, "UnknownErrorException"]);
          _this2.details = details;
          return _this2;
        }
        _inherits(UnknownErrorException, _BaseException2);
        return _createClass(UnknownErrorException);
      }(BaseException);
      exports.UnknownErrorException = UnknownErrorException;
      var InvalidPDFException = /*#__PURE__*/function (_BaseException3) {
        function InvalidPDFException(msg) {
          _classCallCheck(this, InvalidPDFException);
          return _callSuper(this, InvalidPDFException, [msg, "InvalidPDFException"]);
        }
        _inherits(InvalidPDFException, _BaseException3);
        return _createClass(InvalidPDFException);
      }(BaseException);
      exports.InvalidPDFException = InvalidPDFException;
      var MissingPDFException = /*#__PURE__*/function (_BaseException4) {
        function MissingPDFException(msg) {
          _classCallCheck(this, MissingPDFException);
          return _callSuper(this, MissingPDFException, [msg, "MissingPDFException"]);
        }
        _inherits(MissingPDFException, _BaseException4);
        return _createClass(MissingPDFException);
      }(BaseException);
      exports.MissingPDFException = MissingPDFException;
      var UnexpectedResponseException = /*#__PURE__*/function (_BaseException5) {
        function UnexpectedResponseException(msg, status) {
          var _this3;
          _classCallCheck(this, UnexpectedResponseException);
          _this3 = _callSuper(this, UnexpectedResponseException, [msg, "UnexpectedResponseException"]);
          _this3.status = status;
          return _this3;
        }
        _inherits(UnexpectedResponseException, _BaseException5);
        return _createClass(UnexpectedResponseException);
      }(BaseException);
      exports.UnexpectedResponseException = UnexpectedResponseException;
      var FormatError = /*#__PURE__*/function (_BaseException6) {
        function FormatError(msg) {
          _classCallCheck(this, FormatError);
          return _callSuper(this, FormatError, [msg, "FormatError"]);
        }
        _inherits(FormatError, _BaseException6);
        return _createClass(FormatError);
      }(BaseException);
      exports.FormatError = FormatError;
      var AbortException = /*#__PURE__*/function (_BaseException7) {
        function AbortException(msg) {
          _classCallCheck(this, AbortException);
          return _callSuper(this, AbortException, [msg, "AbortException"]);
        }
        _inherits(AbortException, _BaseException7);
        return _createClass(AbortException);
      }(BaseException);
      exports.AbortException = AbortException;
      function bytesToString(bytes) {
        if (_typeof(bytes) !== "object" || bytes === null || bytes.length === undefined) {
          unreachable("Invalid argument for bytesToString");
        }
        var length = bytes.length;
        var MAX_ARGUMENT_COUNT = 8192;
        if (length < MAX_ARGUMENT_COUNT) {
          return String.fromCharCode.apply(null, bytes);
        }
        var strBuf = [];
        for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
          var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
          var chunk = bytes.subarray(i, chunkEnd);
          strBuf.push(String.fromCharCode.apply(null, chunk));
        }
        return strBuf.join("");
      }
      function stringToBytes(str) {
        if (typeof str !== "string") {
          unreachable("Invalid argument for stringToBytes");
        }
        var length = str.length;
        var bytes = new Uint8Array(length);
        for (var i = 0; i < length; ++i) {
          bytes[i] = str.charCodeAt(i) & 0xff;
        }
        return bytes;
      }
      function string32(value) {
        return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
      }
      function objectSize(obj) {
        return Object.keys(obj).length;
      }
      function objectFromMap(map) {
        var obj = Object.create(null);
        var _iterator = _createForOfIteratorHelper(map),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _ref = _step.value;
            var _ref2 = _slicedToArray(_ref, 2);
            var key = _ref2[0];
            var value = _ref2[1];
            obj[key] = value;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return obj;
      }
      function isLittleEndian() {
        var buffer8 = new Uint8Array(4);
        buffer8[0] = 1;
        var view32 = new Uint32Array(buffer8.buffer, 0, 1);
        return view32[0] === 1;
      }
      function isEvalSupported() {
        try {
          new Function("");
          return true;
        } catch (e) {
          return false;
        }
      }
      var FeatureTest = /*#__PURE__*/function () {
        function FeatureTest() {
          _classCallCheck(this, FeatureTest);
        }
        return _createClass(FeatureTest, null, [{
          key: "isLittleEndian",
          get: function get() {
            return shadow(this, "isLittleEndian", isLittleEndian());
          }
        }, {
          key: "isEvalSupported",
          get: function get() {
            return shadow(this, "isEvalSupported", isEvalSupported());
          }
        }, {
          key: "isOffscreenCanvasSupported",
          get: function get() {
            return shadow(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
          }
        }, {
          key: "platform",
          get: function get() {
            if (typeof navigator === "undefined") {
              return shadow(this, "platform", {
                isWin: false,
                isMac: false
              });
            }
            return shadow(this, "platform", {
              isWin: navigator.platform.includes("Win"),
              isMac: navigator.platform.includes("Mac")
            });
          }
        }]);
      }();
      exports.FeatureTest = FeatureTest;
      var hexNumbers = _toConsumableArray(Array(256).keys()).map(function (n) {
        return n.toString(16).padStart(2, "0");
      });
      var Util = /*#__PURE__*/function () {
        function Util() {
          _classCallCheck(this, Util);
        }
        return _createClass(Util, null, [{
          key: "makeHexColor",
          value: function makeHexColor(r, g, b) {
            return "#".concat(hexNumbers[r]).concat(hexNumbers[g]).concat(hexNumbers[b]);
          }
        }, {
          key: "scaleMinMax",
          value: function scaleMinMax(transform, minMax) {
            var temp;
            if (transform[0]) {
              if (transform[0] < 0) {
                temp = minMax[0];
                minMax[0] = minMax[1];
                minMax[1] = temp;
              }
              minMax[0] *= transform[0];
              minMax[1] *= transform[0];
              if (transform[3] < 0) {
                temp = minMax[2];
                minMax[2] = minMax[3];
                minMax[3] = temp;
              }
              minMax[2] *= transform[3];
              minMax[3] *= transform[3];
            } else {
              temp = minMax[0];
              minMax[0] = minMax[2];
              minMax[2] = temp;
              temp = minMax[1];
              minMax[1] = minMax[3];
              minMax[3] = temp;
              if (transform[1] < 0) {
                temp = minMax[2];
                minMax[2] = minMax[3];
                minMax[3] = temp;
              }
              minMax[2] *= transform[1];
              minMax[3] *= transform[1];
              if (transform[2] < 0) {
                temp = minMax[0];
                minMax[0] = minMax[1];
                minMax[1] = temp;
              }
              minMax[0] *= transform[2];
              minMax[1] *= transform[2];
            }
            minMax[0] += transform[4];
            minMax[1] += transform[4];
            minMax[2] += transform[5];
            minMax[3] += transform[5];
          }
        }, {
          key: "transform",
          value: function transform(m1, m2) {
            return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
          }
        }, {
          key: "applyTransform",
          value: function applyTransform(p, m) {
            var xt = p[0] * m[0] + p[1] * m[2] + m[4];
            var yt = p[0] * m[1] + p[1] * m[3] + m[5];
            return [xt, yt];
          }
        }, {
          key: "applyInverseTransform",
          value: function applyInverseTransform(p, m) {
            var d = m[0] * m[3] - m[1] * m[2];
            var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
            var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
            return [xt, yt];
          }
        }, {
          key: "getAxialAlignedBoundingBox",
          value: function getAxialAlignedBoundingBox(r, m) {
            var p1 = Util.applyTransform(r, m);
            var p2 = Util.applyTransform(r.slice(2, 4), m);
            var p3 = Util.applyTransform([r[0], r[3]], m);
            var p4 = Util.applyTransform([r[2], r[1]], m);
            return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
          }
        }, {
          key: "inverseTransform",
          value: function inverseTransform(m) {
            var d = m[0] * m[3] - m[1] * m[2];
            return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
          }
        }, {
          key: "singularValueDecompose2dScale",
          value: function singularValueDecompose2dScale(m) {
            var transpose = [m[0], m[2], m[1], m[3]];
            var a = m[0] * transpose[0] + m[1] * transpose[2];
            var b = m[0] * transpose[1] + m[1] * transpose[3];
            var c = m[2] * transpose[0] + m[3] * transpose[2];
            var d = m[2] * transpose[1] + m[3] * transpose[3];
            var first = (a + d) / 2;
            var second = Math.sqrt(Math.pow(a + d, 2) - 4 * (a * d - c * b)) / 2;
            var sx = first + second || 1;
            var sy = first - second || 1;
            return [Math.sqrt(sx), Math.sqrt(sy)];
          }
        }, {
          key: "normalizeRect",
          value: function normalizeRect(rect) {
            var r = rect.slice(0);
            if (rect[0] > rect[2]) {
              r[0] = rect[2];
              r[2] = rect[0];
            }
            if (rect[1] > rect[3]) {
              r[1] = rect[3];
              r[3] = rect[1];
            }
            return r;
          }
        }, {
          key: "intersect",
          value: function intersect(rect1, rect2) {
            var xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
            var xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
            if (xLow > xHigh) {
              return null;
            }
            var yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
            var yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
            if (yLow > yHigh) {
              return null;
            }
            return [xLow, yLow, xHigh, yHigh];
          }
        }, {
          key: "bezierBoundingBox",
          value: function bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3) {
            var tvalues = [],
              bounds = [[], []];
            var a, b, c, t, t1, t2, b2ac, sqrtb2ac;
            for (var i = 0; i < 2; ++i) {
              if (i === 0) {
                b = 6 * x0 - 12 * x1 + 6 * x2;
                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                c = 3 * x1 - 3 * x0;
              } else {
                b = 6 * y0 - 12 * y1 + 6 * y2;
                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                c = 3 * y1 - 3 * y0;
              }
              if (Math.abs(a) < 1e-12) {
                if (Math.abs(b) < 1e-12) {
                  continue;
                }
                t = -c / b;
                if (0 < t && t < 1) {
                  tvalues.push(t);
                }
                continue;
              }
              b2ac = b * b - 4 * c * a;
              sqrtb2ac = Math.sqrt(b2ac);
              if (b2ac < 0) {
                continue;
              }
              t1 = (-b + sqrtb2ac) / (2 * a);
              if (0 < t1 && t1 < 1) {
                tvalues.push(t1);
              }
              t2 = (-b - sqrtb2ac) / (2 * a);
              if (0 < t2 && t2 < 1) {
                tvalues.push(t2);
              }
            }
            var j = tvalues.length,
              mt;
            var jlen = j;
            while (j--) {
              t = tvalues[j];
              mt = 1 - t;
              bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
              bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
            }
            bounds[0][jlen] = x0;
            bounds[1][jlen] = y0;
            bounds[0][jlen + 1] = x3;
            bounds[1][jlen + 1] = y3;
            bounds[0].length = bounds[1].length = jlen + 2;
            return [Math.min.apply(Math, _toConsumableArray(bounds[0])), Math.min.apply(Math, _toConsumableArray(bounds[1])), Math.max.apply(Math, _toConsumableArray(bounds[0])), Math.max.apply(Math, _toConsumableArray(bounds[1]))];
          }
        }]);
      }();
      exports.Util = Util;
      var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2d8, 0x2c7, 0x2c6, 0x2d9, 0x2dd, 0x2db, 0x2da, 0x2dc, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203a, 0x2212, 0x2030, 0x201e, 0x201c, 0x201d, 0x2018, 0x2019, 0x201a, 0x2122, 0xfb01, 0xfb02, 0x141, 0x152, 0x160, 0x178, 0x17d, 0x131, 0x142, 0x153, 0x161, 0x17e, 0, 0x20ac];
      function stringToPDFString(str) {
        if (str[0] >= "\xEF") {
          var encoding;
          if (str[0] === "\xFE" && str[1] === "\xFF") {
            encoding = "utf-16be";
          } else if (str[0] === "\xFF" && str[1] === "\xFE") {
            encoding = "utf-16le";
          } else if (str[0] === "\xEF" && str[1] === "\xBB" && str[2] === "\xBF") {
            encoding = "utf-8";
          }
          if (encoding) {
            try {
              var decoder = new TextDecoder(encoding, {
                fatal: true
              });
              var buffer = stringToBytes(str);
              return decoder.decode(buffer);
            } catch (ex) {
              warn("stringToPDFString: \"".concat(ex, "\"."));
            }
          }
        }
        var strBuf = [];
        for (var i = 0, ii = str.length; i < ii; i++) {
          var code = PDFStringTranslateTable[str.charCodeAt(i)];
          strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
        }
        return strBuf.join("");
      }
      function stringToUTF8String(str) {
        return decodeURIComponent(escape(str));
      }
      function utf8StringToString(str) {
        return unescape(encodeURIComponent(str));
      }
      function isArrayBuffer(v) {
        return _typeof(v) === "object" && v !== null && v.byteLength !== undefined;
      }
      function isArrayEqual(arr1, arr2) {
        if (arr1.length !== arr2.length) {
          return false;
        }
        for (var i = 0, ii = arr1.length; i < ii; i++) {
          if (arr1[i] !== arr2[i]) {
            return false;
          }
        }
        return true;
      }
      function getModificationDate() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var buffer = [date.getUTCFullYear().toString(), (date.getUTCMonth() + 1).toString().padStart(2, "0"), date.getUTCDate().toString().padStart(2, "0"), date.getUTCHours().toString().padStart(2, "0"), date.getUTCMinutes().toString().padStart(2, "0"), date.getUTCSeconds().toString().padStart(2, "0")];
        return buffer.join("");
      }
      function createPromiseCapability() {
        var capability = Object.create(null);
        var isSettled = false;
        Object.defineProperty(capability, "settled", {
          get: function get() {
            return isSettled;
          }
        });
        capability.promise = new Promise(function (resolve, reject) {
          capability.resolve = function (data) {
            isSettled = true;
            resolve(data);
          };
          capability.reject = function (reason) {
            isSettled = true;
            reject(reason);
          };
        });
        return capability;
      }

      /***/
    }), (/* 2 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.build = exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0;
      exports.getDocument = getDocument;
      exports.version = void 0;
      var _util = __w_pdfjs_require__(1);
      var _annotation_storage = __w_pdfjs_require__(3);
      var _display_utils = __w_pdfjs_require__(6);
      var _font_loader = __w_pdfjs_require__(9);
      var _canvas = __w_pdfjs_require__(11);
      var _worker_options = __w_pdfjs_require__(14);
      var _is_node = __w_pdfjs_require__(10);
      var _message_handler = __w_pdfjs_require__(15);
      var _metadata = __w_pdfjs_require__(16);
      var _optional_content_config = __w_pdfjs_require__(17);
      var _transport_stream = __w_pdfjs_require__(18);
      var _xfa_text = __w_pdfjs_require__(19);
      var DEFAULT_RANGE_CHUNK_SIZE = 65536;
      var RENDERING_CANCELLED_TIMEOUT = 100;
      var DefaultCanvasFactory = _display_utils.DOMCanvasFactory;
      exports.DefaultCanvasFactory = DefaultCanvasFactory;
      var DefaultCMapReaderFactory = _display_utils.DOMCMapReaderFactory;
      exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
      var DefaultStandardFontDataFactory = _display_utils.DOMStandardFontDataFactory;
      exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
      if (_is_node.isNodeJS) {
        var _w_pdfjs_require__ = __w_pdfjs_require__(20),
          NodeCanvasFactory = _w_pdfjs_require__.NodeCanvasFactory,
          NodeCMapReaderFactory = _w_pdfjs_require__.NodeCMapReaderFactory,
          NodeStandardFontDataFactory = _w_pdfjs_require__.NodeStandardFontDataFactory;
        exports.DefaultCanvasFactory = DefaultCanvasFactory = NodeCanvasFactory;
        exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory = NodeCMapReaderFactory;
        exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory = NodeStandardFontDataFactory;
      }
      var createPDFNetworkStream;
      {
        if (_is_node.isNodeJS) {
          var _w_pdfjs_require__2 = __w_pdfjs_require__(21),
            PDFNodeStream = _w_pdfjs_require__2.PDFNodeStream;
          createPDFNetworkStream = function createPDFNetworkStream(params) {
            return new PDFNodeStream(params);
          };
        } else {
          var _w_pdfjs_require__3 = __w_pdfjs_require__(24),
            PDFNetworkStream = _w_pdfjs_require__3.PDFNetworkStream;
          var _w_pdfjs_require__4 = __w_pdfjs_require__(25),
            PDFFetchStream = _w_pdfjs_require__4.PDFFetchStream;
          createPDFNetworkStream = function createPDFNetworkStream(params) {
            return (0, _display_utils.isValidFetchUrl)(params.url) ? new PDFFetchStream(params) : new PDFNetworkStream(params);
          };
        }
      }
      function getDocument(src) {
        var _src$password, _src$length;
        if (typeof src === "string" || src instanceof URL) {
          src = {
            url: src
          };
        } else if ((0, _util.isArrayBuffer)(src)) {
          src = {
            data: src
          };
        } else if (src instanceof PDFDataRangeTransport) {
          (0, _display_utils.deprecated)("`PDFDataRangeTransport`-instance, " + "please use a parameter object with `range`-property instead.");
          src = {
            range: src
          };
        } else {
          if (_typeof(src) !== "object") {
            throw new Error("Invalid parameter in getDocument, " + "need either string, URL, TypedArray, or parameter object.");
          }
        }
        if (!src.url && !src.data && !src.range) {
          throw new Error("Invalid parameter object: need either .data, .range or .url");
        }
        var task = new PDFDocumentLoadingTask();
        var url = src.url ? getUrlProp(src.url) : null;
        var data = src.data ? getDataProp(src.data) : null;
        var httpHeaders = src.httpHeaders || null;
        var withCredentials = src.withCredentials === true;
        var password = (_src$password = src.password) !== null && _src$password !== void 0 ? _src$password : null;
        var rangeTransport = src.range instanceof PDFDataRangeTransport ? src.range : null;
        var rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
        var worker = src.worker instanceof PDFWorker ? src.worker : null;
        var verbosity = src.verbosity;
        var docBaseUrl = typeof src.docBaseUrl === "string" && !(0, _display_utils.isDataScheme)(src.docBaseUrl) ? src.docBaseUrl : null;
        var cMapUrl = typeof src.cMapUrl === "string" ? src.cMapUrl : null;
        var cMapPacked = src.cMapPacked !== false;
        var CMapReaderFactory = src.CMapReaderFactory || DefaultCMapReaderFactory;
        var standardFontDataUrl = typeof src.standardFontDataUrl === "string" ? src.standardFontDataUrl : null;
        var StandardFontDataFactory = src.StandardFontDataFactory || DefaultStandardFontDataFactory;
        var ignoreErrors = src.stopAtErrors !== true;
        var maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
        var isEvalSupported = src.isEvalSupported !== false;
        var isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !_is_node.isNodeJS;
        var disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : _is_node.isNodeJS;
        var fontExtraProperties = src.fontExtraProperties === true;
        var enableXfa = src.enableXfa === true;
        var ownerDocument = src.ownerDocument || globalThis.document;
        var disableRange = src.disableRange === true;
        var disableStream = src.disableStream === true;
        var disableAutoFetch = src.disableAutoFetch === true;
        var pdfBug = src.pdfBug === true;
        var length = rangeTransport ? rangeTransport.length : (_src$length = src.length) !== null && _src$length !== void 0 ? _src$length : NaN;
        var useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !_is_node.isNodeJS && !disableFontFace;
        var useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : CMapReaderFactory === _display_utils.DOMCMapReaderFactory && StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory && (0, _display_utils.isValidFetchUrl)(cMapUrl, document.baseURI) && (0, _display_utils.isValidFetchUrl)(standardFontDataUrl, document.baseURI);
        var styleElement = null;
        (0, _util.setVerbosityLevel)(verbosity);
        var transportFactory = useWorkerFetch ? null : {
          cMapReaderFactory: new CMapReaderFactory({
            baseUrl: cMapUrl,
            isCompressed: cMapPacked
          }),
          standardFontDataFactory: new StandardFontDataFactory({
            baseUrl: standardFontDataUrl
          })
        };
        if (!worker) {
          var workerParams = {
            verbosity: verbosity,
            port: _worker_options.GlobalWorkerOptions.workerPort
          };
          worker = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
          task._worker = worker;
        }
        var docId = task.docId;
        var fetchDocParams = {
          docId: docId,
          apiVersion: '3.4.120',
          data: data,
          password: password,
          disableAutoFetch: disableAutoFetch,
          rangeChunkSize: rangeChunkSize,
          length: length,
          docBaseUrl: docBaseUrl,
          enableXfa: enableXfa,
          evaluatorOptions: {
            maxImageSize: maxImageSize,
            disableFontFace: disableFontFace,
            ignoreErrors: ignoreErrors,
            isEvalSupported: isEvalSupported,
            isOffscreenCanvasSupported: isOffscreenCanvasSupported,
            fontExtraProperties: fontExtraProperties,
            useSystemFonts: useSystemFonts,
            cMapUrl: useWorkerFetch ? cMapUrl : null,
            standardFontDataUrl: useWorkerFetch ? standardFontDataUrl : null
          }
        };
        var transportParams = {
          ignoreErrors: ignoreErrors,
          isEvalSupported: isEvalSupported,
          disableFontFace: disableFontFace,
          fontExtraProperties: fontExtraProperties,
          enableXfa: enableXfa,
          ownerDocument: ownerDocument,
          disableAutoFetch: disableAutoFetch,
          pdfBug: pdfBug,
          styleElement: styleElement
        };
        worker.promise.then(function () {
          if (task.destroyed) {
            throw new Error("Loading aborted");
          }
          var workerIdPromise = _fetchDocument(worker, fetchDocParams);
          var networkStreamPromise = new Promise(function (resolve) {
            var networkStream;
            if (rangeTransport) {
              networkStream = new _transport_stream.PDFDataTransportStream({
                length: length,
                initialData: rangeTransport.initialData,
                progressiveDone: rangeTransport.progressiveDone,
                contentDispositionFilename: rangeTransport.contentDispositionFilename,
                disableRange: disableRange,
                disableStream: disableStream
              }, rangeTransport);
            } else if (!data) {
              networkStream = createPDFNetworkStream({
                url: url,
                length: length,
                httpHeaders: httpHeaders,
                withCredentials: withCredentials,
                rangeChunkSize: rangeChunkSize,
                disableRange: disableRange,
                disableStream: disableStream
              });
            }
            resolve(networkStream);
          });
          return Promise.all([workerIdPromise, networkStreamPromise]).then(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
              workerId = _ref4[0],
              networkStream = _ref4[1];
            if (task.destroyed) {
              throw new Error("Loading aborted");
            }
            var messageHandler = new _message_handler.MessageHandler(docId, workerId, worker.port);
            var transport = new WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory);
            task._transport = transport;
            messageHandler.send("Ready", null);
          });
        }).catch(task._capability.reject);
        return task;
      }
      function _fetchDocument(_x, _x2) {
        return _fetchDocument2.apply(this, arguments);
      }
      function _fetchDocument2() {
        _fetchDocument2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(worker, source) {
          var workerId;
          return _regenerator().w(function (_context6) {
            while (1) switch (_context6.n) {
              case 0:
                if (!worker.destroyed) {
                  _context6.n = 1;
                  break;
                }
                throw new Error("Worker was destroyed");
              case 1:
                _context6.n = 2;
                return worker.messageHandler.sendWithPromise("GetDocRequest", source, source.data ? [source.data.buffer] : null);
              case 2:
                workerId = _context6.v;
                if (!worker.destroyed) {
                  _context6.n = 3;
                  break;
                }
                throw new Error("Worker was destroyed");
              case 3:
                return _context6.a(2, workerId);
            }
          }, _callee6);
        }));
        return _fetchDocument2.apply(this, arguments);
      }
      function getUrlProp(val) {
        if (val instanceof URL) {
          return val.href;
        }
        try {
          return new URL(val, window.location).href;
        } catch (ex) {
          if (_is_node.isNodeJS && typeof val === "string") {
            return val;
          }
        }
        throw new Error("Invalid PDF url data: " + "either string or URL-object is expected in the url property.");
      }
      function getDataProp(val) {
        if (_is_node.isNodeJS && typeof Buffer !== "undefined" && val instanceof Buffer) {
          (0, _display_utils.deprecated)("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
          return new Uint8Array(val);
        }
        if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) {
          return val;
        }
        if (typeof val === "string") {
          return (0, _util.stringToBytes)(val);
        }
        if (_typeof(val) === "object" && !isNaN(val === null || val === void 0 ? void 0 : val.length) || (0, _util.isArrayBuffer)(val)) {
          return new Uint8Array(val);
        }
        throw new Error("Invalid PDF binary data: either TypedArray, " + "string, or array-like object is expected in the data property.");
      }
      var _docId = /*#__PURE__*/_classPrivateFieldLooseKey("docId");
      var _onUnsupportedFeature = /*#__PURE__*/_classPrivateFieldLooseKey("onUnsupportedFeature");
      var PDFDocumentLoadingTask = /*#__PURE__*/function () {
        function PDFDocumentLoadingTask() {
          _classCallCheck(this, PDFDocumentLoadingTask);
          Object.defineProperty(this, _onUnsupportedFeature, {
            writable: true,
            value: null
          });
          this._capability = (0, _util.createPromiseCapability)();
          this._transport = null;
          this._worker = null;
          this.docId = "d".concat(_classPrivateFieldLooseBase(PDFDocumentLoadingTask, _docId)[_docId]++);
          this.destroyed = false;
          this.onPassword = null;
          this.onProgress = null;
        }
        return _createClass(PDFDocumentLoadingTask, [{
          key: "onUnsupportedFeature",
          get: function get() {
            return _classPrivateFieldLooseBase(this, _onUnsupportedFeature)[_onUnsupportedFeature];
          },
          set: function set(callback) {
            (0, _display_utils.deprecated)("The PDFDocumentLoadingTask onUnsupportedFeature property will be removed in the future.");
            _classPrivateFieldLooseBase(this, _onUnsupportedFeature)[_onUnsupportedFeature] = callback;
          }
        }, {
          key: "promise",
          get: function get() {
            return this._capability.promise;
          }
        }, {
          key: "destroy",
          value: function () {
            var _destroy = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
              var _this$_transport;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    this.destroyed = true;
                    _context.n = 1;
                    return (_this$_transport = this._transport) === null || _this$_transport === void 0 ? void 0 : _this$_transport.destroy();
                  case 1:
                    this._transport = null;
                    if (this._worker) {
                      this._worker.destroy();
                      this._worker = null;
                    }
                  case 2:
                    return _context.a(2);
                }
              }, _callee, this);
            }));
            function destroy() {
              return _destroy.apply(this, arguments);
            }
            return destroy;
          }()
        }]);
      }();
      Object.defineProperty(PDFDocumentLoadingTask, _docId, {
        writable: true,
        value: 0
      });
      exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
      var PDFDataRangeTransport = /*#__PURE__*/function () {
        function PDFDataRangeTransport(length, initialData) {
          var progressiveDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          var contentDispositionFilename = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
          _classCallCheck(this, PDFDataRangeTransport);
          this.length = length;
          this.initialData = initialData;
          this.progressiveDone = progressiveDone;
          this.contentDispositionFilename = contentDispositionFilename;
          this._rangeListeners = [];
          this._progressListeners = [];
          this._progressiveReadListeners = [];
          this._progressiveDoneListeners = [];
          this._readyCapability = (0, _util.createPromiseCapability)();
        }
        return _createClass(PDFDataRangeTransport, [{
          key: "addRangeListener",
          value: function addRangeListener(listener) {
            this._rangeListeners.push(listener);
          }
        }, {
          key: "addProgressListener",
          value: function addProgressListener(listener) {
            this._progressListeners.push(listener);
          }
        }, {
          key: "addProgressiveReadListener",
          value: function addProgressiveReadListener(listener) {
            this._progressiveReadListeners.push(listener);
          }
        }, {
          key: "addProgressiveDoneListener",
          value: function addProgressiveDoneListener(listener) {
            this._progressiveDoneListeners.push(listener);
          }
        }, {
          key: "onDataRange",
          value: function onDataRange(begin, chunk) {
            var _iterator2 = _createForOfIteratorHelper(this._rangeListeners),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var listener = _step2.value;
                listener(begin, chunk);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        }, {
          key: "onDataProgress",
          value: function onDataProgress(loaded, total) {
            var _this4 = this;
            this._readyCapability.promise.then(function () {
              var _iterator3 = _createForOfIteratorHelper(_this4._progressListeners),
                _step3;
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var listener = _step3.value;
                  listener(loaded, total);
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            });
          }
        }, {
          key: "onDataProgressiveRead",
          value: function onDataProgressiveRead(chunk) {
            var _this5 = this;
            this._readyCapability.promise.then(function () {
              var _iterator4 = _createForOfIteratorHelper(_this5._progressiveReadListeners),
                _step4;
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  var listener = _step4.value;
                  listener(chunk);
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
            });
          }
        }, {
          key: "onDataProgressiveDone",
          value: function onDataProgressiveDone() {
            var _this6 = this;
            this._readyCapability.promise.then(function () {
              var _iterator5 = _createForOfIteratorHelper(_this6._progressiveDoneListeners),
                _step5;
              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  var listener = _step5.value;
                  listener();
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
            });
          }
        }, {
          key: "transportReady",
          value: function transportReady() {
            this._readyCapability.resolve();
          }
        }, {
          key: "requestDataRange",
          value: function requestDataRange(begin, end) {
            (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
          }
        }, {
          key: "abort",
          value: function abort() {}
        }]);
      }();
      exports.PDFDataRangeTransport = PDFDataRangeTransport;
      var PDFDocumentProxy = /*#__PURE__*/function () {
        function PDFDocumentProxy(pdfInfo, transport) {
          _classCallCheck(this, PDFDocumentProxy);
          this._pdfInfo = pdfInfo;
          this._transport = transport;
        }
        return _createClass(PDFDocumentProxy, [{
          key: "annotationStorage",
          get: function get() {
            return this._transport.annotationStorage;
          }
        }, {
          key: "numPages",
          get: function get() {
            return this._pdfInfo.numPages;
          }
        }, {
          key: "fingerprints",
          get: function get() {
            return this._pdfInfo.fingerprints;
          }
        }, {
          key: "isPureXfa",
          get: function get() {
            return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
          }
        }, {
          key: "allXfaHtml",
          get: function get() {
            return this._transport._htmlForXfa;
          }
        }, {
          key: "getPage",
          value: function getPage(pageNumber) {
            return this._transport.getPage(pageNumber);
          }
        }, {
          key: "getPageIndex",
          value: function getPageIndex(ref) {
            return this._transport.getPageIndex(ref);
          }
        }, {
          key: "getDestinations",
          value: function getDestinations() {
            return this._transport.getDestinations();
          }
        }, {
          key: "getDestination",
          value: function getDestination(id) {
            return this._transport.getDestination(id);
          }
        }, {
          key: "getPageLabels",
          value: function getPageLabels() {
            return this._transport.getPageLabels();
          }
        }, {
          key: "getPageLayout",
          value: function getPageLayout() {
            return this._transport.getPageLayout();
          }
        }, {
          key: "getPageMode",
          value: function getPageMode() {
            return this._transport.getPageMode();
          }
        }, {
          key: "getViewerPreferences",
          value: function getViewerPreferences() {
            return this._transport.getViewerPreferences();
          }
        }, {
          key: "getOpenAction",
          value: function getOpenAction() {
            return this._transport.getOpenAction();
          }
        }, {
          key: "getAttachments",
          value: function getAttachments() {
            return this._transport.getAttachments();
          }
        }, {
          key: "getJavaScript",
          value: function getJavaScript() {
            return this._transport.getJavaScript();
          }
        }, {
          key: "getJSActions",
          value: function getJSActions() {
            return this._transport.getDocJSActions();
          }
        }, {
          key: "getOutline",
          value: function getOutline() {
            return this._transport.getOutline();
          }
        }, {
          key: "getOptionalContentConfig",
          value: function getOptionalContentConfig() {
            return this._transport.getOptionalContentConfig();
          }
        }, {
          key: "getPermissions",
          value: function getPermissions() {
            return this._transport.getPermissions();
          }
        }, {
          key: "getMetadata",
          value: function getMetadata() {
            return this._transport.getMetadata();
          }
        }, {
          key: "getMarkInfo",
          value: function getMarkInfo() {
            return this._transport.getMarkInfo();
          }
        }, {
          key: "getData",
          value: function getData() {
            return this._transport.getData();
          }
        }, {
          key: "saveDocument",
          value: function saveDocument() {
            return this._transport.saveDocument();
          }
        }, {
          key: "getDownloadInfo",
          value: function getDownloadInfo() {
            return this._transport.downloadInfoCapability.promise;
          }
        }, {
          key: "cleanup",
          value: function cleanup() {
            var keepLoadedFonts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            return this.loadingTask.destroy();
          }
        }, {
          key: "loadingParams",
          get: function get() {
            return this._transport.loadingParams;
          }
        }, {
          key: "loadingTask",
          get: function get() {
            return this._transport.loadingTask;
          }
        }, {
          key: "getFieldObjects",
          value: function getFieldObjects() {
            return this._transport.getFieldObjects();
          }
        }, {
          key: "hasJSActions",
          value: function hasJSActions() {
            return this._transport.hasJSActions();
          }
        }, {
          key: "getCalculationOrderIds",
          value: function getCalculationOrderIds() {
            return this._transport.getCalculationOrderIds();
          }
        }]);
      }();
      exports.PDFDocumentProxy = PDFDocumentProxy;
      var PDFPageProxy = /*#__PURE__*/function () {
        function PDFPageProxy(pageIndex, pageInfo, transport, ownerDocument) {
          var pdfBug = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
          _classCallCheck(this, PDFPageProxy);
          this._pageIndex = pageIndex;
          this._pageInfo = pageInfo;
          this._ownerDocument = ownerDocument;
          this._transport = transport;
          this._stats = pdfBug ? new _display_utils.StatTimer() : null;
          this._pdfBug = pdfBug;
          this.commonObjs = transport.commonObjs;
          this.objs = new PDFObjects();
          this.cleanupAfterRender = false;
          this.pendingCleanup = false;
          this._intentStates = new Map();
          this.destroyed = false;
        }
        return _createClass(PDFPageProxy, [{
          key: "pageNumber",
          get: function get() {
            return this._pageIndex + 1;
          }
        }, {
          key: "rotate",
          get: function get() {
            return this._pageInfo.rotate;
          }
        }, {
          key: "ref",
          get: function get() {
            return this._pageInfo.ref;
          }
        }, {
          key: "userUnit",
          get: function get() {
            return this._pageInfo.userUnit;
          }
        }, {
          key: "view",
          get: function get() {
            return this._pageInfo.view;
          }
        }, {
          key: "getViewport",
          value: function getViewport() {
            var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              scale = _ref5.scale,
              _ref5$rotation = _ref5.rotation,
              rotation = _ref5$rotation === void 0 ? this.rotate : _ref5$rotation,
              _ref5$offsetX = _ref5.offsetX,
              offsetX = _ref5$offsetX === void 0 ? 0 : _ref5$offsetX,
              _ref5$offsetY = _ref5.offsetY,
              offsetY = _ref5$offsetY === void 0 ? 0 : _ref5$offsetY,
              _ref5$dontFlip = _ref5.dontFlip,
              dontFlip = _ref5$dontFlip === void 0 ? false : _ref5$dontFlip;
            return new _display_utils.PageViewport({
              viewBox: this.view,
              scale: scale,
              rotation: rotation,
              offsetX: offsetX,
              offsetY: offsetY,
              dontFlip: dontFlip
            });
          }
        }, {
          key: "getAnnotations",
          value: function getAnnotations() {
            var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              _ref6$intent = _ref6.intent,
              intent = _ref6$intent === void 0 ? "display" : _ref6$intent;
            var intentArgs = this._transport.getRenderingIntent(intent);
            return this._transport.getAnnotations(this._pageIndex, intentArgs.renderingIntent);
          }
        }, {
          key: "getJSActions",
          value: function getJSActions() {
            return this._transport.getPageJSActions(this._pageIndex);
          }
        }, {
          key: "isPureXfa",
          get: function get() {
            return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
          }
        }, {
          key: "getXfa",
          value: function () {
            var _getXfa = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
              var _this$_transport$_htm;
              return _regenerator().w(function (_context2) {
                while (1) switch (_context2.n) {
                  case 0:
                    return _context2.a(2, ((_this$_transport$_htm = this._transport._htmlForXfa) === null || _this$_transport$_htm === void 0 ? void 0 : _this$_transport$_htm.children[this._pageIndex]) || null);
                }
              }, _callee2, this);
            }));
            function getXfa() {
              return _getXfa.apply(this, arguments);
            }
            return getXfa;
          }()
        }, {
          key: "render",
          value: function render(_ref7) {
            var _this$_stats,
              _this7 = this,
              _intentState;
            var canvasContext = _ref7.canvasContext,
              viewport = _ref7.viewport,
              _ref7$intent = _ref7.intent,
              intent = _ref7$intent === void 0 ? "display" : _ref7$intent,
              _ref7$annotationMode = _ref7.annotationMode,
              annotationMode = _ref7$annotationMode === void 0 ? _util.AnnotationMode.ENABLE : _ref7$annotationMode,
              _ref7$transform = _ref7.transform,
              transform = _ref7$transform === void 0 ? null : _ref7$transform,
              _ref7$canvasFactory = _ref7.canvasFactory,
              canvasFactory = _ref7$canvasFactory === void 0 ? null : _ref7$canvasFactory,
              _ref7$background = _ref7.background,
              background = _ref7$background === void 0 ? null : _ref7$background,
              _ref7$optionalContent = _ref7.optionalContentConfigPromise,
              optionalContentConfigPromise = _ref7$optionalContent === void 0 ? null : _ref7$optionalContent,
              _ref7$annotationCanva = _ref7.annotationCanvasMap,
              annotationCanvasMap = _ref7$annotationCanva === void 0 ? null : _ref7$annotationCanva,
              _ref7$pageColors = _ref7.pageColors,
              pageColors = _ref7$pageColors === void 0 ? null : _ref7$pageColors,
              _ref7$printAnnotation = _ref7.printAnnotationStorage,
              printAnnotationStorage = _ref7$printAnnotation === void 0 ? null : _ref7$printAnnotation;
            (_this$_stats = this._stats) === null || _this$_stats === void 0 || _this$_stats.time("Overall");
            var intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage);
            this.pendingCleanup = false;
            if (!optionalContentConfigPromise) {
              optionalContentConfigPromise = this._transport.getOptionalContentConfig();
            }
            var intentState = this._intentStates.get(intentArgs.cacheKey);
            if (!intentState) {
              intentState = Object.create(null);
              this._intentStates.set(intentArgs.cacheKey, intentState);
            }
            if (intentState.streamReaderCancelTimeout) {
              clearTimeout(intentState.streamReaderCancelTimeout);
              intentState.streamReaderCancelTimeout = null;
            }
            var canvasFactoryInstance = canvasFactory || new DefaultCanvasFactory({
              ownerDocument: this._ownerDocument
            });
            var intentPrint = !!(intentArgs.renderingIntent & _util.RenderingIntentFlag.PRINT);
            if (!intentState.displayReadyCapability) {
              var _this$_stats2;
              intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
              intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false,
                separateAnnots: null
              };
              (_this$_stats2 = this._stats) === null || _this$_stats2 === void 0 || _this$_stats2.time("Page Request");
              this._pumpOperatorList(intentArgs);
            }
            var complete = function complete(error) {
              var _this7$_stats, _this7$_stats2;
              intentState.renderTasks.delete(internalRenderTask);
              if (_this7.cleanupAfterRender || intentPrint) {
                _this7.pendingCleanup = true;
              }
              _this7._tryCleanup();
              if (error) {
                internalRenderTask.capability.reject(error);
                _this7._abortOperatorList({
                  intentState: intentState,
                  reason: error instanceof Error ? error : new Error(error)
                });
              } else {
                internalRenderTask.capability.resolve();
              }
              (_this7$_stats = _this7._stats) === null || _this7$_stats === void 0 || _this7$_stats.timeEnd("Rendering");
              (_this7$_stats2 = _this7._stats) === null || _this7$_stats2 === void 0 || _this7$_stats2.timeEnd("Overall");
            };
            var internalRenderTask = new InternalRenderTask({
              callback: complete,
              params: {
                canvasContext: canvasContext,
                viewport: viewport,
                transform: transform,
                background: background
              },
              objs: this.objs,
              commonObjs: this.commonObjs,
              annotationCanvasMap: annotationCanvasMap,
              operatorList: intentState.operatorList,
              pageIndex: this._pageIndex,
              canvasFactory: canvasFactoryInstance,
              useRequestAnimationFrame: !intentPrint,
              pdfBug: this._pdfBug,
              pageColors: pageColors
            });
            ((_intentState = intentState).renderTasks || (_intentState.renderTasks = new Set())).add(internalRenderTask);
            var renderTask = internalRenderTask.task;
            Promise.all([intentState.displayReadyCapability.promise, optionalContentConfigPromise]).then(function (_ref8) {
              var _this7$_stats3;
              var _ref9 = _slicedToArray(_ref8, 2),
                transparency = _ref9[0],
                optionalContentConfig = _ref9[1];
              if (_this7.pendingCleanup) {
                complete();
                return;
              }
              (_this7$_stats3 = _this7._stats) === null || _this7$_stats3 === void 0 || _this7$_stats3.time("Rendering");
              internalRenderTask.initializeGraphics({
                transparency: transparency,
                optionalContentConfig: optionalContentConfig
              });
              internalRenderTask.operatorListChanged();
            }).catch(complete);
            return renderTask;
          }
        }, {
          key: "getOperatorList",
          value: function getOperatorList() {
            var _ref0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              _ref0$intent = _ref0.intent,
              intent = _ref0$intent === void 0 ? "display" : _ref0$intent,
              _ref0$annotationMode = _ref0.annotationMode,
              annotationMode = _ref0$annotationMode === void 0 ? _util.AnnotationMode.ENABLE : _ref0$annotationMode,
              _ref0$printAnnotation = _ref0.printAnnotationStorage,
              printAnnotationStorage = _ref0$printAnnotation === void 0 ? null : _ref0$printAnnotation;
            function operatorListChanged() {
              if (intentState.operatorList.lastChunk) {
                intentState.opListReadCapability.resolve(intentState.operatorList);
                intentState.renderTasks.delete(opListTask);
              }
            }
            var intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, true);
            var intentState = this._intentStates.get(intentArgs.cacheKey);
            if (!intentState) {
              intentState = Object.create(null);
              this._intentStates.set(intentArgs.cacheKey, intentState);
            }
            var opListTask;
            if (!intentState.opListReadCapability) {
              var _intentState2, _this$_stats3;
              opListTask = Object.create(null);
              opListTask.operatorListChanged = operatorListChanged;
              intentState.opListReadCapability = (0, _util.createPromiseCapability)();
              ((_intentState2 = intentState).renderTasks || (_intentState2.renderTasks = new Set())).add(opListTask);
              intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false,
                separateAnnots: null
              };
              (_this$_stats3 = this._stats) === null || _this$_stats3 === void 0 || _this$_stats3.time("Page Request");
              this._pumpOperatorList(intentArgs);
            }
            return intentState.opListReadCapability.promise;
          }
        }, {
          key: "streamTextContent",
          value: function streamTextContent() {
            var _ref1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              _ref1$disableCombineT = _ref1.disableCombineTextItems,
              disableCombineTextItems = _ref1$disableCombineT === void 0 ? false : _ref1$disableCombineT,
              _ref1$includeMarkedCo = _ref1.includeMarkedContent,
              includeMarkedContent = _ref1$includeMarkedCo === void 0 ? false : _ref1$includeMarkedCo;
            var TEXT_CONTENT_CHUNK_SIZE = 100;
            return this._transport.messageHandler.sendWithStream("GetTextContent", {
              pageIndex: this._pageIndex,
              combineTextItems: disableCombineTextItems !== true,
              includeMarkedContent: includeMarkedContent === true
            }, {
              highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
              size: function size(textContent) {
                return textContent.items.length;
              }
            });
          }
        }, {
          key: "getTextContent",
          value: function getTextContent() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (this._transport._htmlForXfa) {
              return this.getXfa().then(function (xfa) {
                return _xfa_text.XfaText.textContent(xfa);
              });
            }
            var readableStream = this.streamTextContent(params);
            return new Promise(function (resolve, reject) {
              function pump() {
                reader.read().then(function (_ref10) {
                  var _textContent$items;
                  var value = _ref10.value,
                    done = _ref10.done;
                  if (done) {
                    resolve(textContent);
                    return;
                  }
                  Object.assign(textContent.styles, value.styles);
                  (_textContent$items = textContent.items).push.apply(_textContent$items, _toConsumableArray(value.items));
                  pump();
                }, reject);
              }
              var reader = readableStream.getReader();
              var textContent = {
                items: [],
                styles: Object.create(null)
              };
              pump();
            });
          }
        }, {
          key: "getStructTree",
          value: function getStructTree() {
            return this._transport.getStructTree(this._pageIndex);
          }
        }, {
          key: "_destroy",
          value: function _destroy() {
            this.destroyed = true;
            var waitOn = [];
            var _iterator6 = _createForOfIteratorHelper(this._intentStates.values()),
              _step6;
            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var intentState = _step6.value;
                this._abortOperatorList({
                  intentState: intentState,
                  reason: new Error("Page was destroyed."),
                  force: true
                });
                if (intentState.opListReadCapability) {
                  continue;
                }
                var _iterator7 = _createForOfIteratorHelper(intentState.renderTasks),
                  _step7;
                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    var internalRenderTask = _step7.value;
                    waitOn.push(internalRenderTask.completed);
                    internalRenderTask.cancel();
                  }
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }
            this.objs.clear();
            this.pendingCleanup = false;
            return Promise.all(waitOn);
          }
        }, {
          key: "cleanup",
          value: function cleanup() {
            var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            this.pendingCleanup = true;
            return this._tryCleanup(resetStats);
          }
        }, {
          key: "_tryCleanup",
          value: function _tryCleanup() {
            var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            if (!this.pendingCleanup) {
              return false;
            }
            var _iterator8 = _createForOfIteratorHelper(this._intentStates.values()),
              _step8;
            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var _ref11 = _step8.value;
                var renderTasks = _ref11.renderTasks;
                var operatorList = _ref11.operatorList;
                if (renderTasks.size > 0 || !operatorList.lastChunk) {
                  return false;
                }
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
            this._intentStates.clear();
            this.objs.clear();
            if (resetStats && this._stats) {
              this._stats = new _display_utils.StatTimer();
            }
            this.pendingCleanup = false;
            return true;
          }
        }, {
          key: "_startRenderPage",
          value: function _startRenderPage(transparency, cacheKey) {
            var _this$_stats4, _intentState$displayR;
            var intentState = this._intentStates.get(cacheKey);
            if (!intentState) {
              return;
            }
            (_this$_stats4 = this._stats) === null || _this$_stats4 === void 0 || _this$_stats4.timeEnd("Page Request");
            (_intentState$displayR = intentState.displayReadyCapability) === null || _intentState$displayR === void 0 || _intentState$displayR.resolve(transparency);
          }
        }, {
          key: "_renderPageChunk",
          value: function _renderPageChunk(operatorListChunk, intentState) {
            for (var i = 0, ii = operatorListChunk.length; i < ii; i++) {
              intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
              intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
            }
            intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
            intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
            var _iterator9 = _createForOfIteratorHelper(intentState.renderTasks),
              _step9;
            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var internalRenderTask = _step9.value;
                internalRenderTask.operatorListChanged();
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }
            if (operatorListChunk.lastChunk) {
              this._tryCleanup();
            }
          }
        }, {
          key: "_pumpOperatorList",
          value: function _pumpOperatorList(_ref12) {
            var _this8 = this;
            var renderingIntent = _ref12.renderingIntent,
              cacheKey = _ref12.cacheKey,
              annotationStorageMap = _ref12.annotationStorageMap;
            var readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
              pageIndex: this._pageIndex,
              intent: renderingIntent,
              cacheKey: cacheKey,
              annotationStorage: annotationStorageMap
            });
            var reader = readableStream.getReader();
            var intentState = this._intentStates.get(cacheKey);
            intentState.streamReader = reader;
            var _pump = function pump() {
              reader.read().then(function (_ref13) {
                var value = _ref13.value,
                  done = _ref13.done;
                if (done) {
                  intentState.streamReader = null;
                  return;
                }
                if (_this8._transport.destroyed) {
                  return;
                }
                _this8._renderPageChunk(value, intentState);
                _pump();
              }, function (reason) {
                intentState.streamReader = null;
                if (_this8._transport.destroyed) {
                  return;
                }
                if (intentState.operatorList) {
                  intentState.operatorList.lastChunk = true;
                  var _iterator0 = _createForOfIteratorHelper(intentState.renderTasks),
                    _step0;
                  try {
                    for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
                      var internalRenderTask = _step0.value;
                      internalRenderTask.operatorListChanged();
                    }
                  } catch (err) {
                    _iterator0.e(err);
                  } finally {
                    _iterator0.f();
                  }
                  _this8._tryCleanup();
                }
                if (intentState.displayReadyCapability) {
                  intentState.displayReadyCapability.reject(reason);
                } else if (intentState.opListReadCapability) {
                  intentState.opListReadCapability.reject(reason);
                } else {
                  throw reason;
                }
              });
            };
            _pump();
          }
        }, {
          key: "_abortOperatorList",
          value: function _abortOperatorList(_ref14) {
            var _this9 = this;
            var intentState = _ref14.intentState,
              reason = _ref14.reason,
              _ref14$force = _ref14.force,
              force = _ref14$force === void 0 ? false : _ref14$force;
            if (!intentState.streamReader) {
              return;
            }
            if (intentState.streamReaderCancelTimeout) {
              clearTimeout(intentState.streamReaderCancelTimeout);
              intentState.streamReaderCancelTimeout = null;
            }
            if (!force) {
              if (intentState.renderTasks.size > 0) {
                return;
              }
              if (reason instanceof _display_utils.RenderingCancelledException) {
                var delay = RENDERING_CANCELLED_TIMEOUT;
                if (reason.extraDelay > 0 && reason.extraDelay < 1000) {
                  delay += reason.extraDelay;
                }
                intentState.streamReaderCancelTimeout = setTimeout(function () {
                  intentState.streamReaderCancelTimeout = null;
                  _this9._abortOperatorList({
                    intentState: intentState,
                    reason: reason,
                    force: true
                  });
                }, delay);
                return;
              }
            }
            intentState.streamReader.cancel(new _util.AbortException(reason.message)).catch(function () {});
            intentState.streamReader = null;
            if (this._transport.destroyed) {
              return;
            }
            var _iterator1 = _createForOfIteratorHelper(this._intentStates),
              _step1;
            try {
              for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
                var _ref15 = _step1.value;
                var _ref16 = _slicedToArray(_ref15, 2);
                var curCacheKey = _ref16[0];
                var curIntentState = _ref16[1];
                if (curIntentState === intentState) {
                  this._intentStates.delete(curCacheKey);
                  break;
                }
              }
            } catch (err) {
              _iterator1.e(err);
            } finally {
              _iterator1.f();
            }
            this.cleanup();
          }
        }, {
          key: "stats",
          get: function get() {
            return this._stats;
          }
        }]);
      }();
      exports.PDFPageProxy = PDFPageProxy;
      var _listeners = /*#__PURE__*/_classPrivateFieldLooseKey("listeners");
      var _deferred = /*#__PURE__*/_classPrivateFieldLooseKey("deferred");
      var LoopbackPort = /*#__PURE__*/function () {
        function LoopbackPort() {
          _classCallCheck(this, LoopbackPort);
          Object.defineProperty(this, _listeners, {
            writable: true,
            value: new Set()
          });
          Object.defineProperty(this, _deferred, {
            writable: true,
            value: Promise.resolve()
          });
        }
        return _createClass(LoopbackPort, [{
          key: "postMessage",
          value: function postMessage(obj, transfers) {
            var _this0 = this;
            var event = {
              data: structuredClone(obj, transfers)
            };
            _classPrivateFieldLooseBase(this, _deferred)[_deferred].then(function () {
              var _iterator10 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(_this0, _listeners)[_listeners]),
                _step10;
              try {
                for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                  var listener = _step10.value;
                  listener.call(_this0, event);
                }
              } catch (err) {
                _iterator10.e(err);
              } finally {
                _iterator10.f();
              }
            });
          }
        }, {
          key: "addEventListener",
          value: function addEventListener(name, listener) {
            _classPrivateFieldLooseBase(this, _listeners)[_listeners].add(listener);
          }
        }, {
          key: "removeEventListener",
          value: function removeEventListener(name, listener) {
            _classPrivateFieldLooseBase(this, _listeners)[_listeners].delete(listener);
          }
        }, {
          key: "terminate",
          value: function terminate() {
            _classPrivateFieldLooseBase(this, _listeners)[_listeners].clear();
          }
        }]);
      }();
      exports.LoopbackPort = LoopbackPort;
      var PDFWorkerUtil = {
        isWorkerDisabled: false,
        fallbackWorkerSrc: null,
        fakeWorkerId: 0
      };
      exports.PDFWorkerUtil = PDFWorkerUtil;
      {
        if (_is_node.isNodeJS && typeof require === "function") {
          PDFWorkerUtil.isWorkerDisabled = true;
          PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
        } else if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === "object") {
          var _document;
          var pdfjsFilePath = (_document = document) === null || _document === void 0 || (_document = _document.currentScript) === null || _document === void 0 ? void 0 : _document.src;
          if (pdfjsFilePath) {
            PDFWorkerUtil.fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
          }
        }
        PDFWorkerUtil.isSameOrigin = function (baseUrl, otherUrl) {
          var base;
          try {
            base = new URL(baseUrl);
            if (!base.origin || base.origin === "null") {
              return false;
            }
          } catch (e) {
            return false;
          }
          var other = new URL(otherUrl, base);
          return base.origin === other.origin;
        };
        PDFWorkerUtil.createCDNWrapper = function (url) {
          var wrapper = "importScripts(\"".concat(url, "\");");
          return URL.createObjectURL(new Blob([wrapper]));
        };
      }
      var _workerPorts = /*#__PURE__*/_classPrivateFieldLooseKey("workerPorts");
      var PDFWorker = /*#__PURE__*/function () {
        function PDFWorker() {
          var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref17$name = _ref17.name,
            name = _ref17$name === void 0 ? null : _ref17$name,
            _ref17$port = _ref17.port,
            port = _ref17$port === void 0 ? null : _ref17$port,
            _ref17$verbosity = _ref17.verbosity,
            verbosity = _ref17$verbosity === void 0 ? (0, _util.getVerbosityLevel)() : _ref17$verbosity;
          _classCallCheck(this, PDFWorker);
          if (port && _classPrivateFieldLooseBase(PDFWorker, _workerPorts)[_workerPorts].has(port)) {
            throw new Error("Cannot use more than one PDFWorker per port.");
          }
          this.name = name;
          this.destroyed = false;
          this.verbosity = verbosity;
          this._readyCapability = (0, _util.createPromiseCapability)();
          this._port = null;
          this._webWorker = null;
          this._messageHandler = null;
          if (port) {
            _classPrivateFieldLooseBase(PDFWorker, _workerPorts)[_workerPorts].set(port, this);
            this._initializeFromPort(port);
            return;
          }
          this._initialize();
        }
        return _createClass(PDFWorker, [{
          key: "promise",
          get: function get() {
            return this._readyCapability.promise;
          }
        }, {
          key: "port",
          get: function get() {
            return this._port;
          }
        }, {
          key: "messageHandler",
          get: function get() {
            return this._messageHandler;
          }
        }, {
          key: "_initializeFromPort",
          value: function _initializeFromPort(port) {
            this._port = port;
            this._messageHandler = new _message_handler.MessageHandler("main", "worker", port);
            this._messageHandler.on("ready", function () {});
            this._readyCapability.resolve();
            this._messageHandler.send("configure", {
              verbosity: this.verbosity
            });
          }
        }, {
          key: "_initialize",
          value: function _initialize() {
            var _this1 = this;
            if (!PDFWorkerUtil.isWorkerDisabled && !PDFWorker._mainThreadWorkerMessageHandler) {
              var workerSrc = PDFWorker.workerSrc;
              try {
                if (!PDFWorkerUtil.isSameOrigin(window.location.href, workerSrc)) {
                  workerSrc = PDFWorkerUtil.createCDNWrapper(new URL(workerSrc, window.location).href);
                }
                var worker = new Worker(workerSrc);
                var messageHandler = new _message_handler.MessageHandler("main", "worker", worker);
                var terminateEarly = function terminateEarly() {
                  worker.removeEventListener("error", onWorkerError);
                  messageHandler.destroy();
                  worker.terminate();
                  if (_this1.destroyed) {
                    _this1._readyCapability.reject(new Error("Worker was destroyed"));
                  } else {
                    _this1._setupFakeWorker();
                  }
                };
                var onWorkerError = function onWorkerError() {
                  if (!_this1._webWorker) {
                    terminateEarly();
                  }
                };
                worker.addEventListener("error", onWorkerError);
                messageHandler.on("test", function (data) {
                  worker.removeEventListener("error", onWorkerError);
                  if (_this1.destroyed) {
                    terminateEarly();
                    return;
                  }
                  if (data) {
                    _this1._messageHandler = messageHandler;
                    _this1._port = worker;
                    _this1._webWorker = worker;
                    _this1._readyCapability.resolve();
                    messageHandler.send("configure", {
                      verbosity: _this1.verbosity
                    });
                  } else {
                    _this1._setupFakeWorker();
                    messageHandler.destroy();
                    worker.terminate();
                  }
                });
                messageHandler.on("ready", function (data) {
                  worker.removeEventListener("error", onWorkerError);
                  if (_this1.destroyed) {
                    terminateEarly();
                    return;
                  }
                  try {
                    sendTest();
                  } catch (e) {
                    _this1._setupFakeWorker();
                  }
                });
                var sendTest = function sendTest() {
                  var testObj = new Uint8Array();
                  messageHandler.send("test", testObj, [testObj.buffer]);
                };
                sendTest();
                return;
              } catch (e) {
                (0, _util.info)("The worker has been disabled.");
              }
            }
            this._setupFakeWorker();
          }
        }, {
          key: "_setupFakeWorker",
          value: function _setupFakeWorker() {
            var _this10 = this;
            if (!PDFWorkerUtil.isWorkerDisabled) {
              (0, _util.warn)("Setting up fake worker.");
              PDFWorkerUtil.isWorkerDisabled = true;
            }
            PDFWorker._setupFakeWorkerGlobal.then(function (WorkerMessageHandler) {
              if (_this10.destroyed) {
                _this10._readyCapability.reject(new Error("Worker was destroyed"));
                return;
              }
              var port = new LoopbackPort();
              _this10._port = port;
              var id = "fake".concat(PDFWorkerUtil.fakeWorkerId++);
              var workerHandler = new _message_handler.MessageHandler(id + "_worker", id, port);
              WorkerMessageHandler.setup(workerHandler, port);
              var messageHandler = new _message_handler.MessageHandler(id, id + "_worker", port);
              _this10._messageHandler = messageHandler;
              _this10._readyCapability.resolve();
              messageHandler.send("configure", {
                verbosity: _this10.verbosity
              });
            }).catch(function (reason) {
              _this10._readyCapability.reject(new Error("Setting up fake worker failed: \"".concat(reason.message, "\".")));
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.destroyed = true;
            if (this._webWorker) {
              this._webWorker.terminate();
              this._webWorker = null;
            }
            _classPrivateFieldLooseBase(PDFWorker, _workerPorts)[_workerPorts].delete(this._port);
            this._port = null;
            if (this._messageHandler) {
              this._messageHandler.destroy();
              this._messageHandler = null;
            }
          }
        }], [{
          key: "fromPort",
          value: function fromPort(params) {
            if (!(params !== null && params !== void 0 && params.port)) {
              throw new Error("PDFWorker.fromPort - invalid method signature.");
            }
            if (_classPrivateFieldLooseBase(this, _workerPorts)[_workerPorts].has(params.port)) {
              return _classPrivateFieldLooseBase(this, _workerPorts)[_workerPorts].get(params.port);
            }
            return new PDFWorker(params);
          }
        }, {
          key: "workerSrc",
          get: function get() {
            if (_worker_options.GlobalWorkerOptions.workerSrc) {
              return _worker_options.GlobalWorkerOptions.workerSrc;
            }
            if (PDFWorkerUtil.fallbackWorkerSrc !== null) {
              if (!_is_node.isNodeJS) {
                (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
              }
              return PDFWorkerUtil.fallbackWorkerSrc;
            }
            throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
          }
        }, {
          key: "_mainThreadWorkerMessageHandler",
          get: function get() {
            try {
              var _globalThis$pdfjsWork;
              return ((_globalThis$pdfjsWork = globalThis.pdfjsWorker) === null || _globalThis$pdfjsWork === void 0 ? void 0 : _globalThis$pdfjsWork.WorkerMessageHandler) || null;
            } catch (ex) {
              return null;
            }
          }
        }, {
          key: "_setupFakeWorkerGlobal",
          get: function get() {
            var _this11 = this;
            var loader = /*#__PURE__*/function () {
              var _ref18 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                var mainWorkerMessageHandler, worker;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      mainWorkerMessageHandler = _this11._mainThreadWorkerMessageHandler;
                      if (!mainWorkerMessageHandler) {
                        _context3.n = 1;
                        break;
                      }
                      return _context3.a(2, mainWorkerMessageHandler);
                    case 1:
                      if (!(_is_node.isNodeJS && typeof require === "function")) {
                        _context3.n = 2;
                        break;
                      }
                      worker = eval("require")(_this11.workerSrc);
                      return _context3.a(2, worker.WorkerMessageHandler);
                    case 2:
                      _context3.n = 3;
                      return (0, _display_utils.loadScript)(_this11.workerSrc);
                    case 3:
                      return _context3.a(2, window.pdfjsWorker.WorkerMessageHandler);
                  }
                }, _callee3);
              }));
              return function loader() {
                return _ref18.apply(this, arguments);
              };
            }();
            return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
          }
        }]);
      }();
      Object.defineProperty(PDFWorker, _workerPorts, {
        writable: true,
        value: new WeakMap()
      });
      exports.PDFWorker = PDFWorker;
      var _methodPromises = /*#__PURE__*/_classPrivateFieldLooseKey("methodPromises");
      var _pageCache = /*#__PURE__*/_classPrivateFieldLooseKey("pageCache");
      var _pagePromises = /*#__PURE__*/_classPrivateFieldLooseKey("pagePromises");
      var _cacheSimpleMethod = /*#__PURE__*/_classPrivateFieldLooseKey("cacheSimpleMethod");
      var WorkerTransport = /*#__PURE__*/function () {
        function WorkerTransport(messageHandler, loadingTask, networkStream, params, factory) {
          _classCallCheck(this, WorkerTransport);
          Object.defineProperty(this, _cacheSimpleMethod, {
            value: _cacheSimpleMethod2
          });
          Object.defineProperty(this, _methodPromises, {
            writable: true,
            value: new Map()
          });
          Object.defineProperty(this, _pageCache, {
            writable: true,
            value: new Map()
          });
          Object.defineProperty(this, _pagePromises, {
            writable: true,
            value: new Map()
          });
          this.messageHandler = messageHandler;
          this.loadingTask = loadingTask;
          this.commonObjs = new PDFObjects();
          this.fontLoader = new _font_loader.FontLoader({
            onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
            ownerDocument: params.ownerDocument,
            styleElement: params.styleElement
          });
          this._params = params;
          this.cMapReaderFactory = factory === null || factory === void 0 ? void 0 : factory.cMapReaderFactory;
          this.standardFontDataFactory = factory === null || factory === void 0 ? void 0 : factory.standardFontDataFactory;
          this.destroyed = false;
          this.destroyCapability = null;
          this._passwordCapability = null;
          this._networkStream = networkStream;
          this._fullReader = null;
          this._lastProgress = null;
          this.downloadInfoCapability = (0, _util.createPromiseCapability)();
          this.setupMessageHandler();
        }
        return _createClass(WorkerTransport, [{
          key: "annotationStorage",
          get: function get() {
            return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
          }
        }, {
          key: "getRenderingIntent",
          value: function getRenderingIntent(intent) {
            var annotationMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _util.AnnotationMode.ENABLE;
            var printAnnotationStorage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var isOpList = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            var renderingIntent = _util.RenderingIntentFlag.DISPLAY;
            var annotationMap = null;
            switch (intent) {
              case "any":
                renderingIntent = _util.RenderingIntentFlag.ANY;
                break;
              case "display":
                break;
              case "print":
                renderingIntent = _util.RenderingIntentFlag.PRINT;
                break;
              default:
                (0, _util.warn)("getRenderingIntent - invalid intent: ".concat(intent));
            }
            switch (annotationMode) {
              case _util.AnnotationMode.DISABLE:
                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                break;
              case _util.AnnotationMode.ENABLE:
                break;
              case _util.AnnotationMode.ENABLE_FORMS:
                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                break;
              case _util.AnnotationMode.ENABLE_STORAGE:
                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE;
                var annotationStorage = renderingIntent & _util.RenderingIntentFlag.PRINT && printAnnotationStorage instanceof _annotation_storage.PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
                annotationMap = annotationStorage.serializable;
                break;
              default:
                (0, _util.warn)("getRenderingIntent - invalid annotationMode: ".concat(annotationMode));
            }
            if (isOpList) {
              renderingIntent += _util.RenderingIntentFlag.OPLIST;
            }
            return {
              renderingIntent: renderingIntent,
              cacheKey: "".concat(renderingIntent, "_").concat(_annotation_storage.AnnotationStorage.getHash(annotationMap)),
              annotationStorageMap: annotationMap
            };
          }
        }, {
          key: "destroy",
          value: function destroy() {
            var _this12 = this;
            if (this.destroyCapability) {
              return this.destroyCapability.promise;
            }
            this.destroyed = true;
            this.destroyCapability = (0, _util.createPromiseCapability)();
            if (this._passwordCapability) {
              this._passwordCapability.reject(new Error("Worker was destroyed during onPassword callback"));
            }
            var waitOn = [];
            var _iterator11 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _pageCache)[_pageCache].values()),
              _step11;
            try {
              for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                var page = _step11.value;
                waitOn.push(page._destroy());
              }
            } catch (err) {
              _iterator11.e(err);
            } finally {
              _iterator11.f();
            }
            _classPrivateFieldLooseBase(this, _pageCache)[_pageCache].clear();
            _classPrivateFieldLooseBase(this, _pagePromises)[_pagePromises].clear();
            if (this.hasOwnProperty("annotationStorage")) {
              this.annotationStorage.resetModified();
            }
            var terminated = this.messageHandler.sendWithPromise("Terminate", null);
            waitOn.push(terminated);
            Promise.all(waitOn).then(function () {
              _this12.commonObjs.clear();
              _this12.fontLoader.clear();
              _classPrivateFieldLooseBase(_this12, _methodPromises)[_methodPromises].clear();
              if (_this12._networkStream) {
                _this12._networkStream.cancelAllRequests(new _util.AbortException("Worker was terminated."));
              }
              if (_this12.messageHandler) {
                _this12.messageHandler.destroy();
                _this12.messageHandler = null;
              }
              _this12.destroyCapability.resolve();
            }, this.destroyCapability.reject);
            return this.destroyCapability.promise;
          }
        }, {
          key: "setupMessageHandler",
          value: function setupMessageHandler() {
            var _this13 = this;
            var messageHandler = this.messageHandler,
              loadingTask = this.loadingTask;
            messageHandler.on("GetReader", function (data, sink) {
              (0, _util.assert)(_this13._networkStream, "GetReader - no `IPDFStream` instance available.");
              _this13._fullReader = _this13._networkStream.getFullReader();
              _this13._fullReader.onProgress = function (evt) {
                _this13._lastProgress = {
                  loaded: evt.loaded,
                  total: evt.total
                };
              };
              sink.onPull = function () {
                _this13._fullReader.read().then(function (_ref19) {
                  var value = _ref19.value,
                    done = _ref19.done;
                  if (done) {
                    sink.close();
                    return;
                  }
                  (0, _util.assert)(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                  sink.enqueue(new Uint8Array(value), 1, [value]);
                }).catch(function (reason) {
                  sink.error(reason);
                });
              };
              sink.onCancel = function (reason) {
                _this13._fullReader.cancel(reason);
                sink.ready.catch(function (readyReason) {
                  if (_this13.destroyed) {
                    return;
                  }
                  throw readyReason;
                });
              };
            });
            messageHandler.on("ReaderHeadersReady", function (data) {
              var headersCapability = (0, _util.createPromiseCapability)();
              var fullReader = _this13._fullReader;
              fullReader.headersReady.then(function () {
                if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
                  if (_this13._lastProgress) {
                    var _loadingTask$onProgre;
                    (_loadingTask$onProgre = loadingTask.onProgress) === null || _loadingTask$onProgre === void 0 || _loadingTask$onProgre.call(loadingTask, _this13._lastProgress);
                  }
                  fullReader.onProgress = function (evt) {
                    var _loadingTask$onProgre2;
                    (_loadingTask$onProgre2 = loadingTask.onProgress) === null || _loadingTask$onProgre2 === void 0 || _loadingTask$onProgre2.call(loadingTask, {
                      loaded: evt.loaded,
                      total: evt.total
                    });
                  };
                }
                headersCapability.resolve({
                  isStreamingSupported: fullReader.isStreamingSupported,
                  isRangeSupported: fullReader.isRangeSupported,
                  contentLength: fullReader.contentLength
                });
              }, headersCapability.reject);
              return headersCapability.promise;
            });
            messageHandler.on("GetRangeReader", function (data, sink) {
              (0, _util.assert)(_this13._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
              var rangeReader = _this13._networkStream.getRangeReader(data.begin, data.end);
              if (!rangeReader) {
                sink.close();
                return;
              }
              sink.onPull = function () {
                rangeReader.read().then(function (_ref20) {
                  var value = _ref20.value,
                    done = _ref20.done;
                  if (done) {
                    sink.close();
                    return;
                  }
                  (0, _util.assert)(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                  sink.enqueue(new Uint8Array(value), 1, [value]);
                }).catch(function (reason) {
                  sink.error(reason);
                });
              };
              sink.onCancel = function (reason) {
                rangeReader.cancel(reason);
                sink.ready.catch(function (readyReason) {
                  if (_this13.destroyed) {
                    return;
                  }
                  throw readyReason;
                });
              };
            });
            messageHandler.on("GetDoc", function (_ref21) {
              var pdfInfo = _ref21.pdfInfo;
              _this13._numPages = pdfInfo.numPages;
              _this13._htmlForXfa = pdfInfo.htmlForXfa;
              delete pdfInfo.htmlForXfa;
              loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, _this13));
            });
            messageHandler.on("DocException", function (ex) {
              var reason;
              switch (ex.name) {
                case "PasswordException":
                  reason = new _util.PasswordException(ex.message, ex.code);
                  break;
                case "InvalidPDFException":
                  reason = new _util.InvalidPDFException(ex.message);
                  break;
                case "MissingPDFException":
                  reason = new _util.MissingPDFException(ex.message);
                  break;
                case "UnexpectedResponseException":
                  reason = new _util.UnexpectedResponseException(ex.message, ex.status);
                  break;
                case "UnknownErrorException":
                  reason = new _util.UnknownErrorException(ex.message, ex.details);
                  break;
                default:
                  (0, _util.unreachable)("DocException - expected a valid Error.");
              }
              loadingTask._capability.reject(reason);
            });
            messageHandler.on("PasswordRequest", function (exception) {
              _this13._passwordCapability = (0, _util.createPromiseCapability)();
              if (loadingTask.onPassword) {
                var updatePassword = function updatePassword(password) {
                  if (password instanceof Error) {
                    _this13._passwordCapability.reject(password);
                  } else {
                    _this13._passwordCapability.resolve({
                      password: password
                    });
                  }
                };
                try {
                  loadingTask.onPassword(updatePassword, exception.code);
                } catch (ex) {
                  _this13._passwordCapability.reject(ex);
                }
              } else {
                _this13._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
              }
              return _this13._passwordCapability.promise;
            });
            messageHandler.on("DataLoaded", function (data) {
              var _loadingTask$onProgre3;
              (_loadingTask$onProgre3 = loadingTask.onProgress) === null || _loadingTask$onProgre3 === void 0 || _loadingTask$onProgre3.call(loadingTask, {
                loaded: data.length,
                total: data.length
              });
              _this13.downloadInfoCapability.resolve(data);
            });
            messageHandler.on("StartRenderPage", function (data) {
              if (_this13.destroyed) {
                return;
              }
              var page = _classPrivateFieldLooseBase(_this13, _pageCache)[_pageCache].get(data.pageIndex);
              page._startRenderPage(data.transparency, data.cacheKey);
            });
            messageHandler.on("commonobj", function (_ref22) {
              var _globalThis$FontInspe;
              var _ref23 = _slicedToArray(_ref22, 3),
                id = _ref23[0],
                type = _ref23[1],
                exportedData = _ref23[2];
              if (_this13.destroyed) {
                return;
              }
              if (_this13.commonObjs.has(id)) {
                return;
              }
              switch (type) {
                case "Font":
                  var params = _this13._params;
                  if ("error" in exportedData) {
                    var exportedError = exportedData.error;
                    (0, _util.warn)("Error during font loading: ".concat(exportedError));
                    _this13.commonObjs.resolve(id, exportedError);
                    break;
                  }
                  var fontRegistry = null;
                  if (params.pdfBug && (_globalThis$FontInspe = globalThis.FontInspector) !== null && _globalThis$FontInspe !== void 0 && _globalThis$FontInspe.enabled) {
                    fontRegistry = {
                      registerFont: function registerFont(font, url) {
                        globalThis.FontInspector.fontAdded(font, url);
                      }
                    };
                  }
                  var font = new _font_loader.FontFaceObject(exportedData, {
                    isEvalSupported: params.isEvalSupported,
                    disableFontFace: params.disableFontFace,
                    ignoreErrors: params.ignoreErrors,
                    onUnsupportedFeature: _this13._onUnsupportedFeature.bind(_this13),
                    fontRegistry: fontRegistry
                  });
                  _this13.fontLoader.bind(font).catch(function (reason) {
                    return messageHandler.sendWithPromise("FontFallback", {
                      id: id
                    });
                  }).finally(function () {
                    if (!params.fontExtraProperties && font.data) {
                      font.data = null;
                    }
                    _this13.commonObjs.resolve(id, font);
                  });
                  break;
                case "FontPath":
                case "Image":
                  _this13.commonObjs.resolve(id, exportedData);
                  break;
                default:
                  throw new Error("Got unknown common object type ".concat(type));
              }
            });
            messageHandler.on("obj", function (_ref24) {
              var _ref25 = _slicedToArray(_ref24, 4),
                id = _ref25[0],
                pageIndex = _ref25[1],
                type = _ref25[2],
                imageData = _ref25[3];
              if (_this13.destroyed) {
                return;
              }
              var pageProxy = _classPrivateFieldLooseBase(_this13, _pageCache)[_pageCache].get(pageIndex);
              if (pageProxy.objs.has(id)) {
                return;
              }
              switch (type) {
                case "Image":
                  pageProxy.objs.resolve(id, imageData);
                  var MAX_IMAGE_SIZE_TO_STORE = 8000000;
                  if (imageData) {
                    var length;
                    if (imageData.bitmap) {
                      var width = imageData.width,
                        height = imageData.height;
                      length = width * height * 4;
                    } else {
                      var _imageData$data;
                      length = ((_imageData$data = imageData.data) === null || _imageData$data === void 0 ? void 0 : _imageData$data.length) || 0;
                    }
                    if (length > MAX_IMAGE_SIZE_TO_STORE) {
                      pageProxy.cleanupAfterRender = true;
                    }
                  }
                  break;
                case "Pattern":
                  pageProxy.objs.resolve(id, imageData);
                  break;
                default:
                  throw new Error("Got unknown object type ".concat(type));
              }
            });
            messageHandler.on("DocProgress", function (data) {
              var _loadingTask$onProgre4;
              if (_this13.destroyed) {
                return;
              }
              (_loadingTask$onProgre4 = loadingTask.onProgress) === null || _loadingTask$onProgre4 === void 0 || _loadingTask$onProgre4.call(loadingTask, {
                loaded: data.loaded,
                total: data.total
              });
            });
            messageHandler.on("UnsupportedFeature", this._onUnsupportedFeature.bind(this));
            messageHandler.on("FetchBuiltInCMap", function (data) {
              if (_this13.destroyed) {
                return Promise.reject(new Error("Worker was destroyed."));
              }
              if (!_this13.cMapReaderFactory) {
                return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
              }
              return _this13.cMapReaderFactory.fetch(data);
            });
            messageHandler.on("FetchStandardFontData", function (data) {
              if (_this13.destroyed) {
                return Promise.reject(new Error("Worker was destroyed."));
              }
              if (!_this13.standardFontDataFactory) {
                return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
              }
              return _this13.standardFontDataFactory.fetch(data);
            });
          }
        }, {
          key: "_onUnsupportedFeature",
          value: function _onUnsupportedFeature(_ref26) {
            var _this$loadingTask$onU, _this$loadingTask;
            var featureId = _ref26.featureId;
            if (this.destroyed) {
              return;
            }
            (_this$loadingTask$onU = (_this$loadingTask = this.loadingTask).onUnsupportedFeature) === null || _this$loadingTask$onU === void 0 || _this$loadingTask$onU.call(_this$loadingTask, featureId);
          }
        }, {
          key: "getData",
          value: function getData() {
            return this.messageHandler.sendWithPromise("GetData", null);
          }
        }, {
          key: "saveDocument",
          value: function saveDocument() {
            var _this$_fullReader$fil,
              _this$_fullReader,
              _this14 = this;
            if (this.annotationStorage.size <= 0) {
              (0, _util.warn)("saveDocument called while `annotationStorage` is empty, " + "please use the getData-method instead.");
            }
            return this.messageHandler.sendWithPromise("SaveDocument", {
              isPureXfa: !!this._htmlForXfa,
              numPages: this._numPages,
              annotationStorage: this.annotationStorage.serializable,
              filename: (_this$_fullReader$fil = (_this$_fullReader = this._fullReader) === null || _this$_fullReader === void 0 ? void 0 : _this$_fullReader.filename) !== null && _this$_fullReader$fil !== void 0 ? _this$_fullReader$fil : null
            }).finally(function () {
              _this14.annotationStorage.resetModified();
            });
          }
        }, {
          key: "getPage",
          value: function getPage(pageNumber) {
            var _this15 = this;
            if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) {
              return Promise.reject(new Error("Invalid page request."));
            }
            var pageIndex = pageNumber - 1,
              cachedPromise = _classPrivateFieldLooseBase(this, _pagePromises)[_pagePromises].get(pageIndex);
            if (cachedPromise) {
              return cachedPromise;
            }
            var promise = this.messageHandler.sendWithPromise("GetPage", {
              pageIndex: pageIndex
            }).then(function (pageInfo) {
              if (_this15.destroyed) {
                throw new Error("Transport destroyed");
              }
              var page = new PDFPageProxy(pageIndex, pageInfo, _this15, _this15._params.ownerDocument, _this15._params.pdfBug);
              _classPrivateFieldLooseBase(_this15, _pageCache)[_pageCache].set(pageIndex, page);
              return page;
            });
            _classPrivateFieldLooseBase(this, _pagePromises)[_pagePromises].set(pageIndex, promise);
            return promise;
          }
        }, {
          key: "getPageIndex",
          value: function getPageIndex(ref) {
            if (_typeof(ref) !== "object" || ref === null || !Number.isInteger(ref.num) || ref.num < 0 || !Number.isInteger(ref.gen) || ref.gen < 0) {
              return Promise.reject(new Error("Invalid pageIndex request."));
            }
            return this.messageHandler.sendWithPromise("GetPageIndex", {
              num: ref.num,
              gen: ref.gen
            });
          }
        }, {
          key: "getAnnotations",
          value: function getAnnotations(pageIndex, intent) {
            return this.messageHandler.sendWithPromise("GetAnnotations", {
              pageIndex: pageIndex,
              intent: intent
            });
          }
        }, {
          key: "getFieldObjects",
          value: function getFieldObjects() {
            return _classPrivateFieldLooseBase(this, _cacheSimpleMethod)[_cacheSimpleMethod]("GetFieldObjects");
          }
        }, {
          key: "hasJSActions",
          value: function hasJSActions() {
            return _classPrivateFieldLooseBase(this, _cacheSimpleMethod)[_cacheSimpleMethod]("HasJSActions");
          }
        }, {
          key: "getCalculationOrderIds",
          value: function getCalculationOrderIds() {
            return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
          }
        }, {
          key: "getDestinations",
          value: function getDestinations() {
            return this.messageHandler.sendWithPromise("GetDestinations", null);
          }
        }, {
          key: "getDestination",
          value: function getDestination(id) {
            if (typeof id !== "string") {
              return Promise.reject(new Error("Invalid destination request."));
            }
            return this.messageHandler.sendWithPromise("GetDestination", {
              id: id
            });
          }
        }, {
          key: "getPageLabels",
          value: function getPageLabels() {
            return this.messageHandler.sendWithPromise("GetPageLabels", null);
          }
        }, {
          key: "getPageLayout",
          value: function getPageLayout() {
            return this.messageHandler.sendWithPromise("GetPageLayout", null);
          }
        }, {
          key: "getPageMode",
          value: function getPageMode() {
            return this.messageHandler.sendWithPromise("GetPageMode", null);
          }
        }, {
          key: "getViewerPreferences",
          value: function getViewerPreferences() {
            return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
          }
        }, {
          key: "getOpenAction",
          value: function getOpenAction() {
            return this.messageHandler.sendWithPromise("GetOpenAction", null);
          }
        }, {
          key: "getAttachments",
          value: function getAttachments() {
            return this.messageHandler.sendWithPromise("GetAttachments", null);
          }
        }, {
          key: "getJavaScript",
          value: function getJavaScript() {
            return this.messageHandler.sendWithPromise("GetJavaScript", null);
          }
        }, {
          key: "getDocJSActions",
          value: function getDocJSActions() {
            return this.messageHandler.sendWithPromise("GetDocJSActions", null);
          }
        }, {
          key: "getPageJSActions",
          value: function getPageJSActions(pageIndex) {
            return this.messageHandler.sendWithPromise("GetPageJSActions", {
              pageIndex: pageIndex
            });
          }
        }, {
          key: "getStructTree",
          value: function getStructTree(pageIndex) {
            return this.messageHandler.sendWithPromise("GetStructTree", {
              pageIndex: pageIndex
            });
          }
        }, {
          key: "getOutline",
          value: function getOutline() {
            return this.messageHandler.sendWithPromise("GetOutline", null);
          }
        }, {
          key: "getOptionalContentConfig",
          value: function getOptionalContentConfig() {
            return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then(function (results) {
              return new _optional_content_config.OptionalContentConfig(results);
            });
          }
        }, {
          key: "getPermissions",
          value: function getPermissions() {
            return this.messageHandler.sendWithPromise("GetPermissions", null);
          }
        }, {
          key: "getMetadata",
          value: function getMetadata() {
            var _this16 = this;
            var name = "GetMetadata",
              cachedPromise = _classPrivateFieldLooseBase(this, _methodPromises)[_methodPromises].get(name);
            if (cachedPromise) {
              return cachedPromise;
            }
            var promise = this.messageHandler.sendWithPromise(name, null).then(function (results) {
              var _this16$_fullReader$f, _this16$_fullReader, _this16$_fullReader$c, _this16$_fullReader2;
              return {
                info: results[0],
                metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
                contentDispositionFilename: (_this16$_fullReader$f = (_this16$_fullReader = _this16._fullReader) === null || _this16$_fullReader === void 0 ? void 0 : _this16$_fullReader.filename) !== null && _this16$_fullReader$f !== void 0 ? _this16$_fullReader$f : null,
                contentLength: (_this16$_fullReader$c = (_this16$_fullReader2 = _this16._fullReader) === null || _this16$_fullReader2 === void 0 ? void 0 : _this16$_fullReader2.contentLength) !== null && _this16$_fullReader$c !== void 0 ? _this16$_fullReader$c : null
              };
            });
            _classPrivateFieldLooseBase(this, _methodPromises)[_methodPromises].set(name, promise);
            return promise;
          }
        }, {
          key: "getMarkInfo",
          value: function getMarkInfo() {
            return this.messageHandler.sendWithPromise("GetMarkInfo", null);
          }
        }, {
          key: "startCleanup",
          value: function () {
            var _startCleanup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
              var keepLoadedFonts,
                _iterator12,
                _step12,
                page,
                cleanupSuccessful,
                _args4 = arguments,
                _t;
              return _regenerator().w(function (_context4) {
                while (1) switch (_context4.p = _context4.n) {
                  case 0:
                    keepLoadedFonts = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : false;
                    if (!this.destroyed) {
                      _context4.n = 1;
                      break;
                    }
                    return _context4.a(2);
                  case 1:
                    _context4.n = 2;
                    return this.messageHandler.sendWithPromise("Cleanup", null);
                  case 2:
                    _iterator12 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _pageCache)[_pageCache].values());
                    _context4.p = 3;
                    _iterator12.s();
                  case 4:
                    if ((_step12 = _iterator12.n()).done) {
                      _context4.n = 6;
                      break;
                    }
                    page = _step12.value;
                    cleanupSuccessful = page.cleanup();
                    if (cleanupSuccessful) {
                      _context4.n = 5;
                      break;
                    }
                    throw new Error("startCleanup: Page ".concat(page.pageNumber, " is currently rendering."));
                  case 5:
                    _context4.n = 4;
                    break;
                  case 6:
                    _context4.n = 8;
                    break;
                  case 7:
                    _context4.p = 7;
                    _t = _context4.v;
                    _iterator12.e(_t);
                  case 8:
                    _context4.p = 8;
                    _iterator12.f();
                    return _context4.f(8);
                  case 9:
                    this.commonObjs.clear();
                    if (!keepLoadedFonts) {
                      this.fontLoader.clear();
                    }
                    _classPrivateFieldLooseBase(this, _methodPromises)[_methodPromises].clear();
                  case 10:
                    return _context4.a(2);
                }
              }, _callee4, this, [[3, 7, 8, 9]]);
            }));
            function startCleanup() {
              return _startCleanup.apply(this, arguments);
            }
            return startCleanup;
          }()
        }, {
          key: "loadingParams",
          get: function get() {
            var _this$_params = this._params,
              disableAutoFetch = _this$_params.disableAutoFetch,
              enableXfa = _this$_params.enableXfa;
            return (0, _util.shadow)(this, "loadingParams", {
              disableAutoFetch: disableAutoFetch,
              enableXfa: enableXfa
            });
          }
        }]);
      }();
      function _cacheSimpleMethod2(name) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var cachedPromise = _classPrivateFieldLooseBase(this, _methodPromises)[_methodPromises].get(name);
        if (cachedPromise) {
          return cachedPromise;
        }
        var promise = this.messageHandler.sendWithPromise(name, data);
        _classPrivateFieldLooseBase(this, _methodPromises)[_methodPromises].set(name, promise);
        return promise;
      }
      var _objs = /*#__PURE__*/_classPrivateFieldLooseKey("objs");
      var _ensureObj = /*#__PURE__*/_classPrivateFieldLooseKey("ensureObj");
      var PDFObjects = /*#__PURE__*/function () {
        function PDFObjects() {
          _classCallCheck(this, PDFObjects);
          Object.defineProperty(this, _ensureObj, {
            value: _ensureObj2
          });
          Object.defineProperty(this, _objs, {
            writable: true,
            value: Object.create(null)
          });
        }
        return _createClass(PDFObjects, [{
          key: "get",
          value: function get(objId) {
            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            if (callback) {
              var _obj = _classPrivateFieldLooseBase(this, _ensureObj)[_ensureObj](objId);
              _obj.capability.promise.then(function () {
                return callback(_obj.data);
              });
              return null;
            }
            var obj = _classPrivateFieldLooseBase(this, _objs)[_objs][objId];
            if (!(obj !== null && obj !== void 0 && obj.capability.settled)) {
              throw new Error("Requesting object that isn't resolved yet ".concat(objId, "."));
            }
            return obj.data;
          }
        }, {
          key: "has",
          value: function has(objId) {
            var obj = _classPrivateFieldLooseBase(this, _objs)[_objs][objId];
            return (obj === null || obj === void 0 ? void 0 : obj.capability.settled) || false;
          }
        }, {
          key: "resolve",
          value: function resolve(objId) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var obj = _classPrivateFieldLooseBase(this, _ensureObj)[_ensureObj](objId);
            obj.data = data;
            obj.capability.resolve();
          }
        }, {
          key: "clear",
          value: function clear() {
            for (var objId in _classPrivateFieldLooseBase(this, _objs)[_objs]) {
              var _data$bitmap;
              var data = _classPrivateFieldLooseBase(this, _objs)[_objs][objId].data;
              data === null || data === void 0 || (_data$bitmap = data.bitmap) === null || _data$bitmap === void 0 || _data$bitmap.close();
            }
            _classPrivateFieldLooseBase(this, _objs)[_objs] = Object.create(null);
          }
        }]);
      }();
      function _ensureObj2(objId) {
        var obj = _classPrivateFieldLooseBase(this, _objs)[_objs][objId];
        if (obj) {
          return obj;
        }
        return _classPrivateFieldLooseBase(this, _objs)[_objs][objId] = {
          capability: (0, _util.createPromiseCapability)(),
          data: null
        };
      }
      var _internalRenderTask = /*#__PURE__*/_classPrivateFieldLooseKey("internalRenderTask");
      var RenderTask = /*#__PURE__*/function () {
        function RenderTask(internalRenderTask) {
          _classCallCheck(this, RenderTask);
          Object.defineProperty(this, _internalRenderTask, {
            writable: true,
            value: null
          });
          _classPrivateFieldLooseBase(this, _internalRenderTask)[_internalRenderTask] = internalRenderTask;
          this.onContinue = null;
        }
        return _createClass(RenderTask, [{
          key: "promise",
          get: function get() {
            return _classPrivateFieldLooseBase(this, _internalRenderTask)[_internalRenderTask].capability.promise;
          }
        }, {
          key: "cancel",
          value: function cancel() {
            var extraDelay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            _classPrivateFieldLooseBase(this, _internalRenderTask)[_internalRenderTask].cancel(null, extraDelay);
          }
        }, {
          key: "separateAnnots",
          get: function get() {
            var separateAnnots = _classPrivateFieldLooseBase(this, _internalRenderTask)[_internalRenderTask].operatorList.separateAnnots;
            if (!separateAnnots) {
              return false;
            }
            var annotationCanvasMap = _classPrivateFieldLooseBase(this, _internalRenderTask)[_internalRenderTask].annotationCanvasMap;
            return separateAnnots.form || separateAnnots.canvas && (annotationCanvasMap === null || annotationCanvasMap === void 0 ? void 0 : annotationCanvasMap.size) > 0;
          }
        }]);
      }();
      exports.RenderTask = RenderTask;
      var _canvasInUse = /*#__PURE__*/_classPrivateFieldLooseKey("canvasInUse");
      var InternalRenderTask = /*#__PURE__*/function () {
        function InternalRenderTask(_ref27) {
          var callback = _ref27.callback,
            params = _ref27.params,
            objs = _ref27.objs,
            commonObjs = _ref27.commonObjs,
            annotationCanvasMap = _ref27.annotationCanvasMap,
            operatorList = _ref27.operatorList,
            pageIndex = _ref27.pageIndex,
            canvasFactory = _ref27.canvasFactory,
            _ref27$useRequestAnim = _ref27.useRequestAnimationFrame,
            useRequestAnimationFrame = _ref27$useRequestAnim === void 0 ? false : _ref27$useRequestAnim,
            _ref27$pdfBug = _ref27.pdfBug,
            pdfBug = _ref27$pdfBug === void 0 ? false : _ref27$pdfBug,
            _ref27$pageColors = _ref27.pageColors,
            pageColors = _ref27$pageColors === void 0 ? null : _ref27$pageColors;
          _classCallCheck(this, InternalRenderTask);
          this.callback = callback;
          this.params = params;
          this.objs = objs;
          this.commonObjs = commonObjs;
          this.annotationCanvasMap = annotationCanvasMap;
          this.operatorListIdx = null;
          this.operatorList = operatorList;
          this._pageIndex = pageIndex;
          this.canvasFactory = canvasFactory;
          this._pdfBug = pdfBug;
          this.pageColors = pageColors;
          this.running = false;
          this.graphicsReadyCallback = null;
          this.graphicsReady = false;
          this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
          this.cancelled = false;
          this.capability = (0, _util.createPromiseCapability)();
          this.task = new RenderTask(this);
          this._cancelBound = this.cancel.bind(this);
          this._continueBound = this._continue.bind(this);
          this._scheduleNextBound = this._scheduleNext.bind(this);
          this._nextBound = this._next.bind(this);
          this._canvas = params.canvasContext.canvas;
        }
        return _createClass(InternalRenderTask, [{
          key: "completed",
          get: function get() {
            return this.capability.promise.catch(function () {});
          }
        }, {
          key: "initializeGraphics",
          value: function initializeGraphics(_ref28) {
            var _globalThis$StepperMa, _this$graphicsReadyCa;
            var _ref28$transparency = _ref28.transparency,
              transparency = _ref28$transparency === void 0 ? false : _ref28$transparency,
              optionalContentConfig = _ref28.optionalContentConfig;
            if (this.cancelled) {
              return;
            }
            if (this._canvas) {
              if (_classPrivateFieldLooseBase(InternalRenderTask, _canvasInUse)[_canvasInUse].has(this._canvas)) {
                throw new Error("Cannot use the same canvas during multiple render() operations. " + "Use different canvas or ensure previous operations were " + "cancelled or completed.");
              }
              _classPrivateFieldLooseBase(InternalRenderTask, _canvasInUse)[_canvasInUse].add(this._canvas);
            }
            if (this._pdfBug && (_globalThis$StepperMa = globalThis.StepperManager) !== null && _globalThis$StepperMa !== void 0 && _globalThis$StepperMa.enabled) {
              this.stepper = globalThis.StepperManager.create(this._pageIndex);
              this.stepper.init(this.operatorList);
              this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
            }
            var _this$params = this.params,
              canvasContext = _this$params.canvasContext,
              viewport = _this$params.viewport,
              transform = _this$params.transform,
              background = _this$params.background;
            this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, {
              optionalContentConfig: optionalContentConfig
            }, this.annotationCanvasMap, this.pageColors);
            this.gfx.beginDrawing({
              transform: transform,
              viewport: viewport,
              transparency: transparency,
              background: background
            });
            this.operatorListIdx = 0;
            this.graphicsReady = true;
            (_this$graphicsReadyCa = this.graphicsReadyCallback) === null || _this$graphicsReadyCa === void 0 || _this$graphicsReadyCa.call(this);
          }
        }, {
          key: "cancel",
          value: function cancel() {
            var _this$gfx;
            var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var extraDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            this.running = false;
            this.cancelled = true;
            (_this$gfx = this.gfx) === null || _this$gfx === void 0 || _this$gfx.endDrawing();
            if (this._canvas) {
              _classPrivateFieldLooseBase(InternalRenderTask, _canvasInUse)[_canvasInUse].delete(this._canvas);
            }
            this.callback(error || new _display_utils.RenderingCancelledException("Rendering cancelled, page ".concat(this._pageIndex + 1), "canvas", extraDelay));
          }
        }, {
          key: "operatorListChanged",
          value: function operatorListChanged() {
            var _this$stepper;
            if (!this.graphicsReady) {
              if (!this.graphicsReadyCallback) {
                this.graphicsReadyCallback = this._continueBound;
              }
              return;
            }
            (_this$stepper = this.stepper) === null || _this$stepper === void 0 || _this$stepper.updateOperatorList(this.operatorList);
            if (this.running) {
              return;
            }
            this._continue();
          }
        }, {
          key: "_continue",
          value: function _continue() {
            this.running = true;
            if (this.cancelled) {
              return;
            }
            if (this.task.onContinue) {
              this.task.onContinue(this._scheduleNextBound);
            } else {
              this._scheduleNext();
            }
          }
        }, {
          key: "_scheduleNext",
          value: function _scheduleNext() {
            var _this17 = this;
            if (this._useRequestAnimationFrame) {
              window.requestAnimationFrame(function () {
                _this17._nextBound().catch(_this17._cancelBound);
              });
            } else {
              Promise.resolve().then(this._nextBound).catch(this._cancelBound);
            }
          }
        }, {
          key: "_next",
          value: function () {
            var _next2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
              return _regenerator().w(function (_context5) {
                while (1) switch (_context5.n) {
                  case 0:
                    if (!this.cancelled) {
                      _context5.n = 1;
                      break;
                    }
                    return _context5.a(2);
                  case 1:
                    this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
                    if (this.operatorListIdx === this.operatorList.argsArray.length) {
                      this.running = false;
                      if (this.operatorList.lastChunk) {
                        this.gfx.endDrawing();
                        if (this._canvas) {
                          _classPrivateFieldLooseBase(InternalRenderTask, _canvasInUse)[_canvasInUse].delete(this._canvas);
                        }
                        this.callback();
                      }
                    }
                  case 2:
                    return _context5.a(2);
                }
              }, _callee5, this);
            }));
            function _next() {
              return _next2.apply(this, arguments);
            }
            return _next;
          }()
        }]);
      }();
      Object.defineProperty(InternalRenderTask, _canvasInUse, {
        writable: true,
        value: new WeakSet()
      });
      var version = '3.4.120';
      exports.version = version;
      var build = 'af6414988';
      exports.build = build;

      /***/
    }), (/* 3 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PrintAnnotationStorage = exports.AnnotationStorage = void 0;
      var _util = __w_pdfjs_require__(1);
      var _editor = __w_pdfjs_require__(4);
      var _murmurhash = __w_pdfjs_require__(8);
      var _modified = /*#__PURE__*/_classPrivateFieldLooseKey("modified");
      var _storage = /*#__PURE__*/_classPrivateFieldLooseKey("storage");
      var _setModified = /*#__PURE__*/_classPrivateFieldLooseKey("setModified");
      var AnnotationStorage = /*#__PURE__*/function () {
        function AnnotationStorage() {
          _classCallCheck(this, AnnotationStorage);
          Object.defineProperty(this, _setModified, {
            value: _setModified2
          });
          Object.defineProperty(this, _modified, {
            writable: true,
            value: false
          });
          Object.defineProperty(this, _storage, {
            writable: true,
            value: new Map()
          });
          this.onSetModified = null;
          this.onResetModified = null;
          this.onAnnotationEditor = null;
        }
        return _createClass(AnnotationStorage, [{
          key: "getValue",
          value: function getValue(key, defaultValue) {
            var value = _classPrivateFieldLooseBase(this, _storage)[_storage].get(key);
            if (value === undefined) {
              return defaultValue;
            }
            return Object.assign(defaultValue, value);
          }
        }, {
          key: "getRawValue",
          value: function getRawValue(key) {
            return _classPrivateFieldLooseBase(this, _storage)[_storage].get(key);
          }
        }, {
          key: "remove",
          value: function remove(key) {
            _classPrivateFieldLooseBase(this, _storage)[_storage].delete(key);
            if (_classPrivateFieldLooseBase(this, _storage)[_storage].size === 0) {
              this.resetModified();
            }
            if (typeof this.onAnnotationEditor === "function") {
              var _iterator13 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _storage)[_storage].values()),
                _step13;
              try {
                for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                  var value = _step13.value;
                  if (value instanceof _editor.AnnotationEditor) {
                    return;
                  }
                }
              } catch (err) {
                _iterator13.e(err);
              } finally {
                _iterator13.f();
              }
              this.onAnnotationEditor(null);
            }
          }
        }, {
          key: "setValue",
          value: function setValue(key, value) {
            var obj = _classPrivateFieldLooseBase(this, _storage)[_storage].get(key);
            var modified = false;
            if (obj !== undefined) {
              for (var _i = 0, _Object$entries = Object.entries(value); _i < _Object$entries.length; _i++) {
                var _ref29 = _Object$entries[_i];
                var _ref30 = _slicedToArray(_ref29, 2);
                var entry = _ref30[0];
                var val = _ref30[1];
                if (obj[entry] !== val) {
                  modified = true;
                  obj[entry] = val;
                }
              }
            } else {
              modified = true;
              _classPrivateFieldLooseBase(this, _storage)[_storage].set(key, value);
            }
            if (modified) {
              _classPrivateFieldLooseBase(this, _setModified)[_setModified]();
            }
            if (value instanceof _editor.AnnotationEditor && typeof this.onAnnotationEditor === "function") {
              this.onAnnotationEditor(value.constructor._type);
            }
          }
        }, {
          key: "has",
          value: function has(key) {
            return _classPrivateFieldLooseBase(this, _storage)[_storage].has(key);
          }
        }, {
          key: "getAll",
          value: function getAll() {
            return _classPrivateFieldLooseBase(this, _storage)[_storage].size > 0 ? (0, _util.objectFromMap)(_classPrivateFieldLooseBase(this, _storage)[_storage]) : null;
          }
        }, {
          key: "setAll",
          value: function setAll(obj) {
            for (var _i2 = 0, _Object$entries2 = Object.entries(obj); _i2 < _Object$entries2.length; _i2++) {
              var _ref31 = _Object$entries2[_i2];
              var _ref32 = _slicedToArray(_ref31, 2);
              var key = _ref32[0];
              var val = _ref32[1];
              this.setValue(key, val);
            }
          }
        }, {
          key: "size",
          get: function get() {
            return _classPrivateFieldLooseBase(this, _storage)[_storage].size;
          }
        }, {
          key: "resetModified",
          value: function resetModified() {
            if (_classPrivateFieldLooseBase(this, _modified)[_modified]) {
              _classPrivateFieldLooseBase(this, _modified)[_modified] = false;
              if (typeof this.onResetModified === "function") {
                this.onResetModified();
              }
            }
          }
        }, {
          key: "print",
          get: function get() {
            return new PrintAnnotationStorage(this);
          }
        }, {
          key: "serializable",
          get: function get() {
            if (_classPrivateFieldLooseBase(this, _storage)[_storage].size === 0) {
              return null;
            }
            var clone = new Map();
            var _iterator14 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _storage)[_storage]),
              _step14;
            try {
              for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                var _ref33 = _step14.value;
                var _ref34 = _slicedToArray(_ref33, 2);
                var key = _ref34[0];
                var val = _ref34[1];
                var serialized = val instanceof _editor.AnnotationEditor ? val.serialize() : val;
                if (serialized) {
                  clone.set(key, serialized);
                }
              }
            } catch (err) {
              _iterator14.e(err);
            } finally {
              _iterator14.f();
            }
            return clone;
          }
        }], [{
          key: "getHash",
          value: function getHash(map) {
            if (!map) {
              return "";
            }
            var hash = new _murmurhash.MurmurHash3_64();
            var _iterator15 = _createForOfIteratorHelper(map),
              _step15;
            try {
              for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                var _ref35 = _step15.value;
                var _ref36 = _slicedToArray(_ref35, 2);
                var key = _ref36[0];
                var val = _ref36[1];
                hash.update("".concat(key, ":").concat(JSON.stringify(val)));
              }
            } catch (err) {
              _iterator15.e(err);
            } finally {
              _iterator15.f();
            }
            return hash.hexdigest();
          }
        }]);
      }();
      function _setModified2() {
        if (!_classPrivateFieldLooseBase(this, _modified)[_modified]) {
          _classPrivateFieldLooseBase(this, _modified)[_modified] = true;
          if (typeof this.onSetModified === "function") {
            this.onSetModified();
          }
        }
      }
      exports.AnnotationStorage = AnnotationStorage;
      var _serializable = /*#__PURE__*/_classPrivateFieldLooseKey("serializable");
      var PrintAnnotationStorage = /*#__PURE__*/function (_AnnotationStorage2) {
        function PrintAnnotationStorage(parent) {
          var _this18;
          _classCallCheck(this, PrintAnnotationStorage);
          _this18 = _callSuper(this, PrintAnnotationStorage);
          Object.defineProperty(_this18, _serializable, {
            writable: true,
            value: null
          });
          _classPrivateFieldLooseBase(_this18, _serializable)[_serializable] = structuredClone(parent.serializable);
          return _this18;
        }
        _inherits(PrintAnnotationStorage, _AnnotationStorage2);
        return _createClass(PrintAnnotationStorage, [{
          key: "print",
          get: function get() {
            (0, _util.unreachable)("Should not call PrintAnnotationStorage.print");
          }
        }, {
          key: "serializable",
          get: function get() {
            return _classPrivateFieldLooseBase(this, _serializable)[_serializable];
          }
        }]);
      }(AnnotationStorage);
      exports.PrintAnnotationStorage = PrintAnnotationStorage;

      /***/
    }), (/* 4 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.AnnotationEditor = void 0;
      var _tools = __w_pdfjs_require__(5);
      var _util = __w_pdfjs_require__(1);
      var _boundFocusin = /*#__PURE__*/_classPrivateFieldLooseKey("boundFocusin");
      var _boundFocusout = /*#__PURE__*/_classPrivateFieldLooseKey("boundFocusout");
      var _hasBeenSelected = /*#__PURE__*/_classPrivateFieldLooseKey("hasBeenSelected");
      var _isEditing = /*#__PURE__*/_classPrivateFieldLooseKey("isEditing");
      var _isInEditMode = /*#__PURE__*/_classPrivateFieldLooseKey("isInEditMode");
      var _zIndex = /*#__PURE__*/_classPrivateFieldLooseKey("zIndex");
      var AnnotationEditor = /*#__PURE__*/function () {
        function AnnotationEditor(parameters) {
          _classCallCheck(this, AnnotationEditor);
          Object.defineProperty(this, _boundFocusin, {
            writable: true,
            value: this.focusin.bind(this)
          });
          Object.defineProperty(this, _boundFocusout, {
            writable: true,
            value: this.focusout.bind(this)
          });
          Object.defineProperty(this, _hasBeenSelected, {
            writable: true,
            value: false
          });
          Object.defineProperty(this, _isEditing, {
            writable: true,
            value: false
          });
          Object.defineProperty(this, _isInEditMode, {
            writable: true,
            value: false
          });
          this._uiManager = null;
          Object.defineProperty(this, _zIndex, {
            writable: true,
            value: AnnotationEditor._zIndex++
          });
          if (this.constructor === AnnotationEditor) {
            (0, _util.unreachable)("Cannot initialize AnnotationEditor.");
          }
          this.parent = parameters.parent;
          this.id = parameters.id;
          this.width = this.height = null;
          this.pageIndex = parameters.parent.pageIndex;
          this.name = parameters.name;
          this.div = null;
          this._uiManager = parameters.uiManager;
          var _this$parent$viewport = this.parent.viewport,
            rotation = _this$parent$viewport.rotation,
            _this$parent$viewport2 = _this$parent$viewport.rawDims,
            pageWidth = _this$parent$viewport2.pageWidth,
            pageHeight = _this$parent$viewport2.pageHeight,
            pageX = _this$parent$viewport2.pageX,
            pageY = _this$parent$viewport2.pageY;
          this.rotation = rotation;
          this.pageDimensions = [pageWidth, pageHeight];
          this.pageTranslation = [pageX, pageY];
          var _this$parentDimension = _slicedToArray(this.parentDimensions, 2),
            width = _this$parentDimension[0],
            height = _this$parentDimension[1];
          this.x = parameters.x / width;
          this.y = parameters.y / height;
          this.isAttachedToDOM = false;
        }
        return _createClass(AnnotationEditor, [{
          key: "addCommands",
          value: function addCommands(params) {
            this._uiManager.addCommands(params);
          }
        }, {
          key: "currentLayer",
          get: function get() {
            return this._uiManager.currentLayer;
          }
        }, {
          key: "setInBackground",
          value: function setInBackground() {
            this.div.style.zIndex = 0;
          }
        }, {
          key: "setInForeground",
          value: function setInForeground() {
            this.div.style.zIndex = _classPrivateFieldLooseBase(this, _zIndex)[_zIndex];
          }
        }, {
          key: "setParent",
          value: function setParent(parent) {
            if (parent !== null) {
              this.pageIndex = parent.pageIndex;
              this.pageDimensions = parent.pageDimensions;
            }
            this.parent = parent;
          }
        }, {
          key: "focusin",
          value: function focusin(event) {
            if (!_classPrivateFieldLooseBase(this, _hasBeenSelected)[_hasBeenSelected]) {
              this.parent.setSelected(this);
            } else {
              _classPrivateFieldLooseBase(this, _hasBeenSelected)[_hasBeenSelected] = false;
            }
          }
        }, {
          key: "focusout",
          value: function focusout(event) {
            var _this$parent;
            if (!this.isAttachedToDOM) {
              return;
            }
            var target = event.relatedTarget;
            if (target !== null && target !== void 0 && target.closest("#".concat(this.id))) {
              return;
            }
            event.preventDefault();
            if (!((_this$parent = this.parent) !== null && _this$parent !== void 0 && _this$parent.isMultipleSelection)) {
              this.commitOrRemove();
            }
          }
        }, {
          key: "commitOrRemove",
          value: function commitOrRemove() {
            if (this.isEmpty()) {
              this.remove();
            } else {
              this.commit();
            }
          }
        }, {
          key: "commit",
          value: function commit() {
            this.addToAnnotationStorage();
          }
        }, {
          key: "addToAnnotationStorage",
          value: function addToAnnotationStorage() {
            this._uiManager.addToAnnotationStorage(this);
          }
        }, {
          key: "dragstart",
          value: function dragstart(event) {
            var rect = this.parent.div.getBoundingClientRect();
            this.startX = event.clientX - rect.x;
            this.startY = event.clientY - rect.y;
            event.dataTransfer.setData("text/plain", this.id);
            event.dataTransfer.effectAllowed = "move";
          }
        }, {
          key: "setAt",
          value: function setAt(x, y, tx, ty) {
            var _this$parentDimension2 = _slicedToArray(this.parentDimensions, 2),
              width = _this$parentDimension2[0],
              height = _this$parentDimension2[1];
            var _this$screenToPageTra = this.screenToPageTranslation(tx, ty);
            var _this$screenToPageTra2 = _slicedToArray(_this$screenToPageTra, 2);
            tx = _this$screenToPageTra2[0];
            ty = _this$screenToPageTra2[1];
            this.x = (x + tx) / width;
            this.y = (y + ty) / height;
            this.div.style.left = "".concat(100 * this.x, "%");
            this.div.style.top = "".concat(100 * this.y, "%");
          }
        }, {
          key: "translate",
          value: function translate(x, y) {
            var _this$parentDimension3 = _slicedToArray(this.parentDimensions, 2),
              width = _this$parentDimension3[0],
              height = _this$parentDimension3[1];
            var _this$screenToPageTra3 = this.screenToPageTranslation(x, y);
            var _this$screenToPageTra4 = _slicedToArray(_this$screenToPageTra3, 2);
            x = _this$screenToPageTra4[0];
            y = _this$screenToPageTra4[1];
            this.x += x / width;
            this.y += y / height;
            this.div.style.left = "".concat(100 * this.x, "%");
            this.div.style.top = "".concat(100 * this.y, "%");
          }
        }, {
          key: "screenToPageTranslation",
          value: function screenToPageTranslation(x, y) {
            switch (this.parentRotation) {
              case 90:
                return [y, -x];
              case 180:
                return [-x, -y];
              case 270:
                return [-y, x];
              default:
                return [x, y];
            }
          }
        }, {
          key: "parentScale",
          get: function get() {
            return this._uiManager.viewParameters.realScale;
          }
        }, {
          key: "parentRotation",
          get: function get() {
            return this._uiManager.viewParameters.rotation;
          }
        }, {
          key: "parentDimensions",
          get: function get() {
            var realScale = this._uiManager.viewParameters.realScale;
            var _this$pageDimensions = _slicedToArray(this.pageDimensions, 2),
              pageWidth = _this$pageDimensions[0],
              pageHeight = _this$pageDimensions[1];
            return [pageWidth * realScale, pageHeight * realScale];
          }
        }, {
          key: "setDims",
          value: function setDims(width, height) {
            var _this$parentDimension4 = _slicedToArray(this.parentDimensions, 2),
              parentWidth = _this$parentDimension4[0],
              parentHeight = _this$parentDimension4[1];
            this.div.style.width = "".concat(100 * width / parentWidth, "%");
            this.div.style.height = "".concat(100 * height / parentHeight, "%");
          }
        }, {
          key: "fixDims",
          value: function fixDims() {
            var style = this.div.style;
            var height = style.height,
              width = style.width;
            var widthPercent = width.endsWith("%");
            var heightPercent = height.endsWith("%");
            if (widthPercent && heightPercent) {
              return;
            }
            var _this$parentDimension5 = _slicedToArray(this.parentDimensions, 2),
              parentWidth = _this$parentDimension5[0],
              parentHeight = _this$parentDimension5[1];
            if (!widthPercent) {
              style.width = "".concat(100 * parseFloat(width) / parentWidth, "%");
            }
            if (!heightPercent) {
              style.height = "".concat(100 * parseFloat(height) / parentHeight, "%");
            }
          }
        }, {
          key: "getInitialTranslation",
          value: function getInitialTranslation() {
            return [0, 0];
          }
        }, {
          key: "render",
          value: function render() {
            this.div = document.createElement("div");
            this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
            this.div.className = this.name;
            this.div.setAttribute("id", this.id);
            this.div.setAttribute("tabIndex", 0);
            this.setInForeground();
            this.div.addEventListener("focusin", _classPrivateFieldLooseBase(this, _boundFocusin)[_boundFocusin]);
            this.div.addEventListener("focusout", _classPrivateFieldLooseBase(this, _boundFocusout)[_boundFocusout]);
            var _this$getInitialTrans = this.getInitialTranslation(),
              _this$getInitialTrans2 = _slicedToArray(_this$getInitialTrans, 2),
              tx = _this$getInitialTrans2[0],
              ty = _this$getInitialTrans2[1];
            this.translate(tx, ty);
            (0, _tools.bindEvents)(this, this.div, ["dragstart", "pointerdown"]);
            return this.div;
          }
        }, {
          key: "pointerdown",
          value: function pointerdown(event) {
            var isMac = _util.FeatureTest.platform.isMac;
            if (event.button !== 0 || event.ctrlKey && isMac) {
              event.preventDefault();
              return;
            }
            if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) {
              this.parent.toggleSelected(this);
            } else {
              this.parent.setSelected(this);
            }
            _classPrivateFieldLooseBase(this, _hasBeenSelected)[_hasBeenSelected] = true;
          }
        }, {
          key: "getRect",
          value: function getRect(tx, ty) {
            var scale = this.parentScale;
            var _this$pageDimensions2 = _slicedToArray(this.pageDimensions, 2),
              pageWidth = _this$pageDimensions2[0],
              pageHeight = _this$pageDimensions2[1];
            var _this$pageTranslation = _slicedToArray(this.pageTranslation, 2),
              pageX = _this$pageTranslation[0],
              pageY = _this$pageTranslation[1];
            var shiftX = tx / scale;
            var shiftY = ty / scale;
            var x = this.x * pageWidth;
            var y = this.y * pageHeight;
            var width = this.width * pageWidth;
            var height = this.height * pageHeight;
            switch (this.rotation) {
              case 0:
                return [x + shiftX + pageX, pageHeight - y - shiftY - height + pageY, x + shiftX + width + pageX, pageHeight - y - shiftY + pageY];
              case 90:
                return [x + shiftY + pageX, pageHeight - y + shiftX + pageY, x + shiftY + height + pageX, pageHeight - y + shiftX + width + pageY];
              case 180:
                return [x - shiftX - width + pageX, pageHeight - y + shiftY + pageY, x - shiftX + pageX, pageHeight - y + shiftY + height + pageY];
              case 270:
                return [x - shiftY - height + pageX, pageHeight - y - shiftX - width + pageY, x - shiftY + pageX, pageHeight - y - shiftX + pageY];
              default:
                throw new Error("Invalid rotation");
            }
          }
        }, {
          key: "getRectInCurrentCoords",
          value: function getRectInCurrentCoords(rect, pageHeight) {
            var _rect = _slicedToArray(rect, 4),
              x1 = _rect[0],
              y1 = _rect[1],
              x2 = _rect[2],
              y2 = _rect[3];
            var width = x2 - x1;
            var height = y2 - y1;
            switch (this.rotation) {
              case 0:
                return [x1, pageHeight - y2, width, height];
              case 90:
                return [x1, pageHeight - y1, height, width];
              case 180:
                return [x2, pageHeight - y1, width, height];
              case 270:
                return [x2, pageHeight - y2, height, width];
              default:
                throw new Error("Invalid rotation");
            }
          }
        }, {
          key: "onceAdded",
          value: function onceAdded() {}
        }, {
          key: "isEmpty",
          value: function isEmpty() {
            return false;
          }
        }, {
          key: "enableEditMode",
          value: function enableEditMode() {
            _classPrivateFieldLooseBase(this, _isInEditMode)[_isInEditMode] = true;
          }
        }, {
          key: "disableEditMode",
          value: function disableEditMode() {
            _classPrivateFieldLooseBase(this, _isInEditMode)[_isInEditMode] = false;
          }
        }, {
          key: "isInEditMode",
          value: function isInEditMode() {
            return _classPrivateFieldLooseBase(this, _isInEditMode)[_isInEditMode];
          }
        }, {
          key: "shouldGetKeyboardEvents",
          value: function shouldGetKeyboardEvents() {
            return false;
          }
        }, {
          key: "needsToBeRebuilt",
          value: function needsToBeRebuilt() {
            return this.div && !this.isAttachedToDOM;
          }
        }, {
          key: "rebuild",
          value: function rebuild() {
            var _this$div;
            (_this$div = this.div) === null || _this$div === void 0 || _this$div.addEventListener("focusin", _classPrivateFieldLooseBase(this, _boundFocusin)[_boundFocusin]);
          }
        }, {
          key: "serialize",
          value: function serialize() {
            (0, _util.unreachable)("An editor must be serializable");
          }
        }, {
          key: "remove",
          value: function remove() {
            this.div.removeEventListener("focusin", _classPrivateFieldLooseBase(this, _boundFocusin)[_boundFocusin]);
            this.div.removeEventListener("focusout", _classPrivateFieldLooseBase(this, _boundFocusout)[_boundFocusout]);
            if (!this.isEmpty()) {
              this.commit();
            }
            this.parent.remove(this);
          }
        }, {
          key: "select",
          value: function select() {
            var _this$div2;
            (_this$div2 = this.div) === null || _this$div2 === void 0 || _this$div2.classList.add("selectedEditor");
          }
        }, {
          key: "unselect",
          value: function unselect() {
            var _this$div3;
            (_this$div3 = this.div) === null || _this$div3 === void 0 || _this$div3.classList.remove("selectedEditor");
          }
        }, {
          key: "updateParams",
          value: function updateParams(type, value) {}
        }, {
          key: "disableEditing",
          value: function disableEditing() {}
        }, {
          key: "enableEditing",
          value: function enableEditing() {}
        }, {
          key: "propertiesToUpdate",
          get: function get() {
            return {};
          }
        }, {
          key: "contentDiv",
          get: function get() {
            return this.div;
          }
        }, {
          key: "isEditing",
          get: function get() {
            return _classPrivateFieldLooseBase(this, _isEditing)[_isEditing];
          },
          set: function set(value) {
            _classPrivateFieldLooseBase(this, _isEditing)[_isEditing] = value;
            if (value) {
              this.parent.setSelected(this);
              this.parent.setActiveEditor(this);
            } else {
              this.parent.setActiveEditor(null);
            }
          }
        }], [{
          key: "_defaultLineColor",
          get: function get() {
            return (0, _util.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
          }
        }, {
          key: "deserialize",
          value: function deserialize(data, parent, uiManager) {
            var editor = new this.prototype.constructor({
              parent: parent,
              id: parent.getNextId(),
              uiManager: uiManager
            });
            editor.rotation = data.rotation;
            var _editor$pageDimension = _slicedToArray(editor.pageDimensions, 2),
              pageWidth = _editor$pageDimension[0],
              pageHeight = _editor$pageDimension[1];
            var _editor$getRectInCurr = editor.getRectInCurrentCoords(data.rect, pageHeight),
              _editor$getRectInCurr2 = _slicedToArray(_editor$getRectInCurr, 4),
              x = _editor$getRectInCurr2[0],
              y = _editor$getRectInCurr2[1],
              width = _editor$getRectInCurr2[2],
              height = _editor$getRectInCurr2[3];
            editor.x = x / pageWidth;
            editor.y = y / pageHeight;
            editor.width = width / pageWidth;
            editor.height = height / pageHeight;
            return editor;
          }
        }]);
      }();
      AnnotationEditor._colorManager = new _tools.ColorManager();
      AnnotationEditor._zIndex = 1;
      exports.AnnotationEditor = AnnotationEditor;

      /***/
    }), (/* 5 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      var _AnnotationEditorUIManager;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.KeyboardManager = exports.CommandManager = exports.ColorManager = exports.AnnotationEditorUIManager = void 0;
      exports.bindEvents = bindEvents;
      exports.opacityToHex = opacityToHex;
      var _util = __w_pdfjs_require__(1);
      var _display_utils = __w_pdfjs_require__(6);
      function bindEvents(obj, element, names) {
        var _iterator16 = _createForOfIteratorHelper(names),
          _step16;
        try {
          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
            var name = _step16.value;
            element.addEventListener(name, obj[name].bind(obj));
          }
        } catch (err) {
          _iterator16.e(err);
        } finally {
          _iterator16.f();
        }
      }
      function opacityToHex(opacity) {
        return Math.round(Math.min(255, Math.max(1, 255 * opacity))).toString(16).padStart(2, "0");
      }
      var _id = /*#__PURE__*/_classPrivateFieldLooseKey("id");
      var IdManager = /*#__PURE__*/function () {
        function IdManager() {
          _classCallCheck(this, IdManager);
          Object.defineProperty(this, _id, {
            writable: true,
            value: 0
          });
        }
        return _createClass(IdManager, [{
          key: "getId",
          value: function getId() {
            return "".concat(_util.AnnotationEditorPrefix).concat(_classPrivateFieldLooseBase(this, _id)[_id]++);
          }
        }]);
      }();
      var _commands = /*#__PURE__*/_classPrivateFieldLooseKey("commands");
      var _locked = /*#__PURE__*/_classPrivateFieldLooseKey("locked");
      var _maxSize = /*#__PURE__*/_classPrivateFieldLooseKey("maxSize");
      var _position = /*#__PURE__*/_classPrivateFieldLooseKey("position");
      var CommandManager = /*#__PURE__*/function () {
        function CommandManager() {
          var maxSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 128;
          _classCallCheck(this, CommandManager);
          Object.defineProperty(this, _commands, {
            writable: true,
            value: []
          });
          Object.defineProperty(this, _locked, {
            writable: true,
            value: false
          });
          Object.defineProperty(this, _maxSize, {
            writable: true,
            value: void 0
          });
          Object.defineProperty(this, _position, {
            writable: true,
            value: -1
          });
          _classPrivateFieldLooseBase(this, _maxSize)[_maxSize] = maxSize;
        }
        return _createClass(CommandManager, [{
          key: "add",
          value: function add(_ref37) {
            var cmd = _ref37.cmd,
              undo = _ref37.undo,
              mustExec = _ref37.mustExec,
              _ref37$type = _ref37.type,
              type = _ref37$type === void 0 ? NaN : _ref37$type,
              _ref37$overwriteIfSam = _ref37.overwriteIfSameType,
              overwriteIfSameType = _ref37$overwriteIfSam === void 0 ? false : _ref37$overwriteIfSam,
              _ref37$keepUndo = _ref37.keepUndo,
              keepUndo = _ref37$keepUndo === void 0 ? false : _ref37$keepUndo;
            if (mustExec) {
              cmd();
            }
            if (_classPrivateFieldLooseBase(this, _locked)[_locked]) {
              return;
            }
            var save = {
              cmd: cmd,
              undo: undo,
              type: type
            };
            if (_classPrivateFieldLooseBase(this, _position)[_position] === -1) {
              if (_classPrivateFieldLooseBase(this, _commands)[_commands].length > 0) {
                _classPrivateFieldLooseBase(this, _commands)[_commands].length = 0;
              }
              _classPrivateFieldLooseBase(this, _position)[_position] = 0;
              _classPrivateFieldLooseBase(this, _commands)[_commands].push(save);
              return;
            }
            if (overwriteIfSameType && _classPrivateFieldLooseBase(this, _commands)[_commands][_classPrivateFieldLooseBase(this, _position)[_position]].type === type) {
              if (keepUndo) {
                save.undo = _classPrivateFieldLooseBase(this, _commands)[_commands][_classPrivateFieldLooseBase(this, _position)[_position]].undo;
              }
              _classPrivateFieldLooseBase(this, _commands)[_commands][_classPrivateFieldLooseBase(this, _position)[_position]] = save;
              return;
            }
            var next = _classPrivateFieldLooseBase(this, _position)[_position] + 1;
            if (next === _classPrivateFieldLooseBase(this, _maxSize)[_maxSize]) {
              _classPrivateFieldLooseBase(this, _commands)[_commands].splice(0, 1);
            } else {
              _classPrivateFieldLooseBase(this, _position)[_position] = next;
              if (next < _classPrivateFieldLooseBase(this, _commands)[_commands].length) {
                _classPrivateFieldLooseBase(this, _commands)[_commands].splice(next);
              }
            }
            _classPrivateFieldLooseBase(this, _commands)[_commands].push(save);
          }
        }, {
          key: "undo",
          value: function undo() {
            if (_classPrivateFieldLooseBase(this, _position)[_position] === -1) {
              return;
            }
            _classPrivateFieldLooseBase(this, _locked)[_locked] = true;
            _classPrivateFieldLooseBase(this, _commands)[_commands][_classPrivateFieldLooseBase(this, _position)[_position]].undo();
            _classPrivateFieldLooseBase(this, _locked)[_locked] = false;
            _classPrivateFieldLooseBase(this, _position)[_position] -= 1;
          }
        }, {
          key: "redo",
          value: function redo() {
            if (_classPrivateFieldLooseBase(this, _position)[_position] < _classPrivateFieldLooseBase(this, _commands)[_commands].length - 1) {
              _classPrivateFieldLooseBase(this, _position)[_position] += 1;
              _classPrivateFieldLooseBase(this, _locked)[_locked] = true;
              _classPrivateFieldLooseBase(this, _commands)[_commands][_classPrivateFieldLooseBase(this, _position)[_position]].cmd();
              _classPrivateFieldLooseBase(this, _locked)[_locked] = false;
            }
          }
        }, {
          key: "hasSomethingToUndo",
          value: function hasSomethingToUndo() {
            return _classPrivateFieldLooseBase(this, _position)[_position] !== -1;
          }
        }, {
          key: "hasSomethingToRedo",
          value: function hasSomethingToRedo() {
            return _classPrivateFieldLooseBase(this, _position)[_position] < _classPrivateFieldLooseBase(this, _commands)[_commands].length - 1;
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _classPrivateFieldLooseBase(this, _commands)[_commands] = null;
          }
        }]);
      }();
      exports.CommandManager = CommandManager;
      var _serialize = /*#__PURE__*/_classPrivateFieldLooseKey("serialize");
      var KeyboardManager = /*#__PURE__*/function () {
        function KeyboardManager(callbacks) {
          _classCallCheck(this, KeyboardManager);
          Object.defineProperty(this, _serialize, {
            value: _serialize2
          });
          this.buffer = [];
          this.callbacks = new Map();
          this.allKeys = new Set();
          var isMac = _util.FeatureTest.platform.isMac;
          var _iterator17 = _createForOfIteratorHelper(callbacks),
            _step17;
          try {
            for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
              var _ref38 = _step17.value;
              var _ref39 = _slicedToArray(_ref38, 2);
              var keys = _ref39[0];
              var callback = _ref39[1];
              var _iterator18 = _createForOfIteratorHelper(keys),
                _step18;
              try {
                for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                  var key = _step18.value;
                  var isMacKey = key.startsWith("mac+");
                  if (isMac && isMacKey) {
                    this.callbacks.set(key.slice(4), callback);
                    this.allKeys.add(key.split("+").at(-1));
                  } else if (!isMac && !isMacKey) {
                    this.callbacks.set(key, callback);
                    this.allKeys.add(key.split("+").at(-1));
                  }
                }
              } catch (err) {
                _iterator18.e(err);
              } finally {
                _iterator18.f();
              }
            }
          } catch (err) {
            _iterator17.e(err);
          } finally {
            _iterator17.f();
          }
        }
        return _createClass(KeyboardManager, [{
          key: "exec",
          value: function exec(self, event) {
            if (!this.allKeys.has(event.key)) {
              return;
            }
            var callback = this.callbacks.get(_classPrivateFieldLooseBase(this, _serialize)[_serialize](event));
            if (!callback) {
              return;
            }
            callback.bind(self)();
            event.stopPropagation();
            event.preventDefault();
          }
        }]);
      }();
      function _serialize2(event) {
        if (event.altKey) {
          this.buffer.push("alt");
        }
        if (event.ctrlKey) {
          this.buffer.push("ctrl");
        }
        if (event.metaKey) {
          this.buffer.push("meta");
        }
        if (event.shiftKey) {
          this.buffer.push("shift");
        }
        this.buffer.push(event.key);
        var str = this.buffer.join("+");
        this.buffer.length = 0;
        return str;
      }
      exports.KeyboardManager = KeyboardManager;
      var ColorManager = /*#__PURE__*/function () {
        function ColorManager() {
          _classCallCheck(this, ColorManager);
        }
        return _createClass(ColorManager, [{
          key: "_colors",
          get: function get() {
            var colors = new Map([["CanvasText", null], ["Canvas", null]]);
            (0, _display_utils.getColorValues)(colors);
            return (0, _util.shadow)(this, "_colors", colors);
          }
        }, {
          key: "convert",
          value: function convert(color) {
            var rgb = (0, _display_utils.getRGB)(color);
            if (!window.matchMedia("(forced-colors: active)").matches) {
              return rgb;
            }
            var _iterator19 = _createForOfIteratorHelper(this._colors),
              _step19;
            try {
              for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                var _ref40 = _step19.value;
                var _ref41 = _slicedToArray(_ref40, 2);
                var name = _ref41[0];
                var RGB = _ref41[1];
                if (RGB.every(function (x, i) {
                  return x === rgb[i];
                })) {
                  return ColorManager._colorsMapping.get(name);
                }
              }
            } catch (err) {
              _iterator19.e(err);
            } finally {
              _iterator19.f();
            }
            return rgb;
          }
        }, {
          key: "getHexCode",
          value: function getHexCode(name) {
            var _util$Util;
            var rgb = this._colors.get(name);
            if (!rgb) {
              return name;
            }
            return (_util$Util = _util.Util).makeHexColor.apply(_util$Util, _toConsumableArray(rgb));
          }
        }]);
      }();
      ColorManager._colorsMapping = new Map([["CanvasText", [0, 0, 0]], ["Canvas", [255, 255, 255]]]);
      exports.ColorManager = ColorManager;
      var _activeEditor = /*#__PURE__*/_classPrivateFieldLooseKey("activeEditor");
      var _allEditors = /*#__PURE__*/_classPrivateFieldLooseKey("allEditors");
      var _allLayers = /*#__PURE__*/_classPrivateFieldLooseKey("allLayers");
      var _annotationStorage = /*#__PURE__*/_classPrivateFieldLooseKey("annotationStorage");
      var _commandManager = /*#__PURE__*/_classPrivateFieldLooseKey("commandManager");
      var _currentPageIndex = /*#__PURE__*/_classPrivateFieldLooseKey("currentPageIndex");
      var _editorTypes = /*#__PURE__*/_classPrivateFieldLooseKey("editorTypes");
      var _editorsToRescale = /*#__PURE__*/_classPrivateFieldLooseKey("editorsToRescale");
      var _eventBus = /*#__PURE__*/_classPrivateFieldLooseKey("eventBus");
      var _idManager = /*#__PURE__*/_classPrivateFieldLooseKey("idManager");
      var _isEnabled = /*#__PURE__*/_classPrivateFieldLooseKey("isEnabled");
      var _mode = /*#__PURE__*/_classPrivateFieldLooseKey("mode");
      var _selectedEditors = /*#__PURE__*/_classPrivateFieldLooseKey("selectedEditors");
      var _boundCopy = /*#__PURE__*/_classPrivateFieldLooseKey("boundCopy");
      var _boundCut = /*#__PURE__*/_classPrivateFieldLooseKey("boundCut");
      var _boundPaste = /*#__PURE__*/_classPrivateFieldLooseKey("boundPaste");
      var _boundKeydown = /*#__PURE__*/_classPrivateFieldLooseKey("boundKeydown");
      var _boundOnEditingAction = /*#__PURE__*/_classPrivateFieldLooseKey("boundOnEditingAction");
      var _boundOnPageChanging = /*#__PURE__*/_classPrivateFieldLooseKey("boundOnPageChanging");
      var _boundOnScaleChanging = /*#__PURE__*/_classPrivateFieldLooseKey("boundOnScaleChanging");
      var _boundOnRotationChanging = /*#__PURE__*/_classPrivateFieldLooseKey("boundOnRotationChanging");
      var _previousStates = /*#__PURE__*/_classPrivateFieldLooseKey("previousStates");
      var _container = /*#__PURE__*/_classPrivateFieldLooseKey("container");
      var _addKeyboardManager = /*#__PURE__*/_classPrivateFieldLooseKey("addKeyboardManager");
      var _removeKeyboardManager = /*#__PURE__*/_classPrivateFieldLooseKey("removeKeyboardManager");
      var _addCopyPasteListeners = /*#__PURE__*/_classPrivateFieldLooseKey("addCopyPasteListeners");
      var _removeCopyPasteListeners = /*#__PURE__*/_classPrivateFieldLooseKey("removeCopyPasteListeners");
      var _dispatchUpdateStates = /*#__PURE__*/_classPrivateFieldLooseKey("dispatchUpdateStates");
      var _dispatchUpdateUI = /*#__PURE__*/_classPrivateFieldLooseKey("dispatchUpdateUI");
      var _enableAll = /*#__PURE__*/_classPrivateFieldLooseKey("enableAll");
      var _disableAll = /*#__PURE__*/_classPrivateFieldLooseKey("disableAll");
      var _addEditorToLayer = /*#__PURE__*/_classPrivateFieldLooseKey("addEditorToLayer");
      var _isEmpty = /*#__PURE__*/_classPrivateFieldLooseKey("isEmpty");
      var _selectEditors = /*#__PURE__*/_classPrivateFieldLooseKey("selectEditors");
      var AnnotationEditorUIManager = /*#__PURE__*/function () {
        function AnnotationEditorUIManager(container, eventBus, annotationStorage) {
          _classCallCheck(this, AnnotationEditorUIManager);
          Object.defineProperty(this, _selectEditors, {
            value: _selectEditors2
          });
          Object.defineProperty(this, _isEmpty, {
            value: _isEmpty2
          });
          Object.defineProperty(this, _addEditorToLayer, {
            value: _addEditorToLayer2
          });
          Object.defineProperty(this, _disableAll, {
            value: _disableAll2
          });
          Object.defineProperty(this, _enableAll, {
            value: _enableAll2
          });
          Object.defineProperty(this, _dispatchUpdateUI, {
            value: _dispatchUpdateUI2
          });
          Object.defineProperty(this, _dispatchUpdateStates, {
            value: _dispatchUpdateStates2
          });
          Object.defineProperty(this, _removeCopyPasteListeners, {
            value: _removeCopyPasteListeners2
          });
          Object.defineProperty(this, _addCopyPasteListeners, {
            value: _addCopyPasteListeners2
          });
          Object.defineProperty(this, _removeKeyboardManager, {
            value: _removeKeyboardManager2
          });
          Object.defineProperty(this, _addKeyboardManager, {
            value: _addKeyboardManager2
          });
          Object.defineProperty(this, _activeEditor, {
            writable: true,
            value: null
          });
          Object.defineProperty(this, _allEditors, {
            writable: true,
            value: new Map()
          });
          Object.defineProperty(this, _allLayers, {
            writable: true,
            value: new Map()
          });
          Object.defineProperty(this, _annotationStorage, {
            writable: true,
            value: null
          });
          Object.defineProperty(this, _commandManager, {
            writable: true,
            value: new CommandManager()
          });
          Object.defineProperty(this, _currentPageIndex, {
            writable: true,
            value: 0
          });
          Object.defineProperty(this, _editorTypes, {
            writable: true,
            value: null
          });
          Object.defineProperty(this, _editorsToRescale, {
            writable: true,
            value: new Set()
          });
          Object.defineProperty(this, _eventBus, {
            writable: true,
            value: null
          });
          Object.defineProperty(this, _idManager, {
            writable: true,
            value: new IdManager()
          });
          Object.defineProperty(this, _isEnabled, {
            writable: true,
            value: false
          });
          Object.defineProperty(this, _mode, {
            writable: true,
            value: _util.AnnotationEditorType.NONE
          });
          Object.defineProperty(this, _selectedEditors, {
            writable: true,
            value: new Set()
          });
          Object.defineProperty(this, _boundCopy, {
            writable: true,
            value: this.copy.bind(this)
          });
          Object.defineProperty(this, _boundCut, {
            writable: true,
            value: this.cut.bind(this)
          });
          Object.defineProperty(this, _boundPaste, {
            writable: true,
            value: this.paste.bind(this)
          });
          Object.defineProperty(this, _boundKeydown, {
            writable: true,
            value: this.keydown.bind(this)
          });
          Object.defineProperty(this, _boundOnEditingAction, {
            writable: true,
            value: this.onEditingAction.bind(this)
          });
          Object.defineProperty(this, _boundOnPageChanging, {
            writable: true,
            value: this.onPageChanging.bind(this)
          });
          Object.defineProperty(this, _boundOnScaleChanging, {
            writable: true,
            value: this.onScaleChanging.bind(this)
          });
          Object.defineProperty(this, _boundOnRotationChanging, {
            writable: true,
            value: this.onRotationChanging.bind(this)
          });
          Object.defineProperty(this, _previousStates, {
            writable: true,
            value: {
              isEditing: false,
              isEmpty: true,
              hasSomethingToUndo: false,
              hasSomethingToRedo: false,
              hasSelectedEditor: false
            }
          });
          Object.defineProperty(this, _container, {
            writable: true,
            value: null
          });
          _classPrivateFieldLooseBase(this, _container)[_container] = container;
          _classPrivateFieldLooseBase(this, _eventBus)[_eventBus] = eventBus;
          _classPrivateFieldLooseBase(this, _eventBus)[_eventBus]._on("editingaction", _classPrivateFieldLooseBase(this, _boundOnEditingAction)[_boundOnEditingAction]);
          _classPrivateFieldLooseBase(this, _eventBus)[_eventBus]._on("pagechanging", _classPrivateFieldLooseBase(this, _boundOnPageChanging)[_boundOnPageChanging]);
          _classPrivateFieldLooseBase(this, _eventBus)[_eventBus]._on("scalechanging", _classPrivateFieldLooseBase(this, _boundOnScaleChanging)[_boundOnScaleChanging]);
          _classPrivateFieldLooseBase(this, _eventBus)[_eventBus]._on("rotationchanging", _classPrivateFieldLooseBase(this, _boundOnRotationChanging)[_boundOnRotationChanging]);
          _classPrivateFieldLooseBase(this, _annotationStorage)[_annotationStorage] = annotationStorage;
          this.viewParameters = {
            realScale: _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS,
            rotation: 0
          };
        }
        return _createClass(AnnotationEditorUIManager, [{
          key: "destroy",
          value: function destroy() {
            _classPrivateFieldLooseBase(this, _removeKeyboardManager)[_removeKeyboardManager]();
            _classPrivateFieldLooseBase(this, _eventBus)[_eventBus]._off("editingaction", _classPrivateFieldLooseBase(this, _boundOnEditingAction)[_boundOnEditingAction]);
            _classPrivateFieldLooseBase(this, _eventBus)[_eventBus]._off("pagechanging", _classPrivateFieldLooseBase(this, _boundOnPageChanging)[_boundOnPageChanging]);
            _classPrivateFieldLooseBase(this, _eventBus)[_eventBus]._off("scalechanging", _classPrivateFieldLooseBase(this, _boundOnScaleChanging)[_boundOnScaleChanging]);
            _classPrivateFieldLooseBase(this, _eventBus)[_eventBus]._off("rotationchanging", _classPrivateFieldLooseBase(this, _boundOnRotationChanging)[_boundOnRotationChanging]);
            var _iterator20 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allLayers)[_allLayers].values()),
              _step20;
            try {
              for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
                var layer = _step20.value;
                layer.destroy();
              }
            } catch (err) {
              _iterator20.e(err);
            } finally {
              _iterator20.f();
            }
            _classPrivateFieldLooseBase(this, _allLayers)[_allLayers].clear();
            _classPrivateFieldLooseBase(this, _allEditors)[_allEditors].clear();
            _classPrivateFieldLooseBase(this, _editorsToRescale)[_editorsToRescale].clear();
            _classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor] = null;
            _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].clear();
            _classPrivateFieldLooseBase(this, _commandManager)[_commandManager].destroy();
          }
        }, {
          key: "onPageChanging",
          value: function onPageChanging(_ref42) {
            var pageNumber = _ref42.pageNumber;
            _classPrivateFieldLooseBase(this, _currentPageIndex)[_currentPageIndex] = pageNumber - 1;
          }
        }, {
          key: "focusMainContainer",
          value: function focusMainContainer() {
            _classPrivateFieldLooseBase(this, _container)[_container].focus();
          }
        }, {
          key: "addShouldRescale",
          value: function addShouldRescale(editor) {
            _classPrivateFieldLooseBase(this, _editorsToRescale)[_editorsToRescale].add(editor);
          }
        }, {
          key: "removeShouldRescale",
          value: function removeShouldRescale(editor) {
            _classPrivateFieldLooseBase(this, _editorsToRescale)[_editorsToRescale].delete(editor);
          }
        }, {
          key: "onScaleChanging",
          value: function onScaleChanging(_ref43) {
            var scale = _ref43.scale;
            this.commitOrRemove();
            this.viewParameters.realScale = scale * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS;
            var _iterator21 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editorsToRescale)[_editorsToRescale]),
              _step21;
            try {
              for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
                var editor = _step21.value;
                editor.onScaleChanging();
              }
            } catch (err) {
              _iterator21.e(err);
            } finally {
              _iterator21.f();
            }
          }
        }, {
          key: "onRotationChanging",
          value: function onRotationChanging(_ref44) {
            var pagesRotation = _ref44.pagesRotation;
            this.commitOrRemove();
            this.viewParameters.rotation = pagesRotation;
          }
        }, {
          key: "addToAnnotationStorage",
          value: function addToAnnotationStorage(editor) {
            if (!editor.isEmpty() && _classPrivateFieldLooseBase(this, _annotationStorage)[_annotationStorage] && !_classPrivateFieldLooseBase(this, _annotationStorage)[_annotationStorage].has(editor.id)) {
              _classPrivateFieldLooseBase(this, _annotationStorage)[_annotationStorage].setValue(editor.id, editor);
            }
          }
        }, {
          key: "copy",
          value: function copy(event) {
            event.preventDefault();
            if (_classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor]) {
              _classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor].commitOrRemove();
            }
            if (!this.hasSelection) {
              return;
            }
            var editors = [];
            var _iterator22 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors]),
              _step22;
            try {
              for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
                var editor = _step22.value;
                if (!editor.isEmpty()) {
                  editors.push(editor.serialize());
                }
              }
            } catch (err) {
              _iterator22.e(err);
            } finally {
              _iterator22.f();
            }
            if (editors.length === 0) {
              return;
            }
            event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
          }
        }, {
          key: "cut",
          value: function cut(event) {
            this.copy(event);
            this.delete();
          }
        }, {
          key: "paste",
          value: function paste(event) {
            var _this19 = this;
            event.preventDefault();
            var data = event.clipboardData.getData("application/pdfjs");
            if (!data) {
              return;
            }
            try {
              data = JSON.parse(data);
            } catch (ex) {
              (0, _util.warn)("paste: \"".concat(ex.message, "\"."));
              return;
            }
            if (!Array.isArray(data)) {
              return;
            }
            this.unselectAll();
            var layer = _classPrivateFieldLooseBase(this, _allLayers)[_allLayers].get(_classPrivateFieldLooseBase(this, _currentPageIndex)[_currentPageIndex]);
            try {
              var newEditors = [];
              var _iterator23 = _createForOfIteratorHelper(data),
                _step23;
              try {
                for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
                  var editor = _step23.value;
                  var deserializedEditor = layer.deserialize(editor);
                  if (!deserializedEditor) {
                    return;
                  }
                  newEditors.push(deserializedEditor);
                }
              } catch (err) {
                _iterator23.e(err);
              } finally {
                _iterator23.f();
              }
              var cmd = function cmd() {
                for (var _i3 = 0, _newEditors = newEditors; _i3 < _newEditors.length; _i3++) {
                  var editor = _newEditors[_i3];
                  _classPrivateFieldLooseBase(_this19, _addEditorToLayer)[_addEditorToLayer](editor);
                }
                _classPrivateFieldLooseBase(_this19, _selectEditors)[_selectEditors](newEditors);
              };
              var undo = function undo() {
                for (var _i4 = 0, _newEditors2 = newEditors; _i4 < _newEditors2.length; _i4++) {
                  var editor = _newEditors2[_i4];
                  editor.remove();
                }
              };
              this.addCommands({
                cmd: cmd,
                undo: undo,
                mustExec: true
              });
            } catch (ex) {
              (0, _util.warn)("paste: \"".concat(ex.message, "\"."));
            }
          }
        }, {
          key: "keydown",
          value: function keydown(event) {
            var _this$getActive;
            if (!((_this$getActive = this.getActive()) !== null && _this$getActive !== void 0 && _this$getActive.shouldGetKeyboardEvents())) {
              AnnotationEditorUIManager._keyboardManager.exec(this, event);
            }
          }
        }, {
          key: "onEditingAction",
          value: function onEditingAction(details) {
            if (["undo", "redo", "delete", "selectAll"].includes(details.name)) {
              this[details.name]();
            }
          }
        }, {
          key: "setEditingState",
          value: function setEditingState(isEditing) {
            if (isEditing) {
              _classPrivateFieldLooseBase(this, _addKeyboardManager)[_addKeyboardManager]();
              _classPrivateFieldLooseBase(this, _addCopyPasteListeners)[_addCopyPasteListeners]();
              _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
                isEditing: _classPrivateFieldLooseBase(this, _mode)[_mode] !== _util.AnnotationEditorType.NONE,
                isEmpty: _classPrivateFieldLooseBase(this, _isEmpty)[_isEmpty](),
                hasSomethingToUndo: _classPrivateFieldLooseBase(this, _commandManager)[_commandManager].hasSomethingToUndo(),
                hasSomethingToRedo: _classPrivateFieldLooseBase(this, _commandManager)[_commandManager].hasSomethingToRedo(),
                hasSelectedEditor: false
              });
            } else {
              _classPrivateFieldLooseBase(this, _removeKeyboardManager)[_removeKeyboardManager]();
              _classPrivateFieldLooseBase(this, _removeCopyPasteListeners)[_removeCopyPasteListeners]();
              _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
                isEditing: false
              });
            }
          }
        }, {
          key: "registerEditorTypes",
          value: function registerEditorTypes(types) {
            if (_classPrivateFieldLooseBase(this, _editorTypes)[_editorTypes]) {
              return;
            }
            _classPrivateFieldLooseBase(this, _editorTypes)[_editorTypes] = types;
            var _iterator24 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editorTypes)[_editorTypes]),
              _step24;
            try {
              for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
                var editorType = _step24.value;
                _classPrivateFieldLooseBase(this, _dispatchUpdateUI)[_dispatchUpdateUI](editorType.defaultPropertiesToUpdate);
              }
            } catch (err) {
              _iterator24.e(err);
            } finally {
              _iterator24.f();
            }
          }
        }, {
          key: "getId",
          value: function getId() {
            return _classPrivateFieldLooseBase(this, _idManager)[_idManager].getId();
          }
        }, {
          key: "currentLayer",
          get: function get() {
            return _classPrivateFieldLooseBase(this, _allLayers)[_allLayers].get(_classPrivateFieldLooseBase(this, _currentPageIndex)[_currentPageIndex]);
          }
        }, {
          key: "currentPageIndex",
          get: function get() {
            return _classPrivateFieldLooseBase(this, _currentPageIndex)[_currentPageIndex];
          }
        }, {
          key: "addLayer",
          value: function addLayer(layer) {
            _classPrivateFieldLooseBase(this, _allLayers)[_allLayers].set(layer.pageIndex, layer);
            if (_classPrivateFieldLooseBase(this, _isEnabled)[_isEnabled]) {
              layer.enable();
            } else {
              layer.disable();
            }
          }
        }, {
          key: "removeLayer",
          value: function removeLayer(layer) {
            _classPrivateFieldLooseBase(this, _allLayers)[_allLayers].delete(layer.pageIndex);
          }
        }, {
          key: "updateMode",
          value: function updateMode(mode) {
            _classPrivateFieldLooseBase(this, _mode)[_mode] = mode;
            if (mode === _util.AnnotationEditorType.NONE) {
              this.setEditingState(false);
              _classPrivateFieldLooseBase(this, _disableAll)[_disableAll]();
            } else {
              this.setEditingState(true);
              _classPrivateFieldLooseBase(this, _enableAll)[_enableAll]();
              var _iterator25 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allLayers)[_allLayers].values()),
                _step25;
              try {
                for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
                  var layer = _step25.value;
                  layer.updateMode(mode);
                }
              } catch (err) {
                _iterator25.e(err);
              } finally {
                _iterator25.f();
              }
            }
          }
        }, {
          key: "updateToolbar",
          value: function updateToolbar(mode) {
            if (mode === _classPrivateFieldLooseBase(this, _mode)[_mode]) {
              return;
            }
            _classPrivateFieldLooseBase(this, _eventBus)[_eventBus].dispatch("switchannotationeditormode", {
              source: this,
              mode: mode
            });
          }
        }, {
          key: "updateParams",
          value: function updateParams(type, value) {
            if (!_classPrivateFieldLooseBase(this, _editorTypes)[_editorTypes]) {
              return;
            }
            var _iterator26 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors]),
              _step26;
            try {
              for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                var editor = _step26.value;
                editor.updateParams(type, value);
              }
            } catch (err) {
              _iterator26.e(err);
            } finally {
              _iterator26.f();
            }
            var _iterator27 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editorTypes)[_editorTypes]),
              _step27;
            try {
              for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
                var editorType = _step27.value;
                editorType.updateDefaultParams(type, value);
              }
            } catch (err) {
              _iterator27.e(err);
            } finally {
              _iterator27.f();
            }
          }
        }, {
          key: "getEditors",
          value: function getEditors(pageIndex) {
            var editors = [];
            var _iterator28 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allEditors)[_allEditors].values()),
              _step28;
            try {
              for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
                var editor = _step28.value;
                if (editor.pageIndex === pageIndex) {
                  editors.push(editor);
                }
              }
            } catch (err) {
              _iterator28.e(err);
            } finally {
              _iterator28.f();
            }
            return editors;
          }
        }, {
          key: "getEditor",
          value: function getEditor(id) {
            return _classPrivateFieldLooseBase(this, _allEditors)[_allEditors].get(id);
          }
        }, {
          key: "addEditor",
          value: function addEditor(editor) {
            _classPrivateFieldLooseBase(this, _allEditors)[_allEditors].set(editor.id, editor);
          }
        }, {
          key: "removeEditor",
          value: function removeEditor(editor) {
            var _classPrivateFieldLoo;
            _classPrivateFieldLooseBase(this, _allEditors)[_allEditors].delete(editor.id);
            this.unselect(editor);
            (_classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _annotationStorage)[_annotationStorage]) === null || _classPrivateFieldLoo === void 0 || _classPrivateFieldLoo.remove(editor.id);
          }
        }, {
          key: "setActiveEditor",
          value: function setActiveEditor(editor) {
            if (_classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor] === editor) {
              return;
            }
            _classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor] = editor;
            if (editor) {
              _classPrivateFieldLooseBase(this, _dispatchUpdateUI)[_dispatchUpdateUI](editor.propertiesToUpdate);
            }
          }
        }, {
          key: "toggleSelected",
          value: function toggleSelected(editor) {
            if (_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].has(editor)) {
              _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].delete(editor);
              editor.unselect();
              _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
                hasSelectedEditor: this.hasSelection
              });
              return;
            }
            _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].add(editor);
            editor.select();
            _classPrivateFieldLooseBase(this, _dispatchUpdateUI)[_dispatchUpdateUI](editor.propertiesToUpdate);
            _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
              hasSelectedEditor: true
            });
          }
        }, {
          key: "setSelected",
          value: function setSelected(editor) {
            var _iterator29 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors]),
              _step29;
            try {
              for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
                var ed = _step29.value;
                if (ed !== editor) {
                  ed.unselect();
                }
              }
            } catch (err) {
              _iterator29.e(err);
            } finally {
              _iterator29.f();
            }
            _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].clear();
            _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].add(editor);
            editor.select();
            _classPrivateFieldLooseBase(this, _dispatchUpdateUI)[_dispatchUpdateUI](editor.propertiesToUpdate);
            _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
              hasSelectedEditor: true
            });
          }
        }, {
          key: "isSelected",
          value: function isSelected(editor) {
            return _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].has(editor);
          }
        }, {
          key: "unselect",
          value: function unselect(editor) {
            editor.unselect();
            _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].delete(editor);
            _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
              hasSelectedEditor: this.hasSelection
            });
          }
        }, {
          key: "hasSelection",
          get: function get() {
            return _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].size !== 0;
          }
        }, {
          key: "undo",
          value: function undo() {
            _classPrivateFieldLooseBase(this, _commandManager)[_commandManager].undo();
            _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
              hasSomethingToUndo: _classPrivateFieldLooseBase(this, _commandManager)[_commandManager].hasSomethingToUndo(),
              hasSomethingToRedo: true,
              isEmpty: _classPrivateFieldLooseBase(this, _isEmpty)[_isEmpty]()
            });
          }
        }, {
          key: "redo",
          value: function redo() {
            _classPrivateFieldLooseBase(this, _commandManager)[_commandManager].redo();
            _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
              hasSomethingToUndo: true,
              hasSomethingToRedo: _classPrivateFieldLooseBase(this, _commandManager)[_commandManager].hasSomethingToRedo(),
              isEmpty: _classPrivateFieldLooseBase(this, _isEmpty)[_isEmpty]()
            });
          }
        }, {
          key: "addCommands",
          value: function addCommands(params) {
            _classPrivateFieldLooseBase(this, _commandManager)[_commandManager].add(params);
            _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
              hasSomethingToUndo: true,
              hasSomethingToRedo: false,
              isEmpty: _classPrivateFieldLooseBase(this, _isEmpty)[_isEmpty]()
            });
          }
        }, {
          key: "delete",
          value: function _delete() {
            var _this20 = this;
            this.commitOrRemove();
            if (!this.hasSelection) {
              return;
            }
            var editors = _toConsumableArray(_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors]);
            var cmd = function cmd() {
              var _iterator30 = _createForOfIteratorHelper(editors),
                _step30;
              try {
                for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
                  var editor = _step30.value;
                  editor.remove();
                }
              } catch (err) {
                _iterator30.e(err);
              } finally {
                _iterator30.f();
              }
            };
            var undo = function undo() {
              var _iterator31 = _createForOfIteratorHelper(editors),
                _step31;
              try {
                for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
                  var editor = _step31.value;
                  _classPrivateFieldLooseBase(_this20, _addEditorToLayer)[_addEditorToLayer](editor);
                }
              } catch (err) {
                _iterator31.e(err);
              } finally {
                _iterator31.f();
              }
            };
            this.addCommands({
              cmd: cmd,
              undo: undo,
              mustExec: true
            });
          }
        }, {
          key: "commitOrRemove",
          value: function commitOrRemove() {
            var _classPrivateFieldLoo2;
            (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor]) === null || _classPrivateFieldLoo2 === void 0 || _classPrivateFieldLoo2.commitOrRemove();
          }
        }, {
          key: "selectAll",
          value: function selectAll() {
            var _iterator32 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors]),
              _step32;
            try {
              for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
                var editor = _step32.value;
                editor.commit();
              }
            } catch (err) {
              _iterator32.e(err);
            } finally {
              _iterator32.f();
            }
            _classPrivateFieldLooseBase(this, _selectEditors)[_selectEditors](_classPrivateFieldLooseBase(this, _allEditors)[_allEditors].values());
          }
        }, {
          key: "unselectAll",
          value: function unselectAll() {
            if (_classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor]) {
              _classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor].commitOrRemove();
              return;
            }
            if (_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].size === 0) {
              return;
            }
            var _iterator33 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors]),
              _step33;
            try {
              for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
                var editor = _step33.value;
                editor.unselect();
              }
            } catch (err) {
              _iterator33.e(err);
            } finally {
              _iterator33.f();
            }
            _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].clear();
            _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
              hasSelectedEditor: false
            });
          }
        }, {
          key: "isActive",
          value: function isActive(editor) {
            return _classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor] === editor;
          }
        }, {
          key: "getActive",
          value: function getActive() {
            return _classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor];
          }
        }, {
          key: "getMode",
          value: function getMode() {
            return _classPrivateFieldLooseBase(this, _mode)[_mode];
          }
        }]);
      }();
      _AnnotationEditorUIManager = AnnotationEditorUIManager;
      function _addKeyboardManager2() {
        _classPrivateFieldLooseBase(this, _container)[_container].addEventListener("keydown", _classPrivateFieldLooseBase(this, _boundKeydown)[_boundKeydown]);
      }
      function _removeKeyboardManager2() {
        _classPrivateFieldLooseBase(this, _container)[_container].removeEventListener("keydown", _classPrivateFieldLooseBase(this, _boundKeydown)[_boundKeydown]);
      }
      function _addCopyPasteListeners2() {
        document.addEventListener("copy", _classPrivateFieldLooseBase(this, _boundCopy)[_boundCopy]);
        document.addEventListener("cut", _classPrivateFieldLooseBase(this, _boundCut)[_boundCut]);
        document.addEventListener("paste", _classPrivateFieldLooseBase(this, _boundPaste)[_boundPaste]);
      }
      function _removeCopyPasteListeners2() {
        document.removeEventListener("copy", _classPrivateFieldLooseBase(this, _boundCopy)[_boundCopy]);
        document.removeEventListener("cut", _classPrivateFieldLooseBase(this, _boundCut)[_boundCut]);
        document.removeEventListener("paste", _classPrivateFieldLooseBase(this, _boundPaste)[_boundPaste]);
      }
      function _dispatchUpdateStates2(details) {
        var _this21 = this;
        var hasChanged = Object.entries(details).some(function (_ref45) {
          var _ref46 = _slicedToArray(_ref45, 2),
            key = _ref46[0],
            value = _ref46[1];
          return _classPrivateFieldLooseBase(_this21, _previousStates)[_previousStates][key] !== value;
        });
        if (hasChanged) {
          _classPrivateFieldLooseBase(this, _eventBus)[_eventBus].dispatch("annotationeditorstateschanged", {
            source: this,
            details: Object.assign(_classPrivateFieldLooseBase(this, _previousStates)[_previousStates], details)
          });
        }
      }
      function _dispatchUpdateUI2(details) {
        _classPrivateFieldLooseBase(this, _eventBus)[_eventBus].dispatch("annotationeditorparamschanged", {
          source: this,
          details: details
        });
      }
      function _enableAll2() {
        if (!_classPrivateFieldLooseBase(this, _isEnabled)[_isEnabled]) {
          _classPrivateFieldLooseBase(this, _isEnabled)[_isEnabled] = true;
          var _iterator34 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allLayers)[_allLayers].values()),
            _step34;
          try {
            for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
              var layer = _step34.value;
              layer.enable();
            }
          } catch (err) {
            _iterator34.e(err);
          } finally {
            _iterator34.f();
          }
        }
      }
      function _disableAll2() {
        this.unselectAll();
        if (_classPrivateFieldLooseBase(this, _isEnabled)[_isEnabled]) {
          _classPrivateFieldLooseBase(this, _isEnabled)[_isEnabled] = false;
          var _iterator35 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allLayers)[_allLayers].values()),
            _step35;
          try {
            for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
              var layer = _step35.value;
              layer.disable();
            }
          } catch (err) {
            _iterator35.e(err);
          } finally {
            _iterator35.f();
          }
        }
      }
      function _addEditorToLayer2(editor) {
        var layer = _classPrivateFieldLooseBase(this, _allLayers)[_allLayers].get(editor.pageIndex);
        if (layer) {
          layer.addOrRebuild(editor);
        } else {
          this.addEditor(editor);
        }
      }
      function _isEmpty2() {
        if (_classPrivateFieldLooseBase(this, _allEditors)[_allEditors].size === 0) {
          return true;
        }
        if (_classPrivateFieldLooseBase(this, _allEditors)[_allEditors].size === 1) {
          var _iterator36 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allEditors)[_allEditors].values()),
            _step36;
          try {
            for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
              var editor = _step36.value;
              return editor.isEmpty();
            }
          } catch (err) {
            _iterator36.e(err);
          } finally {
            _iterator36.f();
          }
        }
        return false;
      }
      function _selectEditors2(editors) {
        _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].clear();
        var _iterator37 = _createForOfIteratorHelper(editors),
          _step37;
        try {
          for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
            var editor = _step37.value;
            if (editor.isEmpty()) {
              continue;
            }
            _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].add(editor);
            editor.select();
          }
        } catch (err) {
          _iterator37.e(err);
        } finally {
          _iterator37.f();
        }
        _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
          hasSelectedEditor: true
        });
      }
      AnnotationEditorUIManager._keyboardManager = new KeyboardManager([[["ctrl+a", "mac+meta+a"], _AnnotationEditorUIManager.prototype.selectAll], [["ctrl+z", "mac+meta+z"], _AnnotationEditorUIManager.prototype.undo], [["ctrl+y", "ctrl+shift+Z", "mac+meta+shift+Z"], _AnnotationEditorUIManager.prototype.redo], [["Backspace", "alt+Backspace", "ctrl+Backspace", "shift+Backspace", "mac+Backspace", "mac+alt+Backspace", "mac+ctrl+Backspace", "Delete", "ctrl+Delete", "shift+Delete"], _AnnotationEditorUIManager.prototype.delete], [["Escape", "mac+Escape"], _AnnotationEditorUIManager.prototype.unselectAll]]);
      exports.AnnotationEditorUIManager = AnnotationEditorUIManager;

      /***/
    }), (/* 6 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      var _PixelsPerInch;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.StatTimer = exports.RenderingCancelledException = exports.PixelsPerInch = exports.PageViewport = exports.PDFDateString = exports.DOMStandardFontDataFactory = exports.DOMSVGFactory = exports.DOMCanvasFactory = exports.DOMCMapReaderFactory = exports.AnnotationPrefix = void 0;
      exports.deprecated = deprecated;
      exports.getColorValues = getColorValues;
      exports.getCurrentTransform = getCurrentTransform;
      exports.getCurrentTransformInverse = getCurrentTransformInverse;
      exports.getFilenameFromUrl = getFilenameFromUrl;
      exports.getPdfFilenameFromUrl = getPdfFilenameFromUrl;
      exports.getRGB = getRGB;
      exports.getXfaPageViewport = getXfaPageViewport;
      exports.isDataScheme = isDataScheme;
      exports.isPdfFile = isPdfFile;
      exports.isValidFetchUrl = isValidFetchUrl;
      exports.loadScript = loadScript;
      exports.setLayerDimensions = setLayerDimensions;
      var _base_factory = __w_pdfjs_require__(7);
      var _util = __w_pdfjs_require__(1);
      var SVG_NS = "http://www.w3.org/2000/svg";
      var AnnotationPrefix = "pdfjs_internal_id_";
      exports.AnnotationPrefix = AnnotationPrefix;
      var PixelsPerInch = /*#__PURE__*/_createClass(function PixelsPerInch() {
        _classCallCheck(this, PixelsPerInch);
      });
      _PixelsPerInch = PixelsPerInch;
      PixelsPerInch.CSS = 96.0;
      PixelsPerInch.PDF = 72.0;
      PixelsPerInch.PDF_TO_CSS_UNITS = _PixelsPerInch.CSS / _PixelsPerInch.PDF;
      exports.PixelsPerInch = PixelsPerInch;
      var DOMCanvasFactory = /*#__PURE__*/function (_base_factory$BaseCan) {
        function DOMCanvasFactory() {
          var _this22;
          var _ref47 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref47$ownerDocument = _ref47.ownerDocument,
            ownerDocument = _ref47$ownerDocument === void 0 ? globalThis.document : _ref47$ownerDocument;
          _classCallCheck(this, DOMCanvasFactory);
          _this22 = _callSuper(this, DOMCanvasFactory);
          _this22._document = ownerDocument;
          return _this22;
        }
        _inherits(DOMCanvasFactory, _base_factory$BaseCan);
        return _createClass(DOMCanvasFactory, [{
          key: "_createCanvas",
          value: function _createCanvas(width, height) {
            var canvas = this._document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            return canvas;
          }
        }]);
      }(_base_factory.BaseCanvasFactory);
      exports.DOMCanvasFactory = DOMCanvasFactory;
      function fetchData(_x3) {
        return _fetchData.apply(this, arguments);
      }
      function _fetchData() {
        _fetchData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(url) {
          var asTypedArray,
            response,
            _args7 = arguments,
            _t2,
            _t3,
            _t4,
            _t5,
            _t6;
          return _regenerator().w(function (_context7) {
            while (1) switch (_context7.n) {
              case 0:
                asTypedArray = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : false;
                if (!isValidFetchUrl(url, document.baseURI)) {
                  _context7.n = 7;
                  break;
                }
                _context7.n = 1;
                return fetch(url);
              case 1:
                response = _context7.v;
                if (response.ok) {
                  _context7.n = 2;
                  break;
                }
                throw new Error(response.statusText);
              case 2:
                if (!asTypedArray) {
                  _context7.n = 4;
                  break;
                }
                _t3 = Uint8Array;
                _context7.n = 3;
                return response.arrayBuffer();
              case 3:
                _t4 = _context7.v;
                _t2 = new _t3(_t4);
                _context7.n = 6;
                break;
              case 4:
                _t5 = (0, _util.stringToBytes);
                _context7.n = 5;
                return response.text();
              case 5:
                _t6 = _context7.v;
                _t2 = _t5(_t6);
              case 6:
                return _context7.a(2, _t2);
              case 7:
                return _context7.a(2, new Promise(function (resolve, reject) {
                  var request = new XMLHttpRequest();
                  request.open("GET", url, true);
                  if (asTypedArray) {
                    request.responseType = "arraybuffer";
                  }
                  request.onreadystatechange = function () {
                    if (request.readyState !== XMLHttpRequest.DONE) {
                      return;
                    }
                    if (request.status === 200 || request.status === 0) {
                      var data;
                      if (asTypedArray && request.response) {
                        data = new Uint8Array(request.response);
                      } else if (!asTypedArray && request.responseText) {
                        data = (0, _util.stringToBytes)(request.responseText);
                      }
                      if (data) {
                        resolve(data);
                        return;
                      }
                    }
                    reject(new Error(request.statusText));
                  };
                  request.send(null);
                }));
            }
          }, _callee7);
        }));
        return _fetchData.apply(this, arguments);
      }
      var DOMCMapReaderFactory = /*#__PURE__*/function (_base_factory$BaseCMa) {
        function DOMCMapReaderFactory() {
          _classCallCheck(this, DOMCMapReaderFactory);
          return _callSuper(this, DOMCMapReaderFactory, arguments);
        }
        _inherits(DOMCMapReaderFactory, _base_factory$BaseCMa);
        return _createClass(DOMCMapReaderFactory, [{
          key: "_fetchData",
          value: function _fetchData(url, compressionType) {
            return fetchData(url, this.isCompressed).then(function (data) {
              return {
                cMapData: data,
                compressionType: compressionType
              };
            });
          }
        }]);
      }(_base_factory.BaseCMapReaderFactory);
      exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
      var DOMStandardFontDataFactory = /*#__PURE__*/function (_base_factory$BaseSta) {
        function DOMStandardFontDataFactory() {
          _classCallCheck(this, DOMStandardFontDataFactory);
          return _callSuper(this, DOMStandardFontDataFactory, arguments);
        }
        _inherits(DOMStandardFontDataFactory, _base_factory$BaseSta);
        return _createClass(DOMStandardFontDataFactory, [{
          key: "_fetchData",
          value: function _fetchData(url) {
            return fetchData(url, true);
          }
        }]);
      }(_base_factory.BaseStandardFontDataFactory);
      exports.DOMStandardFontDataFactory = DOMStandardFontDataFactory;
      var DOMSVGFactory = /*#__PURE__*/function (_base_factory$BaseSVG) {
        function DOMSVGFactory() {
          _classCallCheck(this, DOMSVGFactory);
          return _callSuper(this, DOMSVGFactory, arguments);
        }
        _inherits(DOMSVGFactory, _base_factory$BaseSVG);
        return _createClass(DOMSVGFactory, [{
          key: "_createSVG",
          value: function _createSVG(type) {
            return document.createElementNS(SVG_NS, type);
          }
        }]);
      }(_base_factory.BaseSVGFactory);
      exports.DOMSVGFactory = DOMSVGFactory;
      var PageViewport = /*#__PURE__*/function () {
        function PageViewport(_ref48) {
          var viewBox = _ref48.viewBox,
            scale = _ref48.scale,
            rotation = _ref48.rotation,
            _ref48$offsetX = _ref48.offsetX,
            offsetX = _ref48$offsetX === void 0 ? 0 : _ref48$offsetX,
            _ref48$offsetY = _ref48.offsetY,
            offsetY = _ref48$offsetY === void 0 ? 0 : _ref48$offsetY,
            _ref48$dontFlip = _ref48.dontFlip,
            dontFlip = _ref48$dontFlip === void 0 ? false : _ref48$dontFlip;
          _classCallCheck(this, PageViewport);
          this.viewBox = viewBox;
          this.scale = scale;
          this.rotation = rotation;
          this.offsetX = offsetX;
          this.offsetY = offsetY;
          var centerX = (viewBox[2] + viewBox[0]) / 2;
          var centerY = (viewBox[3] + viewBox[1]) / 2;
          var rotateA, rotateB, rotateC, rotateD;
          rotation %= 360;
          if (rotation < 0) {
            rotation += 360;
          }
          switch (rotation) {
            case 180:
              rotateA = -1;
              rotateB = 0;
              rotateC = 0;
              rotateD = 1;
              break;
            case 90:
              rotateA = 0;
              rotateB = 1;
              rotateC = 1;
              rotateD = 0;
              break;
            case 270:
              rotateA = 0;
              rotateB = -1;
              rotateC = -1;
              rotateD = 0;
              break;
            case 0:
              rotateA = 1;
              rotateB = 0;
              rotateC = 0;
              rotateD = -1;
              break;
            default:
              throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
          }
          if (dontFlip) {
            rotateC = -rotateC;
            rotateD = -rotateD;
          }
          var offsetCanvasX, offsetCanvasY;
          var width, height;
          if (rotateA === 0) {
            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
            width = (viewBox[3] - viewBox[1]) * scale;
            height = (viewBox[2] - viewBox[0]) * scale;
          } else {
            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
            width = (viewBox[2] - viewBox[0]) * scale;
            height = (viewBox[3] - viewBox[1]) * scale;
          }
          this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
          this.width = width;
          this.height = height;
        }
        return _createClass(PageViewport, [{
          key: "rawDims",
          get: function get() {
            var viewBox = this.viewBox;
            return (0, _util.shadow)(this, "rawDims", {
              pageWidth: viewBox[2] - viewBox[0],
              pageHeight: viewBox[3] - viewBox[1],
              pageX: viewBox[0],
              pageY: viewBox[1]
            });
          }
        }, {
          key: "clone",
          value: function clone() {
            var _ref49 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              _ref49$scale = _ref49.scale,
              scale = _ref49$scale === void 0 ? this.scale : _ref49$scale,
              _ref49$rotation = _ref49.rotation,
              rotation = _ref49$rotation === void 0 ? this.rotation : _ref49$rotation,
              _ref49$offsetX = _ref49.offsetX,
              offsetX = _ref49$offsetX === void 0 ? this.offsetX : _ref49$offsetX,
              _ref49$offsetY = _ref49.offsetY,
              offsetY = _ref49$offsetY === void 0 ? this.offsetY : _ref49$offsetY,
              _ref49$dontFlip = _ref49.dontFlip,
              dontFlip = _ref49$dontFlip === void 0 ? false : _ref49$dontFlip;
            return new PageViewport({
              viewBox: this.viewBox.slice(),
              scale: scale,
              rotation: rotation,
              offsetX: offsetX,
              offsetY: offsetY,
              dontFlip: dontFlip
            });
          }
        }, {
          key: "convertToViewportPoint",
          value: function convertToViewportPoint(x, y) {
            return _util.Util.applyTransform([x, y], this.transform);
          }
        }, {
          key: "convertToViewportRectangle",
          value: function convertToViewportRectangle(rect) {
            var topLeft = _util.Util.applyTransform([rect[0], rect[1]], this.transform);
            var bottomRight = _util.Util.applyTransform([rect[2], rect[3]], this.transform);
            return [topLeft[0], topLeft[1], bottomRight[0], bottomRight[1]];
          }
        }, {
          key: "convertToPdfPoint",
          value: function convertToPdfPoint(x, y) {
            return _util.Util.applyInverseTransform([x, y], this.transform);
          }
        }]);
      }();
      exports.PageViewport = PageViewport;
      var RenderingCancelledException = /*#__PURE__*/function (_util$BaseException) {
        function RenderingCancelledException(msg, type) {
          var _this23;
          var extraDelay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          _classCallCheck(this, RenderingCancelledException);
          _this23 = _callSuper(this, RenderingCancelledException, [msg, "RenderingCancelledException"]);
          _this23.type = type;
          _this23.extraDelay = extraDelay;
          return _this23;
        }
        _inherits(RenderingCancelledException, _util$BaseException);
        return _createClass(RenderingCancelledException);
      }(_util.BaseException);
      exports.RenderingCancelledException = RenderingCancelledException;
      function isDataScheme(url) {
        var ii = url.length;
        var i = 0;
        while (i < ii && url[i].trim() === "") {
          i++;
        }
        return url.substring(i, i + 5).toLowerCase() === "data:";
      }
      function isPdfFile(filename) {
        return typeof filename === "string" && /\.pdf$/i.test(filename);
      }
      function getFilenameFromUrl(url) {
        var onlyStripPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (!onlyStripPath) {
          var _url$split = url.split(/[#?]/, 1);
          var _url$split2 = _slicedToArray(_url$split, 1);
          url = _url$split2[0];
        }
        return url.substring(url.lastIndexOf("/") + 1);
      }
      function getPdfFilenameFromUrl(url) {
        var defaultFilename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "document.pdf";
        if (typeof url !== "string") {
          return defaultFilename;
        }
        if (isDataScheme(url)) {
          (0, _util.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
          return defaultFilename;
        }
        var reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
        var reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
        var splitURI = reURI.exec(url);
        var suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
        if (suggestedFilename) {
          suggestedFilename = suggestedFilename[0];
          if (suggestedFilename.includes("%")) {
            try {
              suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
            } catch (ex) {}
          }
        }
        return suggestedFilename || defaultFilename;
      }
      var StatTimer = /*#__PURE__*/function () {
        function StatTimer() {
          _classCallCheck(this, StatTimer);
          this.started = Object.create(null);
          this.times = [];
        }
        return _createClass(StatTimer, [{
          key: "time",
          value: function time(name) {
            if (name in this.started) {
              (0, _util.warn)("Timer is already running for ".concat(name));
            }
            this.started[name] = Date.now();
          }
        }, {
          key: "timeEnd",
          value: function timeEnd(name) {
            if (!(name in this.started)) {
              (0, _util.warn)("Timer has not been started for ".concat(name));
            }
            this.times.push({
              name: name,
              start: this.started[name],
              end: Date.now()
            });
            delete this.started[name];
          }
        }, {
          key: "toString",
          value: function toString() {
            var outBuf = [];
            var longest = 0;
            var _iterator38 = _createForOfIteratorHelper(this.times),
              _step38;
            try {
              for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
                var _ref50 = _step38.value;
                var name = _ref50.name;
                longest = Math.max(name.length, longest);
              }
            } catch (err) {
              _iterator38.e(err);
            } finally {
              _iterator38.f();
            }
            var _iterator39 = _createForOfIteratorHelper(this.times),
              _step39;
            try {
              for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
                var _ref51 = _step39.value;
                var _name = _ref51.name;
                var start = _ref51.start;
                var end = _ref51.end;
                outBuf.push("".concat(_name.padEnd(longest), " ").concat(end - start, "ms\n"));
              }
            } catch (err) {
              _iterator39.e(err);
            } finally {
              _iterator39.f();
            }
            return outBuf.join("");
          }
        }]);
      }();
      exports.StatTimer = StatTimer;
      function isValidFetchUrl(url, baseUrl) {
        try {
          var _ref52 = baseUrl ? new URL(url, baseUrl) : new URL(url),
            protocol = _ref52.protocol;
          return protocol === "http:" || protocol === "https:";
        } catch (ex) {
          return false;
        }
      }
      function loadScript(src) {
        var removeScriptElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return new Promise(function (resolve, reject) {
          var script = document.createElement("script");
          script.src = src;
          script.onload = function (evt) {
            if (removeScriptElement) {
              script.remove();
            }
            resolve(evt);
          };
          script.onerror = function () {
            reject(new Error("Cannot load script at: ".concat(script.src)));
          };
          (document.head || document.documentElement).append(script);
        });
      }
      function deprecated(details) {
        console.log("Deprecated API usage: " + details);
      }
      var pdfDateStringRegex;
      var PDFDateString = /*#__PURE__*/function () {
        function PDFDateString() {
          _classCallCheck(this, PDFDateString);
        }
        return _createClass(PDFDateString, null, [{
          key: "toDateObject",
          value: function toDateObject(input) {
            if (!input || typeof input !== "string") {
              return null;
            }
            if (!pdfDateStringRegex) {
              pdfDateStringRegex = new RegExp("^D:" + "(\\d{4})" + "(\\d{2})?" + "(\\d{2})?" + "(\\d{2})?" + "(\\d{2})?" + "(\\d{2})?" + "([Z|+|-])?" + "(\\d{2})?" + "'?" + "(\\d{2})?" + "'?");
            }
            var matches = pdfDateStringRegex.exec(input);
            if (!matches) {
              return null;
            }
            var year = parseInt(matches[1], 10);
            var month = parseInt(matches[2], 10);
            month = month >= 1 && month <= 12 ? month - 1 : 0;
            var day = parseInt(matches[3], 10);
            day = day >= 1 && day <= 31 ? day : 1;
            var hour = parseInt(matches[4], 10);
            hour = hour >= 0 && hour <= 23 ? hour : 0;
            var minute = parseInt(matches[5], 10);
            minute = minute >= 0 && minute <= 59 ? minute : 0;
            var second = parseInt(matches[6], 10);
            second = second >= 0 && second <= 59 ? second : 0;
            var universalTimeRelation = matches[7] || "Z";
            var offsetHour = parseInt(matches[8], 10);
            offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
            var offsetMinute = parseInt(matches[9], 10) || 0;
            offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
            if (universalTimeRelation === "-") {
              hour += offsetHour;
              minute += offsetMinute;
            } else if (universalTimeRelation === "+") {
              hour -= offsetHour;
              minute -= offsetMinute;
            }
            return new Date(Date.UTC(year, month, day, hour, minute, second));
          }
        }]);
      }();
      exports.PDFDateString = PDFDateString;
      function getXfaPageViewport(xfaPage, _ref53) {
        var _ref53$scale = _ref53.scale,
          scale = _ref53$scale === void 0 ? 1 : _ref53$scale,
          _ref53$rotation = _ref53.rotation,
          rotation = _ref53$rotation === void 0 ? 0 : _ref53$rotation;
        var _xfaPage$attributes$s = xfaPage.attributes.style,
          width = _xfaPage$attributes$s.width,
          height = _xfaPage$attributes$s.height;
        var viewBox = [0, 0, parseInt(width), parseInt(height)];
        return new PageViewport({
          viewBox: viewBox,
          scale: scale,
          rotation: rotation
        });
      }
      function getRGB(color) {
        if (color.startsWith("#")) {
          var colorRGB = parseInt(color.slice(1), 16);
          return [(colorRGB & 0xff0000) >> 16, (colorRGB & 0x00ff00) >> 8, colorRGB & 0x0000ff];
        }
        if (color.startsWith("rgb(")) {
          return color.slice(4, -1).split(",").map(function (x) {
            return parseInt(x);
          });
        }
        if (color.startsWith("rgba(")) {
          return color.slice(5, -1).split(",").map(function (x) {
            return parseInt(x);
          }).slice(0, 3);
        }
        (0, _util.warn)("Not a valid color format: \"".concat(color, "\""));
        return [0, 0, 0];
      }
      function getColorValues(colors) {
        var span = document.createElement("span");
        span.style.visibility = "hidden";
        document.body.append(span);
        var _iterator40 = _createForOfIteratorHelper(colors.keys()),
          _step40;
        try {
          for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
            var name = _step40.value;
            span.style.color = name;
            var computedColor = window.getComputedStyle(span).color;
            colors.set(name, getRGB(computedColor));
          }
        } catch (err) {
          _iterator40.e(err);
        } finally {
          _iterator40.f();
        }
        span.remove();
      }
      function getCurrentTransform(ctx) {
        var _ctx$getTransform = ctx.getTransform(),
          a = _ctx$getTransform.a,
          b = _ctx$getTransform.b,
          c = _ctx$getTransform.c,
          d = _ctx$getTransform.d,
          e = _ctx$getTransform.e,
          f = _ctx$getTransform.f;
        return [a, b, c, d, e, f];
      }
      function getCurrentTransformInverse(ctx) {
        var _ctx$getTransform$inv = ctx.getTransform().invertSelf(),
          a = _ctx$getTransform$inv.a,
          b = _ctx$getTransform$inv.b,
          c = _ctx$getTransform$inv.c,
          d = _ctx$getTransform$inv.d,
          e = _ctx$getTransform$inv.e,
          f = _ctx$getTransform$inv.f;
        return [a, b, c, d, e, f];
      }
      function setLayerDimensions(div, viewport) {
        var mustFlip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var mustRotate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        if (viewport instanceof PageViewport) {
          var _viewport$rawDims = viewport.rawDims,
            pageWidth = _viewport$rawDims.pageWidth,
            pageHeight = _viewport$rawDims.pageHeight;
          var style = div.style;
          var widthStr = "calc(var(--scale-factor) * ".concat(pageWidth, "px)");
          var heightStr = "calc(var(--scale-factor) * ".concat(pageHeight, "px)");
          if (!mustFlip || viewport.rotation % 180 === 0) {
            style.width = widthStr;
            style.height = heightStr;
          } else {
            style.width = heightStr;
            style.height = widthStr;
          }
        }
        if (mustRotate) {
          div.setAttribute("data-main-rotation", viewport.rotation);
        }
      }

      /***/
    }), (/* 7 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.BaseStandardFontDataFactory = exports.BaseSVGFactory = exports.BaseCanvasFactory = exports.BaseCMapReaderFactory = void 0;
      var _util = __w_pdfjs_require__(1);
      var BaseCanvasFactory = /*#__PURE__*/function () {
        function BaseCanvasFactory() {
          _classCallCheck(this, BaseCanvasFactory);
          if (this.constructor === BaseCanvasFactory) {
            (0, _util.unreachable)("Cannot initialize BaseCanvasFactory.");
          }
        }
        return _createClass(BaseCanvasFactory, [{
          key: "create",
          value: function create(width, height) {
            if (width <= 0 || height <= 0) {
              throw new Error("Invalid canvas size");
            }
            var canvas = this._createCanvas(width, height);
            return {
              canvas: canvas,
              context: canvas.getContext("2d")
            };
          }
        }, {
          key: "reset",
          value: function reset(canvasAndContext, width, height) {
            if (!canvasAndContext.canvas) {
              throw new Error("Canvas is not specified");
            }
            if (width <= 0 || height <= 0) {
              throw new Error("Invalid canvas size");
            }
            canvasAndContext.canvas.width = width;
            canvasAndContext.canvas.height = height;
          }
        }, {
          key: "destroy",
          value: function destroy(canvasAndContext) {
            if (!canvasAndContext.canvas) {
              throw new Error("Canvas is not specified");
            }
            canvasAndContext.canvas.width = 0;
            canvasAndContext.canvas.height = 0;
            canvasAndContext.canvas = null;
            canvasAndContext.context = null;
          }
        }, {
          key: "_createCanvas",
          value: function _createCanvas(width, height) {
            (0, _util.unreachable)("Abstract method `_createCanvas` called.");
          }
        }]);
      }();
      exports.BaseCanvasFactory = BaseCanvasFactory;
      var BaseCMapReaderFactory = /*#__PURE__*/function () {
        function BaseCMapReaderFactory(_ref54) {
          var _ref54$baseUrl = _ref54.baseUrl,
            baseUrl = _ref54$baseUrl === void 0 ? null : _ref54$baseUrl,
            _ref54$isCompressed = _ref54.isCompressed,
            isCompressed = _ref54$isCompressed === void 0 ? true : _ref54$isCompressed;
          _classCallCheck(this, BaseCMapReaderFactory);
          if (this.constructor === BaseCMapReaderFactory) {
            (0, _util.unreachable)("Cannot initialize BaseCMapReaderFactory.");
          }
          this.baseUrl = baseUrl;
          this.isCompressed = isCompressed;
        }
        return _createClass(BaseCMapReaderFactory, [{
          key: "fetch",
          value: function () {
            var _fetch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_ref55) {
              var _this24 = this;
              var name, url, compressionType;
              return _regenerator().w(function (_context8) {
                while (1) switch (_context8.n) {
                  case 0:
                    name = _ref55.name;
                    if (this.baseUrl) {
                      _context8.n = 1;
                      break;
                    }
                    throw new Error('The CMap "baseUrl" parameter must be specified, ensure that ' + 'the "cMapUrl" and "cMapPacked" API parameters are provided.');
                  case 1:
                    if (name) {
                      _context8.n = 2;
                      break;
                    }
                    throw new Error("CMap name must be specified.");
                  case 2:
                    url = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
                    compressionType = this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE;
                    return _context8.a(2, this._fetchData(url, compressionType).catch(function (reason) {
                      throw new Error("Unable to load ".concat(_this24.isCompressed ? "binary " : "", "CMap at: ").concat(url));
                    }));
                }
              }, _callee8, this);
            }));
            function fetch(_x4) {
              return _fetch.apply(this, arguments);
            }
            return fetch;
          }()
        }, {
          key: "_fetchData",
          value: function _fetchData(url, compressionType) {
            (0, _util.unreachable)("Abstract method `_fetchData` called.");
          }
        }]);
      }();
      exports.BaseCMapReaderFactory = BaseCMapReaderFactory;
      var BaseStandardFontDataFactory = /*#__PURE__*/function () {
        function BaseStandardFontDataFactory(_ref56) {
          var _ref56$baseUrl = _ref56.baseUrl,
            baseUrl = _ref56$baseUrl === void 0 ? null : _ref56$baseUrl;
          _classCallCheck(this, BaseStandardFontDataFactory);
          if (this.constructor === BaseStandardFontDataFactory) {
            (0, _util.unreachable)("Cannot initialize BaseStandardFontDataFactory.");
          }
          this.baseUrl = baseUrl;
        }
        return _createClass(BaseStandardFontDataFactory, [{
          key: "fetch",
          value: function () {
            var _fetch2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(_ref57) {
              var filename, url;
              return _regenerator().w(function (_context9) {
                while (1) switch (_context9.n) {
                  case 0:
                    filename = _ref57.filename;
                    if (this.baseUrl) {
                      _context9.n = 1;
                      break;
                    }
                    throw new Error('The standard font "baseUrl" parameter must be specified, ensure that ' + 'the "standardFontDataUrl" API parameter is provided.');
                  case 1:
                    if (filename) {
                      _context9.n = 2;
                      break;
                    }
                    throw new Error("Font filename must be specified.");
                  case 2:
                    url = "".concat(this.baseUrl).concat(filename);
                    return _context9.a(2, this._fetchData(url).catch(function (reason) {
                      throw new Error("Unable to load font data at: ".concat(url));
                    }));
                }
              }, _callee9, this);
            }));
            function fetch(_x5) {
              return _fetch2.apply(this, arguments);
            }
            return fetch;
          }()
        }, {
          key: "_fetchData",
          value: function _fetchData(url) {
            (0, _util.unreachable)("Abstract method `_fetchData` called.");
          }
        }]);
      }();
      exports.BaseStandardFontDataFactory = BaseStandardFontDataFactory;
      var BaseSVGFactory = /*#__PURE__*/function () {
        function BaseSVGFactory() {
          _classCallCheck(this, BaseSVGFactory);
          if (this.constructor === BaseSVGFactory) {
            (0, _util.unreachable)("Cannot initialize BaseSVGFactory.");
          }
        }
        return _createClass(BaseSVGFactory, [{
          key: "create",
          value: function create(width, height) {
            var skipDimensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            if (width <= 0 || height <= 0) {
              throw new Error("Invalid SVG dimensions");
            }
            var svg = this._createSVG("svg:svg");
            svg.setAttribute("version", "1.1");
            if (!skipDimensions) {
              svg.setAttribute("width", "".concat(width, "px"));
              svg.setAttribute("height", "".concat(height, "px"));
            }
            svg.setAttribute("preserveAspectRatio", "none");
            svg.setAttribute("viewBox", "0 0 ".concat(width, " ").concat(height));
            return svg;
          }
        }, {
          key: "createElement",
          value: function createElement(type) {
            if (typeof type !== "string") {
              throw new Error("Invalid SVG element type");
            }
            return this._createSVG(type);
          }
        }, {
          key: "_createSVG",
          value: function _createSVG(type) {
            (0, _util.unreachable)("Abstract method `_createSVG` called.");
          }
        }]);
      }();
      exports.BaseSVGFactory = BaseSVGFactory;

      /***/
    }), (/* 8 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.MurmurHash3_64 = void 0;
      var _util = __w_pdfjs_require__(1);
      var SEED = 0xc3d2e1f0;
      var MASK_HIGH = 0xffff0000;
      var MASK_LOW = 0xffff;
      var MurmurHash3_64 = /*#__PURE__*/function () {
        function MurmurHash3_64(seed) {
          _classCallCheck(this, MurmurHash3_64);
          this.h1 = seed ? seed & 0xffffffff : SEED;
          this.h2 = seed ? seed & 0xffffffff : SEED;
        }
        return _createClass(MurmurHash3_64, [{
          key: "update",
          value: function update(input) {
            var data, length;
            if (typeof input === "string") {
              data = new Uint8Array(input.length * 2);
              length = 0;
              for (var i = 0, ii = input.length; i < ii; i++) {
                var code = input.charCodeAt(i);
                if (code <= 0xff) {
                  data[length++] = code;
                } else {
                  data[length++] = code >>> 8;
                  data[length++] = code & 0xff;
                }
              }
            } else if ((0, _util.isArrayBuffer)(input)) {
              data = input.slice();
              length = data.byteLength;
            } else {
              throw new Error("Wrong data format in MurmurHash3_64_update. " + "Input must be a string or array.");
            }
            var blockCounts = length >> 2;
            var tailLength = length - blockCounts * 4;
            var dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
            var k1 = 0,
              k2 = 0;
            var h1 = this.h1,
              h2 = this.h2;
            var C1 = 0xcc9e2d51,
              C2 = 0x1b873593;
            var C1_LOW = C1 & MASK_LOW,
              C2_LOW = C2 & MASK_LOW;
            for (var _i5 = 0; _i5 < blockCounts; _i5++) {
              if (_i5 & 1) {
                k1 = dataUint32[_i5];
                k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                k1 = k1 << 15 | k1 >>> 17;
                k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                h1 ^= k1;
                h1 = h1 << 13 | h1 >>> 19;
                h1 = h1 * 5 + 0xe6546b64;
              } else {
                k2 = dataUint32[_i5];
                k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
                k2 = k2 << 15 | k2 >>> 17;
                k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
                h2 ^= k2;
                h2 = h2 << 13 | h2 >>> 19;
                h2 = h2 * 5 + 0xe6546b64;
              }
            }
            k1 = 0;
            switch (tailLength) {
              case 3:
                k1 ^= data[blockCounts * 4 + 2] << 16;
              case 2:
                k1 ^= data[blockCounts * 4 + 1] << 8;
              case 1:
                k1 ^= data[blockCounts * 4];
                k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                k1 = k1 << 15 | k1 >>> 17;
                k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                if (blockCounts & 1) {
                  h1 ^= k1;
                } else {
                  h2 ^= k1;
                }
            }
            this.h1 = h1;
            this.h2 = h2;
          }
        }, {
          key: "hexdigest",
          value: function hexdigest() {
            var h1 = this.h1,
              h2 = this.h2;
            h1 ^= h2 >>> 1;
            h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
            h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
            h1 ^= h2 >>> 1;
            h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
            h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
            h1 ^= h2 >>> 1;
            return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
          }
        }]);
      }();
      exports.MurmurHash3_64 = MurmurHash3_64;

      /***/
    }), (/* 9 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.FontLoader = exports.FontFaceObject = void 0;
      var _util = __w_pdfjs_require__(1);
      var _is_node = __w_pdfjs_require__(10);
      var FontLoader = /*#__PURE__*/function () {
        function FontLoader(_ref58) {
          var onUnsupportedFeature = _ref58.onUnsupportedFeature,
            _ref58$ownerDocument = _ref58.ownerDocument,
            ownerDocument = _ref58$ownerDocument === void 0 ? globalThis.document : _ref58$ownerDocument,
            _ref58$styleElement = _ref58.styleElement,
            styleElement = _ref58$styleElement === void 0 ? null : _ref58$styleElement;
          _classCallCheck(this, FontLoader);
          this._onUnsupportedFeature = onUnsupportedFeature;
          this._document = ownerDocument;
          this.nativeFontFaces = [];
          this.styleElement = null;
          this.loadingRequests = [];
          this.loadTestFontId = 0;
        }
        return _createClass(FontLoader, [{
          key: "addNativeFontFace",
          value: function addNativeFontFace(nativeFontFace) {
            this.nativeFontFaces.push(nativeFontFace);
            this._document.fonts.add(nativeFontFace);
          }
        }, {
          key: "insertRule",
          value: function insertRule(rule) {
            if (!this.styleElement) {
              this.styleElement = this._document.createElement("style");
              this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
            }
            var styleSheet = this.styleElement.sheet;
            styleSheet.insertRule(rule, styleSheet.cssRules.length);
          }
        }, {
          key: "clear",
          value: function clear() {
            var _iterator41 = _createForOfIteratorHelper(this.nativeFontFaces),
              _step41;
            try {
              for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
                var nativeFontFace = _step41.value;
                this._document.fonts.delete(nativeFontFace);
              }
            } catch (err) {
              _iterator41.e(err);
            } finally {
              _iterator41.f();
            }
            this.nativeFontFaces.length = 0;
            if (this.styleElement) {
              this.styleElement.remove();
              this.styleElement = null;
            }
          }
        }, {
          key: "bind",
          value: function () {
            var _bind = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(font) {
              var _this25 = this;
              var nativeFontFace, rule, _t7;
              return _regenerator().w(function (_context0) {
                while (1) switch (_context0.p = _context0.n) {
                  case 0:
                    if (!(font.attached || font.missingFile)) {
                      _context0.n = 1;
                      break;
                    }
                    return _context0.a(2);
                  case 1:
                    font.attached = true;
                    if (!this.isFontLoadingAPISupported) {
                      _context0.n = 6;
                      break;
                    }
                    nativeFontFace = font.createNativeFontFace();
                    if (!nativeFontFace) {
                      _context0.n = 5;
                      break;
                    }
                    this.addNativeFontFace(nativeFontFace);
                    _context0.p = 2;
                    _context0.n = 3;
                    return nativeFontFace.loaded;
                  case 3:
                    _context0.n = 5;
                    break;
                  case 4:
                    _context0.p = 4;
                    _t7 = _context0.v;
                    this._onUnsupportedFeature({
                      featureId: _util.UNSUPPORTED_FEATURES.errorFontLoadNative
                    });
                    (0, _util.warn)("Failed to load font '".concat(nativeFontFace.family, "': '").concat(_t7, "'."));
                    font.disableFontFace = true;
                    throw _t7;
                  case 5:
                    return _context0.a(2);
                  case 6:
                    rule = font.createFontFaceRule();
                    if (!rule) {
                      _context0.n = 8;
                      break;
                    }
                    this.insertRule(rule);
                    if (!this.isSyncFontLoadingSupported) {
                      _context0.n = 7;
                      break;
                    }
                    return _context0.a(2);
                  case 7:
                    _context0.n = 8;
                    return new Promise(function (resolve) {
                      var request = _this25._queueLoadingCallback(resolve);
                      _this25._prepareFontLoadEvent(font, request);
                    });
                  case 8:
                    return _context0.a(2);
                }
              }, _callee0, this, [[2, 4]]);
            }));
            function bind(_x6) {
              return _bind.apply(this, arguments);
            }
            return bind;
          }()
        }, {
          key: "isFontLoadingAPISupported",
          get: function get() {
            var _this$_document;
            var hasFonts = !!((_this$_document = this._document) !== null && _this$_document !== void 0 && _this$_document.fonts);
            return (0, _util.shadow)(this, "isFontLoadingAPISupported", hasFonts);
          }
        }, {
          key: "isSyncFontLoadingSupported",
          get: function get() {
            var supported = false;
            if (_is_node.isNodeJS) {
              supported = true;
            } else if (typeof navigator !== "undefined" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) {
              supported = true;
            }
            return (0, _util.shadow)(this, "isSyncFontLoadingSupported", supported);
          }
        }, {
          key: "_queueLoadingCallback",
          value: function _queueLoadingCallback(callback) {
            function completeRequest() {
              (0, _util.assert)(!request.done, "completeRequest() cannot be called twice.");
              request.done = true;
              while (loadingRequests.length > 0 && loadingRequests[0].done) {
                var otherRequest = loadingRequests.shift();
                setTimeout(otherRequest.callback, 0);
              }
            }
            var loadingRequests = this.loadingRequests;
            var request = {
              done: false,
              complete: completeRequest,
              callback: callback
            };
            loadingRequests.push(request);
            return request;
          }
        }, {
          key: "_loadTestFont",
          get: function get() {
            var testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQA" + "FQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAA" + "ALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgA" + "AAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1" + "AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD" + "6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACM" + "AooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4D" + "IP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAA" + "AAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUA" + "AQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgAB" + "AAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABY" + "AAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAA" + "AC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAA" + "AAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQAC" + "AQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3" + "Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTj" + "FQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
            return (0, _util.shadow)(this, "_loadTestFont", testFont);
          }
        }, {
          key: "_prepareFontLoadEvent",
          value: function _prepareFontLoadEvent(font, request) {
            function int32(data, offset) {
              return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
            }
            function spliceString(s, offset, remove, insert) {
              var chunk1 = s.substring(0, offset);
              var chunk2 = s.substring(offset + remove);
              return chunk1 + insert + chunk2;
            }
            var i, ii;
            var canvas = this._document.createElement("canvas");
            canvas.width = 1;
            canvas.height = 1;
            var ctx = canvas.getContext("2d");
            var called = 0;
            function isFontReady(name, callback) {
              if (++called > 30) {
                (0, _util.warn)("Load test font never loaded.");
                callback();
                return;
              }
              ctx.font = "30px " + name;
              ctx.fillText(".", 0, 20);
              var imageData = ctx.getImageData(0, 0, 1, 1);
              if (imageData.data[3] > 0) {
                callback();
                return;
              }
              setTimeout(isFontReady.bind(null, name, callback));
            }
            var loadTestFontId = "lt".concat(Date.now()).concat(this.loadTestFontId++);
            var data = this._loadTestFont;
            var COMMENT_OFFSET = 976;
            data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
            var CFF_CHECKSUM_OFFSET = 16;
            var XXXX_VALUE = 0x58585858;
            var checksum = int32(data, CFF_CHECKSUM_OFFSET);
            for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
              checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
            }
            if (i < loadTestFontId.length) {
              checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
            }
            data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
            var url = "url(data:font/opentype;base64,".concat(btoa(data), ");");
            var rule = "@font-face {font-family:\"".concat(loadTestFontId, "\";src:").concat(url, "}");
            this.insertRule(rule);
            var div = this._document.createElement("div");
            div.style.visibility = "hidden";
            div.style.width = div.style.height = "10px";
            div.style.position = "absolute";
            div.style.top = div.style.left = "0px";
            for (var _i6 = 0, _arr = [font.loadedName, loadTestFontId]; _i6 < _arr.length; _i6++) {
              var name = _arr[_i6];
              var span = this._document.createElement("span");
              span.textContent = "Hi";
              span.style.fontFamily = name;
              div.append(span);
            }
            this._document.body.append(div);
            isFontReady(loadTestFontId, function () {
              div.remove();
              request.complete();
            });
          }
        }]);
      }();
      exports.FontLoader = FontLoader;
      var FontFaceObject = /*#__PURE__*/function () {
        function FontFaceObject(translatedData, _ref59) {
          var _ref59$isEvalSupporte = _ref59.isEvalSupported,
            isEvalSupported = _ref59$isEvalSupporte === void 0 ? true : _ref59$isEvalSupporte,
            _ref59$disableFontFac = _ref59.disableFontFace,
            disableFontFace = _ref59$disableFontFac === void 0 ? false : _ref59$disableFontFac,
            _ref59$ignoreErrors = _ref59.ignoreErrors,
            ignoreErrors = _ref59$ignoreErrors === void 0 ? false : _ref59$ignoreErrors,
            onUnsupportedFeature = _ref59.onUnsupportedFeature,
            _ref59$fontRegistry = _ref59.fontRegistry,
            fontRegistry = _ref59$fontRegistry === void 0 ? null : _ref59$fontRegistry;
          _classCallCheck(this, FontFaceObject);
          this.compiledGlyphs = Object.create(null);
          for (var i in translatedData) {
            this[i] = translatedData[i];
          }
          this.isEvalSupported = isEvalSupported !== false;
          this.disableFontFace = disableFontFace === true;
          this.ignoreErrors = ignoreErrors === true;
          this._onUnsupportedFeature = onUnsupportedFeature;
          this.fontRegistry = fontRegistry;
        }
        return _createClass(FontFaceObject, [{
          key: "createNativeFontFace",
          value: function createNativeFontFace() {
            var _this$fontRegistry;
            if (!this.data || this.disableFontFace) {
              return null;
            }
            var nativeFontFace;
            if (!this.cssFontInfo) {
              nativeFontFace = new FontFace(this.loadedName, this.data, {});
            } else {
              var css = {
                weight: this.cssFontInfo.fontWeight
              };
              if (this.cssFontInfo.italicAngle) {
                css.style = "oblique ".concat(this.cssFontInfo.italicAngle, "deg");
              }
              nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
            }
            (_this$fontRegistry = this.fontRegistry) === null || _this$fontRegistry === void 0 || _this$fontRegistry.registerFont(this);
            return nativeFontFace;
          }
        }, {
          key: "createFontFaceRule",
          value: function createFontFaceRule() {
            var _this$fontRegistry2;
            if (!this.data || this.disableFontFace) {
              return null;
            }
            var data = (0, _util.bytesToString)(this.data);
            var url = "url(data:".concat(this.mimetype, ";base64,").concat(btoa(data), ");");
            var rule;
            if (!this.cssFontInfo) {
              rule = "@font-face {font-family:\"".concat(this.loadedName, "\";src:").concat(url, "}");
            } else {
              var css = "font-weight: ".concat(this.cssFontInfo.fontWeight, ";");
              if (this.cssFontInfo.italicAngle) {
                css += "font-style: oblique ".concat(this.cssFontInfo.italicAngle, "deg;");
              }
              rule = "@font-face {font-family:\"".concat(this.cssFontInfo.fontFamily, "\";").concat(css, "src:").concat(url, "}");
            }
            (_this$fontRegistry2 = this.fontRegistry) === null || _this$fontRegistry2 === void 0 || _this$fontRegistry2.registerFont(this, url);
            return rule;
          }
        }, {
          key: "getPathGenerator",
          value: function getPathGenerator(objs, character) {
            if (this.compiledGlyphs[character] !== undefined) {
              return this.compiledGlyphs[character];
            }
            var cmds;
            try {
              cmds = objs.get(this.loadedName + "_path_" + character);
            } catch (ex) {
              if (!this.ignoreErrors) {
                throw ex;
              }
              this._onUnsupportedFeature({
                featureId: _util.UNSUPPORTED_FEATURES.errorFontGetPath
              });
              (0, _util.warn)("getPathGenerator - ignoring character: \"".concat(ex, "\"."));
              return this.compiledGlyphs[character] = function (c, size) {};
            }
            if (this.isEvalSupported && _util.FeatureTest.isEvalSupported) {
              var jsBuf = [];
              var _iterator42 = _createForOfIteratorHelper(cmds),
                _step42;
              try {
                for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
                  var current = _step42.value;
                  var args = current.args !== undefined ? current.args.join(",") : "";
                  jsBuf.push("c.", current.cmd, "(", args, ");\n");
                }
              } catch (err) {
                _iterator42.e(err);
              } finally {
                _iterator42.f();
              }
              return this.compiledGlyphs[character] = new Function("c", "size", jsBuf.join(""));
            }
            return this.compiledGlyphs[character] = function (c, size) {
              var _iterator43 = _createForOfIteratorHelper(cmds),
                _step43;
              try {
                for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
                  var _current = _step43.value;
                  if (_current.cmd === "scale") {
                    _current.args = [size, -size];
                  }
                  c[_current.cmd].apply(c, _current.args);
                }
              } catch (err) {
                _iterator43.e(err);
              } finally {
                _iterator43.f();
              }
            };
          }
        }]);
      }();
      exports.FontFaceObject = FontFaceObject;

      /***/
    }), (/* 10 */
    /***/function (__unused_webpack_module, exports) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.isNodeJS = void 0;
      var isNodeJS = (typeof process === "undefined" ? "undefined" : _typeof(process)) === "object" && process + "" === "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
      exports.isNodeJS = isNodeJS;

      /***/
    }), (/* 11 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.CanvasGraphics = void 0;
      var _util = __w_pdfjs_require__(1);
      var _display_utils = __w_pdfjs_require__(6);
      var _pattern_helper = __w_pdfjs_require__(12);
      var _image_utils = __w_pdfjs_require__(13);
      var MIN_FONT_SIZE = 16;
      var MAX_FONT_SIZE = 100;
      var MAX_GROUP_SIZE = 4096;
      var EXECUTION_TIME = 15;
      var EXECUTION_STEPS = 10;
      var MAX_SIZE_TO_COMPILE = 1000;
      var FULL_CHUNK_HEIGHT = 16;
      function mirrorContextOperations(ctx, destCtx) {
        if (ctx._removeMirroring) {
          throw new Error("Context is already forwarding operations.");
        }
        ctx.__originalSave = ctx.save;
        ctx.__originalRestore = ctx.restore;
        ctx.__originalRotate = ctx.rotate;
        ctx.__originalScale = ctx.scale;
        ctx.__originalTranslate = ctx.translate;
        ctx.__originalTransform = ctx.transform;
        ctx.__originalSetTransform = ctx.setTransform;
        ctx.__originalResetTransform = ctx.resetTransform;
        ctx.__originalClip = ctx.clip;
        ctx.__originalMoveTo = ctx.moveTo;
        ctx.__originalLineTo = ctx.lineTo;
        ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
        ctx.__originalRect = ctx.rect;
        ctx.__originalClosePath = ctx.closePath;
        ctx.__originalBeginPath = ctx.beginPath;
        ctx._removeMirroring = function () {
          ctx.save = ctx.__originalSave;
          ctx.restore = ctx.__originalRestore;
          ctx.rotate = ctx.__originalRotate;
          ctx.scale = ctx.__originalScale;
          ctx.translate = ctx.__originalTranslate;
          ctx.transform = ctx.__originalTransform;
          ctx.setTransform = ctx.__originalSetTransform;
          ctx.resetTransform = ctx.__originalResetTransform;
          ctx.clip = ctx.__originalClip;
          ctx.moveTo = ctx.__originalMoveTo;
          ctx.lineTo = ctx.__originalLineTo;
          ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
          ctx.rect = ctx.__originalRect;
          ctx.closePath = ctx.__originalClosePath;
          ctx.beginPath = ctx.__originalBeginPath;
          delete ctx._removeMirroring;
        };
        ctx.save = function ctxSave() {
          destCtx.save();
          this.__originalSave();
        };
        ctx.restore = function ctxRestore() {
          destCtx.restore();
          this.__originalRestore();
        };
        ctx.translate = function ctxTranslate(x, y) {
          destCtx.translate(x, y);
          this.__originalTranslate(x, y);
        };
        ctx.scale = function ctxScale(x, y) {
          destCtx.scale(x, y);
          this.__originalScale(x, y);
        };
        ctx.transform = function ctxTransform(a, b, c, d, e, f) {
          destCtx.transform(a, b, c, d, e, f);
          this.__originalTransform(a, b, c, d, e, f);
        };
        ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
          destCtx.setTransform(a, b, c, d, e, f);
          this.__originalSetTransform(a, b, c, d, e, f);
        };
        ctx.resetTransform = function ctxResetTransform() {
          destCtx.resetTransform();
          this.__originalResetTransform();
        };
        ctx.rotate = function ctxRotate(angle) {
          destCtx.rotate(angle);
          this.__originalRotate(angle);
        };
        ctx.clip = function ctxRotate(rule) {
          destCtx.clip(rule);
          this.__originalClip(rule);
        };
        ctx.moveTo = function (x, y) {
          destCtx.moveTo(x, y);
          this.__originalMoveTo(x, y);
        };
        ctx.lineTo = function (x, y) {
          destCtx.lineTo(x, y);
          this.__originalLineTo(x, y);
        };
        ctx.bezierCurveTo = function (cp1x, cp1y, cp2x, cp2y, x, y) {
          destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
          this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
        };
        ctx.rect = function (x, y, width, height) {
          destCtx.rect(x, y, width, height);
          this.__originalRect(x, y, width, height);
        };
        ctx.closePath = function () {
          destCtx.closePath();
          this.__originalClosePath();
        };
        ctx.beginPath = function () {
          destCtx.beginPath();
          this.__originalBeginPath();
        };
      }
      var CachedCanvases = /*#__PURE__*/function () {
        function CachedCanvases(canvasFactory) {
          _classCallCheck(this, CachedCanvases);
          this.canvasFactory = canvasFactory;
          this.cache = Object.create(null);
        }
        return _createClass(CachedCanvases, [{
          key: "getCanvas",
          value: function getCanvas(id, width, height) {
            var canvasEntry;
            if (this.cache[id] !== undefined) {
              canvasEntry = this.cache[id];
              this.canvasFactory.reset(canvasEntry, width, height);
            } else {
              canvasEntry = this.canvasFactory.create(width, height);
              this.cache[id] = canvasEntry;
            }
            return canvasEntry;
          }
        }, {
          key: "delete",
          value: function _delete(id) {
            delete this.cache[id];
          }
        }, {
          key: "clear",
          value: function clear() {
            for (var _id2 in this.cache) {
              var canvasEntry = this.cache[_id2];
              this.canvasFactory.destroy(canvasEntry);
              delete this.cache[_id2];
            }
          }
        }]);
      }();
      function drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
        var _ref60 = (0, _display_utils.getCurrentTransform)(ctx),
          _ref61 = _slicedToArray(_ref60, 6),
          a = _ref61[0],
          b = _ref61[1],
          c = _ref61[2],
          d = _ref61[3],
          tx = _ref61[4],
          ty = _ref61[5];
        if (b === 0 && c === 0) {
          var tlX = destX * a + tx;
          var rTlX = Math.round(tlX);
          var tlY = destY * d + ty;
          var rTlY = Math.round(tlY);
          var brX = (destX + destW) * a + tx;
          var rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
          var brY = (destY + destH) * d + ty;
          var rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
          ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
          ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
          ctx.setTransform(a, b, c, d, tx, ty);
          return [rWidth, rHeight];
        }
        if (a === 0 && d === 0) {
          var _tlX = destY * c + tx;
          var _rTlX = Math.round(_tlX);
          var _tlY = destX * b + ty;
          var _rTlY = Math.round(_tlY);
          var _brX = (destY + destH) * c + tx;
          var _rWidth = Math.abs(Math.round(_brX) - _rTlX) || 1;
          var _brY = (destX + destW) * b + ty;
          var _rHeight = Math.abs(Math.round(_brY) - _rTlY) || 1;
          ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, _rTlX, _rTlY);
          ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, _rHeight, _rWidth);
          ctx.setTransform(a, b, c, d, tx, ty);
          return [_rHeight, _rWidth];
        }
        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
        var scaleX = Math.hypot(a, b);
        var scaleY = Math.hypot(c, d);
        return [scaleX * destW, scaleY * destH];
      }
      function compileType3Glyph(imgData) {
        var width = imgData.width,
          height = imgData.height;
        if (width > MAX_SIZE_TO_COMPILE || height > MAX_SIZE_TO_COMPILE) {
          return null;
        }
        var POINT_TO_PROCESS_LIMIT = 1000;
        var POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
        var width1 = width + 1;
        var points = new Uint8Array(width1 * (height + 1));
        var i, j, j0;
        var lineSize = width + 7 & ~7;
        var data = new Uint8Array(lineSize * height),
          pos = 0;
        var _iterator44 = _createForOfIteratorHelper(imgData.data),
          _step44;
        try {
          for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
            var elem = _step44.value;
            var mask = 128;
            while (mask > 0) {
              data[pos++] = elem & mask ? 0 : 255;
              mask >>= 1;
            }
          }
        } catch (err) {
          _iterator44.e(err);
        } finally {
          _iterator44.f();
        }
        var count = 0;
        pos = 0;
        if (data[pos] !== 0) {
          points[0] = 1;
          ++count;
        }
        for (j = 1; j < width; j++) {
          if (data[pos] !== data[pos + 1]) {
            points[j] = data[pos] ? 2 : 1;
            ++count;
          }
          pos++;
        }
        if (data[pos] !== 0) {
          points[j] = 2;
          ++count;
        }
        for (i = 1; i < height; i++) {
          pos = i * lineSize;
          j0 = i * width1;
          if (data[pos - lineSize] !== data[pos]) {
            points[j0] = data[pos] ? 1 : 8;
            ++count;
          }
          var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
          for (j = 1; j < width; j++) {
            sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
            if (POINT_TYPES[sum]) {
              points[j0 + j] = POINT_TYPES[sum];
              ++count;
            }
            pos++;
          }
          if (data[pos - lineSize] !== data[pos]) {
            points[j0 + j] = data[pos] ? 2 : 4;
            ++count;
          }
          if (count > POINT_TO_PROCESS_LIMIT) {
            return null;
          }
        }
        pos = lineSize * (height - 1);
        j0 = i * width1;
        if (data[pos] !== 0) {
          points[j0] = 8;
          ++count;
        }
        for (j = 1; j < width; j++) {
          if (data[pos] !== data[pos + 1]) {
            points[j0 + j] = data[pos] ? 4 : 8;
            ++count;
          }
          pos++;
        }
        if (data[pos] !== 0) {
          points[j0 + j] = 4;
          ++count;
        }
        if (count > POINT_TO_PROCESS_LIMIT) {
          return null;
        }
        var steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
        var path = new Path2D();
        for (i = 0; count && i <= height; i++) {
          var p = i * width1;
          var end = p + width;
          while (p < end && !points[p]) {
            p++;
          }
          if (p === end) {
            continue;
          }
          path.moveTo(p % width1, i);
          var p0 = p;
          var type = points[p];
          do {
            var step = steps[type];
            do {
              p += step;
            } while (!points[p]);
            var pp = points[p];
            if (pp !== 5 && pp !== 10) {
              type = pp;
              points[p] = 0;
            } else {
              type = pp & 0x33 * type >> 4;
              points[p] &= type >> 2 | type << 2;
            }
            path.lineTo(p % width1, p / width1 | 0);
            if (!points[p]) {
              --count;
            }
          } while (p0 !== p);
          --i;
        }
        data = null;
        points = null;
        var drawOutline = function drawOutline(c) {
          c.save();
          c.scale(1 / width, -1 / height);
          c.translate(0, -height);
          c.fill(path);
          c.beginPath();
          c.restore();
        };
        return drawOutline;
      }
      var CanvasExtraState = /*#__PURE__*/function () {
        function CanvasExtraState(width, height) {
          _classCallCheck(this, CanvasExtraState);
          this.alphaIsShape = false;
          this.fontSize = 0;
          this.fontSizeScale = 1;
          this.textMatrix = _util.IDENTITY_MATRIX;
          this.textMatrixScale = 1;
          this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
          this.leading = 0;
          this.x = 0;
          this.y = 0;
          this.lineX = 0;
          this.lineY = 0;
          this.charSpacing = 0;
          this.wordSpacing = 0;
          this.textHScale = 1;
          this.textRenderingMode = _util.TextRenderingMode.FILL;
          this.textRise = 0;
          this.fillColor = "#000000";
          this.strokeColor = "#000000";
          this.patternFill = false;
          this.fillAlpha = 1;
          this.strokeAlpha = 1;
          this.lineWidth = 1;
          this.activeSMask = null;
          this.transferMaps = null;
          this.startNewPathAndClipBox([0, 0, width, height]);
        }
        return _createClass(CanvasExtraState, [{
          key: "clone",
          value: function clone() {
            var clone = Object.create(this);
            clone.clipBox = this.clipBox.slice();
            return clone;
          }
        }, {
          key: "setCurrentPoint",
          value: function setCurrentPoint(x, y) {
            this.x = x;
            this.y = y;
          }
        }, {
          key: "updatePathMinMax",
          value: function updatePathMinMax(transform, x, y) {
            var _util$Util$applyTrans = _util.Util.applyTransform([x, y], transform);
            var _util$Util$applyTrans2 = _slicedToArray(_util$Util$applyTrans, 2);
            x = _util$Util$applyTrans2[0];
            y = _util$Util$applyTrans2[1];
            this.minX = Math.min(this.minX, x);
            this.minY = Math.min(this.minY, y);
            this.maxX = Math.max(this.maxX, x);
            this.maxY = Math.max(this.maxY, y);
          }
        }, {
          key: "updateRectMinMax",
          value: function updateRectMinMax(transform, rect) {
            var p1 = _util.Util.applyTransform(rect, transform);
            var p2 = _util.Util.applyTransform(rect.slice(2), transform);
            this.minX = Math.min(this.minX, p1[0], p2[0]);
            this.minY = Math.min(this.minY, p1[1], p2[1]);
            this.maxX = Math.max(this.maxX, p1[0], p2[0]);
            this.maxY = Math.max(this.maxY, p1[1], p2[1]);
          }
        }, {
          key: "updateScalingPathMinMax",
          value: function updateScalingPathMinMax(transform, minMax) {
            _util.Util.scaleMinMax(transform, minMax);
            this.minX = Math.min(this.minX, minMax[0]);
            this.maxX = Math.max(this.maxX, minMax[1]);
            this.minY = Math.min(this.minY, minMax[2]);
            this.maxY = Math.max(this.maxY, minMax[3]);
          }
        }, {
          key: "updateCurvePathMinMax",
          value: function updateCurvePathMinMax(transform, x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
            var box = _util.Util.bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3);
            if (minMax) {
              minMax[0] = Math.min(minMax[0], box[0], box[2]);
              minMax[1] = Math.max(minMax[1], box[0], box[2]);
              minMax[2] = Math.min(minMax[2], box[1], box[3]);
              minMax[3] = Math.max(minMax[3], box[1], box[3]);
              return;
            }
            this.updateRectMinMax(transform, box);
          }
        }, {
          key: "getPathBoundingBox",
          value: function getPathBoundingBox() {
            var pathType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _pattern_helper.PathType.FILL;
            var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var box = [this.minX, this.minY, this.maxX, this.maxY];
            if (pathType === _pattern_helper.PathType.STROKE) {
              if (!transform) {
                (0, _util.unreachable)("Stroke bounding box must include transform.");
              }
              var scale = _util.Util.singularValueDecompose2dScale(transform);
              var xStrokePad = scale[0] * this.lineWidth / 2;
              var yStrokePad = scale[1] * this.lineWidth / 2;
              box[0] -= xStrokePad;
              box[1] -= yStrokePad;
              box[2] += xStrokePad;
              box[3] += yStrokePad;
            }
            return box;
          }
        }, {
          key: "updateClipFromPath",
          value: function updateClipFromPath() {
            var intersect = _util.Util.intersect(this.clipBox, this.getPathBoundingBox());
            this.startNewPathAndClipBox(intersect || [0, 0, 0, 0]);
          }
        }, {
          key: "isEmptyClip",
          value: function isEmptyClip() {
            return this.minX === Infinity;
          }
        }, {
          key: "startNewPathAndClipBox",
          value: function startNewPathAndClipBox(box) {
            this.clipBox = box;
            this.minX = Infinity;
            this.minY = Infinity;
            this.maxX = 0;
            this.maxY = 0;
          }
        }, {
          key: "getClippedPathBoundingBox",
          value: function getClippedPathBoundingBox() {
            var pathType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _pattern_helper.PathType.FILL;
            var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            return _util.Util.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
          }
        }]);
      }();
      function putBinaryImageData(ctx, imgData) {
        var transferMaps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
          ctx.putImageData(imgData, 0, 0);
          return;
        }
        var height = imgData.height,
          width = imgData.width;
        var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
        var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
        var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
        var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
        var srcPos = 0,
          destPos;
        var src = imgData.data;
        var dest = chunkImgData.data;
        var i, j, thisChunkHeight, elemsInThisChunk;
        var transferMapRed, transferMapGreen, transferMapBlue, transferMapGray;
        if (transferMaps) {
          switch (transferMaps.length) {
            case 1:
              transferMapRed = transferMaps[0];
              transferMapGreen = transferMaps[0];
              transferMapBlue = transferMaps[0];
              transferMapGray = transferMaps[0];
              break;
            case 4:
              transferMapRed = transferMaps[0];
              transferMapGreen = transferMaps[1];
              transferMapBlue = transferMaps[2];
              transferMapGray = transferMaps[3];
              break;
          }
        }
        if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
          var srcLength = src.byteLength;
          var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
          var dest32DataLength = dest32.length;
          var fullSrcDiff = width + 7 >> 3;
          var white = 0xffffffff;
          var black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
          if (transferMapGray) {
            if (transferMapGray[0] === 0xff && transferMapGray[0xff] === 0) {
              var _ref62 = [black, white];
              white = _ref62[0];
              black = _ref62[1];
            }
          }
          for (i = 0; i < totalChunks; i++) {
            thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
            destPos = 0;
            for (j = 0; j < thisChunkHeight; j++) {
              var srcDiff = srcLength - srcPos;
              var k = 0;
              var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
              var kEndUnrolled = kEnd & ~7;
              var mask = 0;
              var srcByte = 0;
              for (; k < kEndUnrolled; k += 8) {
                srcByte = src[srcPos++];
                dest32[destPos++] = srcByte & 128 ? white : black;
                dest32[destPos++] = srcByte & 64 ? white : black;
                dest32[destPos++] = srcByte & 32 ? white : black;
                dest32[destPos++] = srcByte & 16 ? white : black;
                dest32[destPos++] = srcByte & 8 ? white : black;
                dest32[destPos++] = srcByte & 4 ? white : black;
                dest32[destPos++] = srcByte & 2 ? white : black;
                dest32[destPos++] = srcByte & 1 ? white : black;
              }
              for (; k < kEnd; k++) {
                if (mask === 0) {
                  srcByte = src[srcPos++];
                  mask = 128;
                }
                dest32[destPos++] = srcByte & mask ? white : black;
                mask >>= 1;
              }
            }
            while (destPos < dest32DataLength) {
              dest32[destPos++] = 0;
            }
            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
          }
        } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
          var hasTransferMaps = !!(transferMapRed || transferMapGreen || transferMapBlue);
          j = 0;
          elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
          for (i = 0; i < fullChunks; i++) {
            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
            srcPos += elemsInThisChunk;
            if (hasTransferMaps) {
              for (var _k = 0; _k < elemsInThisChunk; _k += 4) {
                if (transferMapRed) {
                  dest[_k + 0] = transferMapRed[dest[_k + 0]];
                }
                if (transferMapGreen) {
                  dest[_k + 1] = transferMapGreen[dest[_k + 1]];
                }
                if (transferMapBlue) {
                  dest[_k + 2] = transferMapBlue[dest[_k + 2]];
                }
              }
            }
            ctx.putImageData(chunkImgData, 0, j);
            j += FULL_CHUNK_HEIGHT;
          }
          if (i < totalChunks) {
            elemsInThisChunk = width * partialChunkHeight * 4;
            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
            if (hasTransferMaps) {
              for (var _k2 = 0; _k2 < elemsInThisChunk; _k2 += 4) {
                if (transferMapRed) {
                  dest[_k2 + 0] = transferMapRed[dest[_k2 + 0]];
                }
                if (transferMapGreen) {
                  dest[_k2 + 1] = transferMapGreen[dest[_k2 + 1]];
                }
                if (transferMapBlue) {
                  dest[_k2 + 2] = transferMapBlue[dest[_k2 + 2]];
                }
              }
            }
            ctx.putImageData(chunkImgData, 0, j);
          }
        } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
          var _hasTransferMaps = !!(transferMapRed || transferMapGreen || transferMapBlue);
          thisChunkHeight = FULL_CHUNK_HEIGHT;
          elemsInThisChunk = width * thisChunkHeight;
          for (i = 0; i < totalChunks; i++) {
            if (i >= fullChunks) {
              thisChunkHeight = partialChunkHeight;
              elemsInThisChunk = width * thisChunkHeight;
            }
            destPos = 0;
            for (j = elemsInThisChunk; j--;) {
              dest[destPos++] = src[srcPos++];
              dest[destPos++] = src[srcPos++];
              dest[destPos++] = src[srcPos++];
              dest[destPos++] = 255;
            }
            if (_hasTransferMaps) {
              for (var _k3 = 0; _k3 < destPos; _k3 += 4) {
                if (transferMapRed) {
                  dest[_k3 + 0] = transferMapRed[dest[_k3 + 0]];
                }
                if (transferMapGreen) {
                  dest[_k3 + 1] = transferMapGreen[dest[_k3 + 1]];
                }
                if (transferMapBlue) {
                  dest[_k3 + 2] = transferMapBlue[dest[_k3 + 2]];
                }
              }
            }
            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
          }
        } else {
          throw new Error("bad image kind: ".concat(imgData.kind));
        }
      }
      function putBinaryImageMask(ctx, imgData) {
        if (imgData.bitmap) {
          ctx.drawImage(imgData.bitmap, 0, 0);
          return;
        }
        var height = imgData.height,
          width = imgData.width;
        var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
        var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
        var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
        var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
        var srcPos = 0;
        var src = imgData.data;
        var dest = chunkImgData.data;
        for (var i = 0; i < totalChunks; i++) {
          var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
          var _ref63 = (0, _image_utils.applyMaskImageData)({
            src: src,
            srcPos: srcPos,
            dest: dest,
            width: width,
            height: thisChunkHeight
          });
          srcPos = _ref63.srcPos;
          ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
        }
      }
      function copyCtxState(sourceCtx, destCtx) {
        var properties = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font"];
        for (var _i7 = 0, _properties = properties; _i7 < _properties.length; _i7++) {
          var property = _properties[_i7];
          if (sourceCtx[property] !== undefined) {
            destCtx[property] = sourceCtx[property];
          }
        }
        if (sourceCtx.setLineDash !== undefined) {
          destCtx.setLineDash(sourceCtx.getLineDash());
          destCtx.lineDashOffset = sourceCtx.lineDashOffset;
        }
      }
      function resetCtxToDefault(ctx, foregroundColor) {
        ctx.strokeStyle = ctx.fillStyle = foregroundColor || "#000000";
        ctx.fillRule = "nonzero";
        ctx.globalAlpha = 1;
        ctx.lineWidth = 1;
        ctx.lineCap = "butt";
        ctx.lineJoin = "miter";
        ctx.miterLimit = 10;
        ctx.globalCompositeOperation = "source-over";
        ctx.font = "10px sans-serif";
        if (ctx.setLineDash !== undefined) {
          ctx.setLineDash([]);
          ctx.lineDashOffset = 0;
        }
      }
      function composeSMaskBackdrop(bytes, r0, g0, b0) {
        var length = bytes.length;
        for (var i = 3; i < length; i += 4) {
          var alpha = bytes[i];
          if (alpha === 0) {
            bytes[i - 3] = r0;
            bytes[i - 2] = g0;
            bytes[i - 1] = b0;
          } else if (alpha < 255) {
            var alpha_ = 255 - alpha;
            bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
            bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
            bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
          }
        }
      }
      function composeSMaskAlpha(maskData, layerData, transferMap) {
        var length = maskData.length;
        var scale = 1 / 255;
        for (var i = 3; i < length; i += 4) {
          var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
          layerData[i] = layerData[i] * alpha * scale | 0;
        }
      }
      function composeSMaskLuminosity(maskData, layerData, transferMap) {
        var length = maskData.length;
        for (var i = 3; i < length; i += 4) {
          var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
          layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
        }
      }
      function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
        var hasBackdrop = !!backdrop;
        var r0 = hasBackdrop ? backdrop[0] : 0;
        var g0 = hasBackdrop ? backdrop[1] : 0;
        var b0 = hasBackdrop ? backdrop[2] : 0;
        var composeFn;
        if (subtype === "Luminosity") {
          composeFn = composeSMaskLuminosity;
        } else {
          composeFn = composeSMaskAlpha;
        }
        var PIXELS_TO_PROCESS = 1048576;
        var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
        for (var row = 0; row < height; row += chunkSize) {
          var chunkHeight = Math.min(chunkSize, height - row);
          var maskData = maskCtx.getImageData(layerOffsetX - maskOffsetX, row + (layerOffsetY - maskOffsetY), width, chunkHeight);
          var layerData = layerCtx.getImageData(layerOffsetX, row + layerOffsetY, width, chunkHeight);
          if (hasBackdrop) {
            composeSMaskBackdrop(maskData.data, r0, g0, b0);
          }
          composeFn(maskData.data, layerData.data, transferMap);
          layerCtx.putImageData(layerData, layerOffsetX, row + layerOffsetY);
        }
      }
      function composeSMask(ctx, smask, layerCtx, layerBox) {
        var layerOffsetX = layerBox[0];
        var layerOffsetY = layerBox[1];
        var layerWidth = layerBox[2] - layerOffsetX;
        var layerHeight = layerBox[3] - layerOffsetY;
        if (layerWidth === 0 || layerHeight === 0) {
          return;
        }
        genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
        ctx.save();
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = "source-over";
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(layerCtx.canvas, 0, 0);
        ctx.restore();
      }
      function getImageSmoothingEnabled(transform, interpolate) {
        var scale = _util.Util.singularValueDecompose2dScale(transform);
        scale[0] = Math.fround(scale[0]);
        scale[1] = Math.fround(scale[1]);
        var actualScale = Math.fround((globalThis.devicePixelRatio || 1) * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
        if (interpolate !== undefined) {
          return interpolate;
        } else if (scale[0] <= actualScale || scale[1] <= actualScale) {
          return true;
        }
        return false;
      }
      var LINE_CAP_STYLES = ["butt", "round", "square"];
      var LINE_JOIN_STYLES = ["miter", "round", "bevel"];
      var NORMAL_CLIP = {};
      var EO_CLIP = {};
      var _restoreInitialState = /*#__PURE__*/_classPrivateFieldLooseKey("restoreInitialState");
      var CanvasGraphics = /*#__PURE__*/function () {
        function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, _ref64, annotationCanvasMap, pageColors) {
          var optionalContentConfig = _ref64.optionalContentConfig,
            _ref64$markedContentS = _ref64.markedContentStack,
            markedContentStack = _ref64$markedContentS === void 0 ? null : _ref64$markedContentS;
          _classCallCheck(this, CanvasGraphics);
          Object.defineProperty(this, _restoreInitialState, {
            value: _restoreInitialState2
          });
          this.ctx = canvasCtx;
          this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
          this.stateStack = [];
          this.pendingClip = null;
          this.pendingEOFill = false;
          this.res = null;
          this.xobjs = null;
          this.commonObjs = commonObjs;
          this.objs = objs;
          this.canvasFactory = canvasFactory;
          this.groupStack = [];
          this.processingType3 = null;
          this.baseTransform = null;
          this.baseTransformStack = [];
          this.groupLevel = 0;
          this.smaskStack = [];
          this.smaskCounter = 0;
          this.tempSMask = null;
          this.suspendedCtx = null;
          this.contentVisible = true;
          this.markedContentStack = markedContentStack || [];
          this.optionalContentConfig = optionalContentConfig;
          this.cachedCanvases = new CachedCanvases(this.canvasFactory);
          this.cachedPatterns = new Map();
          this.annotationCanvasMap = annotationCanvasMap;
          this.viewportScale = 1;
          this.outputScaleX = 1;
          this.outputScaleY = 1;
          this.backgroundColor = (pageColors === null || pageColors === void 0 ? void 0 : pageColors.background) || null;
          this.foregroundColor = (pageColors === null || pageColors === void 0 ? void 0 : pageColors.foreground) || null;
          this._cachedScaleForStroking = null;
          this._cachedGetSinglePixelWidth = null;
          this._cachedBitmapsMap = new Map();
        }
        return _createClass(CanvasGraphics, [{
          key: "getObject",
          value: function getObject(data) {
            var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            if (typeof data === "string") {
              return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
            }
            return fallback;
          }
        }, {
          key: "beginDrawing",
          value: function beginDrawing(_ref65) {
            var _this$ctx3;
            var transform = _ref65.transform,
              viewport = _ref65.viewport,
              _ref65$transparency = _ref65.transparency,
              transparency = _ref65$transparency === void 0 ? false : _ref65$transparency,
              _ref65$background = _ref65.background,
              background = _ref65$background === void 0 ? null : _ref65$background;
            var width = this.ctx.canvas.width;
            var height = this.ctx.canvas.height;
            var defaultBackgroundColor = background || "#ffffff";
            this.ctx.save();
            if (this.foregroundColor && this.backgroundColor) {
              this.ctx.fillStyle = this.foregroundColor;
              var fg = this.foregroundColor = this.ctx.fillStyle;
              this.ctx.fillStyle = this.backgroundColor;
              var bg = this.backgroundColor = this.ctx.fillStyle;
              var isValidDefaultBg = true;
              var defaultBg = defaultBackgroundColor;
              this.ctx.fillStyle = defaultBackgroundColor;
              defaultBg = this.ctx.fillStyle;
              isValidDefaultBg = typeof defaultBg === "string" && /^#[0-9A-Fa-f]{6}$/.test(defaultBg);
              if (fg === "#000000" && bg === "#ffffff" || fg === bg || !isValidDefaultBg) {
                this.foregroundColor = this.backgroundColor = null;
              } else {
                var _ref66 = (0, _display_utils.getRGB)(defaultBg),
                  _ref67 = _slicedToArray(_ref66, 3),
                  rB = _ref67[0],
                  gB = _ref67[1],
                  bB = _ref67[2];
                var newComp = function newComp(x) {
                  x /= 255;
                  return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
                };
                var lumB = Math.round(0.2126 * newComp(rB) + 0.7152 * newComp(gB) + 0.0722 * newComp(bB));
                this.selectColor = function (r, g, b) {
                  var lumC = 0.2126 * newComp(r) + 0.7152 * newComp(g) + 0.0722 * newComp(b);
                  return Math.round(lumC) === lumB ? bg : fg;
                };
              }
            }
            this.ctx.fillStyle = this.backgroundColor || defaultBackgroundColor;
            this.ctx.fillRect(0, 0, width, height);
            this.ctx.restore();
            if (transparency) {
              var _this$ctx;
              var transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height);
              this.compositeCtx = this.ctx;
              this.transparentCanvas = transparentCanvas.canvas;
              this.ctx = transparentCanvas.context;
              this.ctx.save();
              (_this$ctx = this.ctx).transform.apply(_this$ctx, _toConsumableArray((0, _display_utils.getCurrentTransform)(this.compositeCtx)));
            }
            this.ctx.save();
            resetCtxToDefault(this.ctx, this.foregroundColor);
            if (transform) {
              var _this$ctx2;
              (_this$ctx2 = this.ctx).transform.apply(_this$ctx2, _toConsumableArray(transform));
              this.outputScaleX = transform[0];
              this.outputScaleY = transform[0];
            }
            (_this$ctx3 = this.ctx).transform.apply(_this$ctx3, _toConsumableArray(viewport.transform));
            this.viewportScale = viewport.scale;
            this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
          }
        }, {
          key: "executeOperatorList",
          value: function executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
            var argsArray = operatorList.argsArray;
            var fnArray = operatorList.fnArray;
            var i = executionStartIdx || 0;
            var argsArrayLen = argsArray.length;
            if (argsArrayLen === i) {
              return i;
            }
            var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === "function";
            var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
            var steps = 0;
            var commonObjs = this.commonObjs;
            var objs = this.objs;
            var fnId;
            while (true) {
              if (stepper !== undefined && i === stepper.nextBreakPoint) {
                stepper.breakIt(i, continueCallback);
                return i;
              }
              fnId = fnArray[i];
              if (fnId !== _util.OPS.dependency) {
                this[fnId].apply(this, argsArray[i]);
              } else {
                var _iterator45 = _createForOfIteratorHelper(argsArray[i]),
                  _step45;
                try {
                  for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
                    var depObjId = _step45.value;
                    var objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                    if (!objsPool.has(depObjId)) {
                      objsPool.get(depObjId, continueCallback);
                      return i;
                    }
                  }
                } catch (err) {
                  _iterator45.e(err);
                } finally {
                  _iterator45.f();
                }
              }
              i++;
              if (i === argsArrayLen) {
                return i;
              }
              if (chunkOperations && ++steps > EXECUTION_STEPS) {
                if (Date.now() > endTime) {
                  continueCallback();
                  return i;
                }
                steps = 0;
              }
            }
          }
        }, {
          key: "endDrawing",
          value: function endDrawing() {
            _classPrivateFieldLooseBase(this, _restoreInitialState)[_restoreInitialState]();
            this.cachedCanvases.clear();
            this.cachedPatterns.clear();
            var _iterator46 = _createForOfIteratorHelper(this._cachedBitmapsMap.values()),
              _step46;
            try {
              for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
                var cache = _step46.value;
                var _iterator47 = _createForOfIteratorHelper(cache.values()),
                  _step47;
                try {
                  for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
                    var canvas = _step47.value;
                    if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) {
                      canvas.width = canvas.height = 0;
                    }
                  }
                } catch (err) {
                  _iterator47.e(err);
                } finally {
                  _iterator47.f();
                }
                cache.clear();
              }
            } catch (err) {
              _iterator46.e(err);
            } finally {
              _iterator46.f();
            }
            this._cachedBitmapsMap.clear();
          }
        }, {
          key: "_scaleImage",
          value: function _scaleImage(img, inverseTransform) {
            var width = img.width;
            var height = img.height;
            var widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
            var heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
            var paintWidth = width,
              paintHeight = height;
            var tmpCanvasId = "prescale1";
            var tmpCanvas, tmpCtx;
            while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
              var newWidth = paintWidth,
                newHeight = paintHeight;
              if (widthScale > 2 && paintWidth > 1) {
                newWidth = Math.ceil(paintWidth / 2);
                widthScale /= paintWidth / newWidth;
              }
              if (heightScale > 2 && paintHeight > 1) {
                newHeight = Math.ceil(paintHeight / 2);
                heightScale /= paintHeight / newHeight;
              }
              tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
              tmpCtx = tmpCanvas.context;
              tmpCtx.clearRect(0, 0, newWidth, newHeight);
              tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
              img = tmpCanvas.canvas;
              paintWidth = newWidth;
              paintHeight = newHeight;
              tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
            }
            return {
              img: img,
              paintWidth: paintWidth,
              paintHeight: paintHeight
            };
          }
        }, {
          key: "_createMaskCanvas",
          value: function _createMaskCanvas(img) {
            var ctx = this.ctx;
            var width = img.width,
              height = img.height;
            var fillColor = this.current.fillColor;
            var isPatternFill = this.current.patternFill;
            var currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
            var cache, cacheKey, scaled, maskCanvas;
            if ((img.bitmap || img.data) && img.count > 1) {
              var mainKey = img.bitmap || img.data.buffer;
              cacheKey = JSON.stringify(isPatternFill ? currentTransform : [currentTransform.slice(0, 4), fillColor]);
              cache = this._cachedBitmapsMap.get(mainKey);
              if (!cache) {
                cache = new Map();
                this._cachedBitmapsMap.set(mainKey, cache);
              }
              var cachedImage = cache.get(cacheKey);
              if (cachedImage && !isPatternFill) {
                var _offsetX = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
                var _offsetY = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
                return {
                  canvas: cachedImage,
                  offsetX: _offsetX,
                  offsetY: _offsetY
                };
              }
              scaled = cachedImage;
            }
            if (!scaled) {
              maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
              putBinaryImageMask(maskCanvas.context, img);
            }
            var maskToCanvas = _util.Util.transform(currentTransform, [1 / width, 0, 0, -1 / height, 0, 0]);
            maskToCanvas = _util.Util.transform(maskToCanvas, [1, 0, 0, 1, 0, -height]);
            var cord1 = _util.Util.applyTransform([0, 0], maskToCanvas);
            var cord2 = _util.Util.applyTransform([width, height], maskToCanvas);
            var rect = _util.Util.normalizeRect([cord1[0], cord1[1], cord2[0], cord2[1]]);
            var drawnWidth = Math.round(rect[2] - rect[0]) || 1;
            var drawnHeight = Math.round(rect[3] - rect[1]) || 1;
            var fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight);
            var fillCtx = fillCanvas.context;
            var offsetX = Math.min(cord1[0], cord2[0]);
            var offsetY = Math.min(cord1[1], cord2[1]);
            fillCtx.translate(-offsetX, -offsetY);
            fillCtx.transform.apply(fillCtx, _toConsumableArray(maskToCanvas));
            if (!scaled) {
              scaled = this._scaleImage(maskCanvas.canvas, (0, _display_utils.getCurrentTransformInverse)(fillCtx));
              scaled = scaled.img;
              if (cache && isPatternFill) {
                cache.set(cacheKey, scaled);
              }
            }
            fillCtx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(fillCtx), img.interpolate);
            drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
            fillCtx.globalCompositeOperation = "source-in";
            var inverse = _util.Util.transform((0, _display_utils.getCurrentTransformInverse)(fillCtx), [1, 0, 0, 1, -offsetX, -offsetY]);
            fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, _pattern_helper.PathType.FILL) : fillColor;
            fillCtx.fillRect(0, 0, width, height);
            if (cache && !isPatternFill) {
              this.cachedCanvases.delete("fillCanvas");
              cache.set(cacheKey, fillCanvas.canvas);
            }
            return {
              canvas: fillCanvas.canvas,
              offsetX: Math.round(offsetX),
              offsetY: Math.round(offsetY)
            };
          }
        }, {
          key: "setLineWidth",
          value: function setLineWidth(width) {
            if (width !== this.current.lineWidth) {
              this._cachedScaleForStroking = null;
            }
            this.current.lineWidth = width;
            this.ctx.lineWidth = width;
          }
        }, {
          key: "setLineCap",
          value: function setLineCap(style) {
            this.ctx.lineCap = LINE_CAP_STYLES[style];
          }
        }, {
          key: "setLineJoin",
          value: function setLineJoin(style) {
            this.ctx.lineJoin = LINE_JOIN_STYLES[style];
          }
        }, {
          key: "setMiterLimit",
          value: function setMiterLimit(limit) {
            this.ctx.miterLimit = limit;
          }
        }, {
          key: "setDash",
          value: function setDash(dashArray, dashPhase) {
            var ctx = this.ctx;
            if (ctx.setLineDash !== undefined) {
              ctx.setLineDash(dashArray);
              ctx.lineDashOffset = dashPhase;
            }
          }
        }, {
          key: "setRenderingIntent",
          value: function setRenderingIntent(intent) {}
        }, {
          key: "setFlatness",
          value: function setFlatness(flatness) {}
        }, {
          key: "setGState",
          value: function setGState(states) {
            var _iterator48 = _createForOfIteratorHelper(states),
              _step48;
            try {
              for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
                var _ref68 = _step48.value;
                var _ref69 = _slicedToArray(_ref68, 2);
                var key = _ref69[0];
                var value = _ref69[1];
                switch (key) {
                  case "LW":
                    this.setLineWidth(value);
                    break;
                  case "LC":
                    this.setLineCap(value);
                    break;
                  case "LJ":
                    this.setLineJoin(value);
                    break;
                  case "ML":
                    this.setMiterLimit(value);
                    break;
                  case "D":
                    this.setDash(value[0], value[1]);
                    break;
                  case "RI":
                    this.setRenderingIntent(value);
                    break;
                  case "FL":
                    this.setFlatness(value);
                    break;
                  case "Font":
                    this.setFont(value[0], value[1]);
                    break;
                  case "CA":
                    this.current.strokeAlpha = value;
                    break;
                  case "ca":
                    this.current.fillAlpha = value;
                    this.ctx.globalAlpha = value;
                    break;
                  case "BM":
                    this.ctx.globalCompositeOperation = value;
                    break;
                  case "SMask":
                    this.current.activeSMask = value ? this.tempSMask : null;
                    this.tempSMask = null;
                    this.checkSMaskState();
                    break;
                  case "TR":
                    this.current.transferMaps = value;
                }
              }
            } catch (err) {
              _iterator48.e(err);
            } finally {
              _iterator48.f();
            }
          }
        }, {
          key: "inSMaskMode",
          get: function get() {
            return !!this.suspendedCtx;
          }
        }, {
          key: "checkSMaskState",
          value: function checkSMaskState() {
            var inSMaskMode = this.inSMaskMode;
            if (this.current.activeSMask && !inSMaskMode) {
              this.beginSMaskMode();
            } else if (!this.current.activeSMask && inSMaskMode) {
              this.endSMaskMode();
            }
          }
        }, {
          key: "beginSMaskMode",
          value: function beginSMaskMode() {
            if (this.inSMaskMode) {
              throw new Error("beginSMaskMode called while already in smask mode");
            }
            var drawnWidth = this.ctx.canvas.width;
            var drawnHeight = this.ctx.canvas.height;
            var cacheId = "smaskGroupAt" + this.groupLevel;
            var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
            this.suspendedCtx = this.ctx;
            this.ctx = scratchCanvas.context;
            var ctx = this.ctx;
            ctx.setTransform.apply(ctx, _toConsumableArray((0, _display_utils.getCurrentTransform)(this.suspendedCtx)));
            copyCtxState(this.suspendedCtx, ctx);
            mirrorContextOperations(ctx, this.suspendedCtx);
            this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
          }
        }, {
          key: "endSMaskMode",
          value: function endSMaskMode() {
            if (!this.inSMaskMode) {
              throw new Error("endSMaskMode called while not in smask mode");
            }
            this.ctx._removeMirroring();
            copyCtxState(this.ctx, this.suspendedCtx);
            this.ctx = this.suspendedCtx;
            this.suspendedCtx = null;
          }
        }, {
          key: "compose",
          value: function compose(dirtyBox) {
            if (!this.current.activeSMask) {
              return;
            }
            if (!dirtyBox) {
              dirtyBox = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
            } else {
              dirtyBox[0] = Math.floor(dirtyBox[0]);
              dirtyBox[1] = Math.floor(dirtyBox[1]);
              dirtyBox[2] = Math.ceil(dirtyBox[2]);
              dirtyBox[3] = Math.ceil(dirtyBox[3]);
            }
            var smask = this.current.activeSMask;
            var suspendedCtx = this.suspendedCtx;
            composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
            this.ctx.save();
            this.ctx.setTransform(1, 0, 0, 1, 0, 0);
            this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
            this.ctx.restore();
          }
        }, {
          key: "save",
          value: function save() {
            if (this.inSMaskMode) {
              copyCtxState(this.ctx, this.suspendedCtx);
              this.suspendedCtx.save();
            } else {
              this.ctx.save();
            }
            var old = this.current;
            this.stateStack.push(old);
            this.current = old.clone();
          }
        }, {
          key: "restore",
          value: function restore() {
            if (this.stateStack.length === 0 && this.inSMaskMode) {
              this.endSMaskMode();
            }
            if (this.stateStack.length !== 0) {
              this.current = this.stateStack.pop();
              if (this.inSMaskMode) {
                this.suspendedCtx.restore();
                copyCtxState(this.suspendedCtx, this.ctx);
              } else {
                this.ctx.restore();
              }
              this.checkSMaskState();
              this.pendingClip = null;
              this._cachedScaleForStroking = null;
              this._cachedGetSinglePixelWidth = null;
            }
          }
        }, {
          key: "transform",
          value: function transform(a, b, c, d, e, f) {
            this.ctx.transform(a, b, c, d, e, f);
            this._cachedScaleForStroking = null;
            this._cachedGetSinglePixelWidth = null;
          }
        }, {
          key: "constructPath",
          value: function constructPath(ops, args, minMax) {
            var ctx = this.ctx;
            var current = this.current;
            var x = current.x,
              y = current.y;
            var startX, startY;
            var currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
            var isScalingMatrix = currentTransform[0] === 0 && currentTransform[3] === 0 || currentTransform[1] === 0 && currentTransform[2] === 0;
            var minMaxForBezier = isScalingMatrix ? minMax.slice(0) : null;
            for (var i = 0, j = 0, ii = ops.length; i < ii; i++) {
              switch (ops[i] | 0) {
                case _util.OPS.rectangle:
                  x = args[j++];
                  y = args[j++];
                  var width = args[j++];
                  var height = args[j++];
                  var xw = x + width;
                  var yh = y + height;
                  ctx.moveTo(x, y);
                  if (width === 0 || height === 0) {
                    ctx.lineTo(xw, yh);
                  } else {
                    ctx.lineTo(xw, y);
                    ctx.lineTo(xw, yh);
                    ctx.lineTo(x, yh);
                  }
                  if (!isScalingMatrix) {
                    current.updateRectMinMax(currentTransform, [x, y, xw, yh]);
                  }
                  ctx.closePath();
                  break;
                case _util.OPS.moveTo:
                  x = args[j++];
                  y = args[j++];
                  ctx.moveTo(x, y);
                  if (!isScalingMatrix) {
                    current.updatePathMinMax(currentTransform, x, y);
                  }
                  break;
                case _util.OPS.lineTo:
                  x = args[j++];
                  y = args[j++];
                  ctx.lineTo(x, y);
                  if (!isScalingMatrix) {
                    current.updatePathMinMax(currentTransform, x, y);
                  }
                  break;
                case _util.OPS.curveTo:
                  startX = x;
                  startY = y;
                  x = args[j + 4];
                  y = args[j + 5];
                  ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
                  current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], args[j + 2], args[j + 3], x, y, minMaxForBezier);
                  j += 6;
                  break;
                case _util.OPS.curveTo2:
                  startX = x;
                  startY = y;
                  ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
                  current.updateCurvePathMinMax(currentTransform, startX, startY, x, y, args[j], args[j + 1], args[j + 2], args[j + 3], minMaxForBezier);
                  x = args[j + 2];
                  y = args[j + 3];
                  j += 4;
                  break;
                case _util.OPS.curveTo3:
                  startX = x;
                  startY = y;
                  x = args[j + 2];
                  y = args[j + 3];
                  ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
                  current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], x, y, x, y, minMaxForBezier);
                  j += 4;
                  break;
                case _util.OPS.closePath:
                  ctx.closePath();
                  break;
              }
            }
            if (isScalingMatrix) {
              current.updateScalingPathMinMax(currentTransform, minMaxForBezier);
            }
            current.setCurrentPoint(x, y);
          }
        }, {
          key: "closePath",
          value: function closePath() {
            this.ctx.closePath();
          }
        }, {
          key: "stroke",
          value: function stroke() {
            var consumePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var ctx = this.ctx;
            var strokeColor = this.current.strokeColor;
            ctx.globalAlpha = this.current.strokeAlpha;
            if (this.contentVisible) {
              if (_typeof(strokeColor) === "object" && strokeColor !== null && strokeColor !== void 0 && strokeColor.getPattern) {
                ctx.save();
                ctx.strokeStyle = strokeColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.STROKE);
                this.rescaleAndStroke(false);
                ctx.restore();
              } else {
                this.rescaleAndStroke(true);
              }
            }
            if (consumePath) {
              this.consumePath(this.current.getClippedPathBoundingBox());
            }
            ctx.globalAlpha = this.current.fillAlpha;
          }
        }, {
          key: "closeStroke",
          value: function closeStroke() {
            this.closePath();
            this.stroke();
          }
        }, {
          key: "fill",
          value: function fill() {
            var consumePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var ctx = this.ctx;
            var fillColor = this.current.fillColor;
            var isPatternFill = this.current.patternFill;
            var needRestore = false;
            if (isPatternFill) {
              ctx.save();
              ctx.fillStyle = fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
              needRestore = true;
            }
            var intersect = this.current.getClippedPathBoundingBox();
            if (this.contentVisible && intersect !== null) {
              if (this.pendingEOFill) {
                ctx.fill("evenodd");
                this.pendingEOFill = false;
              } else {
                ctx.fill();
              }
            }
            if (needRestore) {
              ctx.restore();
            }
            if (consumePath) {
              this.consumePath(intersect);
            }
          }
        }, {
          key: "eoFill",
          value: function eoFill() {
            this.pendingEOFill = true;
            this.fill();
          }
        }, {
          key: "fillStroke",
          value: function fillStroke() {
            this.fill(false);
            this.stroke(false);
            this.consumePath();
          }
        }, {
          key: "eoFillStroke",
          value: function eoFillStroke() {
            this.pendingEOFill = true;
            this.fillStroke();
          }
        }, {
          key: "closeFillStroke",
          value: function closeFillStroke() {
            this.closePath();
            this.fillStroke();
          }
        }, {
          key: "closeEOFillStroke",
          value: function closeEOFillStroke() {
            this.pendingEOFill = true;
            this.closePath();
            this.fillStroke();
          }
        }, {
          key: "endPath",
          value: function endPath() {
            this.consumePath();
          }
        }, {
          key: "clip",
          value: function clip() {
            this.pendingClip = NORMAL_CLIP;
          }
        }, {
          key: "eoClip",
          value: function eoClip() {
            this.pendingClip = EO_CLIP;
          }
        }, {
          key: "beginText",
          value: function beginText() {
            this.current.textMatrix = _util.IDENTITY_MATRIX;
            this.current.textMatrixScale = 1;
            this.current.x = this.current.lineX = 0;
            this.current.y = this.current.lineY = 0;
          }
        }, {
          key: "endText",
          value: function endText() {
            var paths = this.pendingTextPaths;
            var ctx = this.ctx;
            if (paths === undefined) {
              ctx.beginPath();
              return;
            }
            ctx.save();
            ctx.beginPath();
            var _iterator49 = _createForOfIteratorHelper(paths),
              _step49;
            try {
              for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
                var path = _step49.value;
                ctx.setTransform.apply(ctx, _toConsumableArray(path.transform));
                ctx.translate(path.x, path.y);
                path.addToPath(ctx, path.fontSize);
              }
            } catch (err) {
              _iterator49.e(err);
            } finally {
              _iterator49.f();
            }
            ctx.restore();
            ctx.clip();
            ctx.beginPath();
            delete this.pendingTextPaths;
          }
        }, {
          key: "setCharSpacing",
          value: function setCharSpacing(spacing) {
            this.current.charSpacing = spacing;
          }
        }, {
          key: "setWordSpacing",
          value: function setWordSpacing(spacing) {
            this.current.wordSpacing = spacing;
          }
        }, {
          key: "setHScale",
          value: function setHScale(scale) {
            this.current.textHScale = scale / 100;
          }
        }, {
          key: "setLeading",
          value: function setLeading(leading) {
            this.current.leading = -leading;
          }
        }, {
          key: "setFont",
          value: function setFont(fontRefName, size) {
            var fontObj = this.commonObjs.get(fontRefName);
            var current = this.current;
            if (!fontObj) {
              throw new Error("Can't find font for ".concat(fontRefName));
            }
            current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
            if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
              (0, _util.warn)("Invalid font matrix for font " + fontRefName);
            }
            if (size < 0) {
              size = -size;
              current.fontDirection = -1;
            } else {
              current.fontDirection = 1;
            }
            this.current.font = fontObj;
            this.current.fontSize = size;
            if (fontObj.isType3Font) {
              return;
            }
            var name = fontObj.loadedName || "sans-serif";
            var bold = "normal";
            if (fontObj.black) {
              bold = "900";
            } else if (fontObj.bold) {
              bold = "bold";
            }
            var italic = fontObj.italic ? "italic" : "normal";
            var typeface = "\"".concat(name, "\", ").concat(fontObj.fallbackName);
            var browserFontSize = size;
            if (size < MIN_FONT_SIZE) {
              browserFontSize = MIN_FONT_SIZE;
            } else if (size > MAX_FONT_SIZE) {
              browserFontSize = MAX_FONT_SIZE;
            }
            this.current.fontSizeScale = size / browserFontSize;
            this.ctx.font = "".concat(italic, " ").concat(bold, " ").concat(browserFontSize, "px ").concat(typeface);
          }
        }, {
          key: "setTextRenderingMode",
          value: function setTextRenderingMode(mode) {
            this.current.textRenderingMode = mode;
          }
        }, {
          key: "setTextRise",
          value: function setTextRise(rise) {
            this.current.textRise = rise;
          }
        }, {
          key: "moveText",
          value: function moveText(x, y) {
            this.current.x = this.current.lineX += x;
            this.current.y = this.current.lineY += y;
          }
        }, {
          key: "setLeadingMoveText",
          value: function setLeadingMoveText(x, y) {
            this.setLeading(-y);
            this.moveText(x, y);
          }
        }, {
          key: "setTextMatrix",
          value: function setTextMatrix(a, b, c, d, e, f) {
            this.current.textMatrix = [a, b, c, d, e, f];
            this.current.textMatrixScale = Math.hypot(a, b);
            this.current.x = this.current.lineX = 0;
            this.current.y = this.current.lineY = 0;
          }
        }, {
          key: "nextLine",
          value: function nextLine() {
            this.moveText(0, this.current.leading);
          }
        }, {
          key: "paintChar",
          value: function paintChar(character, x, y, patternTransform) {
            var ctx = this.ctx;
            var current = this.current;
            var font = current.font;
            var textRenderingMode = current.textRenderingMode;
            var fontSize = current.fontSize / current.fontSizeScale;
            var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
            var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
            var patternFill = current.patternFill && !font.missingFile;
            var addToPath;
            if (font.disableFontFace || isAddToPathSet || patternFill) {
              addToPath = font.getPathGenerator(this.commonObjs, character);
            }
            if (font.disableFontFace || patternFill) {
              ctx.save();
              ctx.translate(x, y);
              ctx.beginPath();
              addToPath(ctx, fontSize);
              if (patternTransform) {
                ctx.setTransform.apply(ctx, _toConsumableArray(patternTransform));
              }
              if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                ctx.fill();
              }
              if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                ctx.stroke();
              }
              ctx.restore();
            } else {
              if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                ctx.fillText(character, x, y);
              }
              if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                ctx.strokeText(character, x, y);
              }
            }
            if (isAddToPathSet) {
              var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
              paths.push({
                transform: (0, _display_utils.getCurrentTransform)(ctx),
                x: x,
                y: y,
                fontSize: fontSize,
                addToPath: addToPath
              });
            }
          }
        }, {
          key: "isFontSubpixelAAEnabled",
          get: function get() {
            var _this$cachedCanvases$ = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10),
              ctx = _this$cachedCanvases$.context;
            ctx.scale(1.5, 1);
            ctx.fillText("I", 0, 10);
            var data = ctx.getImageData(0, 0, 10, 10).data;
            var enabled = false;
            for (var i = 3; i < data.length; i += 4) {
              if (data[i] > 0 && data[i] < 255) {
                enabled = true;
                break;
              }
            }
            return (0, _util.shadow)(this, "isFontSubpixelAAEnabled", enabled);
          }
        }, {
          key: "showText",
          value: function showText(glyphs) {
            var current = this.current;
            var font = current.font;
            if (font.isType3Font) {
              return this.showType3Text(glyphs);
            }
            var fontSize = current.fontSize;
            if (fontSize === 0) {
              return undefined;
            }
            var ctx = this.ctx;
            var fontSizeScale = current.fontSizeScale;
            var charSpacing = current.charSpacing;
            var wordSpacing = current.wordSpacing;
            var fontDirection = current.fontDirection;
            var textHScale = current.textHScale * fontDirection;
            var glyphsLength = glyphs.length;
            var vertical = font.vertical;
            var spacingDir = vertical ? 1 : -1;
            var defaultVMetrics = font.defaultVMetrics;
            var widthAdvanceScale = fontSize * current.fontMatrix[0];
            var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
            ctx.save();
            ctx.transform.apply(ctx, _toConsumableArray(current.textMatrix));
            ctx.translate(current.x, current.y + current.textRise);
            if (fontDirection > 0) {
              ctx.scale(textHScale, -1);
            } else {
              ctx.scale(textHScale, 1);
            }
            var patternTransform;
            if (current.patternFill) {
              ctx.save();
              var pattern = current.fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
              patternTransform = (0, _display_utils.getCurrentTransform)(ctx);
              ctx.restore();
              ctx.fillStyle = pattern;
            }
            var lineWidth = current.lineWidth;
            var scale = current.textMatrixScale;
            if (scale === 0 || lineWidth === 0) {
              var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
              if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                lineWidth = this.getSinglePixelWidth();
              }
            } else {
              lineWidth /= scale;
            }
            if (fontSizeScale !== 1.0) {
              ctx.scale(fontSizeScale, fontSizeScale);
              lineWidth /= fontSizeScale;
            }
            ctx.lineWidth = lineWidth;
            if (font.isInvalidPDFjsFont) {
              var chars = [];
              var width = 0;
              var _iterator50 = _createForOfIteratorHelper(glyphs),
                _step50;
              try {
                for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
                  var glyph = _step50.value;
                  chars.push(glyph.unicode);
                  width += glyph.width;
                }
              } catch (err) {
                _iterator50.e(err);
              } finally {
                _iterator50.f();
              }
              ctx.fillText(chars.join(""), 0, 0);
              current.x += width * widthAdvanceScale * textHScale;
              ctx.restore();
              this.compose();
              return undefined;
            }
            var x = 0,
              i;
            for (i = 0; i < glyphsLength; ++i) {
              var _glyph = glyphs[i];
              if (typeof _glyph === "number") {
                x += spacingDir * _glyph * fontSize / 1000;
                continue;
              }
              var restoreNeeded = false;
              var spacing = (_glyph.isSpace ? wordSpacing : 0) + charSpacing;
              var character = _glyph.fontChar;
              var accent = _glyph.accent;
              var scaledX = void 0,
                scaledY = void 0;
              var _width = _glyph.width;
              if (vertical) {
                var vmetric = _glyph.vmetric || defaultVMetrics;
                var vx = -(_glyph.vmetric ? vmetric[1] : _width * 0.5) * widthAdvanceScale;
                var vy = vmetric[2] * widthAdvanceScale;
                _width = vmetric ? -vmetric[0] : _width;
                scaledX = vx / fontSizeScale;
                scaledY = (x + vy) / fontSizeScale;
              } else {
                scaledX = x / fontSizeScale;
                scaledY = 0;
              }
              if (font.remeasure && _width > 0) {
                var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
                if (_width < measuredWidth && this.isFontSubpixelAAEnabled) {
                  var characterScaleX = _width / measuredWidth;
                  restoreNeeded = true;
                  ctx.save();
                  ctx.scale(characterScaleX, 1);
                  scaledX /= characterScaleX;
                } else if (_width !== measuredWidth) {
                  scaledX += (_width - measuredWidth) / 2000 * fontSize / fontSizeScale;
                }
              }
              if (this.contentVisible && (_glyph.isInFont || font.missingFile)) {
                if (simpleFillText && !accent) {
                  ctx.fillText(character, scaledX, scaledY);
                } else {
                  this.paintChar(character, scaledX, scaledY, patternTransform);
                  if (accent) {
                    var scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                    var scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                    this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
                  }
                }
              }
              var charWidth = void 0;
              if (vertical) {
                charWidth = _width * widthAdvanceScale - spacing * fontDirection;
              } else {
                charWidth = _width * widthAdvanceScale + spacing * fontDirection;
              }
              x += charWidth;
              if (restoreNeeded) {
                ctx.restore();
              }
            }
            if (vertical) {
              current.y -= x;
            } else {
              current.x += x * textHScale;
            }
            ctx.restore();
            this.compose();
            return undefined;
          }
        }, {
          key: "showType3Text",
          value: function showType3Text(glyphs) {
            var ctx = this.ctx;
            var current = this.current;
            var font = current.font;
            var fontSize = current.fontSize;
            var fontDirection = current.fontDirection;
            var spacingDir = font.vertical ? 1 : -1;
            var charSpacing = current.charSpacing;
            var wordSpacing = current.wordSpacing;
            var textHScale = current.textHScale * fontDirection;
            var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
            var glyphsLength = glyphs.length;
            var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
            var i, glyph, width, spacingLength;
            if (isTextInvisible || fontSize === 0) {
              return;
            }
            this._cachedScaleForStroking = null;
            this._cachedGetSinglePixelWidth = null;
            ctx.save();
            ctx.transform.apply(ctx, _toConsumableArray(current.textMatrix));
            ctx.translate(current.x, current.y);
            ctx.scale(textHScale, fontDirection);
            for (i = 0; i < glyphsLength; ++i) {
              glyph = glyphs[i];
              if (typeof glyph === "number") {
                spacingLength = spacingDir * glyph * fontSize / 1000;
                this.ctx.translate(spacingLength, 0);
                current.x += spacingLength * textHScale;
                continue;
              }
              var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
              var operatorList = font.charProcOperatorList[glyph.operatorListId];
              if (!operatorList) {
                (0, _util.warn)("Type3 character \"".concat(glyph.operatorListId, "\" is not available."));
                continue;
              }
              if (this.contentVisible) {
                this.processingType3 = glyph;
                this.save();
                ctx.scale(fontSize, fontSize);
                ctx.transform.apply(ctx, _toConsumableArray(fontMatrix));
                this.executeOperatorList(operatorList);
                this.restore();
              }
              var transformed = _util.Util.applyTransform([glyph.width, 0], fontMatrix);
              width = transformed[0] * fontSize + spacing;
              ctx.translate(width, 0);
              current.x += width * textHScale;
            }
            ctx.restore();
            this.processingType3 = null;
          }
        }, {
          key: "setCharWidth",
          value: function setCharWidth(xWidth, yWidth) {}
        }, {
          key: "setCharWidthAndBounds",
          value: function setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
            this.ctx.rect(llx, lly, urx - llx, ury - lly);
            this.ctx.clip();
            this.endPath();
          }
        }, {
          key: "getColorN_Pattern",
          value: function getColorN_Pattern(IR) {
            var _this26 = this;
            var pattern;
            if (IR[0] === "TilingPattern") {
              var color = IR[1];
              var baseTransform = this.baseTransform || (0, _display_utils.getCurrentTransform)(this.ctx);
              var canvasGraphicsFactory = {
                createCanvasGraphics: function createCanvasGraphics(ctx) {
                  return new CanvasGraphics(ctx, _this26.commonObjs, _this26.objs, _this26.canvasFactory, {
                    optionalContentConfig: _this26.optionalContentConfig,
                    markedContentStack: _this26.markedContentStack
                  });
                }
              };
              pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
            } else {
              pattern = this._getPattern(IR[1], IR[2]);
            }
            return pattern;
          }
        }, {
          key: "setStrokeColorN",
          value: function setStrokeColorN() {
            this.current.strokeColor = this.getColorN_Pattern(arguments);
          }
        }, {
          key: "setFillColorN",
          value: function setFillColorN() {
            this.current.fillColor = this.getColorN_Pattern(arguments);
            this.current.patternFill = true;
          }
        }, {
          key: "setStrokeRGBColor",
          value: function setStrokeRGBColor(r, g, b) {
            var _this$selectColor;
            var color = ((_this$selectColor = this.selectColor) === null || _this$selectColor === void 0 ? void 0 : _this$selectColor.call(this, r, g, b)) || _util.Util.makeHexColor(r, g, b);
            this.ctx.strokeStyle = color;
            this.current.strokeColor = color;
          }
        }, {
          key: "setFillRGBColor",
          value: function setFillRGBColor(r, g, b) {
            var _this$selectColor2;
            var color = ((_this$selectColor2 = this.selectColor) === null || _this$selectColor2 === void 0 ? void 0 : _this$selectColor2.call(this, r, g, b)) || _util.Util.makeHexColor(r, g, b);
            this.ctx.fillStyle = color;
            this.current.fillColor = color;
            this.current.patternFill = false;
          }
        }, {
          key: "_getPattern",
          value: function _getPattern(objId) {
            var matrix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var pattern;
            if (this.cachedPatterns.has(objId)) {
              pattern = this.cachedPatterns.get(objId);
            } else {
              pattern = (0, _pattern_helper.getShadingPattern)(this.objs.get(objId));
              this.cachedPatterns.set(objId, pattern);
            }
            if (matrix) {
              pattern.matrix = matrix;
            }
            return pattern;
          }
        }, {
          key: "shadingFill",
          value: function shadingFill(objId) {
            if (!this.contentVisible) {
              return;
            }
            var ctx = this.ctx;
            this.save();
            var pattern = this._getPattern(objId);
            ctx.fillStyle = pattern.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.SHADING);
            var inv = (0, _display_utils.getCurrentTransformInverse)(ctx);
            if (inv) {
              var canvas = ctx.canvas;
              var width = canvas.width;
              var height = canvas.height;
              var bl = _util.Util.applyTransform([0, 0], inv);
              var br = _util.Util.applyTransform([0, height], inv);
              var ul = _util.Util.applyTransform([width, 0], inv);
              var ur = _util.Util.applyTransform([width, height], inv);
              var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
              var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
              var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
              var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
              this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
            } else {
              this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
            }
            this.compose(this.current.getClippedPathBoundingBox());
            this.restore();
          }
        }, {
          key: "beginInlineImage",
          value: function beginInlineImage() {
            (0, _util.unreachable)("Should not call beginInlineImage");
          }
        }, {
          key: "beginImageData",
          value: function beginImageData() {
            (0, _util.unreachable)("Should not call beginImageData");
          }
        }, {
          key: "paintFormXObjectBegin",
          value: function paintFormXObjectBegin(matrix, bbox) {
            if (!this.contentVisible) {
              return;
            }
            this.save();
            this.baseTransformStack.push(this.baseTransform);
            if (Array.isArray(matrix) && matrix.length === 6) {
              this.transform.apply(this, _toConsumableArray(matrix));
            }
            this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
            if (bbox) {
              var width = bbox[2] - bbox[0];
              var height = bbox[3] - bbox[1];
              this.ctx.rect(bbox[0], bbox[1], width, height);
              this.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(this.ctx), bbox);
              this.clip();
              this.endPath();
            }
          }
        }, {
          key: "paintFormXObjectEnd",
          value: function paintFormXObjectEnd() {
            if (!this.contentVisible) {
              return;
            }
            this.restore();
            this.baseTransform = this.baseTransformStack.pop();
          }
        }, {
          key: "beginGroup",
          value: function beginGroup(group) {
            if (!this.contentVisible) {
              return;
            }
            this.save();
            if (this.inSMaskMode) {
              this.endSMaskMode();
              this.current.activeSMask = null;
            }
            var currentCtx = this.ctx;
            if (!group.isolated) {
              (0, _util.info)("TODO: Support non-isolated groups.");
            }
            if (group.knockout) {
              (0, _util.warn)("Knockout groups not supported.");
            }
            var currentTransform = (0, _display_utils.getCurrentTransform)(currentCtx);
            if (group.matrix) {
              currentCtx.transform.apply(currentCtx, _toConsumableArray(group.matrix));
            }
            if (!group.bbox) {
              throw new Error("Bounding box is required.");
            }
            var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, (0, _display_utils.getCurrentTransform)(currentCtx));
            var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
            bounds = _util.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
            var offsetX = Math.floor(bounds[0]);
            var offsetY = Math.floor(bounds[1]);
            var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
            var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
            var scaleX = 1,
              scaleY = 1;
            if (drawnWidth > MAX_GROUP_SIZE) {
              scaleX = drawnWidth / MAX_GROUP_SIZE;
              drawnWidth = MAX_GROUP_SIZE;
            }
            if (drawnHeight > MAX_GROUP_SIZE) {
              scaleY = drawnHeight / MAX_GROUP_SIZE;
              drawnHeight = MAX_GROUP_SIZE;
            }
            this.current.startNewPathAndClipBox([0, 0, drawnWidth, drawnHeight]);
            var cacheId = "groupAt" + this.groupLevel;
            if (group.smask) {
              cacheId += "_smask_" + this.smaskCounter++ % 2;
            }
            var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
            var groupCtx = scratchCanvas.context;
            groupCtx.scale(1 / scaleX, 1 / scaleY);
            groupCtx.translate(-offsetX, -offsetY);
            groupCtx.transform.apply(groupCtx, _toConsumableArray(currentTransform));
            if (group.smask) {
              this.smaskStack.push({
                canvas: scratchCanvas.canvas,
                context: groupCtx,
                offsetX: offsetX,
                offsetY: offsetY,
                scaleX: scaleX,
                scaleY: scaleY,
                subtype: group.smask.subtype,
                backdrop: group.smask.backdrop,
                transferMap: group.smask.transferMap || null,
                startTransformInverse: null
              });
            } else {
              currentCtx.setTransform(1, 0, 0, 1, 0, 0);
              currentCtx.translate(offsetX, offsetY);
              currentCtx.scale(scaleX, scaleY);
              currentCtx.save();
            }
            copyCtxState(currentCtx, groupCtx);
            this.ctx = groupCtx;
            this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
            this.groupStack.push(currentCtx);
            this.groupLevel++;
          }
        }, {
          key: "endGroup",
          value: function endGroup(group) {
            if (!this.contentVisible) {
              return;
            }
            this.groupLevel--;
            var groupCtx = this.ctx;
            var ctx = this.groupStack.pop();
            this.ctx = ctx;
            this.ctx.imageSmoothingEnabled = false;
            if (group.smask) {
              this.tempSMask = this.smaskStack.pop();
              this.restore();
            } else {
              var _this$ctx4;
              this.ctx.restore();
              var currentMtx = (0, _display_utils.getCurrentTransform)(this.ctx);
              this.restore();
              this.ctx.save();
              (_this$ctx4 = this.ctx).setTransform.apply(_this$ctx4, _toConsumableArray(currentMtx));
              var dirtyBox = _util.Util.getAxialAlignedBoundingBox([0, 0, groupCtx.canvas.width, groupCtx.canvas.height], currentMtx);
              this.ctx.drawImage(groupCtx.canvas, 0, 0);
              this.ctx.restore();
              this.compose(dirtyBox);
            }
          }
        }, {
          key: "beginAnnotation",
          value: function beginAnnotation(id, rect, transform, matrix, hasOwnCanvas) {
            _classPrivateFieldLooseBase(this, _restoreInitialState)[_restoreInitialState]();
            resetCtxToDefault(this.ctx, this.foregroundColor);
            this.ctx.save();
            this.save();
            if (this.baseTransform) {
              var _this$ctx5;
              (_this$ctx5 = this.ctx).setTransform.apply(_this$ctx5, _toConsumableArray(this.baseTransform));
            }
            if (Array.isArray(rect) && rect.length === 4) {
              var width = rect[2] - rect[0];
              var height = rect[3] - rect[1];
              if (hasOwnCanvas && this.annotationCanvasMap) {
                transform = transform.slice();
                transform[4] -= rect[0];
                transform[5] -= rect[1];
                rect = rect.slice();
                rect[0] = rect[1] = 0;
                rect[2] = width;
                rect[3] = height;
                var _util$Util$singularVa = _util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(this.ctx)),
                  _util$Util$singularVa2 = _slicedToArray(_util$Util$singularVa, 2),
                  scaleX = _util$Util$singularVa2[0],
                  scaleY = _util$Util$singularVa2[1];
                var viewportScale = this.viewportScale;
                var canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                var canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                var _this$annotationCanva = this.annotationCanvas,
                  canvas = _this$annotationCanva.canvas,
                  context = _this$annotationCanva.context;
                this.annotationCanvasMap.set(id, canvas);
                this.annotationCanvas.savedCtx = this.ctx;
                this.ctx = context;
                this.ctx.setTransform(scaleX, 0, 0, -scaleY, 0, height * scaleY);
                resetCtxToDefault(this.ctx, this.foregroundColor);
              } else {
                resetCtxToDefault(this.ctx, this.foregroundColor);
                this.ctx.rect(rect[0], rect[1], width, height);
                this.ctx.clip();
                this.endPath();
              }
            }
            this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
            this.transform.apply(this, _toConsumableArray(transform));
            this.transform.apply(this, _toConsumableArray(matrix));
          }
        }, {
          key: "endAnnotation",
          value: function endAnnotation() {
            if (this.annotationCanvas) {
              this.ctx = this.annotationCanvas.savedCtx;
              delete this.annotationCanvas.savedCtx;
              delete this.annotationCanvas;
            }
          }
        }, {
          key: "paintImageMaskXObject",
          value: function paintImageMaskXObject(img) {
            if (!this.contentVisible) {
              return;
            }
            var count = img.count;
            img = this.getObject(img.data, img);
            img.count = count;
            var ctx = this.ctx;
            var glyph = this.processingType3;
            if (glyph) {
              if (glyph.compiled === undefined) {
                glyph.compiled = compileType3Glyph(img);
              }
              if (glyph.compiled) {
                glyph.compiled(ctx);
                return;
              }
            }
            var mask = this._createMaskCanvas(img);
            var maskCanvas = mask.canvas;
            ctx.save();
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
            ctx.restore();
            this.compose();
          }
        }, {
          key: "paintImageMaskXObjectRepeat",
          value: function paintImageMaskXObjectRepeat(img, scaleX) {
            var skewX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var skewY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
            var scaleY = arguments.length > 4 ? arguments[4] : undefined;
            var positions = arguments.length > 5 ? arguments[5] : undefined;
            if (!this.contentVisible) {
              return;
            }
            img = this.getObject(img.data, img);
            var ctx = this.ctx;
            ctx.save();
            var currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
            ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
            var mask = this._createMaskCanvas(img);
            ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
            for (var i = 0, ii = positions.length; i < ii; i += 2) {
              var trans = _util.Util.transform(currentTransform, [scaleX, skewX, skewY, scaleY, positions[i], positions[i + 1]]);
              var _util$Util$applyTrans3 = _util.Util.applyTransform([0, 0], trans),
                _util$Util$applyTrans4 = _slicedToArray(_util$Util$applyTrans3, 2),
                x = _util$Util$applyTrans4[0],
                y = _util$Util$applyTrans4[1];
              ctx.drawImage(mask.canvas, x, y);
            }
            ctx.restore();
            this.compose();
          }
        }, {
          key: "paintImageMaskXObjectGroup",
          value: function paintImageMaskXObjectGroup(images) {
            if (!this.contentVisible) {
              return;
            }
            var ctx = this.ctx;
            var fillColor = this.current.fillColor;
            var isPatternFill = this.current.patternFill;
            var _iterator51 = _createForOfIteratorHelper(images),
              _step51;
            try {
              for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
                var image = _step51.value;
                var data = image.data,
                  width = image.width,
                  height = image.height,
                  transform = image.transform;
                var maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                var maskCtx = maskCanvas.context;
                maskCtx.save();
                var img = this.getObject(data, image);
                putBinaryImageMask(maskCtx, img);
                maskCtx.globalCompositeOperation = "source-in";
                maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL) : fillColor;
                maskCtx.fillRect(0, 0, width, height);
                maskCtx.restore();
                ctx.save();
                ctx.transform.apply(ctx, _toConsumableArray(transform));
                ctx.scale(1, -1);
                drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
                ctx.restore();
              }
            } catch (err) {
              _iterator51.e(err);
            } finally {
              _iterator51.f();
            }
            this.compose();
          }
        }, {
          key: "paintImageXObject",
          value: function paintImageXObject(objId) {
            if (!this.contentVisible) {
              return;
            }
            var imgData = this.getObject(objId);
            if (!imgData) {
              (0, _util.warn)("Dependent image isn't ready yet");
              return;
            }
            this.paintInlineImageXObject(imgData);
          }
        }, {
          key: "paintImageXObjectRepeat",
          value: function paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
            if (!this.contentVisible) {
              return;
            }
            var imgData = this.getObject(objId);
            if (!imgData) {
              (0, _util.warn)("Dependent image isn't ready yet");
              return;
            }
            var width = imgData.width;
            var height = imgData.height;
            var map = [];
            for (var i = 0, ii = positions.length; i < ii; i += 2) {
              map.push({
                transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
                x: 0,
                y: 0,
                w: width,
                h: height
              });
            }
            this.paintInlineImageXObjectGroup(imgData, map);
          }
        }, {
          key: "paintInlineImageXObject",
          value: function paintInlineImageXObject(imgData) {
            if (!this.contentVisible) {
              return;
            }
            var width = imgData.width;
            var height = imgData.height;
            var ctx = this.ctx;
            this.save();
            ctx.scale(1 / width, -1 / height);
            var imgToPaint;
            if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) {
              imgToPaint = imgData;
            } else {
              var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
              var tmpCtx = tmpCanvas.context;
              putBinaryImageData(tmpCtx, imgData, this.current.transferMaps);
              imgToPaint = tmpCanvas.canvas;
            }
            var scaled = this._scaleImage(imgToPaint, (0, _display_utils.getCurrentTransformInverse)(ctx));
            ctx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(ctx), imgData.interpolate);
            drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
            this.compose();
            this.restore();
          }
        }, {
          key: "paintInlineImageXObjectGroup",
          value: function paintInlineImageXObjectGroup(imgData, map) {
            if (!this.contentVisible) {
              return;
            }
            var ctx = this.ctx;
            var w = imgData.width;
            var h = imgData.height;
            var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
            var tmpCtx = tmpCanvas.context;
            putBinaryImageData(tmpCtx, imgData, this.current.transferMaps);
            var _iterator52 = _createForOfIteratorHelper(map),
              _step52;
            try {
              for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
                var entry = _step52.value;
                ctx.save();
                ctx.transform.apply(ctx, _toConsumableArray(entry.transform));
                ctx.scale(1, -1);
                drawImageAtIntegerCoords(ctx, tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
                ctx.restore();
              }
            } catch (err) {
              _iterator52.e(err);
            } finally {
              _iterator52.f();
            }
            this.compose();
          }
        }, {
          key: "paintSolidColorImageMask",
          value: function paintSolidColorImageMask() {
            if (!this.contentVisible) {
              return;
            }
            this.ctx.fillRect(0, 0, 1, 1);
            this.compose();
          }
        }, {
          key: "markPoint",
          value: function markPoint(tag) {}
        }, {
          key: "markPointProps",
          value: function markPointProps(tag, properties) {}
        }, {
          key: "beginMarkedContent",
          value: function beginMarkedContent(tag) {
            this.markedContentStack.push({
              visible: true
            });
          }
        }, {
          key: "beginMarkedContentProps",
          value: function beginMarkedContentProps(tag, properties) {
            if (tag === "OC") {
              this.markedContentStack.push({
                visible: this.optionalContentConfig.isVisible(properties)
              });
            } else {
              this.markedContentStack.push({
                visible: true
              });
            }
            this.contentVisible = this.isContentVisible();
          }
        }, {
          key: "endMarkedContent",
          value: function endMarkedContent() {
            this.markedContentStack.pop();
            this.contentVisible = this.isContentVisible();
          }
        }, {
          key: "beginCompat",
          value: function beginCompat() {}
        }, {
          key: "endCompat",
          value: function endCompat() {}
        }, {
          key: "consumePath",
          value: function consumePath(clipBox) {
            var isEmpty = this.current.isEmptyClip();
            if (this.pendingClip) {
              this.current.updateClipFromPath();
            }
            if (!this.pendingClip) {
              this.compose(clipBox);
            }
            var ctx = this.ctx;
            if (this.pendingClip) {
              if (!isEmpty) {
                if (this.pendingClip === EO_CLIP) {
                  ctx.clip("evenodd");
                } else {
                  ctx.clip();
                }
              }
              this.pendingClip = null;
            }
            this.current.startNewPathAndClipBox(this.current.clipBox);
            ctx.beginPath();
          }
        }, {
          key: "getSinglePixelWidth",
          value: function getSinglePixelWidth() {
            if (!this._cachedGetSinglePixelWidth) {
              var m = (0, _display_utils.getCurrentTransform)(this.ctx);
              if (m[1] === 0 && m[2] === 0) {
                this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
              } else {
                var absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                var normX = Math.hypot(m[0], m[2]);
                var normY = Math.hypot(m[1], m[3]);
                this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
              }
            }
            return this._cachedGetSinglePixelWidth;
          }
        }, {
          key: "getScaleForStroking",
          value: function getScaleForStroking() {
            if (!this._cachedScaleForStroking) {
              var lineWidth = this.current.lineWidth;
              var m = (0, _display_utils.getCurrentTransform)(this.ctx);
              var scaleX, scaleY;
              if (m[1] === 0 && m[2] === 0) {
                var normX = Math.abs(m[0]);
                var normY = Math.abs(m[3]);
                if (lineWidth === 0) {
                  scaleX = 1 / normX;
                  scaleY = 1 / normY;
                } else {
                  var scaledXLineWidth = normX * lineWidth;
                  var scaledYLineWidth = normY * lineWidth;
                  scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
                  scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
                }
              } else {
                var absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                var _normX = Math.hypot(m[0], m[1]);
                var _normY = Math.hypot(m[2], m[3]);
                if (lineWidth === 0) {
                  scaleX = _normY / absDet;
                  scaleY = _normX / absDet;
                } else {
                  var baseArea = lineWidth * absDet;
                  scaleX = _normY > baseArea ? _normY / baseArea : 1;
                  scaleY = _normX > baseArea ? _normX / baseArea : 1;
                }
              }
              this._cachedScaleForStroking = [scaleX, scaleY];
            }
            return this._cachedScaleForStroking;
          }
        }, {
          key: "rescaleAndStroke",
          value: function rescaleAndStroke(saveRestore) {
            var ctx = this.ctx;
            var lineWidth = this.current.lineWidth;
            var _this$getScaleForStro = this.getScaleForStroking(),
              _this$getScaleForStro2 = _slicedToArray(_this$getScaleForStro, 2),
              scaleX = _this$getScaleForStro2[0],
              scaleY = _this$getScaleForStro2[1];
            ctx.lineWidth = lineWidth || 1;
            if (scaleX === 1 && scaleY === 1) {
              ctx.stroke();
              return;
            }
            var savedMatrix, savedDashes, savedDashOffset;
            if (saveRestore) {
              savedMatrix = (0, _display_utils.getCurrentTransform)(ctx);
              savedDashes = ctx.getLineDash().slice();
              savedDashOffset = ctx.lineDashOffset;
            }
            ctx.scale(scaleX, scaleY);
            var scale = Math.max(scaleX, scaleY);
            ctx.setLineDash(ctx.getLineDash().map(function (x) {
              return x / scale;
            }));
            ctx.lineDashOffset /= scale;
            ctx.stroke();
            if (saveRestore) {
              ctx.setTransform.apply(ctx, _toConsumableArray(savedMatrix));
              ctx.setLineDash(savedDashes);
              ctx.lineDashOffset = savedDashOffset;
            }
          }
        }, {
          key: "isContentVisible",
          value: function isContentVisible() {
            for (var i = this.markedContentStack.length - 1; i >= 0; i--) {
              if (!this.markedContentStack[i].visible) {
                return false;
              }
            }
            return true;
          }
        }]);
      }();
      function _restoreInitialState2() {
        while (this.stateStack.length || this.inSMaskMode) {
          this.restore();
        }
        this.ctx.restore();
        if (this.transparentCanvas) {
          this.ctx = this.compositeCtx;
          this.ctx.save();
          this.ctx.setTransform(1, 0, 0, 1, 0, 0);
          this.ctx.drawImage(this.transparentCanvas, 0, 0);
          this.ctx.restore();
          this.transparentCanvas = null;
        }
      }
      exports.CanvasGraphics = CanvasGraphics;
      for (var op in _util.OPS) {
        if (CanvasGraphics.prototype[op] !== undefined) {
          CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
        }
      }

      /***/
    }), (/* 12 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.TilingPattern = exports.PathType = void 0;
      exports.getShadingPattern = getShadingPattern;
      var _util = __w_pdfjs_require__(1);
      var _display_utils = __w_pdfjs_require__(6);
      var PathType = {
        FILL: "Fill",
        STROKE: "Stroke",
        SHADING: "Shading"
      };
      exports.PathType = PathType;
      function applyBoundingBox(ctx, bbox) {
        if (!bbox) {
          return;
        }
        var width = bbox[2] - bbox[0];
        var height = bbox[3] - bbox[1];
        var region = new Path2D();
        region.rect(bbox[0], bbox[1], width, height);
        ctx.clip(region);
      }
      var BaseShadingPattern = /*#__PURE__*/function () {
        function BaseShadingPattern() {
          _classCallCheck(this, BaseShadingPattern);
          if (this.constructor === BaseShadingPattern) {
            (0, _util.unreachable)("Cannot initialize BaseShadingPattern.");
          }
        }
        return _createClass(BaseShadingPattern, [{
          key: "getPattern",
          value: function getPattern() {
            (0, _util.unreachable)("Abstract method `getPattern` called.");
          }
        }]);
      }();
      var RadialAxialShadingPattern = /*#__PURE__*/function (_BaseShadingPattern) {
        function RadialAxialShadingPattern(IR) {
          var _this27;
          _classCallCheck(this, RadialAxialShadingPattern);
          _this27 = _callSuper(this, RadialAxialShadingPattern);
          _this27._type = IR[1];
          _this27._bbox = IR[2];
          _this27._colorStops = IR[3];
          _this27._p0 = IR[4];
          _this27._p1 = IR[5];
          _this27._r0 = IR[6];
          _this27._r1 = IR[7];
          _this27.matrix = null;
          return _this27;
        }
        _inherits(RadialAxialShadingPattern, _BaseShadingPattern);
        return _createClass(RadialAxialShadingPattern, [{
          key: "_createGradient",
          value: function _createGradient(ctx) {
            var grad;
            if (this._type === "axial") {
              grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
            } else if (this._type === "radial") {
              grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
            }
            var _iterator53 = _createForOfIteratorHelper(this._colorStops),
              _step53;
            try {
              for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
                var colorStop = _step53.value;
                grad.addColorStop(colorStop[0], colorStop[1]);
              }
            } catch (err) {
              _iterator53.e(err);
            } finally {
              _iterator53.f();
            }
            return grad;
          }
        }, {
          key: "getPattern",
          value: function getPattern(ctx, owner, inverse, pathType) {
            var pattern;
            if (pathType === PathType.STROKE || pathType === PathType.FILL) {
              var ownerBBox = owner.current.getClippedPathBoundingBox(pathType, (0, _display_utils.getCurrentTransform)(ctx)) || [0, 0, 0, 0];
              var width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
              var height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
              var tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height, true);
              var tmpCtx = tmpCanvas.context;
              tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
              tmpCtx.beginPath();
              tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
              tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
              inverse = _util.Util.transform(inverse, [1, 0, 0, 1, ownerBBox[0], ownerBBox[1]]);
              tmpCtx.transform.apply(tmpCtx, _toConsumableArray(owner.baseTransform));
              if (this.matrix) {
                tmpCtx.transform.apply(tmpCtx, _toConsumableArray(this.matrix));
              }
              applyBoundingBox(tmpCtx, this._bbox);
              tmpCtx.fillStyle = this._createGradient(tmpCtx);
              tmpCtx.fill();
              pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
              var domMatrix = new DOMMatrix(inverse);
              pattern.setTransform(domMatrix);
            } else {
              applyBoundingBox(ctx, this._bbox);
              pattern = this._createGradient(ctx);
            }
            return pattern;
          }
        }]);
      }(BaseShadingPattern);
      function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
        var coords = context.coords,
          colors = context.colors;
        var bytes = data.data,
          rowSize = data.width * 4;
        var tmp;
        if (coords[p1 + 1] > coords[p2 + 1]) {
          tmp = p1;
          p1 = p2;
          p2 = tmp;
          tmp = c1;
          c1 = c2;
          c2 = tmp;
        }
        if (coords[p2 + 1] > coords[p3 + 1]) {
          tmp = p2;
          p2 = p3;
          p3 = tmp;
          tmp = c2;
          c2 = c3;
          c3 = tmp;
        }
        if (coords[p1 + 1] > coords[p2 + 1]) {
          tmp = p1;
          p1 = p2;
          p2 = tmp;
          tmp = c1;
          c1 = c2;
          c2 = tmp;
        }
        var x1 = (coords[p1] + context.offsetX) * context.scaleX;
        var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
        var x2 = (coords[p2] + context.offsetX) * context.scaleX;
        var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
        var x3 = (coords[p3] + context.offsetX) * context.scaleX;
        var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
        if (y1 >= y3) {
          return;
        }
        var c1r = colors[c1],
          c1g = colors[c1 + 1],
          c1b = colors[c1 + 2];
        var c2r = colors[c2],
          c2g = colors[c2 + 1],
          c2b = colors[c2 + 2];
        var c3r = colors[c3],
          c3g = colors[c3 + 1],
          c3b = colors[c3 + 2];
        var minY = Math.round(y1),
          maxY = Math.round(y3);
        var xa, car, cag, cab;
        var xb, cbr, cbg, cbb;
        for (var y = minY; y <= maxY; y++) {
          if (y < y2) {
            var _k4 = void 0;
            if (y < y1) {
              _k4 = 0;
            } else {
              _k4 = (y1 - y) / (y1 - y2);
            }
            xa = x1 - (x1 - x2) * _k4;
            car = c1r - (c1r - c2r) * _k4;
            cag = c1g - (c1g - c2g) * _k4;
            cab = c1b - (c1b - c2b) * _k4;
          } else {
            var _k5 = void 0;
            if (y > y3) {
              _k5 = 1;
            } else if (y2 === y3) {
              _k5 = 0;
            } else {
              _k5 = (y2 - y) / (y2 - y3);
            }
            xa = x2 - (x2 - x3) * _k5;
            car = c2r - (c2r - c3r) * _k5;
            cag = c2g - (c2g - c3g) * _k5;
            cab = c2b - (c2b - c3b) * _k5;
          }
          var k = void 0;
          if (y < y1) {
            k = 0;
          } else if (y > y3) {
            k = 1;
          } else {
            k = (y1 - y) / (y1 - y3);
          }
          xb = x1 - (x1 - x3) * k;
          cbr = c1r - (c1r - c3r) * k;
          cbg = c1g - (c1g - c3g) * k;
          cbb = c1b - (c1b - c3b) * k;
          var x1_ = Math.round(Math.min(xa, xb));
          var x2_ = Math.round(Math.max(xa, xb));
          var j = rowSize * y + x1_ * 4;
          for (var x = x1_; x <= x2_; x++) {
            k = (xa - x) / (xa - xb);
            if (k < 0) {
              k = 0;
            } else if (k > 1) {
              k = 1;
            }
            bytes[j++] = car - (car - cbr) * k | 0;
            bytes[j++] = cag - (cag - cbg) * k | 0;
            bytes[j++] = cab - (cab - cbb) * k | 0;
            bytes[j++] = 255;
          }
        }
      }
      function drawFigure(data, figure, context) {
        var ps = figure.coords;
        var cs = figure.colors;
        var i, ii;
        switch (figure.type) {
          case "lattice":
            var verticesPerRow = figure.verticesPerRow;
            var rows = Math.floor(ps.length / verticesPerRow) - 1;
            var cols = verticesPerRow - 1;
            for (i = 0; i < rows; i++) {
              var q = i * verticesPerRow;
              for (var j = 0; j < cols; j++, q++) {
                drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
              }
            }
            break;
          case "triangles":
            for (i = 0, ii = ps.length; i < ii; i += 3) {
              drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
            }
            break;
          default:
            throw new Error("illegal figure");
        }
      }
      var MeshShadingPattern = /*#__PURE__*/function (_BaseShadingPattern2) {
        function MeshShadingPattern(IR) {
          var _this28;
          _classCallCheck(this, MeshShadingPattern);
          _this28 = _callSuper(this, MeshShadingPattern);
          _this28._coords = IR[2];
          _this28._colors = IR[3];
          _this28._figures = IR[4];
          _this28._bounds = IR[5];
          _this28._bbox = IR[7];
          _this28._background = IR[8];
          _this28.matrix = null;
          return _this28;
        }
        _inherits(MeshShadingPattern, _BaseShadingPattern2);
        return _createClass(MeshShadingPattern, [{
          key: "_createMeshCanvas",
          value: function _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
            var EXPECTED_SCALE = 1.1;
            var MAX_PATTERN_SIZE = 3000;
            var BORDER_SIZE = 2;
            var offsetX = Math.floor(this._bounds[0]);
            var offsetY = Math.floor(this._bounds[1]);
            var boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
            var boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
            var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
            var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
            var scaleX = boundsWidth / width;
            var scaleY = boundsHeight / height;
            var context = {
              coords: this._coords,
              colors: this._colors,
              offsetX: -offsetX,
              offsetY: -offsetY,
              scaleX: 1 / scaleX,
              scaleY: 1 / scaleY
            };
            var paddedWidth = width + BORDER_SIZE * 2;
            var paddedHeight = height + BORDER_SIZE * 2;
            var tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
            var tmpCtx = tmpCanvas.context;
            var data = tmpCtx.createImageData(width, height);
            if (backgroundColor) {
              var bytes = data.data;
              for (var i = 0, ii = bytes.length; i < ii; i += 4) {
                bytes[i] = backgroundColor[0];
                bytes[i + 1] = backgroundColor[1];
                bytes[i + 2] = backgroundColor[2];
                bytes[i + 3] = 255;
              }
            }
            var _iterator54 = _createForOfIteratorHelper(this._figures),
              _step54;
            try {
              for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
                var figure = _step54.value;
                drawFigure(data, figure, context);
              }
            } catch (err) {
              _iterator54.e(err);
            } finally {
              _iterator54.f();
            }
            tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
            var canvas = tmpCanvas.canvas;
            return {
              canvas: canvas,
              offsetX: offsetX - BORDER_SIZE * scaleX,
              offsetY: offsetY - BORDER_SIZE * scaleY,
              scaleX: scaleX,
              scaleY: scaleY
            };
          }
        }, {
          key: "getPattern",
          value: function getPattern(ctx, owner, inverse, pathType) {
            applyBoundingBox(ctx, this._bbox);
            var scale;
            if (pathType === PathType.SHADING) {
              scale = _util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(ctx));
            } else {
              scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
              if (this.matrix) {
                var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
              }
            }
            var temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === PathType.SHADING ? null : this._background, owner.cachedCanvases);
            if (pathType !== PathType.SHADING) {
              ctx.setTransform.apply(ctx, _toConsumableArray(owner.baseTransform));
              if (this.matrix) {
                ctx.transform.apply(ctx, _toConsumableArray(this.matrix));
              }
            }
            ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
            ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
            return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
          }
        }]);
      }(BaseShadingPattern);
      var DummyShadingPattern = /*#__PURE__*/function (_BaseShadingPattern3) {
        function DummyShadingPattern() {
          _classCallCheck(this, DummyShadingPattern);
          return _callSuper(this, DummyShadingPattern, arguments);
        }
        _inherits(DummyShadingPattern, _BaseShadingPattern3);
        return _createClass(DummyShadingPattern, [{
          key: "getPattern",
          value: function getPattern() {
            return "hotpink";
          }
        }]);
      }(BaseShadingPattern);
      function getShadingPattern(IR) {
        switch (IR[0]) {
          case "RadialAxial":
            return new RadialAxialShadingPattern(IR);
          case "Mesh":
            return new MeshShadingPattern(IR);
          case "Dummy":
            return new DummyShadingPattern();
        }
        throw new Error("Unknown IR type: ".concat(IR[0]));
      }
      var PaintType = {
        COLORED: 1,
        UNCOLORED: 2
      };
      var TilingPattern = /*#__PURE__*/function () {
        function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
          _classCallCheck(this, TilingPattern);
          this.operatorList = IR[2];
          this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
          this.bbox = IR[4];
          this.xstep = IR[5];
          this.ystep = IR[6];
          this.paintType = IR[7];
          this.tilingType = IR[8];
          this.color = color;
          this.ctx = ctx;
          this.canvasGraphicsFactory = canvasGraphicsFactory;
          this.baseTransform = baseTransform;
        }
        return _createClass(TilingPattern, [{
          key: "createPatternCanvas",
          value: function createPatternCanvas(owner) {
            var operatorList = this.operatorList;
            var bbox = this.bbox;
            var xstep = this.xstep;
            var ystep = this.ystep;
            var paintType = this.paintType;
            var tilingType = this.tilingType;
            var color = this.color;
            var canvasGraphicsFactory = this.canvasGraphicsFactory;
            (0, _util.info)("TilingType: " + tilingType);
            var x0 = bbox[0],
              y0 = bbox[1],
              x1 = bbox[2],
              y1 = bbox[3];
            var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
            var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
            var combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
            var dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
            var dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
            var tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size, true);
            var tmpCtx = tmpCanvas.context;
            var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
            graphics.groupLevel = owner.groupLevel;
            this.setFillAndStrokeStyleToContext(graphics, paintType, color);
            var adjustedX0 = x0;
            var adjustedY0 = y0;
            var adjustedX1 = x1;
            var adjustedY1 = y1;
            if (x0 < 0) {
              adjustedX0 = 0;
              adjustedX1 += Math.abs(x0);
            }
            if (y0 < 0) {
              adjustedY0 = 0;
              adjustedY1 += Math.abs(y0);
            }
            tmpCtx.translate(-(dimx.scale * adjustedX0), -(dimy.scale * adjustedY0));
            graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
            tmpCtx.save();
            this.clipBbox(graphics, adjustedX0, adjustedY0, adjustedX1, adjustedY1);
            graphics.baseTransform = (0, _display_utils.getCurrentTransform)(graphics.ctx);
            graphics.executeOperatorList(operatorList);
            graphics.endDrawing();
            return {
              canvas: tmpCanvas.canvas,
              scaleX: dimx.scale,
              scaleY: dimy.scale,
              offsetX: adjustedX0,
              offsetY: adjustedY0
            };
          }
        }, {
          key: "getSizeAndScale",
          value: function getSizeAndScale(step, realOutputSize, scale) {
            step = Math.abs(step);
            var maxSize = Math.max(TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
            var size = Math.ceil(step * scale);
            if (size >= maxSize) {
              size = maxSize;
            } else {
              scale = size / step;
            }
            return {
              scale: scale,
              size: size
            };
          }
        }, {
          key: "clipBbox",
          value: function clipBbox(graphics, x0, y0, x1, y1) {
            var bboxWidth = x1 - x0;
            var bboxHeight = y1 - y0;
            graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
            graphics.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(graphics.ctx), [x0, y0, x1, y1]);
            graphics.clip();
            graphics.endPath();
          }
        }, {
          key: "setFillAndStrokeStyleToContext",
          value: function setFillAndStrokeStyleToContext(graphics, paintType, color) {
            var context = graphics.ctx,
              current = graphics.current;
            switch (paintType) {
              case PaintType.COLORED:
                var ctx = this.ctx;
                context.fillStyle = ctx.fillStyle;
                context.strokeStyle = ctx.strokeStyle;
                current.fillColor = ctx.fillStyle;
                current.strokeColor = ctx.strokeStyle;
                break;
              case PaintType.UNCOLORED:
                var cssColor = _util.Util.makeHexColor(color[0], color[1], color[2]);
                context.fillStyle = cssColor;
                context.strokeStyle = cssColor;
                current.fillColor = cssColor;
                current.strokeColor = cssColor;
                break;
              default:
                throw new _util.FormatError("Unsupported paint type: ".concat(paintType));
            }
          }
        }, {
          key: "getPattern",
          value: function getPattern(ctx, owner, inverse, pathType) {
            var matrix = inverse;
            if (pathType !== PathType.SHADING) {
              matrix = _util.Util.transform(matrix, owner.baseTransform);
              if (this.matrix) {
                matrix = _util.Util.transform(matrix, this.matrix);
              }
            }
            var temporaryPatternCanvas = this.createPatternCanvas(owner);
            var domMatrix = new DOMMatrix(matrix);
            domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
            domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
            var pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
            pattern.setTransform(domMatrix);
            return pattern;
          }
        }], [{
          key: "MAX_PATTERN_SIZE",
          get: function get() {
            return (0, _util.shadow)(this, "MAX_PATTERN_SIZE", 3000);
          }
        }]);
      }();
      exports.TilingPattern = TilingPattern;

      /***/
    }), (/* 13 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.applyMaskImageData = applyMaskImageData;
      var _util = __w_pdfjs_require__(1);
      function applyMaskImageData(_ref70) {
        var src = _ref70.src,
          _ref70$srcPos = _ref70.srcPos,
          srcPos = _ref70$srcPos === void 0 ? 0 : _ref70$srcPos,
          dest = _ref70.dest,
          _ref70$destPos = _ref70.destPos,
          destPos = _ref70$destPos === void 0 ? 0 : _ref70$destPos,
          width = _ref70.width,
          height = _ref70.height,
          _ref70$inverseDecode = _ref70.inverseDecode,
          inverseDecode = _ref70$inverseDecode === void 0 ? false : _ref70$inverseDecode;
        var opaque = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
        var _ref71 = !inverseDecode ? [opaque, 0] : [0, opaque],
          _ref72 = _slicedToArray(_ref71, 2),
          zeroMapping = _ref72[0],
          oneMapping = _ref72[1];
        var widthInSource = width >> 3;
        var widthRemainder = width & 7;
        var srcLength = src.length;
        dest = new Uint32Array(dest.buffer);
        for (var i = 0; i < height; i++) {
          for (var max = srcPos + widthInSource; srcPos < max; srcPos++) {
            var _elem = srcPos < srcLength ? src[srcPos] : 255;
            dest[destPos++] = _elem & 128 ? oneMapping : zeroMapping;
            dest[destPos++] = _elem & 64 ? oneMapping : zeroMapping;
            dest[destPos++] = _elem & 32 ? oneMapping : zeroMapping;
            dest[destPos++] = _elem & 16 ? oneMapping : zeroMapping;
            dest[destPos++] = _elem & 8 ? oneMapping : zeroMapping;
            dest[destPos++] = _elem & 4 ? oneMapping : zeroMapping;
            dest[destPos++] = _elem & 2 ? oneMapping : zeroMapping;
            dest[destPos++] = _elem & 1 ? oneMapping : zeroMapping;
          }
          if (widthRemainder === 0) {
            continue;
          }
          var elem = srcPos < srcLength ? src[srcPos++] : 255;
          for (var j = 0; j < widthRemainder; j++) {
            dest[destPos++] = elem & 1 << 7 - j ? oneMapping : zeroMapping;
          }
        }
        return {
          srcPos: srcPos,
          destPos: destPos
        };
      }

      /***/
    }), (/* 14 */
    /***/function (__unused_webpack_module, exports) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.GlobalWorkerOptions = void 0;
      var GlobalWorkerOptions = Object.create(null);
      exports.GlobalWorkerOptions = GlobalWorkerOptions;
      GlobalWorkerOptions.workerPort = null;
      GlobalWorkerOptions.workerSrc = "";

      /***/
    }), (/* 15 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.MessageHandler = void 0;
      var _util = __w_pdfjs_require__(1);
      var CallbackKind = {
        UNKNOWN: 0,
        DATA: 1,
        ERROR: 2
      };
      var StreamKind = {
        UNKNOWN: 0,
        CANCEL: 1,
        CANCEL_COMPLETE: 2,
        CLOSE: 3,
        ENQUEUE: 4,
        ERROR: 5,
        PULL: 6,
        PULL_COMPLETE: 7,
        START_COMPLETE: 8
      };
      function wrapReason(reason) {
        if (!(reason instanceof Error || _typeof(reason) === "object" && reason !== null)) {
          (0, _util.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
        }
        switch (reason.name) {
          case "AbortException":
            return new _util.AbortException(reason.message);
          case "MissingPDFException":
            return new _util.MissingPDFException(reason.message);
          case "PasswordException":
            return new _util.PasswordException(reason.message, reason.code);
          case "UnexpectedResponseException":
            return new _util.UnexpectedResponseException(reason.message, reason.status);
          case "UnknownErrorException":
            return new _util.UnknownErrorException(reason.message, reason.details);
          default:
            return new _util.UnknownErrorException(reason.message, reason.toString());
        }
      }
      var MessageHandler = /*#__PURE__*/function () {
        function MessageHandler(sourceName, targetName, comObj) {
          var _this29 = this;
          _classCallCheck(this, MessageHandler);
          this.sourceName = sourceName;
          this.targetName = targetName;
          this.comObj = comObj;
          this.callbackId = 1;
          this.streamId = 1;
          this.streamSinks = Object.create(null);
          this.streamControllers = Object.create(null);
          this.callbackCapabilities = Object.create(null);
          this.actionHandler = Object.create(null);
          this._onComObjOnMessage = function (event) {
            var data = event.data;
            if (data.targetName !== _this29.sourceName) {
              return;
            }
            if (data.stream) {
              _this29._processStreamMessage(data);
              return;
            }
            if (data.callback) {
              var callbackId = data.callbackId;
              var capability = _this29.callbackCapabilities[callbackId];
              if (!capability) {
                throw new Error("Cannot resolve callback ".concat(callbackId));
              }
              delete _this29.callbackCapabilities[callbackId];
              if (data.callback === CallbackKind.DATA) {
                capability.resolve(data.data);
              } else if (data.callback === CallbackKind.ERROR) {
                capability.reject(wrapReason(data.reason));
              } else {
                throw new Error("Unexpected callback case");
              }
              return;
            }
            var action = _this29.actionHandler[data.action];
            if (!action) {
              throw new Error("Unknown action from worker: ".concat(data.action));
            }
            if (data.callbackId) {
              var cbSourceName = _this29.sourceName;
              var cbTargetName = data.sourceName;
              new Promise(function (resolve) {
                resolve(action(data.data));
              }).then(function (result) {
                comObj.postMessage({
                  sourceName: cbSourceName,
                  targetName: cbTargetName,
                  callback: CallbackKind.DATA,
                  callbackId: data.callbackId,
                  data: result
                });
              }, function (reason) {
                comObj.postMessage({
                  sourceName: cbSourceName,
                  targetName: cbTargetName,
                  callback: CallbackKind.ERROR,
                  callbackId: data.callbackId,
                  reason: wrapReason(reason)
                });
              });
              return;
            }
            if (data.streamId) {
              _this29._createStreamSink(data);
              return;
            }
            action(data.data);
          };
          comObj.addEventListener("message", this._onComObjOnMessage);
        }
        return _createClass(MessageHandler, [{
          key: "on",
          value: function on(actionName, handler) {
            var ah = this.actionHandler;
            if (ah[actionName]) {
              throw new Error("There is already an actionName called \"".concat(actionName, "\""));
            }
            ah[actionName] = handler;
          }
        }, {
          key: "send",
          value: function send(actionName, data, transfers) {
            this.comObj.postMessage({
              sourceName: this.sourceName,
              targetName: this.targetName,
              action: actionName,
              data: data
            }, transfers);
          }
        }, {
          key: "sendWithPromise",
          value: function sendWithPromise(actionName, data, transfers) {
            var callbackId = this.callbackId++;
            var capability = (0, _util.createPromiseCapability)();
            this.callbackCapabilities[callbackId] = capability;
            try {
              this.comObj.postMessage({
                sourceName: this.sourceName,
                targetName: this.targetName,
                action: actionName,
                callbackId: callbackId,
                data: data
              }, transfers);
            } catch (ex) {
              capability.reject(ex);
            }
            return capability.promise;
          }
        }, {
          key: "sendWithStream",
          value: function sendWithStream(actionName, data, queueingStrategy, transfers) {
            var _this30 = this;
            var streamId = this.streamId++,
              sourceName = this.sourceName,
              targetName = this.targetName,
              comObj = this.comObj;
            return new ReadableStream({
              start: function start(controller) {
                var startCapability = (0, _util.createPromiseCapability)();
                _this30.streamControllers[streamId] = {
                  controller: controller,
                  startCall: startCapability,
                  pullCall: null,
                  cancelCall: null,
                  isClosed: false
                };
                comObj.postMessage({
                  sourceName: sourceName,
                  targetName: targetName,
                  action: actionName,
                  streamId: streamId,
                  data: data,
                  desiredSize: controller.desiredSize
                }, transfers);
                return startCapability.promise;
              },
              pull: function pull(controller) {
                var pullCapability = (0, _util.createPromiseCapability)();
                _this30.streamControllers[streamId].pullCall = pullCapability;
                comObj.postMessage({
                  sourceName: sourceName,
                  targetName: targetName,
                  stream: StreamKind.PULL,
                  streamId: streamId,
                  desiredSize: controller.desiredSize
                });
                return pullCapability.promise;
              },
              cancel: function cancel(reason) {
                (0, _util.assert)(reason instanceof Error, "cancel must have a valid reason");
                var cancelCapability = (0, _util.createPromiseCapability)();
                _this30.streamControllers[streamId].cancelCall = cancelCapability;
                _this30.streamControllers[streamId].isClosed = true;
                comObj.postMessage({
                  sourceName: sourceName,
                  targetName: targetName,
                  stream: StreamKind.CANCEL,
                  streamId: streamId,
                  reason: wrapReason(reason)
                });
                return cancelCapability.promise;
              }
            }, queueingStrategy);
          }
        }, {
          key: "_createStreamSink",
          value: function _createStreamSink(data) {
            var streamId = data.streamId,
              sourceName = this.sourceName,
              targetName = data.sourceName,
              comObj = this.comObj;
            var self = this,
              action = this.actionHandler[data.action];
            var streamSink = {
              enqueue: function enqueue(chunk) {
                var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
                var transfers = arguments.length > 2 ? arguments[2] : undefined;
                if (this.isCancelled) {
                  return;
                }
                var lastDesiredSize = this.desiredSize;
                this.desiredSize -= size;
                if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                  this.sinkCapability = (0, _util.createPromiseCapability)();
                  this.ready = this.sinkCapability.promise;
                }
                comObj.postMessage({
                  sourceName: sourceName,
                  targetName: targetName,
                  stream: StreamKind.ENQUEUE,
                  streamId: streamId,
                  chunk: chunk
                }, transfers);
              },
              close: function close() {
                if (this.isCancelled) {
                  return;
                }
                this.isCancelled = true;
                comObj.postMessage({
                  sourceName: sourceName,
                  targetName: targetName,
                  stream: StreamKind.CLOSE,
                  streamId: streamId
                });
                delete self.streamSinks[streamId];
              },
              error: function error(reason) {
                (0, _util.assert)(reason instanceof Error, "error must have a valid reason");
                if (this.isCancelled) {
                  return;
                }
                this.isCancelled = true;
                comObj.postMessage({
                  sourceName: sourceName,
                  targetName: targetName,
                  stream: StreamKind.ERROR,
                  streamId: streamId,
                  reason: wrapReason(reason)
                });
              },
              sinkCapability: (0, _util.createPromiseCapability)(),
              onPull: null,
              onCancel: null,
              isCancelled: false,
              desiredSize: data.desiredSize,
              ready: null
            };
            streamSink.sinkCapability.resolve();
            streamSink.ready = streamSink.sinkCapability.promise;
            this.streamSinks[streamId] = streamSink;
            new Promise(function (resolve) {
              resolve(action(data.data, streamSink));
            }).then(function () {
              comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: StreamKind.START_COMPLETE,
                streamId: streamId,
                success: true
              });
            }, function (reason) {
              comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: StreamKind.START_COMPLETE,
                streamId: streamId,
                reason: wrapReason(reason)
              });
            });
          }
        }, {
          key: "_processStreamMessage",
          value: function _processStreamMessage(data) {
            var streamId = data.streamId,
              sourceName = this.sourceName,
              targetName = data.sourceName,
              comObj = this.comObj;
            var streamController = this.streamControllers[streamId],
              streamSink = this.streamSinks[streamId];
            switch (data.stream) {
              case StreamKind.START_COMPLETE:
                if (data.success) {
                  streamController.startCall.resolve();
                } else {
                  streamController.startCall.reject(wrapReason(data.reason));
                }
                break;
              case StreamKind.PULL_COMPLETE:
                if (data.success) {
                  streamController.pullCall.resolve();
                } else {
                  streamController.pullCall.reject(wrapReason(data.reason));
                }
                break;
              case StreamKind.PULL:
                if (!streamSink) {
                  comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: StreamKind.PULL_COMPLETE,
                    streamId: streamId,
                    success: true
                  });
                  break;
                }
                if (streamSink.desiredSize <= 0 && data.desiredSize > 0) {
                  streamSink.sinkCapability.resolve();
                }
                streamSink.desiredSize = data.desiredSize;
                new Promise(function (resolve) {
                  resolve(streamSink.onPull && streamSink.onPull());
                }).then(function () {
                  comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: StreamKind.PULL_COMPLETE,
                    streamId: streamId,
                    success: true
                  });
                }, function (reason) {
                  comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: StreamKind.PULL_COMPLETE,
                    streamId: streamId,
                    reason: wrapReason(reason)
                  });
                });
                break;
              case StreamKind.ENQUEUE:
                (0, _util.assert)(streamController, "enqueue should have stream controller");
                if (streamController.isClosed) {
                  break;
                }
                streamController.controller.enqueue(data.chunk);
                break;
              case StreamKind.CLOSE:
                (0, _util.assert)(streamController, "close should have stream controller");
                if (streamController.isClosed) {
                  break;
                }
                streamController.isClosed = true;
                streamController.controller.close();
                this._deleteStreamController(streamController, streamId);
                break;
              case StreamKind.ERROR:
                (0, _util.assert)(streamController, "error should have stream controller");
                streamController.controller.error(wrapReason(data.reason));
                this._deleteStreamController(streamController, streamId);
                break;
              case StreamKind.CANCEL_COMPLETE:
                if (data.success) {
                  streamController.cancelCall.resolve();
                } else {
                  streamController.cancelCall.reject(wrapReason(data.reason));
                }
                this._deleteStreamController(streamController, streamId);
                break;
              case StreamKind.CANCEL:
                if (!streamSink) {
                  break;
                }
                new Promise(function (resolve) {
                  resolve(streamSink.onCancel && streamSink.onCancel(wrapReason(data.reason)));
                }).then(function () {
                  comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: StreamKind.CANCEL_COMPLETE,
                    streamId: streamId,
                    success: true
                  });
                }, function (reason) {
                  comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: StreamKind.CANCEL_COMPLETE,
                    streamId: streamId,
                    reason: wrapReason(reason)
                  });
                });
                streamSink.sinkCapability.reject(wrapReason(data.reason));
                streamSink.isCancelled = true;
                delete this.streamSinks[streamId];
                break;
              default:
                throw new Error("Unexpected stream case");
            }
          }
        }, {
          key: "_deleteStreamController",
          value: function () {
            var _deleteStreamController2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(streamController, streamId) {
              return _regenerator().w(function (_context1) {
                while (1) switch (_context1.n) {
                  case 0:
                    _context1.n = 1;
                    return Promise.allSettled([streamController.startCall && streamController.startCall.promise, streamController.pullCall && streamController.pullCall.promise, streamController.cancelCall && streamController.cancelCall.promise]);
                  case 1:
                    delete this.streamControllers[streamId];
                  case 2:
                    return _context1.a(2);
                }
              }, _callee1, this);
            }));
            function _deleteStreamController(_x7, _x8) {
              return _deleteStreamController2.apply(this, arguments);
            }
            return _deleteStreamController;
          }()
        }, {
          key: "destroy",
          value: function destroy() {
            this.comObj.removeEventListener("message", this._onComObjOnMessage);
          }
        }]);
      }();
      exports.MessageHandler = MessageHandler;

      /***/
    }), (/* 16 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Metadata = void 0;
      var _util = __w_pdfjs_require__(1);
      var _metadataMap = /*#__PURE__*/_classPrivateFieldLooseKey("metadataMap");
      var _data = /*#__PURE__*/_classPrivateFieldLooseKey("data");
      var Metadata = /*#__PURE__*/function () {
        function Metadata(_ref73) {
          var parsedData = _ref73.parsedData,
            rawData = _ref73.rawData;
          _classCallCheck(this, Metadata);
          Object.defineProperty(this, _metadataMap, {
            writable: true,
            value: void 0
          });
          Object.defineProperty(this, _data, {
            writable: true,
            value: void 0
          });
          _classPrivateFieldLooseBase(this, _metadataMap)[_metadataMap] = parsedData;
          _classPrivateFieldLooseBase(this, _data)[_data] = rawData;
        }
        return _createClass(Metadata, [{
          key: "getRaw",
          value: function getRaw() {
            return _classPrivateFieldLooseBase(this, _data)[_data];
          }
        }, {
          key: "get",
          value: function get(name) {
            var _classPrivateFieldLoo3;
            return (_classPrivateFieldLoo3 = _classPrivateFieldLooseBase(this, _metadataMap)[_metadataMap].get(name)) !== null && _classPrivateFieldLoo3 !== void 0 ? _classPrivateFieldLoo3 : null;
          }
        }, {
          key: "getAll",
          value: function getAll() {
            return (0, _util.objectFromMap)(_classPrivateFieldLooseBase(this, _metadataMap)[_metadataMap]);
          }
        }, {
          key: "has",
          value: function has(name) {
            return _classPrivateFieldLooseBase(this, _metadataMap)[_metadataMap].has(name);
          }
        }]);
      }();
      exports.Metadata = Metadata;

      /***/
    }), (/* 17 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.OptionalContentConfig = void 0;
      var _util = __w_pdfjs_require__(1);
      var _murmurhash = __w_pdfjs_require__(8);
      var INTERNAL = Symbol("INTERNAL");
      var _visible = /*#__PURE__*/_classPrivateFieldLooseKey("visible");
      var OptionalContentGroup = /*#__PURE__*/function () {
        function OptionalContentGroup(name, intent) {
          _classCallCheck(this, OptionalContentGroup);
          Object.defineProperty(this, _visible, {
            writable: true,
            value: true
          });
          this.name = name;
          this.intent = intent;
        }
        return _createClass(OptionalContentGroup, [{
          key: "visible",
          get: function get() {
            return _classPrivateFieldLooseBase(this, _visible)[_visible];
          }
        }, {
          key: "_setVisible",
          value: function _setVisible(internal, visible) {
            if (internal !== INTERNAL) {
              (0, _util.unreachable)("Internal method `_setVisible` called.");
            }
            _classPrivateFieldLooseBase(this, _visible)[_visible] = visible;
          }
        }]);
      }();
      var _cachedGetHash = /*#__PURE__*/_classPrivateFieldLooseKey("cachedGetHash");
      var _groups = /*#__PURE__*/_classPrivateFieldLooseKey("groups");
      var _initialHash = /*#__PURE__*/_classPrivateFieldLooseKey("initialHash");
      var _order = /*#__PURE__*/_classPrivateFieldLooseKey("order");
      var _evaluateVisibilityExpression = /*#__PURE__*/_classPrivateFieldLooseKey("evaluateVisibilityExpression");
      var OptionalContentConfig = /*#__PURE__*/function () {
        function OptionalContentConfig(data) {
          _classCallCheck(this, OptionalContentConfig);
          Object.defineProperty(this, _evaluateVisibilityExpression, {
            value: _evaluateVisibilityExpression2
          });
          Object.defineProperty(this, _cachedGetHash, {
            writable: true,
            value: null
          });
          Object.defineProperty(this, _groups, {
            writable: true,
            value: new Map()
          });
          Object.defineProperty(this, _initialHash, {
            writable: true,
            value: null
          });
          Object.defineProperty(this, _order, {
            writable: true,
            value: null
          });
          this.name = null;
          this.creator = null;
          if (data === null) {
            return;
          }
          this.name = data.name;
          this.creator = data.creator;
          _classPrivateFieldLooseBase(this, _order)[_order] = data.order;
          var _iterator55 = _createForOfIteratorHelper(data.groups),
            _step55;
          try {
            for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
              var _group = _step55.value;
              _classPrivateFieldLooseBase(this, _groups)[_groups].set(_group.id, new OptionalContentGroup(_group.name, _group.intent));
            }
          } catch (err) {
            _iterator55.e(err);
          } finally {
            _iterator55.f();
          }
          if (data.baseState === "OFF") {
            var _iterator56 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _groups)[_groups].values()),
              _step56;
            try {
              for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
                var group = _step56.value;
                group._setVisible(INTERNAL, false);
              }
            } catch (err) {
              _iterator56.e(err);
            } finally {
              _iterator56.f();
            }
          }
          var _iterator57 = _createForOfIteratorHelper(data.on),
            _step57;
          try {
            for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
              var on = _step57.value;
              _classPrivateFieldLooseBase(this, _groups)[_groups].get(on)._setVisible(INTERNAL, true);
            }
          } catch (err) {
            _iterator57.e(err);
          } finally {
            _iterator57.f();
          }
          var _iterator58 = _createForOfIteratorHelper(data.off),
            _step58;
          try {
            for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
              var off = _step58.value;
              _classPrivateFieldLooseBase(this, _groups)[_groups].get(off)._setVisible(INTERNAL, false);
            }
          } catch (err) {
            _iterator58.e(err);
          } finally {
            _iterator58.f();
          }
          _classPrivateFieldLooseBase(this, _initialHash)[_initialHash] = this.getHash();
        }
        return _createClass(OptionalContentConfig, [{
          key: "isVisible",
          value: function isVisible(group) {
            if (_classPrivateFieldLooseBase(this, _groups)[_groups].size === 0) {
              return true;
            }
            if (!group) {
              (0, _util.warn)("Optional content group not defined.");
              return true;
            }
            if (group.type === "OCG") {
              if (!_classPrivateFieldLooseBase(this, _groups)[_groups].has(group.id)) {
                (0, _util.warn)("Optional content group not found: ".concat(group.id));
                return true;
              }
              return _classPrivateFieldLooseBase(this, _groups)[_groups].get(group.id).visible;
            } else if (group.type === "OCMD") {
              if (group.expression) {
                return _classPrivateFieldLooseBase(this, _evaluateVisibilityExpression)[_evaluateVisibilityExpression](group.expression);
              }
              if (!group.policy || group.policy === "AnyOn") {
                var _iterator59 = _createForOfIteratorHelper(group.ids),
                  _step59;
                try {
                  for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
                    var _id3 = _step59.value;
                    if (!_classPrivateFieldLooseBase(this, _groups)[_groups].has(_id3)) {
                      (0, _util.warn)("Optional content group not found: ".concat(_id3));
                      return true;
                    }
                    if (_classPrivateFieldLooseBase(this, _groups)[_groups].get(_id3).visible) {
                      return true;
                    }
                  }
                } catch (err) {
                  _iterator59.e(err);
                } finally {
                  _iterator59.f();
                }
                return false;
              } else if (group.policy === "AllOn") {
                var _iterator60 = _createForOfIteratorHelper(group.ids),
                  _step60;
                try {
                  for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
                    var _id4 = _step60.value;
                    if (!_classPrivateFieldLooseBase(this, _groups)[_groups].has(_id4)) {
                      (0, _util.warn)("Optional content group not found: ".concat(_id4));
                      return true;
                    }
                    if (!_classPrivateFieldLooseBase(this, _groups)[_groups].get(_id4).visible) {
                      return false;
                    }
                  }
                } catch (err) {
                  _iterator60.e(err);
                } finally {
                  _iterator60.f();
                }
                return true;
              } else if (group.policy === "AnyOff") {
                var _iterator61 = _createForOfIteratorHelper(group.ids),
                  _step61;
                try {
                  for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
                    var _id5 = _step61.value;
                    if (!_classPrivateFieldLooseBase(this, _groups)[_groups].has(_id5)) {
                      (0, _util.warn)("Optional content group not found: ".concat(_id5));
                      return true;
                    }
                    if (!_classPrivateFieldLooseBase(this, _groups)[_groups].get(_id5).visible) {
                      return true;
                    }
                  }
                } catch (err) {
                  _iterator61.e(err);
                } finally {
                  _iterator61.f();
                }
                return false;
              } else if (group.policy === "AllOff") {
                var _iterator62 = _createForOfIteratorHelper(group.ids),
                  _step62;
                try {
                  for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
                    var _id6 = _step62.value;
                    if (!_classPrivateFieldLooseBase(this, _groups)[_groups].has(_id6)) {
                      (0, _util.warn)("Optional content group not found: ".concat(_id6));
                      return true;
                    }
                    if (_classPrivateFieldLooseBase(this, _groups)[_groups].get(_id6).visible) {
                      return false;
                    }
                  }
                } catch (err) {
                  _iterator62.e(err);
                } finally {
                  _iterator62.f();
                }
                return true;
              }
              (0, _util.warn)("Unknown optional content policy ".concat(group.policy, "."));
              return true;
            }
            (0, _util.warn)("Unknown group type ".concat(group.type, "."));
            return true;
          }
        }, {
          key: "setVisibility",
          value: function setVisibility(id) {
            var visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            if (!_classPrivateFieldLooseBase(this, _groups)[_groups].has(id)) {
              (0, _util.warn)("Optional content group not found: ".concat(id));
              return;
            }
            _classPrivateFieldLooseBase(this, _groups)[_groups].get(id)._setVisible(INTERNAL, !!visible);
            _classPrivateFieldLooseBase(this, _cachedGetHash)[_cachedGetHash] = null;
          }
        }, {
          key: "hasInitialVisibility",
          get: function get() {
            return this.getHash() === _classPrivateFieldLooseBase(this, _initialHash)[_initialHash];
          }
        }, {
          key: "getOrder",
          value: function getOrder() {
            if (!_classPrivateFieldLooseBase(this, _groups)[_groups].size) {
              return null;
            }
            if (_classPrivateFieldLooseBase(this, _order)[_order]) {
              return _classPrivateFieldLooseBase(this, _order)[_order].slice();
            }
            return _toConsumableArray(_classPrivateFieldLooseBase(this, _groups)[_groups].keys());
          }
        }, {
          key: "getGroups",
          value: function getGroups() {
            return _classPrivateFieldLooseBase(this, _groups)[_groups].size > 0 ? (0, _util.objectFromMap)(_classPrivateFieldLooseBase(this, _groups)[_groups]) : null;
          }
        }, {
          key: "getGroup",
          value: function getGroup(id) {
            return _classPrivateFieldLooseBase(this, _groups)[_groups].get(id) || null;
          }
        }, {
          key: "getHash",
          value: function getHash() {
            if (_classPrivateFieldLooseBase(this, _cachedGetHash)[_cachedGetHash] !== null) {
              return _classPrivateFieldLooseBase(this, _cachedGetHash)[_cachedGetHash];
            }
            var hash = new _murmurhash.MurmurHash3_64();
            var _iterator63 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _groups)[_groups]),
              _step63;
            try {
              for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
                var _ref74 = _step63.value;
                var _ref75 = _slicedToArray(_ref74, 2);
                var _id7 = _ref75[0];
                var group = _ref75[1];
                hash.update("".concat(_id7, ":").concat(group.visible));
              }
            } catch (err) {
              _iterator63.e(err);
            } finally {
              _iterator63.f();
            }
            return _classPrivateFieldLooseBase(this, _cachedGetHash)[_cachedGetHash] = hash.hexdigest();
          }
        }]);
      }();
      function _evaluateVisibilityExpression2(array) {
        var length = array.length;
        if (length < 2) {
          return true;
        }
        var operator = array[0];
        for (var i = 1; i < length; i++) {
          var element = array[i];
          var state = void 0;
          if (Array.isArray(element)) {
            state = _classPrivateFieldLooseBase(this, _evaluateVisibilityExpression)[_evaluateVisibilityExpression](element);
          } else if (_classPrivateFieldLooseBase(this, _groups)[_groups].has(element)) {
            state = _classPrivateFieldLooseBase(this, _groups)[_groups].get(element).visible;
          } else {
            (0, _util.warn)("Optional content group not found: ".concat(element));
            return true;
          }
          switch (operator) {
            case "And":
              if (!state) {
                return false;
              }
              break;
            case "Or":
              if (state) {
                return true;
              }
              break;
            case "Not":
              return !state;
            default:
              return true;
          }
        }
        return operator === "And";
      }
      exports.OptionalContentConfig = OptionalContentConfig;

      /***/
    }), (/* 18 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PDFDataTransportStream = void 0;
      var _util = __w_pdfjs_require__(1);
      var _display_utils = __w_pdfjs_require__(6);
      var PDFDataTransportStream = /*#__PURE__*/function () {
        function PDFDataTransportStream(_ref76, pdfDataRangeTransport) {
          var _this31 = this;
          var length = _ref76.length,
            initialData = _ref76.initialData,
            _ref76$progressiveDon = _ref76.progressiveDone,
            progressiveDone = _ref76$progressiveDon === void 0 ? false : _ref76$progressiveDon,
            _ref76$contentDisposi = _ref76.contentDispositionFilename,
            contentDispositionFilename = _ref76$contentDisposi === void 0 ? null : _ref76$contentDisposi,
            _ref76$disableRange = _ref76.disableRange,
            disableRange = _ref76$disableRange === void 0 ? false : _ref76$disableRange,
            _ref76$disableStream = _ref76.disableStream,
            disableStream = _ref76$disableStream === void 0 ? false : _ref76$disableStream;
          _classCallCheck(this, PDFDataTransportStream);
          (0, _util.assert)(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
          this._queuedChunks = [];
          this._progressiveDone = progressiveDone;
          this._contentDispositionFilename = contentDispositionFilename;
          if ((initialData === null || initialData === void 0 ? void 0 : initialData.length) > 0) {
            var buffer = initialData instanceof Uint8Array && initialData.byteLength === initialData.buffer.byteLength ? initialData.buffer : new Uint8Array(initialData).buffer;
            this._queuedChunks.push(buffer);
          }
          this._pdfDataRangeTransport = pdfDataRangeTransport;
          this._isStreamingSupported = !disableStream;
          this._isRangeSupported = !disableRange;
          this._contentLength = length;
          this._fullRequestReader = null;
          this._rangeReaders = [];
          this._pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
            _this31._onReceiveData({
              begin: begin,
              chunk: chunk
            });
          });
          this._pdfDataRangeTransport.addProgressListener(function (loaded, total) {
            _this31._onProgress({
              loaded: loaded,
              total: total
            });
          });
          this._pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
            _this31._onReceiveData({
              chunk: chunk
            });
          });
          this._pdfDataRangeTransport.addProgressiveDoneListener(function () {
            _this31._onProgressiveDone();
          });
          this._pdfDataRangeTransport.transportReady();
        }
        return _createClass(PDFDataTransportStream, [{
          key: "_onReceiveData",
          value: function _onReceiveData(_ref77) {
            var begin = _ref77.begin,
              chunk = _ref77.chunk;
            var buffer = chunk instanceof Uint8Array && chunk.byteLength === chunk.buffer.byteLength ? chunk.buffer : new Uint8Array(chunk).buffer;
            if (begin === undefined) {
              if (this._fullRequestReader) {
                this._fullRequestReader._enqueue(buffer);
              } else {
                this._queuedChunks.push(buffer);
              }
            } else {
              var found = this._rangeReaders.some(function (rangeReader) {
                if (rangeReader._begin !== begin) {
                  return false;
                }
                rangeReader._enqueue(buffer);
                return true;
              });
              (0, _util.assert)(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
            }
          }
        }, {
          key: "_progressiveDataLength",
          get: function get() {
            var _this$_fullRequestRea, _this$_fullRequestRea2;
            return (_this$_fullRequestRea = (_this$_fullRequestRea2 = this._fullRequestReader) === null || _this$_fullRequestRea2 === void 0 ? void 0 : _this$_fullRequestRea2._loaded) !== null && _this$_fullRequestRea !== void 0 ? _this$_fullRequestRea : 0;
          }
        }, {
          key: "_onProgress",
          value: function _onProgress(evt) {
            if (evt.total === undefined) {
              var _this$_rangeReaders$, _this$_rangeReaders$$;
              (_this$_rangeReaders$ = this._rangeReaders[0]) === null || _this$_rangeReaders$ === void 0 || (_this$_rangeReaders$$ = _this$_rangeReaders$.onProgress) === null || _this$_rangeReaders$$ === void 0 || _this$_rangeReaders$$.call(_this$_rangeReaders$, {
                loaded: evt.loaded
              });
            } else {
              var _this$_fullRequestRea3, _this$_fullRequestRea4;
              (_this$_fullRequestRea3 = this._fullRequestReader) === null || _this$_fullRequestRea3 === void 0 || (_this$_fullRequestRea4 = _this$_fullRequestRea3.onProgress) === null || _this$_fullRequestRea4 === void 0 || _this$_fullRequestRea4.call(_this$_fullRequestRea3, {
                loaded: evt.loaded,
                total: evt.total
              });
            }
          }
        }, {
          key: "_onProgressiveDone",
          value: function _onProgressiveDone() {
            var _this$_fullRequestRea5;
            (_this$_fullRequestRea5 = this._fullRequestReader) === null || _this$_fullRequestRea5 === void 0 || _this$_fullRequestRea5.progressiveDone();
            this._progressiveDone = true;
          }
        }, {
          key: "_removeRangeReader",
          value: function _removeRangeReader(reader) {
            var i = this._rangeReaders.indexOf(reader);
            if (i >= 0) {
              this._rangeReaders.splice(i, 1);
            }
          }
        }, {
          key: "getFullReader",
          value: function getFullReader() {
            (0, _util.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
            var queuedChunks = this._queuedChunks;
            this._queuedChunks = null;
            return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
          }
        }, {
          key: "getRangeReader",
          value: function getRangeReader(begin, end) {
            if (end <= this._progressiveDataLength) {
              return null;
            }
            var reader = new PDFDataTransportStreamRangeReader(this, begin, end);
            this._pdfDataRangeTransport.requestDataRange(begin, end);
            this._rangeReaders.push(reader);
            return reader;
          }
        }, {
          key: "cancelAllRequests",
          value: function cancelAllRequests(reason) {
            var _this$_fullRequestRea6;
            (_this$_fullRequestRea6 = this._fullRequestReader) === null || _this$_fullRequestRea6 === void 0 || _this$_fullRequestRea6.cancel(reason);
            var _iterator64 = _createForOfIteratorHelper(this._rangeReaders.slice(0)),
              _step64;
            try {
              for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
                var reader = _step64.value;
                reader.cancel(reason);
              }
            } catch (err) {
              _iterator64.e(err);
            } finally {
              _iterator64.f();
            }
            this._pdfDataRangeTransport.abort();
          }
        }]);
      }();
      exports.PDFDataTransportStream = PDFDataTransportStream;
      var PDFDataTransportStreamReader = /*#__PURE__*/function () {
        function PDFDataTransportStreamReader(stream, queuedChunks) {
          var progressiveDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          var contentDispositionFilename = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
          _classCallCheck(this, PDFDataTransportStreamReader);
          this._stream = stream;
          this._done = progressiveDone || false;
          this._filename = (0, _display_utils.isPdfFile)(contentDispositionFilename) ? contentDispositionFilename : null;
          this._queuedChunks = queuedChunks || [];
          this._loaded = 0;
          var _iterator65 = _createForOfIteratorHelper(this._queuedChunks),
            _step65;
          try {
            for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
              var chunk = _step65.value;
              this._loaded += chunk.byteLength;
            }
          } catch (err) {
            _iterator65.e(err);
          } finally {
            _iterator65.f();
          }
          this._requests = [];
          this._headersReady = Promise.resolve();
          stream._fullRequestReader = this;
          this.onProgress = null;
        }
        return _createClass(PDFDataTransportStreamReader, [{
          key: "_enqueue",
          value: function _enqueue(chunk) {
            if (this._done) {
              return;
            }
            if (this._requests.length > 0) {
              var requestCapability = this._requests.shift();
              requestCapability.resolve({
                value: chunk,
                done: false
              });
            } else {
              this._queuedChunks.push(chunk);
            }
            this._loaded += chunk.byteLength;
          }
        }, {
          key: "headersReady",
          get: function get() {
            return this._headersReady;
          }
        }, {
          key: "filename",
          get: function get() {
            return this._filename;
          }
        }, {
          key: "isRangeSupported",
          get: function get() {
            return this._stream._isRangeSupported;
          }
        }, {
          key: "isStreamingSupported",
          get: function get() {
            return this._stream._isStreamingSupported;
          }
        }, {
          key: "contentLength",
          get: function get() {
            return this._stream._contentLength;
          }
        }, {
          key: "read",
          value: function () {
            var _read = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
              var chunk, requestCapability;
              return _regenerator().w(function (_context10) {
                while (1) switch (_context10.n) {
                  case 0:
                    if (!(this._queuedChunks.length > 0)) {
                      _context10.n = 1;
                      break;
                    }
                    chunk = this._queuedChunks.shift();
                    return _context10.a(2, {
                      value: chunk,
                      done: false
                    });
                  case 1:
                    if (!this._done) {
                      _context10.n = 2;
                      break;
                    }
                    return _context10.a(2, {
                      value: undefined,
                      done: true
                    });
                  case 2:
                    requestCapability = (0, _util.createPromiseCapability)();
                    this._requests.push(requestCapability);
                    return _context10.a(2, requestCapability.promise);
                }
              }, _callee10, this);
            }));
            function read() {
              return _read.apply(this, arguments);
            }
            return read;
          }()
        }, {
          key: "cancel",
          value: function cancel(reason) {
            this._done = true;
            var _iterator66 = _createForOfIteratorHelper(this._requests),
              _step66;
            try {
              for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
                var requestCapability = _step66.value;
                requestCapability.resolve({
                  value: undefined,
                  done: true
                });
              }
            } catch (err) {
              _iterator66.e(err);
            } finally {
              _iterator66.f();
            }
            this._requests.length = 0;
          }
        }, {
          key: "progressiveDone",
          value: function progressiveDone() {
            if (this._done) {
              return;
            }
            this._done = true;
          }
        }]);
      }();
      var PDFDataTransportStreamRangeReader = /*#__PURE__*/function () {
        function PDFDataTransportStreamRangeReader(stream, begin, end) {
          _classCallCheck(this, PDFDataTransportStreamRangeReader);
          this._stream = stream;
          this._begin = begin;
          this._end = end;
          this._queuedChunk = null;
          this._requests = [];
          this._done = false;
          this.onProgress = null;
        }
        return _createClass(PDFDataTransportStreamRangeReader, [{
          key: "_enqueue",
          value: function _enqueue(chunk) {
            if (this._done) {
              return;
            }
            if (this._requests.length === 0) {
              this._queuedChunk = chunk;
            } else {
              var requestsCapability = this._requests.shift();
              requestsCapability.resolve({
                value: chunk,
                done: false
              });
              var _iterator67 = _createForOfIteratorHelper(this._requests),
                _step67;
              try {
                for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
                  var requestCapability = _step67.value;
                  requestCapability.resolve({
                    value: undefined,
                    done: true
                  });
                }
              } catch (err) {
                _iterator67.e(err);
              } finally {
                _iterator67.f();
              }
              this._requests.length = 0;
            }
            this._done = true;
            this._stream._removeRangeReader(this);
          }
        }, {
          key: "isStreamingSupported",
          get: function get() {
            return false;
          }
        }, {
          key: "read",
          value: function () {
            var _read2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
              var chunk, requestCapability;
              return _regenerator().w(function (_context11) {
                while (1) switch (_context11.n) {
                  case 0:
                    if (!this._queuedChunk) {
                      _context11.n = 1;
                      break;
                    }
                    chunk = this._queuedChunk;
                    this._queuedChunk = null;
                    return _context11.a(2, {
                      value: chunk,
                      done: false
                    });
                  case 1:
                    if (!this._done) {
                      _context11.n = 2;
                      break;
                    }
                    return _context11.a(2, {
                      value: undefined,
                      done: true
                    });
                  case 2:
                    requestCapability = (0, _util.createPromiseCapability)();
                    this._requests.push(requestCapability);
                    return _context11.a(2, requestCapability.promise);
                }
              }, _callee11, this);
            }));
            function read() {
              return _read2.apply(this, arguments);
            }
            return read;
          }()
        }, {
          key: "cancel",
          value: function cancel(reason) {
            this._done = true;
            var _iterator68 = _createForOfIteratorHelper(this._requests),
              _step68;
            try {
              for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
                var requestCapability = _step68.value;
                requestCapability.resolve({
                  value: undefined,
                  done: true
                });
              }
            } catch (err) {
              _iterator68.e(err);
            } finally {
              _iterator68.f();
            }
            this._requests.length = 0;
            this._stream._removeRangeReader(this);
          }
        }]);
      }();
      /***/
    }), (/* 19 */
    /***/function (__unused_webpack_module, exports) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.XfaText = void 0;
      var XfaText = /*#__PURE__*/function () {
        function XfaText() {
          _classCallCheck(this, XfaText);
        }
        return _createClass(XfaText, null, [{
          key: "textContent",
          value: function textContent(xfa) {
            var items = [];
            var output = {
              items: items,
              styles: Object.create(null)
            };
            function walk(node) {
              var _node$attributes;
              if (!node) {
                return;
              }
              var str = null;
              var name = node.name;
              if (name === "#text") {
                str = node.value;
              } else if (!XfaText.shouldBuildText(name)) {
                return;
              } else if (node !== null && node !== void 0 && (_node$attributes = node.attributes) !== null && _node$attributes !== void 0 && _node$attributes.textContent) {
                str = node.attributes.textContent;
              } else if (node.value) {
                str = node.value;
              }
              if (str !== null) {
                items.push({
                  str: str
                });
              }
              if (!node.children) {
                return;
              }
              var _iterator69 = _createForOfIteratorHelper(node.children),
                _step69;
              try {
                for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
                  var child = _step69.value;
                  walk(child);
                }
              } catch (err) {
                _iterator69.e(err);
              } finally {
                _iterator69.f();
              }
            }
            walk(xfa);
            return output;
          }
        }, {
          key: "shouldBuildText",
          value: function shouldBuildText(name) {
            return !(name === "textarea" || name === "input" || name === "option" || name === "select");
          }
        }]);
      }();
      exports.XfaText = XfaText;

      /***/
    }), (/* 20 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.NodeStandardFontDataFactory = exports.NodeCanvasFactory = exports.NodeCMapReaderFactory = void 0;
      var _base_factory = __w_pdfjs_require__(7);
      ;
      var fetchData = function fetchData(url) {
        return new Promise(function (resolve, reject) {
          var fs = require("fs");
          fs.readFile(url, function (error, data) {
            if (error || !data) {
              reject(new Error(error));
              return;
            }
            resolve(new Uint8Array(data));
          });
        });
      };
      var NodeCanvasFactory = /*#__PURE__*/function (_base_factory$BaseCan2) {
        function NodeCanvasFactory() {
          _classCallCheck(this, NodeCanvasFactory);
          return _callSuper(this, NodeCanvasFactory, arguments);
        }
        _inherits(NodeCanvasFactory, _base_factory$BaseCan2);
        return _createClass(NodeCanvasFactory, [{
          key: "_createCanvas",
          value: function _createCanvas(width, height) {
            var Canvas = require("canvas");
            return Canvas.createCanvas(width, height);
          }
        }]);
      }(_base_factory.BaseCanvasFactory);
      exports.NodeCanvasFactory = NodeCanvasFactory;
      var NodeCMapReaderFactory = /*#__PURE__*/function (_base_factory$BaseCMa2) {
        function NodeCMapReaderFactory() {
          _classCallCheck(this, NodeCMapReaderFactory);
          return _callSuper(this, NodeCMapReaderFactory, arguments);
        }
        _inherits(NodeCMapReaderFactory, _base_factory$BaseCMa2);
        return _createClass(NodeCMapReaderFactory, [{
          key: "_fetchData",
          value: function _fetchData(url, compressionType) {
            return fetchData(url).then(function (data) {
              return {
                cMapData: data,
                compressionType: compressionType
              };
            });
          }
        }]);
      }(_base_factory.BaseCMapReaderFactory);
      exports.NodeCMapReaderFactory = NodeCMapReaderFactory;
      var NodeStandardFontDataFactory = /*#__PURE__*/function (_base_factory$BaseSta2) {
        function NodeStandardFontDataFactory() {
          _classCallCheck(this, NodeStandardFontDataFactory);
          return _callSuper(this, NodeStandardFontDataFactory, arguments);
        }
        _inherits(NodeStandardFontDataFactory, _base_factory$BaseSta2);
        return _createClass(NodeStandardFontDataFactory, [{
          key: "_fetchData",
          value: function _fetchData(url) {
            return fetchData(url);
          }
        }]);
      }(_base_factory.BaseStandardFontDataFactory);
      exports.NodeStandardFontDataFactory = NodeStandardFontDataFactory;

      /***/
    }), (/* 21 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PDFNodeStream = void 0;
      var _util = __w_pdfjs_require__(1);
      var _network_utils = __w_pdfjs_require__(22);
      ;
      var fs = require("fs");
      var http = require("http");
      var https = require("https");
      var url = require("url");
      var fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
      function parseUrl(sourceUrl) {
        var parsedUrl = url.parse(sourceUrl);
        if (parsedUrl.protocol === "file:" || parsedUrl.host) {
          return parsedUrl;
        }
        if (/^[a-z]:[/\\]/i.test(sourceUrl)) {
          return url.parse("file:///".concat(sourceUrl));
        }
        if (!parsedUrl.host) {
          parsedUrl.protocol = "file:";
        }
        return parsedUrl;
      }
      var PDFNodeStream = /*#__PURE__*/function () {
        function PDFNodeStream(source) {
          _classCallCheck(this, PDFNodeStream);
          this.source = source;
          this.url = parseUrl(source.url);
          this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
          this.isFsUrl = this.url.protocol === "file:";
          this.httpHeaders = this.isHttp && source.httpHeaders || {};
          this._fullRequestReader = null;
          this._rangeRequestReaders = [];
        }
        return _createClass(PDFNodeStream, [{
          key: "_progressiveDataLength",
          get: function get() {
            var _this$_fullRequestRea7, _this$_fullRequestRea8;
            return (_this$_fullRequestRea7 = (_this$_fullRequestRea8 = this._fullRequestReader) === null || _this$_fullRequestRea8 === void 0 ? void 0 : _this$_fullRequestRea8._loaded) !== null && _this$_fullRequestRea7 !== void 0 ? _this$_fullRequestRea7 : 0;
          }
        }, {
          key: "getFullReader",
          value: function getFullReader() {
            (0, _util.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
            this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
            return this._fullRequestReader;
          }
        }, {
          key: "getRangeReader",
          value: function getRangeReader(start, end) {
            if (end <= this._progressiveDataLength) {
              return null;
            }
            var rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
            this._rangeRequestReaders.push(rangeReader);
            return rangeReader;
          }
        }, {
          key: "cancelAllRequests",
          value: function cancelAllRequests(reason) {
            var _this$_fullRequestRea9;
            (_this$_fullRequestRea9 = this._fullRequestReader) === null || _this$_fullRequestRea9 === void 0 || _this$_fullRequestRea9.cancel(reason);
            var _iterator70 = _createForOfIteratorHelper(this._rangeRequestReaders.slice(0)),
              _step70;
            try {
              for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
                var reader = _step70.value;
                reader.cancel(reason);
              }
            } catch (err) {
              _iterator70.e(err);
            } finally {
              _iterator70.f();
            }
          }
        }]);
      }();
      exports.PDFNodeStream = PDFNodeStream;
      var BaseFullReader = /*#__PURE__*/function () {
        function BaseFullReader(stream) {
          _classCallCheck(this, BaseFullReader);
          this._url = stream.url;
          this._done = false;
          this._storedError = null;
          this.onProgress = null;
          var source = stream.source;
          this._contentLength = source.length;
          this._loaded = 0;
          this._filename = null;
          this._disableRange = source.disableRange || false;
          this._rangeChunkSize = source.rangeChunkSize;
          if (!this._rangeChunkSize && !this._disableRange) {
            this._disableRange = true;
          }
          this._isStreamingSupported = !source.disableStream;
          this._isRangeSupported = !source.disableRange;
          this._readableStream = null;
          this._readCapability = (0, _util.createPromiseCapability)();
          this._headersCapability = (0, _util.createPromiseCapability)();
        }
        return _createClass(BaseFullReader, [{
          key: "headersReady",
          get: function get() {
            return this._headersCapability.promise;
          }
        }, {
          key: "filename",
          get: function get() {
            return this._filename;
          }
        }, {
          key: "contentLength",
          get: function get() {
            return this._contentLength;
          }
        }, {
          key: "isRangeSupported",
          get: function get() {
            return this._isRangeSupported;
          }
        }, {
          key: "isStreamingSupported",
          get: function get() {
            return this._isStreamingSupported;
          }
        }, {
          key: "read",
          value: function () {
            var _read3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
              var _this$onProgress;
              var chunk, buffer;
              return _regenerator().w(function (_context12) {
                while (1) switch (_context12.n) {
                  case 0:
                    _context12.n = 1;
                    return this._readCapability.promise;
                  case 1:
                    if (!this._done) {
                      _context12.n = 2;
                      break;
                    }
                    return _context12.a(2, {
                      value: undefined,
                      done: true
                    });
                  case 2:
                    if (!this._storedError) {
                      _context12.n = 3;
                      break;
                    }
                    throw this._storedError;
                  case 3:
                    chunk = this._readableStream.read();
                    if (!(chunk === null)) {
                      _context12.n = 4;
                      break;
                    }
                    this._readCapability = (0, _util.createPromiseCapability)();
                    return _context12.a(2, this.read());
                  case 4:
                    this._loaded += chunk.length;
                    (_this$onProgress = this.onProgress) === null || _this$onProgress === void 0 || _this$onProgress.call(this, {
                      loaded: this._loaded,
                      total: this._contentLength
                    });
                    buffer = new Uint8Array(chunk).buffer;
                    return _context12.a(2, {
                      value: buffer,
                      done: false
                    });
                }
              }, _callee12, this);
            }));
            function read() {
              return _read3.apply(this, arguments);
            }
            return read;
          }()
        }, {
          key: "cancel",
          value: function cancel(reason) {
            if (!this._readableStream) {
              this._error(reason);
              return;
            }
            this._readableStream.destroy(reason);
          }
        }, {
          key: "_error",
          value: function _error(reason) {
            this._storedError = reason;
            this._readCapability.resolve();
          }
        }, {
          key: "_setReadableStream",
          value: function _setReadableStream(readableStream) {
            var _this32 = this;
            this._readableStream = readableStream;
            readableStream.on("readable", function () {
              _this32._readCapability.resolve();
            });
            readableStream.on("end", function () {
              readableStream.destroy();
              _this32._done = true;
              _this32._readCapability.resolve();
            });
            readableStream.on("error", function (reason) {
              _this32._error(reason);
            });
            if (!this._isStreamingSupported && this._isRangeSupported) {
              this._error(new _util.AbortException("streaming is disabled"));
            }
            if (this._storedError) {
              this._readableStream.destroy(this._storedError);
            }
          }
        }]);
      }();
      var BaseRangeReader = /*#__PURE__*/function () {
        function BaseRangeReader(stream) {
          _classCallCheck(this, BaseRangeReader);
          this._url = stream.url;
          this._done = false;
          this._storedError = null;
          this.onProgress = null;
          this._loaded = 0;
          this._readableStream = null;
          this._readCapability = (0, _util.createPromiseCapability)();
          var source = stream.source;
          this._isStreamingSupported = !source.disableStream;
        }
        return _createClass(BaseRangeReader, [{
          key: "isStreamingSupported",
          get: function get() {
            return this._isStreamingSupported;
          }
        }, {
          key: "read",
          value: function () {
            var _read4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
              var _this$onProgress2;
              var chunk, buffer;
              return _regenerator().w(function (_context13) {
                while (1) switch (_context13.n) {
                  case 0:
                    _context13.n = 1;
                    return this._readCapability.promise;
                  case 1:
                    if (!this._done) {
                      _context13.n = 2;
                      break;
                    }
                    return _context13.a(2, {
                      value: undefined,
                      done: true
                    });
                  case 2:
                    if (!this._storedError) {
                      _context13.n = 3;
                      break;
                    }
                    throw this._storedError;
                  case 3:
                    chunk = this._readableStream.read();
                    if (!(chunk === null)) {
                      _context13.n = 4;
                      break;
                    }
                    this._readCapability = (0, _util.createPromiseCapability)();
                    return _context13.a(2, this.read());
                  case 4:
                    this._loaded += chunk.length;
                    (_this$onProgress2 = this.onProgress) === null || _this$onProgress2 === void 0 || _this$onProgress2.call(this, {
                      loaded: this._loaded
                    });
                    buffer = new Uint8Array(chunk).buffer;
                    return _context13.a(2, {
                      value: buffer,
                      done: false
                    });
                }
              }, _callee13, this);
            }));
            function read() {
              return _read4.apply(this, arguments);
            }
            return read;
          }()
        }, {
          key: "cancel",
          value: function cancel(reason) {
            if (!this._readableStream) {
              this._error(reason);
              return;
            }
            this._readableStream.destroy(reason);
          }
        }, {
          key: "_error",
          value: function _error(reason) {
            this._storedError = reason;
            this._readCapability.resolve();
          }
        }, {
          key: "_setReadableStream",
          value: function _setReadableStream(readableStream) {
            var _this33 = this;
            this._readableStream = readableStream;
            readableStream.on("readable", function () {
              _this33._readCapability.resolve();
            });
            readableStream.on("end", function () {
              readableStream.destroy();
              _this33._done = true;
              _this33._readCapability.resolve();
            });
            readableStream.on("error", function (reason) {
              _this33._error(reason);
            });
            if (this._storedError) {
              this._readableStream.destroy(this._storedError);
            }
          }
        }]);
      }();
      function createRequestOptions(parsedUrl, headers) {
        return {
          protocol: parsedUrl.protocol,
          auth: parsedUrl.auth,
          host: parsedUrl.hostname,
          port: parsedUrl.port,
          path: parsedUrl.path,
          method: "GET",
          headers: headers
        };
      }
      var PDFNodeStreamFullReader = /*#__PURE__*/function (_BaseFullReader) {
        function PDFNodeStreamFullReader(stream) {
          var _this34;
          _classCallCheck(this, PDFNodeStreamFullReader);
          _this34 = _callSuper(this, PDFNodeStreamFullReader, [stream]);
          var handleResponse = function handleResponse(response) {
            if (response.statusCode === 404) {
              var error = new _util.MissingPDFException("Missing PDF \"".concat(_this34._url, "\"."));
              _this34._storedError = error;
              _this34._headersCapability.reject(error);
              return;
            }
            _this34._headersCapability.resolve();
            _this34._setReadableStream(response);
            var getResponseHeader = function getResponseHeader(name) {
              return _this34._readableStream.headers[name.toLowerCase()];
            };
            var _ref78 = (0, _network_utils.validateRangeRequestCapabilities)({
                getResponseHeader: getResponseHeader,
                isHttp: stream.isHttp,
                rangeChunkSize: _this34._rangeChunkSize,
                disableRange: _this34._disableRange
              }),
              allowRangeRequests = _ref78.allowRangeRequests,
              suggestedLength = _ref78.suggestedLength;
            _this34._isRangeSupported = allowRangeRequests;
            _this34._contentLength = suggestedLength || _this34._contentLength;
            _this34._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
          };
          _this34._request = null;
          if (_this34._url.protocol === "http:") {
            _this34._request = http.request(createRequestOptions(_this34._url, stream.httpHeaders), handleResponse);
          } else {
            _this34._request = https.request(createRequestOptions(_this34._url, stream.httpHeaders), handleResponse);
          }
          _this34._request.on("error", function (reason) {
            _this34._storedError = reason;
            _this34._headersCapability.reject(reason);
          });
          _this34._request.end();
          return _this34;
        }
        _inherits(PDFNodeStreamFullReader, _BaseFullReader);
        return _createClass(PDFNodeStreamFullReader);
      }(BaseFullReader);
      var PDFNodeStreamRangeReader = /*#__PURE__*/function (_BaseRangeReader) {
        function PDFNodeStreamRangeReader(stream, start, end) {
          var _this35;
          _classCallCheck(this, PDFNodeStreamRangeReader);
          _this35 = _callSuper(this, PDFNodeStreamRangeReader, [stream]);
          _this35._httpHeaders = {};
          for (var property in stream.httpHeaders) {
            var value = stream.httpHeaders[property];
            if (value === undefined) {
              continue;
            }
            _this35._httpHeaders[property] = value;
          }
          _this35._httpHeaders.Range = "bytes=".concat(start, "-").concat(end - 1);
          var handleResponse = function handleResponse(response) {
            if (response.statusCode === 404) {
              var error = new _util.MissingPDFException("Missing PDF \"".concat(_this35._url, "\"."));
              _this35._storedError = error;
              return;
            }
            _this35._setReadableStream(response);
          };
          _this35._request = null;
          if (_this35._url.protocol === "http:") {
            _this35._request = http.request(createRequestOptions(_this35._url, _this35._httpHeaders), handleResponse);
          } else {
            _this35._request = https.request(createRequestOptions(_this35._url, _this35._httpHeaders), handleResponse);
          }
          _this35._request.on("error", function (reason) {
            _this35._storedError = reason;
          });
          _this35._request.end();
          return _this35;
        }
        _inherits(PDFNodeStreamRangeReader, _BaseRangeReader);
        return _createClass(PDFNodeStreamRangeReader);
      }(BaseRangeReader);
      var PDFNodeStreamFsFullReader = /*#__PURE__*/function (_BaseFullReader2) {
        function PDFNodeStreamFsFullReader(stream) {
          var _this36;
          _classCallCheck(this, PDFNodeStreamFsFullReader);
          _this36 = _callSuper(this, PDFNodeStreamFsFullReader, [stream]);
          var path = decodeURIComponent(_this36._url.path);
          if (fileUriRegex.test(_this36._url.href)) {
            path = path.replace(/^\//, "");
          }
          fs.lstat(path, function (error, stat) {
            if (error) {
              if (error.code === "ENOENT") {
                error = new _util.MissingPDFException("Missing PDF \"".concat(path, "\"."));
              }
              _this36._storedError = error;
              _this36._headersCapability.reject(error);
              return;
            }
            _this36._contentLength = stat.size;
            _this36._setReadableStream(fs.createReadStream(path));
            _this36._headersCapability.resolve();
          });
          return _this36;
        }
        _inherits(PDFNodeStreamFsFullReader, _BaseFullReader2);
        return _createClass(PDFNodeStreamFsFullReader);
      }(BaseFullReader);
      var PDFNodeStreamFsRangeReader = /*#__PURE__*/function (_BaseRangeReader2) {
        function PDFNodeStreamFsRangeReader(stream, start, end) {
          var _this37;
          _classCallCheck(this, PDFNodeStreamFsRangeReader);
          _this37 = _callSuper(this, PDFNodeStreamFsRangeReader, [stream]);
          var path = decodeURIComponent(_this37._url.path);
          if (fileUriRegex.test(_this37._url.href)) {
            path = path.replace(/^\//, "");
          }
          _this37._setReadableStream(fs.createReadStream(path, {
            start: start,
            end: end - 1
          }));
          return _this37;
        }
        _inherits(PDFNodeStreamFsRangeReader, _BaseRangeReader2);
        return _createClass(PDFNodeStreamFsRangeReader);
      }(BaseRangeReader);
      /***/
    }), (/* 22 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.createResponseStatusError = createResponseStatusError;
      exports.extractFilenameFromHeader = extractFilenameFromHeader;
      exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
      exports.validateResponseStatus = validateResponseStatus;
      var _util = __w_pdfjs_require__(1);
      var _content_disposition = __w_pdfjs_require__(23);
      var _display_utils = __w_pdfjs_require__(6);
      function validateRangeRequestCapabilities(_ref79) {
        var getResponseHeader = _ref79.getResponseHeader,
          isHttp = _ref79.isHttp,
          rangeChunkSize = _ref79.rangeChunkSize,
          disableRange = _ref79.disableRange;
        var returnValues = {
          allowRangeRequests: false,
          suggestedLength: undefined
        };
        var length = parseInt(getResponseHeader("Content-Length"), 10);
        if (!Number.isInteger(length)) {
          return returnValues;
        }
        returnValues.suggestedLength = length;
        if (length <= 2 * rangeChunkSize) {
          return returnValues;
        }
        if (disableRange || !isHttp) {
          return returnValues;
        }
        if (getResponseHeader("Accept-Ranges") !== "bytes") {
          return returnValues;
        }
        var contentEncoding = getResponseHeader("Content-Encoding") || "identity";
        if (contentEncoding !== "identity") {
          return returnValues;
        }
        returnValues.allowRangeRequests = true;
        return returnValues;
      }
      function extractFilenameFromHeader(getResponseHeader) {
        var contentDisposition = getResponseHeader("Content-Disposition");
        if (contentDisposition) {
          var filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
          if (filename.includes("%")) {
            try {
              filename = decodeURIComponent(filename);
            } catch (ex) {}
          }
          if ((0, _display_utils.isPdfFile)(filename)) {
            return filename;
          }
        }
        return null;
      }
      function createResponseStatusError(status, url) {
        if (status === 404 || status === 0 && url.startsWith("file:")) {
          return new _util.MissingPDFException('Missing PDF "' + url + '".');
        }
        return new _util.UnexpectedResponseException("Unexpected server response (".concat(status, ") while retrieving PDF \"").concat(url, "\"."), status);
      }
      function validateResponseStatus(status) {
        return status === 200 || status === 206;
      }

      /***/
    }), (/* 23 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;
      var _util = __w_pdfjs_require__(1);
      function getFilenameFromContentDispositionHeader(contentDisposition) {
        var needsEncodingFixup = true;
        var tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
        if (tmp) {
          tmp = tmp[1];
          var filename = rfc2616unquote(tmp);
          filename = unescape(filename);
          filename = rfc5987decode(filename);
          filename = rfc2047decode(filename);
          return fixupEncoding(filename);
        }
        tmp = rfc2231getparam(contentDisposition);
        if (tmp) {
          var _filename = rfc2047decode(tmp);
          return fixupEncoding(_filename);
        }
        tmp = toParamRegExp("filename", "i").exec(contentDisposition);
        if (tmp) {
          tmp = tmp[1];
          var _filename2 = rfc2616unquote(tmp);
          _filename2 = rfc2047decode(_filename2);
          return fixupEncoding(_filename2);
        }
        function toParamRegExp(attributePattern, flags) {
          return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
        }
        function textdecode(encoding, value) {
          if (encoding) {
            if (!/^[\x00-\xFF]+$/.test(value)) {
              return value;
            }
            try {
              var decoder = new TextDecoder(encoding, {
                fatal: true
              });
              var buffer = (0, _util.stringToBytes)(value);
              value = decoder.decode(buffer);
              needsEncodingFixup = false;
            } catch (e) {}
          }
          return value;
        }
        function fixupEncoding(value) {
          if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
            value = textdecode("utf-8", value);
            if (needsEncodingFixup) {
              value = textdecode("iso-8859-1", value);
            }
          }
          return value;
        }
        function rfc2231getparam(contentDispositionStr) {
          var matches = [];
          var match;
          var iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
          while ((match = iter.exec(contentDispositionStr)) !== null) {
            var _match = match,
              _match2 = _slicedToArray(_match, 4),
              n = _match2[1],
              quot = _match2[2],
              part = _match2[3];
            n = parseInt(n, 10);
            if (n in matches) {
              if (n === 0) {
                break;
              }
              continue;
            }
            matches[n] = [quot, part];
          }
          var parts = [];
          for (var _n = 0; _n < matches.length; ++_n) {
            if (!(_n in matches)) {
              break;
            }
            var _matches$_n = _slicedToArray(matches[_n], 2),
              _quot = _matches$_n[0],
              _part = _matches$_n[1];
            _part = rfc2616unquote(_part);
            if (_quot) {
              _part = unescape(_part);
              if (_n === 0) {
                _part = rfc5987decode(_part);
              }
            }
            parts.push(_part);
          }
          return parts.join("");
        }
        function rfc2616unquote(value) {
          if (value.startsWith('"')) {
            var parts = value.slice(1).split('\\"');
            for (var i = 0; i < parts.length; ++i) {
              var quotindex = parts[i].indexOf('"');
              if (quotindex !== -1) {
                parts[i] = parts[i].slice(0, quotindex);
                parts.length = i + 1;
              }
              parts[i] = parts[i].replace(/\\(.)/g, "$1");
            }
            value = parts.join('"');
          }
          return value;
        }
        function rfc5987decode(extvalue) {
          var encodingend = extvalue.indexOf("'");
          if (encodingend === -1) {
            return extvalue;
          }
          var encoding = extvalue.slice(0, encodingend);
          var langvalue = extvalue.slice(encodingend + 1);
          var value = langvalue.replace(/^[^']*'/, "");
          return textdecode(encoding, value);
        }
        function rfc2047decode(value) {
          if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) {
            return value;
          }
          return value.replace(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function (matches, charset, encoding, text) {
            if (encoding === "q" || encoding === "Q") {
              text = text.replace(/_/g, " ");
              text = text.replace(/=([0-9a-fA-F]{2})/g, function (match, hex) {
                return String.fromCharCode(parseInt(hex, 16));
              });
              return textdecode(charset, text);
            }
            try {
              text = atob(text);
            } catch (e) {}
            return textdecode(charset, text);
          });
        }
        return "";
      }

      /***/
    }), (/* 24 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PDFNetworkStream = void 0;
      var _util = __w_pdfjs_require__(1);
      var _network_utils = __w_pdfjs_require__(22);
      ;
      var OK_RESPONSE = 200;
      var PARTIAL_CONTENT_RESPONSE = 206;
      function getArrayBuffer(xhr) {
        var data = xhr.response;
        if (typeof data !== "string") {
          return data;
        }
        return (0, _util.stringToBytes)(data).buffer;
      }
      var NetworkManager = /*#__PURE__*/function () {
        function NetworkManager(url) {
          var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          _classCallCheck(this, NetworkManager);
          this.url = url;
          this.isHttp = /^https?:/i.test(url);
          this.httpHeaders = this.isHttp && args.httpHeaders || Object.create(null);
          this.withCredentials = args.withCredentials || false;
          this.getXhr = args.getXhr || function NetworkManager_getXhr() {
            return new XMLHttpRequest();
          };
          this.currXhrId = 0;
          this.pendingRequests = Object.create(null);
        }
        return _createClass(NetworkManager, [{
          key: "requestRange",
          value: function requestRange(begin, end, listeners) {
            var args = {
              begin: begin,
              end: end
            };
            for (var prop in listeners) {
              args[prop] = listeners[prop];
            }
            return this.request(args);
          }
        }, {
          key: "requestFull",
          value: function requestFull(listeners) {
            return this.request(listeners);
          }
        }, {
          key: "request",
          value: function request(args) {
            var xhr = this.getXhr();
            var xhrId = this.currXhrId++;
            var pendingRequest = this.pendingRequests[xhrId] = {
              xhr: xhr
            };
            xhr.open("GET", this.url);
            xhr.withCredentials = this.withCredentials;
            for (var property in this.httpHeaders) {
              var value = this.httpHeaders[property];
              if (value === undefined) {
                continue;
              }
              xhr.setRequestHeader(property, value);
            }
            if (this.isHttp && "begin" in args && "end" in args) {
              xhr.setRequestHeader("Range", "bytes=".concat(args.begin, "-").concat(args.end - 1));
              pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
            } else {
              pendingRequest.expectedStatus = OK_RESPONSE;
            }
            xhr.responseType = "arraybuffer";
            if (args.onError) {
              xhr.onerror = function (evt) {
                args.onError(xhr.status);
              };
            }
            xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
            xhr.onprogress = this.onProgress.bind(this, xhrId);
            pendingRequest.onHeadersReceived = args.onHeadersReceived;
            pendingRequest.onDone = args.onDone;
            pendingRequest.onError = args.onError;
            pendingRequest.onProgress = args.onProgress;
            xhr.send(null);
            return xhrId;
          }
        }, {
          key: "onProgress",
          value: function onProgress(xhrId, evt) {
            var _pendingRequest$onPro;
            var pendingRequest = this.pendingRequests[xhrId];
            if (!pendingRequest) {
              return;
            }
            (_pendingRequest$onPro = pendingRequest.onProgress) === null || _pendingRequest$onPro === void 0 || _pendingRequest$onPro.call(pendingRequest, evt);
          }
        }, {
          key: "onStateChange",
          value: function onStateChange(xhrId, evt) {
            var pendingRequest = this.pendingRequests[xhrId];
            if (!pendingRequest) {
              return;
            }
            var xhr = pendingRequest.xhr;
            if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
              pendingRequest.onHeadersReceived();
              delete pendingRequest.onHeadersReceived;
            }
            if (xhr.readyState !== 4) {
              return;
            }
            if (!(xhrId in this.pendingRequests)) {
              return;
            }
            delete this.pendingRequests[xhrId];
            if (xhr.status === 0 && this.isHttp) {
              var _pendingRequest$onErr;
              (_pendingRequest$onErr = pendingRequest.onError) === null || _pendingRequest$onErr === void 0 || _pendingRequest$onErr.call(pendingRequest, xhr.status);
              return;
            }
            var xhrStatus = xhr.status || OK_RESPONSE;
            var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
            if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
              var _pendingRequest$onErr2;
              (_pendingRequest$onErr2 = pendingRequest.onError) === null || _pendingRequest$onErr2 === void 0 || _pendingRequest$onErr2.call(pendingRequest, xhr.status);
              return;
            }
            var chunk = getArrayBuffer(xhr);
            if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
              var rangeHeader = xhr.getResponseHeader("Content-Range");
              var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
              pendingRequest.onDone({
                begin: parseInt(matches[1], 10),
                chunk: chunk
              });
            } else if (chunk) {
              pendingRequest.onDone({
                begin: 0,
                chunk: chunk
              });
            } else {
              var _pendingRequest$onErr3;
              (_pendingRequest$onErr3 = pendingRequest.onError) === null || _pendingRequest$onErr3 === void 0 || _pendingRequest$onErr3.call(pendingRequest, xhr.status);
            }
          }
        }, {
          key: "getRequestXhr",
          value: function getRequestXhr(xhrId) {
            return this.pendingRequests[xhrId].xhr;
          }
        }, {
          key: "isPendingRequest",
          value: function isPendingRequest(xhrId) {
            return xhrId in this.pendingRequests;
          }
        }, {
          key: "abortRequest",
          value: function abortRequest(xhrId) {
            var xhr = this.pendingRequests[xhrId].xhr;
            delete this.pendingRequests[xhrId];
            xhr.abort();
          }
        }]);
      }();
      var PDFNetworkStream = /*#__PURE__*/function () {
        function PDFNetworkStream(source) {
          _classCallCheck(this, PDFNetworkStream);
          this._source = source;
          this._manager = new NetworkManager(source.url, {
            httpHeaders: source.httpHeaders,
            withCredentials: source.withCredentials
          });
          this._rangeChunkSize = source.rangeChunkSize;
          this._fullRequestReader = null;
          this._rangeRequestReaders = [];
        }
        return _createClass(PDFNetworkStream, [{
          key: "_onRangeRequestReaderClosed",
          value: function _onRangeRequestReaderClosed(reader) {
            var i = this._rangeRequestReaders.indexOf(reader);
            if (i >= 0) {
              this._rangeRequestReaders.splice(i, 1);
            }
          }
        }, {
          key: "getFullReader",
          value: function getFullReader() {
            (0, _util.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
            this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
            return this._fullRequestReader;
          }
        }, {
          key: "getRangeReader",
          value: function getRangeReader(begin, end) {
            var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
            reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
            this._rangeRequestReaders.push(reader);
            return reader;
          }
        }, {
          key: "cancelAllRequests",
          value: function cancelAllRequests(reason) {
            var _this$_fullRequestRea0;
            (_this$_fullRequestRea0 = this._fullRequestReader) === null || _this$_fullRequestRea0 === void 0 || _this$_fullRequestRea0.cancel(reason);
            var _iterator71 = _createForOfIteratorHelper(this._rangeRequestReaders.slice(0)),
              _step71;
            try {
              for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
                var reader = _step71.value;
                reader.cancel(reason);
              }
            } catch (err) {
              _iterator71.e(err);
            } finally {
              _iterator71.f();
            }
          }
        }]);
      }();
      exports.PDFNetworkStream = PDFNetworkStream;
      var PDFNetworkStreamFullRequestReader = /*#__PURE__*/function () {
        function PDFNetworkStreamFullRequestReader(manager, source) {
          _classCallCheck(this, PDFNetworkStreamFullRequestReader);
          this._manager = manager;
          var args = {
            onHeadersReceived: this._onHeadersReceived.bind(this),
            onDone: this._onDone.bind(this),
            onError: this._onError.bind(this),
            onProgress: this._onProgress.bind(this)
          };
          this._url = source.url;
          this._fullRequestId = manager.requestFull(args);
          this._headersReceivedCapability = (0, _util.createPromiseCapability)();
          this._disableRange = source.disableRange || false;
          this._contentLength = source.length;
          this._rangeChunkSize = source.rangeChunkSize;
          if (!this._rangeChunkSize && !this._disableRange) {
            this._disableRange = true;
          }
          this._isStreamingSupported = false;
          this._isRangeSupported = false;
          this._cachedChunks = [];
          this._requests = [];
          this._done = false;
          this._storedError = undefined;
          this._filename = null;
          this.onProgress = null;
        }
        return _createClass(PDFNetworkStreamFullRequestReader, [{
          key: "_onHeadersReceived",
          value: function _onHeadersReceived() {
            var fullRequestXhrId = this._fullRequestId;
            var fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
            var getResponseHeader = function getResponseHeader(name) {
              return fullRequestXhr.getResponseHeader(name);
            };
            var _ref80 = (0, _network_utils.validateRangeRequestCapabilities)({
                getResponseHeader: getResponseHeader,
                isHttp: this._manager.isHttp,
                rangeChunkSize: this._rangeChunkSize,
                disableRange: this._disableRange
              }),
              allowRangeRequests = _ref80.allowRangeRequests,
              suggestedLength = _ref80.suggestedLength;
            if (allowRangeRequests) {
              this._isRangeSupported = true;
            }
            this._contentLength = suggestedLength || this._contentLength;
            this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
            if (this._isRangeSupported) {
              this._manager.abortRequest(fullRequestXhrId);
            }
            this._headersReceivedCapability.resolve();
          }
        }, {
          key: "_onDone",
          value: function _onDone(data) {
            if (data) {
              if (this._requests.length > 0) {
                var requestCapability = this._requests.shift();
                requestCapability.resolve({
                  value: data.chunk,
                  done: false
                });
              } else {
                this._cachedChunks.push(data.chunk);
              }
            }
            this._done = true;
            if (this._cachedChunks.length > 0) {
              return;
            }
            var _iterator72 = _createForOfIteratorHelper(this._requests),
              _step72;
            try {
              for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
                var _requestCapability = _step72.value;
                _requestCapability.resolve({
                  value: undefined,
                  done: true
                });
              }
            } catch (err) {
              _iterator72.e(err);
            } finally {
              _iterator72.f();
            }
            this._requests.length = 0;
          }
        }, {
          key: "_onError",
          value: function _onError(status) {
            this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
            this._headersReceivedCapability.reject(this._storedError);
            var _iterator73 = _createForOfIteratorHelper(this._requests),
              _step73;
            try {
              for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
                var requestCapability = _step73.value;
                requestCapability.reject(this._storedError);
              }
            } catch (err) {
              _iterator73.e(err);
            } finally {
              _iterator73.f();
            }
            this._requests.length = 0;
            this._cachedChunks.length = 0;
          }
        }, {
          key: "_onProgress",
          value: function _onProgress(evt) {
            var _this$onProgress3;
            (_this$onProgress3 = this.onProgress) === null || _this$onProgress3 === void 0 || _this$onProgress3.call(this, {
              loaded: evt.loaded,
              total: evt.lengthComputable ? evt.total : this._contentLength
            });
          }
        }, {
          key: "filename",
          get: function get() {
            return this._filename;
          }
        }, {
          key: "isRangeSupported",
          get: function get() {
            return this._isRangeSupported;
          }
        }, {
          key: "isStreamingSupported",
          get: function get() {
            return this._isStreamingSupported;
          }
        }, {
          key: "contentLength",
          get: function get() {
            return this._contentLength;
          }
        }, {
          key: "headersReady",
          get: function get() {
            return this._headersReceivedCapability.promise;
          }
        }, {
          key: "read",
          value: function () {
            var _read5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
              var chunk, requestCapability;
              return _regenerator().w(function (_context14) {
                while (1) switch (_context14.n) {
                  case 0:
                    if (!this._storedError) {
                      _context14.n = 1;
                      break;
                    }
                    throw this._storedError;
                  case 1:
                    if (!(this._cachedChunks.length > 0)) {
                      _context14.n = 2;
                      break;
                    }
                    chunk = this._cachedChunks.shift();
                    return _context14.a(2, {
                      value: chunk,
                      done: false
                    });
                  case 2:
                    if (!this._done) {
                      _context14.n = 3;
                      break;
                    }
                    return _context14.a(2, {
                      value: undefined,
                      done: true
                    });
                  case 3:
                    requestCapability = (0, _util.createPromiseCapability)();
                    this._requests.push(requestCapability);
                    return _context14.a(2, requestCapability.promise);
                }
              }, _callee14, this);
            }));
            function read() {
              return _read5.apply(this, arguments);
            }
            return read;
          }()
        }, {
          key: "cancel",
          value: function cancel(reason) {
            this._done = true;
            this._headersReceivedCapability.reject(reason);
            var _iterator74 = _createForOfIteratorHelper(this._requests),
              _step74;
            try {
              for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
                var requestCapability = _step74.value;
                requestCapability.resolve({
                  value: undefined,
                  done: true
                });
              }
            } catch (err) {
              _iterator74.e(err);
            } finally {
              _iterator74.f();
            }
            this._requests.length = 0;
            if (this._manager.isPendingRequest(this._fullRequestId)) {
              this._manager.abortRequest(this._fullRequestId);
            }
            this._fullRequestReader = null;
          }
        }]);
      }();
      var PDFNetworkStreamRangeRequestReader = /*#__PURE__*/function () {
        function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
          _classCallCheck(this, PDFNetworkStreamRangeRequestReader);
          this._manager = manager;
          var args = {
            onDone: this._onDone.bind(this),
            onError: this._onError.bind(this),
            onProgress: this._onProgress.bind(this)
          };
          this._url = manager.url;
          this._requestId = manager.requestRange(begin, end, args);
          this._requests = [];
          this._queuedChunk = null;
          this._done = false;
          this._storedError = undefined;
          this.onProgress = null;
          this.onClosed = null;
        }
        return _createClass(PDFNetworkStreamRangeRequestReader, [{
          key: "_close",
          value: function _close() {
            var _this$onClosed;
            (_this$onClosed = this.onClosed) === null || _this$onClosed === void 0 || _this$onClosed.call(this, this);
          }
        }, {
          key: "_onDone",
          value: function _onDone(data) {
            var chunk = data.chunk;
            if (this._requests.length > 0) {
              var requestCapability = this._requests.shift();
              requestCapability.resolve({
                value: chunk,
                done: false
              });
            } else {
              this._queuedChunk = chunk;
            }
            this._done = true;
            var _iterator75 = _createForOfIteratorHelper(this._requests),
              _step75;
            try {
              for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
                var _requestCapability2 = _step75.value;
                _requestCapability2.resolve({
                  value: undefined,
                  done: true
                });
              }
            } catch (err) {
              _iterator75.e(err);
            } finally {
              _iterator75.f();
            }
            this._requests.length = 0;
            this._close();
          }
        }, {
          key: "_onError",
          value: function _onError(status) {
            this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
            var _iterator76 = _createForOfIteratorHelper(this._requests),
              _step76;
            try {
              for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
                var requestCapability = _step76.value;
                requestCapability.reject(this._storedError);
              }
            } catch (err) {
              _iterator76.e(err);
            } finally {
              _iterator76.f();
            }
            this._requests.length = 0;
            this._queuedChunk = null;
          }
        }, {
          key: "_onProgress",
          value: function _onProgress(evt) {
            if (!this.isStreamingSupported) {
              var _this$onProgress4;
              (_this$onProgress4 = this.onProgress) === null || _this$onProgress4 === void 0 || _this$onProgress4.call(this, {
                loaded: evt.loaded
              });
            }
          }
        }, {
          key: "isStreamingSupported",
          get: function get() {
            return false;
          }
        }, {
          key: "read",
          value: function () {
            var _read6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
              var chunk, requestCapability;
              return _regenerator().w(function (_context15) {
                while (1) switch (_context15.n) {
                  case 0:
                    if (!this._storedError) {
                      _context15.n = 1;
                      break;
                    }
                    throw this._storedError;
                  case 1:
                    if (!(this._queuedChunk !== null)) {
                      _context15.n = 2;
                      break;
                    }
                    chunk = this._queuedChunk;
                    this._queuedChunk = null;
                    return _context15.a(2, {
                      value: chunk,
                      done: false
                    });
                  case 2:
                    if (!this._done) {
                      _context15.n = 3;
                      break;
                    }
                    return _context15.a(2, {
                      value: undefined,
                      done: true
                    });
                  case 3:
                    requestCapability = (0, _util.createPromiseCapability)();
                    this._requests.push(requestCapability);
                    return _context15.a(2, requestCapability.promise);
                }
              }, _callee15, this);
            }));
            function read() {
              return _read6.apply(this, arguments);
            }
            return read;
          }()
        }, {
          key: "cancel",
          value: function cancel(reason) {
            this._done = true;
            var _iterator77 = _createForOfIteratorHelper(this._requests),
              _step77;
            try {
              for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
                var requestCapability = _step77.value;
                requestCapability.resolve({
                  value: undefined,
                  done: true
                });
              }
            } catch (err) {
              _iterator77.e(err);
            } finally {
              _iterator77.f();
            }
            this._requests.length = 0;
            if (this._manager.isPendingRequest(this._requestId)) {
              this._manager.abortRequest(this._requestId);
            }
            this._close();
          }
        }]);
      }();
      /***/
    }), (/* 25 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PDFFetchStream = void 0;
      var _util = __w_pdfjs_require__(1);
      var _network_utils = __w_pdfjs_require__(22);
      ;
      function createFetchOptions(headers, withCredentials, abortController) {
        return {
          method: "GET",
          headers: headers,
          signal: abortController.signal,
          mode: "cors",
          credentials: withCredentials ? "include" : "same-origin",
          redirect: "follow"
        };
      }
      function createHeaders(httpHeaders) {
        var headers = new Headers();
        for (var property in httpHeaders) {
          var value = httpHeaders[property];
          if (value === undefined) {
            continue;
          }
          headers.append(property, value);
        }
        return headers;
      }
      function getArrayBuffer(val) {
        if (val instanceof Uint8Array) {
          return val.buffer;
        }
        if (val instanceof ArrayBuffer) {
          return val;
        }
        (0, _util.warn)("getArrayBuffer - unexpected data format: ".concat(val));
        return new Uint8Array(val).buffer;
      }
      var PDFFetchStream = /*#__PURE__*/function () {
        function PDFFetchStream(source) {
          _classCallCheck(this, PDFFetchStream);
          this.source = source;
          this.isHttp = /^https?:/i.test(source.url);
          this.httpHeaders = this.isHttp && source.httpHeaders || {};
          this._fullRequestReader = null;
          this._rangeRequestReaders = [];
        }
        return _createClass(PDFFetchStream, [{
          key: "_progressiveDataLength",
          get: function get() {
            var _this$_fullRequestRea1, _this$_fullRequestRea10;
            return (_this$_fullRequestRea1 = (_this$_fullRequestRea10 = this._fullRequestReader) === null || _this$_fullRequestRea10 === void 0 ? void 0 : _this$_fullRequestRea10._loaded) !== null && _this$_fullRequestRea1 !== void 0 ? _this$_fullRequestRea1 : 0;
          }
        }, {
          key: "getFullReader",
          value: function getFullReader() {
            (0, _util.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
            this._fullRequestReader = new PDFFetchStreamReader(this);
            return this._fullRequestReader;
          }
        }, {
          key: "getRangeReader",
          value: function getRangeReader(begin, end) {
            if (end <= this._progressiveDataLength) {
              return null;
            }
            var reader = new PDFFetchStreamRangeReader(this, begin, end);
            this._rangeRequestReaders.push(reader);
            return reader;
          }
        }, {
          key: "cancelAllRequests",
          value: function cancelAllRequests(reason) {
            var _this$_fullRequestRea11;
            (_this$_fullRequestRea11 = this._fullRequestReader) === null || _this$_fullRequestRea11 === void 0 || _this$_fullRequestRea11.cancel(reason);
            var _iterator78 = _createForOfIteratorHelper(this._rangeRequestReaders.slice(0)),
              _step78;
            try {
              for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
                var reader = _step78.value;
                reader.cancel(reason);
              }
            } catch (err) {
              _iterator78.e(err);
            } finally {
              _iterator78.f();
            }
          }
        }]);
      }();
      exports.PDFFetchStream = PDFFetchStream;
      var PDFFetchStreamReader = /*#__PURE__*/function () {
        function PDFFetchStreamReader(stream) {
          var _this38 = this;
          _classCallCheck(this, PDFFetchStreamReader);
          this._stream = stream;
          this._reader = null;
          this._loaded = 0;
          this._filename = null;
          var source = stream.source;
          this._withCredentials = source.withCredentials || false;
          this._contentLength = source.length;
          this._headersCapability = (0, _util.createPromiseCapability)();
          this._disableRange = source.disableRange || false;
          this._rangeChunkSize = source.rangeChunkSize;
          if (!this._rangeChunkSize && !this._disableRange) {
            this._disableRange = true;
          }
          this._abortController = new AbortController();
          this._isStreamingSupported = !source.disableStream;
          this._isRangeSupported = !source.disableRange;
          this._headers = createHeaders(this._stream.httpHeaders);
          var url = source.url;
          fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function (response) {
            if (!(0, _network_utils.validateResponseStatus)(response.status)) {
              throw (0, _network_utils.createResponseStatusError)(response.status, url);
            }
            _this38._reader = response.body.getReader();
            _this38._headersCapability.resolve();
            var getResponseHeader = function getResponseHeader(name) {
              return response.headers.get(name);
            };
            var _ref81 = (0, _network_utils.validateRangeRequestCapabilities)({
                getResponseHeader: getResponseHeader,
                isHttp: _this38._stream.isHttp,
                rangeChunkSize: _this38._rangeChunkSize,
                disableRange: _this38._disableRange
              }),
              allowRangeRequests = _ref81.allowRangeRequests,
              suggestedLength = _ref81.suggestedLength;
            _this38._isRangeSupported = allowRangeRequests;
            _this38._contentLength = suggestedLength || _this38._contentLength;
            _this38._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
            if (!_this38._isStreamingSupported && _this38._isRangeSupported) {
              _this38.cancel(new _util.AbortException("Streaming is disabled."));
            }
          }).catch(this._headersCapability.reject);
          this.onProgress = null;
        }
        return _createClass(PDFFetchStreamReader, [{
          key: "headersReady",
          get: function get() {
            return this._headersCapability.promise;
          }
        }, {
          key: "filename",
          get: function get() {
            return this._filename;
          }
        }, {
          key: "contentLength",
          get: function get() {
            return this._contentLength;
          }
        }, {
          key: "isRangeSupported",
          get: function get() {
            return this._isRangeSupported;
          }
        }, {
          key: "isStreamingSupported",
          get: function get() {
            return this._isStreamingSupported;
          }
        }, {
          key: "read",
          value: function () {
            var _read7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16() {
              var _this$onProgress5;
              var _yield$this$_reader$r, value, done;
              return _regenerator().w(function (_context16) {
                while (1) switch (_context16.n) {
                  case 0:
                    _context16.n = 1;
                    return this._headersCapability.promise;
                  case 1:
                    _context16.n = 2;
                    return this._reader.read();
                  case 2:
                    _yield$this$_reader$r = _context16.v;
                    value = _yield$this$_reader$r.value;
                    done = _yield$this$_reader$r.done;
                    if (!done) {
                      _context16.n = 3;
                      break;
                    }
                    return _context16.a(2, {
                      value: value,
                      done: done
                    });
                  case 3:
                    this._loaded += value.byteLength;
                    (_this$onProgress5 = this.onProgress) === null || _this$onProgress5 === void 0 || _this$onProgress5.call(this, {
                      loaded: this._loaded,
                      total: this._contentLength
                    });
                    return _context16.a(2, {
                      value: getArrayBuffer(value),
                      done: false
                    });
                }
              }, _callee16, this);
            }));
            function read() {
              return _read7.apply(this, arguments);
            }
            return read;
          }()
        }, {
          key: "cancel",
          value: function cancel(reason) {
            var _this$_reader;
            (_this$_reader = this._reader) === null || _this$_reader === void 0 || _this$_reader.cancel(reason);
            this._abortController.abort();
          }
        }]);
      }();
      var PDFFetchStreamRangeReader = /*#__PURE__*/function () {
        function PDFFetchStreamRangeReader(stream, begin, end) {
          var _this39 = this;
          _classCallCheck(this, PDFFetchStreamRangeReader);
          this._stream = stream;
          this._reader = null;
          this._loaded = 0;
          var source = stream.source;
          this._withCredentials = source.withCredentials || false;
          this._readCapability = (0, _util.createPromiseCapability)();
          this._isStreamingSupported = !source.disableStream;
          this._abortController = new AbortController();
          this._headers = createHeaders(this._stream.httpHeaders);
          this._headers.append("Range", "bytes=".concat(begin, "-").concat(end - 1));
          var url = source.url;
          fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function (response) {
            if (!(0, _network_utils.validateResponseStatus)(response.status)) {
              throw (0, _network_utils.createResponseStatusError)(response.status, url);
            }
            _this39._readCapability.resolve();
            _this39._reader = response.body.getReader();
          }).catch(this._readCapability.reject);
          this.onProgress = null;
        }
        return _createClass(PDFFetchStreamRangeReader, [{
          key: "isStreamingSupported",
          get: function get() {
            return this._isStreamingSupported;
          }
        }, {
          key: "read",
          value: function () {
            var _read8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
              var _this$onProgress6;
              var _yield$this$_reader$r2, value, done;
              return _regenerator().w(function (_context17) {
                while (1) switch (_context17.n) {
                  case 0:
                    _context17.n = 1;
                    return this._readCapability.promise;
                  case 1:
                    _context17.n = 2;
                    return this._reader.read();
                  case 2:
                    _yield$this$_reader$r2 = _context17.v;
                    value = _yield$this$_reader$r2.value;
                    done = _yield$this$_reader$r2.done;
                    if (!done) {
                      _context17.n = 3;
                      break;
                    }
                    return _context17.a(2, {
                      value: value,
                      done: done
                    });
                  case 3:
                    this._loaded += value.byteLength;
                    (_this$onProgress6 = this.onProgress) === null || _this$onProgress6 === void 0 || _this$onProgress6.call(this, {
                      loaded: this._loaded
                    });
                    return _context17.a(2, {
                      value: getArrayBuffer(value),
                      done: false
                    });
                }
              }, _callee17, this);
            }));
            function read() {
              return _read8.apply(this, arguments);
            }
            return read;
          }()
        }, {
          key: "cancel",
          value: function cancel(reason) {
            var _this$_reader2;
            (_this$_reader2 = this._reader) === null || _this$_reader2 === void 0 || _this$_reader2.cancel(reason);
            this._abortController.abort();
          }
        }]);
      }();
      /***/
    }), (/* 26 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.TextLayerRenderTask = void 0;
      exports.renderTextLayer = renderTextLayer;
      exports.updateTextLayer = updateTextLayer;
      var _util = __w_pdfjs_require__(1);
      var _display_utils = __w_pdfjs_require__(6);
      var MAX_TEXT_DIVS_TO_RENDER = 100000;
      var DEFAULT_FONT_SIZE = 30;
      var DEFAULT_FONT_ASCENT = 0.8;
      var ascentCache = new Map();
      function getCtx(size, isOffscreenCanvasSupported) {
        var ctx;
        if (isOffscreenCanvasSupported && _util.FeatureTest.isOffscreenCanvasSupported) {
          ctx = new OffscreenCanvas(size, size).getContext("2d", {
            alpha: false
          });
        } else {
          var canvas = document.createElement("canvas");
          canvas.width = canvas.height = size;
          ctx = canvas.getContext("2d", {
            alpha: false
          });
        }
        return ctx;
      }
      function getAscent(fontFamily, isOffscreenCanvasSupported) {
        var cachedAscent = ascentCache.get(fontFamily);
        if (cachedAscent) {
          return cachedAscent;
        }
        var ctx = getCtx(DEFAULT_FONT_SIZE, isOffscreenCanvasSupported);
        ctx.font = "".concat(DEFAULT_FONT_SIZE, "px ").concat(fontFamily);
        var metrics = ctx.measureText("");
        var ascent = metrics.fontBoundingBoxAscent;
        var descent = Math.abs(metrics.fontBoundingBoxDescent);
        if (ascent) {
          var ratio = ascent / (ascent + descent);
          ascentCache.set(fontFamily, ratio);
          ctx.canvas.width = ctx.canvas.height = 0;
          return ratio;
        }
        ctx.strokeStyle = "red";
        ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
        ctx.strokeText("g", 0, 0);
        var pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
        descent = 0;
        for (var i = pixels.length - 1 - 3; i >= 0; i -= 4) {
          if (pixels[i] > 0) {
            descent = Math.ceil(i / 4 / DEFAULT_FONT_SIZE);
            break;
          }
        }
        ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
        ctx.strokeText("A", 0, DEFAULT_FONT_SIZE);
        pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
        ascent = 0;
        for (var _i8 = 0, ii = pixels.length; _i8 < ii; _i8 += 4) {
          if (pixels[_i8] > 0) {
            ascent = DEFAULT_FONT_SIZE - Math.floor(_i8 / 4 / DEFAULT_FONT_SIZE);
            break;
          }
        }
        ctx.canvas.width = ctx.canvas.height = 0;
        if (ascent) {
          var _ratio = ascent / (ascent + descent);
          ascentCache.set(fontFamily, _ratio);
          return _ratio;
        }
        ascentCache.set(fontFamily, DEFAULT_FONT_ASCENT);
        return DEFAULT_FONT_ASCENT;
      }
      function appendText(task, geom, styles) {
        var textDiv = document.createElement("span");
        var textDivProperties = {
          angle: 0,
          canvasWidth: 0,
          hasText: geom.str !== "",
          hasEOL: geom.hasEOL,
          fontSize: 0
        };
        task._textDivs.push(textDiv);
        var tx = _util.Util.transform(task._transform, geom.transform);
        var angle = Math.atan2(tx[1], tx[0]);
        var style = styles[geom.fontName];
        if (style.vertical) {
          angle += Math.PI / 2;
        }
        var fontHeight = Math.hypot(tx[2], tx[3]);
        var fontAscent = fontHeight * getAscent(style.fontFamily, task._isOffscreenCanvasSupported);
        var left, top;
        if (angle === 0) {
          left = tx[4];
          top = tx[5] - fontAscent;
        } else {
          left = tx[4] + fontAscent * Math.sin(angle);
          top = tx[5] - fontAscent * Math.cos(angle);
        }
        var scaleFactorStr = "calc(var(--scale-factor)*";
        var divStyle = textDiv.style;
        if (task._container === task._rootContainer) {
          divStyle.left = "".concat((100 * left / task._pageWidth).toFixed(2), "%");
          divStyle.top = "".concat((100 * top / task._pageHeight).toFixed(2), "%");
        } else {
          divStyle.left = "".concat(scaleFactorStr).concat(left.toFixed(2), "px)");
          divStyle.top = "".concat(scaleFactorStr).concat(top.toFixed(2), "px)");
        }
        divStyle.fontSize = "".concat(scaleFactorStr).concat(fontHeight.toFixed(2), "px)");
        divStyle.fontFamily = style.fontFamily;
        textDivProperties.fontSize = fontHeight;
        textDiv.setAttribute("role", "presentation");
        textDiv.textContent = geom.str;
        textDiv.dir = geom.dir;
        if (task._fontInspectorEnabled) {
          textDiv.dataset.fontName = geom.fontName;
        }
        if (angle !== 0) {
          textDivProperties.angle = angle * (180 / Math.PI);
        }
        var shouldScaleText = false;
        if (geom.str.length > 1) {
          shouldScaleText = true;
        } else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
          var absScaleX = Math.abs(geom.transform[0]),
            absScaleY = Math.abs(geom.transform[3]);
          if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) {
            shouldScaleText = true;
          }
        }
        if (shouldScaleText) {
          textDivProperties.canvasWidth = style.vertical ? geom.height : geom.width;
        }
        task._textDivProperties.set(textDiv, textDivProperties);
        if (task._isReadableStream) {
          task._layoutText(textDiv);
        }
      }
      function layout(params) {
        var div = params.div,
          scale = params.scale,
          properties = params.properties,
          ctx = params.ctx,
          prevFontSize = params.prevFontSize,
          prevFontFamily = params.prevFontFamily;
        var style = div.style;
        var transform = "";
        if (properties.canvasWidth !== 0 && properties.hasText) {
          var fontFamily = style.fontFamily;
          var canvasWidth = properties.canvasWidth,
            fontSize = properties.fontSize;
          if (prevFontSize !== fontSize || prevFontFamily !== fontFamily) {
            ctx.font = "".concat(fontSize * scale, "px ").concat(fontFamily);
            params.prevFontSize = fontSize;
            params.prevFontFamily = fontFamily;
          }
          var _ctx$measureText = ctx.measureText(div.textContent),
            width = _ctx$measureText.width;
          if (width > 0) {
            transform = "scaleX(".concat(canvasWidth * scale / width, ")");
          }
        }
        if (properties.angle !== 0) {
          transform = "rotate(".concat(properties.angle, "deg) ").concat(transform);
        }
        if (transform.length > 0) {
          style.transform = transform;
        }
      }
      function render(task) {
        if (task._canceled) {
          return;
        }
        var textDivs = task._textDivs;
        var capability = task._capability;
        var textDivsLength = textDivs.length;
        if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
          capability.resolve();
          return;
        }
        if (!task._isReadableStream) {
          var _iterator79 = _createForOfIteratorHelper(textDivs),
            _step79;
          try {
            for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
              var textDiv = _step79.value;
              task._layoutText(textDiv);
            }
          } catch (err) {
            _iterator79.e(err);
          } finally {
            _iterator79.f();
          }
        }
        capability.resolve();
      }
      var TextLayerRenderTask = /*#__PURE__*/function () {
        function TextLayerRenderTask(_ref82) {
          var _globalThis$FontInspe2,
            _this40 = this;
          var textContentSource = _ref82.textContentSource,
            container = _ref82.container,
            viewport = _ref82.viewport,
            textDivs = _ref82.textDivs,
            textDivProperties = _ref82.textDivProperties,
            textContentItemsStr = _ref82.textContentItemsStr,
            isOffscreenCanvasSupported = _ref82.isOffscreenCanvasSupported;
          _classCallCheck(this, TextLayerRenderTask);
          this._textContentSource = textContentSource;
          this._isReadableStream = textContentSource instanceof ReadableStream;
          this._container = this._rootContainer = container;
          this._textDivs = textDivs || [];
          this._textContentItemsStr = textContentItemsStr || [];
          this._isOffscreenCanvasSupported = isOffscreenCanvasSupported;
          this._fontInspectorEnabled = !!((_globalThis$FontInspe2 = globalThis.FontInspector) !== null && _globalThis$FontInspe2 !== void 0 && _globalThis$FontInspe2.enabled);
          this._reader = null;
          this._textDivProperties = textDivProperties || new WeakMap();
          this._canceled = false;
          this._capability = (0, _util.createPromiseCapability)();
          this._layoutTextParams = {
            prevFontSize: null,
            prevFontFamily: null,
            div: null,
            scale: viewport.scale * (globalThis.devicePixelRatio || 1),
            properties: null,
            ctx: getCtx(0, isOffscreenCanvasSupported)
          };
          var _viewport$rawDims2 = viewport.rawDims,
            pageWidth = _viewport$rawDims2.pageWidth,
            pageHeight = _viewport$rawDims2.pageHeight,
            pageX = _viewport$rawDims2.pageX,
            pageY = _viewport$rawDims2.pageY;
          this._transform = [1, 0, 0, -1, -pageX, pageY + pageHeight];
          this._pageWidth = pageWidth;
          this._pageHeight = pageHeight;
          (0, _display_utils.setLayerDimensions)(container, viewport);
          this._capability.promise.finally(function () {
            _this40._layoutTextParams = null;
          }).catch(function () {});
        }
        return _createClass(TextLayerRenderTask, [{
          key: "promise",
          get: function get() {
            return this._capability.promise;
          }
        }, {
          key: "cancel",
          value: function cancel() {
            this._canceled = true;
            if (this._reader) {
              this._reader.cancel(new _util.AbortException("TextLayer task cancelled.")).catch(function () {});
              this._reader = null;
            }
            this._capability.reject(new _util.AbortException("TextLayer task cancelled."));
          }
        }, {
          key: "_processItems",
          value: function _processItems(items, styleCache) {
            var _iterator80 = _createForOfIteratorHelper(items),
              _step80;
            try {
              for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
                var item = _step80.value;
                if (item.str === undefined) {
                  if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
                    var parent = this._container;
                    this._container = document.createElement("span");
                    this._container.classList.add("markedContent");
                    if (item.id !== null) {
                      this._container.setAttribute("id", "".concat(item.id));
                    }
                    parent.append(this._container);
                  } else if (item.type === "endMarkedContent") {
                    this._container = this._container.parentNode;
                  }
                  continue;
                }
                this._textContentItemsStr.push(item.str);
                appendText(this, item, styleCache);
              }
            } catch (err) {
              _iterator80.e(err);
            } finally {
              _iterator80.f();
            }
          }
        }, {
          key: "_layoutText",
          value: function _layoutText(textDiv) {
            var textDivProperties = this._layoutTextParams.properties = this._textDivProperties.get(textDiv);
            this._layoutTextParams.div = textDiv;
            layout(this._layoutTextParams);
            if (textDivProperties.hasText) {
              this._container.append(textDiv);
            }
            if (textDivProperties.hasEOL) {
              var br = document.createElement("br");
              br.setAttribute("role", "presentation");
              this._container.append(br);
            }
          }
        }, {
          key: "_render",
          value: function _render() {
            var _this41 = this;
            var capability = (0, _util.createPromiseCapability)();
            var styleCache = Object.create(null);
            if (this._isReadableStream) {
              var _pump2 = function pump() {
                _this41._reader.read().then(function (_ref83) {
                  var value = _ref83.value,
                    done = _ref83.done;
                  if (done) {
                    capability.resolve();
                    return;
                  }
                  Object.assign(styleCache, value.styles);
                  _this41._processItems(value.items, styleCache);
                  _pump2();
                }, capability.reject);
              };
              this._reader = this._textContentSource.getReader();
              _pump2();
            } else if (this._textContentSource) {
              var _this$_textContentSou = this._textContentSource,
                items = _this$_textContentSou.items,
                styles = _this$_textContentSou.styles;
              this._processItems(items, styles);
              capability.resolve();
            } else {
              throw new Error('No "textContentSource" parameter specified.');
            }
            capability.promise.then(function () {
              styleCache = null;
              render(_this41);
            }, this._capability.reject);
          }
        }]);
      }();
      exports.TextLayerRenderTask = TextLayerRenderTask;
      function renderTextLayer(params) {
        if (!params.textContentSource && (params.textContent || params.textContentStream)) {
          (0, _display_utils.deprecated)("The TextLayerRender `textContent`/`textContentStream` parameters " + "will be removed in the future, please use `textContentSource` instead.");
          params.textContentSource = params.textContent || params.textContentStream;
        }
        var task = new TextLayerRenderTask(params);
        task._render();
        return task;
      }
      function updateTextLayer(_ref84) {
        var container = _ref84.container,
          viewport = _ref84.viewport,
          textDivs = _ref84.textDivs,
          textDivProperties = _ref84.textDivProperties,
          isOffscreenCanvasSupported = _ref84.isOffscreenCanvasSupported,
          _ref84$mustRotate = _ref84.mustRotate,
          mustRotate = _ref84$mustRotate === void 0 ? true : _ref84$mustRotate,
          _ref84$mustRescale = _ref84.mustRescale,
          mustRescale = _ref84$mustRescale === void 0 ? true : _ref84$mustRescale;
        if (mustRotate) {
          (0, _display_utils.setLayerDimensions)(container, {
            rotation: viewport.rotation
          });
        }
        if (mustRescale) {
          var ctx = getCtx(0, isOffscreenCanvasSupported);
          var scale = viewport.scale * (globalThis.devicePixelRatio || 1);
          var params = {
            prevFontSize: null,
            prevFontFamily: null,
            div: null,
            scale: scale,
            properties: null,
            ctx: ctx
          };
          var _iterator81 = _createForOfIteratorHelper(textDivs),
            _step81;
          try {
            for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
              var div = _step81.value;
              params.properties = textDivProperties.get(div);
              params.div = div;
              layout(params);
            }
          } catch (err) {
            _iterator81.e(err);
          } finally {
            _iterator81.f();
          }
        }
      }

      /***/
    }), (/* 27 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.AnnotationEditorLayer = void 0;
      var _util = __w_pdfjs_require__(1);
      var _tools = __w_pdfjs_require__(5);
      var _freetext = __w_pdfjs_require__(28);
      var _ink = __w_pdfjs_require__(29);
      var _display_utils = __w_pdfjs_require__(6);
      var _accessibilityManager = /*#__PURE__*/_classPrivateFieldLooseKey("accessibilityManager");
      var _allowClick = /*#__PURE__*/_classPrivateFieldLooseKey("allowClick");
      var _boundPointerup = /*#__PURE__*/_classPrivateFieldLooseKey("boundPointerup");
      var _boundPointerdown = /*#__PURE__*/_classPrivateFieldLooseKey("boundPointerdown");
      var _editors = /*#__PURE__*/_classPrivateFieldLooseKey("editors");
      var _hadPointerDown = /*#__PURE__*/_classPrivateFieldLooseKey("hadPointerDown");
      var _isCleaningUp = /*#__PURE__*/_classPrivateFieldLooseKey("isCleaningUp");
      var _uiManager = /*#__PURE__*/_classPrivateFieldLooseKey("uiManager");
      var _changeParent = /*#__PURE__*/_classPrivateFieldLooseKey("changeParent");
      var _createNewEditor = /*#__PURE__*/_classPrivateFieldLooseKey("createNewEditor");
      var _createAndAddNewEditor = /*#__PURE__*/_classPrivateFieldLooseKey("createAndAddNewEditor");
      var _cleanup = /*#__PURE__*/_classPrivateFieldLooseKey("cleanup");
      var AnnotationEditorLayer = /*#__PURE__*/function () {
        function AnnotationEditorLayer(options) {
          _classCallCheck(this, AnnotationEditorLayer);
          Object.defineProperty(this, _cleanup, {
            value: _cleanup2
          });
          Object.defineProperty(this, _createAndAddNewEditor, {
            value: _createAndAddNewEditor2
          });
          Object.defineProperty(this, _createNewEditor, {
            value: _createNewEditor2
          });
          Object.defineProperty(this, _changeParent, {
            value: _changeParent2
          });
          Object.defineProperty(this, _accessibilityManager, {
            writable: true,
            value: void 0
          });
          Object.defineProperty(this, _allowClick, {
            writable: true,
            value: false
          });
          Object.defineProperty(this, _boundPointerup, {
            writable: true,
            value: this.pointerup.bind(this)
          });
          Object.defineProperty(this, _boundPointerdown, {
            writable: true,
            value: this.pointerdown.bind(this)
          });
          Object.defineProperty(this, _editors, {
            writable: true,
            value: new Map()
          });
          Object.defineProperty(this, _hadPointerDown, {
            writable: true,
            value: false
          });
          Object.defineProperty(this, _isCleaningUp, {
            writable: true,
            value: false
          });
          Object.defineProperty(this, _uiManager, {
            writable: true,
            value: void 0
          });
          if (!AnnotationEditorLayer._initialized) {
            AnnotationEditorLayer._initialized = true;
            _freetext.FreeTextEditor.initialize(options.l10n);
            _ink.InkEditor.initialize(options.l10n);
          }
          options.uiManager.registerEditorTypes([_freetext.FreeTextEditor, _ink.InkEditor]);
          _classPrivateFieldLooseBase(this, _uiManager)[_uiManager] = options.uiManager;
          this.pageIndex = options.pageIndex;
          this.div = options.div;
          _classPrivateFieldLooseBase(this, _accessibilityManager)[_accessibilityManager] = options.accessibilityManager;
          _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].addLayer(this);
        }
        return _createClass(AnnotationEditorLayer, [{
          key: "isEmpty",
          get: function get() {
            return _classPrivateFieldLooseBase(this, _editors)[_editors].size === 0;
          }
        }, {
          key: "updateToolbar",
          value: function updateToolbar(mode) {
            _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].updateToolbar(mode);
          }
        }, {
          key: "updateMode",
          value: function updateMode() {
            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].getMode();
            _classPrivateFieldLooseBase(this, _cleanup)[_cleanup]();
            if (mode === _util.AnnotationEditorType.INK) {
              this.addInkEditorIfNeeded(false);
              this.disableClick();
            } else {
              this.enableClick();
            }
            _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].unselectAll();
            if (mode !== _util.AnnotationEditorType.NONE) {
              this.div.classList.toggle("freeTextEditing", mode === _util.AnnotationEditorType.FREETEXT);
              this.div.classList.toggle("inkEditing", mode === _util.AnnotationEditorType.INK);
              this.div.hidden = false;
            }
          }
        }, {
          key: "addInkEditorIfNeeded",
          value: function addInkEditorIfNeeded(isCommitting) {
            if (!isCommitting && _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].getMode() !== _util.AnnotationEditorType.INK) {
              return;
            }
            if (!isCommitting) {
              var _iterator82 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editors)[_editors].values()),
                _step82;
              try {
                for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
                  var _editor2 = _step82.value;
                  if (_editor2.isEmpty()) {
                    _editor2.setInBackground();
                    return;
                  }
                }
              } catch (err) {
                _iterator82.e(err);
              } finally {
                _iterator82.f();
              }
            }
            var editor = _classPrivateFieldLooseBase(this, _createAndAddNewEditor)[_createAndAddNewEditor]({
              offsetX: 0,
              offsetY: 0
            });
            editor.setInBackground();
          }
        }, {
          key: "setEditingState",
          value: function setEditingState(isEditing) {
            _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].setEditingState(isEditing);
          }
        }, {
          key: "addCommands",
          value: function addCommands(params) {
            _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].addCommands(params);
          }
        }, {
          key: "enable",
          value: function enable() {
            this.div.style.pointerEvents = "auto";
            var _iterator83 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editors)[_editors].values()),
              _step83;
            try {
              for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
                var editor = _step83.value;
                editor.enableEditing();
              }
            } catch (err) {
              _iterator83.e(err);
            } finally {
              _iterator83.f();
            }
          }
        }, {
          key: "disable",
          value: function disable() {
            this.div.style.pointerEvents = "none";
            var _iterator84 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editors)[_editors].values()),
              _step84;
            try {
              for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
                var editor = _step84.value;
                editor.disableEditing();
              }
            } catch (err) {
              _iterator84.e(err);
            } finally {
              _iterator84.f();
            }
            _classPrivateFieldLooseBase(this, _cleanup)[_cleanup]();
            if (this.isEmpty) {
              this.div.hidden = true;
            }
          }
        }, {
          key: "setActiveEditor",
          value: function setActiveEditor(editor) {
            var currentActive = _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].getActive();
            if (currentActive === editor) {
              return;
            }
            _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].setActiveEditor(editor);
          }
        }, {
          key: "enableClick",
          value: function enableClick() {
            this.div.addEventListener("pointerdown", _classPrivateFieldLooseBase(this, _boundPointerdown)[_boundPointerdown]);
            this.div.addEventListener("pointerup", _classPrivateFieldLooseBase(this, _boundPointerup)[_boundPointerup]);
          }
        }, {
          key: "disableClick",
          value: function disableClick() {
            this.div.removeEventListener("pointerdown", _classPrivateFieldLooseBase(this, _boundPointerdown)[_boundPointerdown]);
            this.div.removeEventListener("pointerup", _classPrivateFieldLooseBase(this, _boundPointerup)[_boundPointerup]);
          }
        }, {
          key: "attach",
          value: function attach(editor) {
            _classPrivateFieldLooseBase(this, _editors)[_editors].set(editor.id, editor);
          }
        }, {
          key: "detach",
          value: function detach(editor) {
            var _classPrivateFieldLoo4;
            _classPrivateFieldLooseBase(this, _editors)[_editors].delete(editor.id);
            (_classPrivateFieldLoo4 = _classPrivateFieldLooseBase(this, _accessibilityManager)[_accessibilityManager]) === null || _classPrivateFieldLoo4 === void 0 || _classPrivateFieldLoo4.removePointerInTextLayer(editor.contentDiv);
          }
        }, {
          key: "remove",
          value: function remove(editor) {
            var _this42 = this;
            _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].removeEditor(editor);
            this.detach(editor);
            editor.div.style.display = "none";
            setTimeout(function () {
              editor.div.style.display = "";
              editor.div.remove();
              editor.isAttachedToDOM = false;
              if (document.activeElement === document.body) {
                _classPrivateFieldLooseBase(_this42, _uiManager)[_uiManager].focusMainContainer();
              }
            }, 0);
            if (!_classPrivateFieldLooseBase(this, _isCleaningUp)[_isCleaningUp]) {
              this.addInkEditorIfNeeded(false);
            }
          }
        }, {
          key: "add",
          value: function add(editor) {
            _classPrivateFieldLooseBase(this, _changeParent)[_changeParent](editor);
            _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].addEditor(editor);
            this.attach(editor);
            if (!editor.isAttachedToDOM) {
              var div = editor.render();
              this.div.append(div);
              editor.isAttachedToDOM = true;
            }
            this.moveEditorInDOM(editor);
            editor.onceAdded();
            _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].addToAnnotationStorage(editor);
          }
        }, {
          key: "moveEditorInDOM",
          value: function moveEditorInDOM(editor) {
            var _classPrivateFieldLoo5;
            (_classPrivateFieldLoo5 = _classPrivateFieldLooseBase(this, _accessibilityManager)[_accessibilityManager]) === null || _classPrivateFieldLoo5 === void 0 || _classPrivateFieldLoo5.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
          }
        }, {
          key: "addOrRebuild",
          value: function addOrRebuild(editor) {
            if (editor.needsToBeRebuilt()) {
              editor.rebuild();
            } else {
              this.add(editor);
            }
          }
        }, {
          key: "addANewEditor",
          value: function addANewEditor(editor) {
            var _this43 = this;
            var cmd = function cmd() {
              _this43.addOrRebuild(editor);
            };
            var undo = function undo() {
              editor.remove();
            };
            this.addCommands({
              cmd: cmd,
              undo: undo,
              mustExec: true
            });
          }
        }, {
          key: "addUndoableEditor",
          value: function addUndoableEditor(editor) {
            var _this44 = this;
            var cmd = function cmd() {
              _this44.addOrRebuild(editor);
            };
            var undo = function undo() {
              editor.remove();
            };
            this.addCommands({
              cmd: cmd,
              undo: undo,
              mustExec: false
            });
          }
        }, {
          key: "getNextId",
          value: function getNextId() {
            return _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].getId();
          }
        }, {
          key: "deserialize",
          value: function deserialize(data) {
            switch (data.annotationType) {
              case _util.AnnotationEditorType.FREETEXT:
                return _freetext.FreeTextEditor.deserialize(data, this, _classPrivateFieldLooseBase(this, _uiManager)[_uiManager]);
              case _util.AnnotationEditorType.INK:
                return _ink.InkEditor.deserialize(data, this, _classPrivateFieldLooseBase(this, _uiManager)[_uiManager]);
            }
            return null;
          }
        }, {
          key: "setSelected",
          value: function setSelected(editor) {
            _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].setSelected(editor);
          }
        }, {
          key: "toggleSelected",
          value: function toggleSelected(editor) {
            _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].toggleSelected(editor);
          }
        }, {
          key: "isSelected",
          value: function isSelected(editor) {
            return _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].isSelected(editor);
          }
        }, {
          key: "unselect",
          value: function unselect(editor) {
            _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].unselect(editor);
          }
        }, {
          key: "pointerup",
          value: function pointerup(event) {
            var isMac = _util.FeatureTest.platform.isMac;
            if (event.button !== 0 || event.ctrlKey && isMac) {
              return;
            }
            if (event.target !== this.div) {
              return;
            }
            if (!_classPrivateFieldLooseBase(this, _hadPointerDown)[_hadPointerDown]) {
              return;
            }
            _classPrivateFieldLooseBase(this, _hadPointerDown)[_hadPointerDown] = false;
            if (!_classPrivateFieldLooseBase(this, _allowClick)[_allowClick]) {
              _classPrivateFieldLooseBase(this, _allowClick)[_allowClick] = true;
              return;
            }
            _classPrivateFieldLooseBase(this, _createAndAddNewEditor)[_createAndAddNewEditor](event);
          }
        }, {
          key: "pointerdown",
          value: function pointerdown(event) {
            var isMac = _util.FeatureTest.platform.isMac;
            if (event.button !== 0 || event.ctrlKey && isMac) {
              return;
            }
            if (event.target !== this.div) {
              return;
            }
            _classPrivateFieldLooseBase(this, _hadPointerDown)[_hadPointerDown] = true;
            var editor = _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].getActive();
            _classPrivateFieldLooseBase(this, _allowClick)[_allowClick] = !editor || editor.isEmpty();
          }
        }, {
          key: "drop",
          value: function drop(event) {
            var id = event.dataTransfer.getData("text/plain");
            var editor = _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].getEditor(id);
            if (!editor) {
              return;
            }
            event.preventDefault();
            event.dataTransfer.dropEffect = "move";
            _classPrivateFieldLooseBase(this, _changeParent)[_changeParent](editor);
            var rect = this.div.getBoundingClientRect();
            var endX = event.clientX - rect.x;
            var endY = event.clientY - rect.y;
            editor.translate(endX - editor.startX, endY - editor.startY);
            this.moveEditorInDOM(editor);
            editor.div.focus();
          }
        }, {
          key: "dragover",
          value: function dragover(event) {
            event.preventDefault();
          }
        }, {
          key: "destroy",
          value: function destroy() {
            var _classPrivateFieldLoo6;
            if (((_classPrivateFieldLoo6 = _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].getActive()) === null || _classPrivateFieldLoo6 === void 0 ? void 0 : _classPrivateFieldLoo6.parent) === this) {
              _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].setActiveEditor(null);
            }
            var _iterator85 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editors)[_editors].values()),
              _step85;
            try {
              for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
                var _classPrivateFieldLoo7;
                var editor = _step85.value;
                (_classPrivateFieldLoo7 = _classPrivateFieldLooseBase(this, _accessibilityManager)[_accessibilityManager]) === null || _classPrivateFieldLoo7 === void 0 || _classPrivateFieldLoo7.removePointerInTextLayer(editor.contentDiv);
                editor.setParent(null);
                editor.isAttachedToDOM = false;
                editor.div.remove();
              }
            } catch (err) {
              _iterator85.e(err);
            } finally {
              _iterator85.f();
            }
            this.div = null;
            _classPrivateFieldLooseBase(this, _editors)[_editors].clear();
            _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].removeLayer(this);
          }
        }, {
          key: "render",
          value: function render(_ref85) {
            var viewport = _ref85.viewport;
            this.viewport = viewport;
            (0, _display_utils.setLayerDimensions)(this.div, viewport);
            (0, _tools.bindEvents)(this, this.div, ["dragover", "drop"]);
            var _iterator86 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _uiManager)[_uiManager].getEditors(this.pageIndex)),
              _step86;
            try {
              for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
                var editor = _step86.value;
                this.add(editor);
              }
            } catch (err) {
              _iterator86.e(err);
            } finally {
              _iterator86.f();
            }
            this.updateMode();
          }
        }, {
          key: "update",
          value: function update(_ref86) {
            var viewport = _ref86.viewport;
            _classPrivateFieldLooseBase(this, _uiManager)[_uiManager].commitOrRemove();
            this.viewport = viewport;
            (0, _display_utils.setLayerDimensions)(this.div, {
              rotation: viewport.rotation
            });
            this.updateMode();
          }
        }, {
          key: "pageDimensions",
          get: function get() {
            var _this$viewport$rawDim = this.viewport.rawDims,
              pageWidth = _this$viewport$rawDim.pageWidth,
              pageHeight = _this$viewport$rawDim.pageHeight;
            return [pageWidth, pageHeight];
          }
        }]);
      }();
      function _changeParent2(editor) {
        var _editor$parent;
        if (editor.parent === this) {
          return;
        }
        this.attach(editor);
        (_editor$parent = editor.parent) === null || _editor$parent === void 0 || _editor$parent.detach(editor);
        editor.setParent(this);
        if (editor.div && editor.isAttachedToDOM) {
          editor.div.remove();
          this.div.append(editor.div);
        }
      }
      function _createNewEditor2(params) {
        switch (_classPrivateFieldLooseBase(this, _uiManager)[_uiManager].getMode()) {
          case _util.AnnotationEditorType.FREETEXT:
            return new _freetext.FreeTextEditor(params);
          case _util.AnnotationEditorType.INK:
            return new _ink.InkEditor(params);
        }
        return null;
      }
      function _createAndAddNewEditor2(event) {
        var id = this.getNextId();
        var editor = _classPrivateFieldLooseBase(this, _createNewEditor)[_createNewEditor]({
          parent: this,
          id: id,
          x: event.offsetX,
          y: event.offsetY,
          uiManager: _classPrivateFieldLooseBase(this, _uiManager)[_uiManager]
        });
        if (editor) {
          this.add(editor);
        }
        return editor;
      }
      function _cleanup2() {
        _classPrivateFieldLooseBase(this, _isCleaningUp)[_isCleaningUp] = true;
        var _iterator87 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editors)[_editors].values()),
          _step87;
        try {
          for (_iterator87.s(); !(_step87 = _iterator87.n()).done;) {
            var editor = _step87.value;
            if (editor.isEmpty()) {
              editor.remove();
            }
          }
        } catch (err) {
          _iterator87.e(err);
        } finally {
          _iterator87.f();
        }
        _classPrivateFieldLooseBase(this, _isCleaningUp)[_isCleaningUp] = false;
      }
      AnnotationEditorLayer._initialized = false;
      exports.AnnotationEditorLayer = AnnotationEditorLayer;

      /***/
    }), (/* 28 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      var _FreeTextEditor;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.FreeTextEditor = void 0;
      var _util = __w_pdfjs_require__(1);
      var _tools = __w_pdfjs_require__(5);
      var _editor = __w_pdfjs_require__(4);
      var _boundEditorDivBlur = /*#__PURE__*/_classPrivateFieldLooseKey("boundEditorDivBlur");
      var _boundEditorDivFocus = /*#__PURE__*/_classPrivateFieldLooseKey("boundEditorDivFocus");
      var _boundEditorDivInput = /*#__PURE__*/_classPrivateFieldLooseKey("boundEditorDivInput");
      var _boundEditorDivKeydown = /*#__PURE__*/_classPrivateFieldLooseKey("boundEditorDivKeydown");
      var _color = /*#__PURE__*/_classPrivateFieldLooseKey("color");
      var _content = /*#__PURE__*/_classPrivateFieldLooseKey("content");
      var _editorDivId = /*#__PURE__*/_classPrivateFieldLooseKey("editorDivId");
      var _hasAlreadyBeenCommitted = /*#__PURE__*/_classPrivateFieldLooseKey("hasAlreadyBeenCommitted");
      var _fontSize = /*#__PURE__*/_classPrivateFieldLooseKey("fontSize");
      var _updateFontSize = /*#__PURE__*/_classPrivateFieldLooseKey("updateFontSize");
      var _updateColor = /*#__PURE__*/_classPrivateFieldLooseKey("updateColor");
      var _extractText = /*#__PURE__*/_classPrivateFieldLooseKey("extractText");
      var _setEditorDimensions = /*#__PURE__*/_classPrivateFieldLooseKey("setEditorDimensions");
      var FreeTextEditor = /*#__PURE__*/function (_editor$AnnotationEdi) {
        function FreeTextEditor(params) {
          var _this45;
          _classCallCheck(this, FreeTextEditor);
          _this45 = _callSuper(this, FreeTextEditor, [_objectSpread(_objectSpread({}, params), {}, {
            name: "freeTextEditor"
          })]);
          Object.defineProperty(_this45, _setEditorDimensions, {
            value: _setEditorDimensions2
          });
          Object.defineProperty(_this45, _extractText, {
            value: _extractText2
          });
          Object.defineProperty(_this45, _updateColor, {
            value: _updateColor2
          });
          Object.defineProperty(_this45, _updateFontSize, {
            value: _updateFontSize2
          });
          Object.defineProperty(_this45, _boundEditorDivBlur, {
            writable: true,
            value: _this45.editorDivBlur.bind(_this45)
          });
          Object.defineProperty(_this45, _boundEditorDivFocus, {
            writable: true,
            value: _this45.editorDivFocus.bind(_this45)
          });
          Object.defineProperty(_this45, _boundEditorDivInput, {
            writable: true,
            value: _this45.editorDivInput.bind(_this45)
          });
          Object.defineProperty(_this45, _boundEditorDivKeydown, {
            writable: true,
            value: _this45.editorDivKeydown.bind(_this45)
          });
          Object.defineProperty(_this45, _color, {
            writable: true,
            value: void 0
          });
          Object.defineProperty(_this45, _content, {
            writable: true,
            value: ""
          });
          Object.defineProperty(_this45, _editorDivId, {
            writable: true,
            value: "".concat(_this45.id, "-editor")
          });
          Object.defineProperty(_this45, _hasAlreadyBeenCommitted, {
            writable: true,
            value: false
          });
          Object.defineProperty(_this45, _fontSize, {
            writable: true,
            value: void 0
          });
          _classPrivateFieldLooseBase(_this45, _color)[_color] = params.color || FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor;
          _classPrivateFieldLooseBase(_this45, _fontSize)[_fontSize] = params.fontSize || FreeTextEditor._defaultFontSize;
          return _this45;
        }
        _inherits(FreeTextEditor, _editor$AnnotationEdi);
        return _createClass(FreeTextEditor, [{
          key: "updateParams",
          value: function updateParams(type, value) {
            switch (type) {
              case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
                _classPrivateFieldLooseBase(this, _updateFontSize)[_updateFontSize](value);
                break;
              case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
                _classPrivateFieldLooseBase(this, _updateColor)[_updateColor](value);
                break;
            }
          }
        }, {
          key: "propertiesToUpdate",
          get: function get() {
            return [[_util.AnnotationEditorParamsType.FREETEXT_SIZE, _classPrivateFieldLooseBase(this, _fontSize)[_fontSize]], [_util.AnnotationEditorParamsType.FREETEXT_COLOR, _classPrivateFieldLooseBase(this, _color)[_color]]];
          }
        }, {
          key: "getInitialTranslation",
          value: function getInitialTranslation() {
            var scale = this.parentScale;
            return [-FreeTextEditor._internalPadding * scale, -(FreeTextEditor._internalPadding + _classPrivateFieldLooseBase(this, _fontSize)[_fontSize]) * scale];
          }
        }, {
          key: "rebuild",
          value: function rebuild() {
            _superPropGet(FreeTextEditor, "rebuild", this, 3)([]);
            if (this.div === null) {
              return;
            }
            if (!this.isAttachedToDOM) {
              this.parent.add(this);
            }
          }
        }, {
          key: "enableEditMode",
          value: function enableEditMode() {
            if (this.isInEditMode()) {
              return;
            }
            this.parent.setEditingState(false);
            this.parent.updateToolbar(_util.AnnotationEditorType.FREETEXT);
            _superPropGet(FreeTextEditor, "enableEditMode", this, 3)([]);
            this.overlayDiv.classList.remove("enabled");
            this.editorDiv.contentEditable = true;
            this.div.draggable = false;
            this.div.removeAttribute("aria-activedescendant");
            this.editorDiv.addEventListener("keydown", _classPrivateFieldLooseBase(this, _boundEditorDivKeydown)[_boundEditorDivKeydown]);
            this.editorDiv.addEventListener("focus", _classPrivateFieldLooseBase(this, _boundEditorDivFocus)[_boundEditorDivFocus]);
            this.editorDiv.addEventListener("blur", _classPrivateFieldLooseBase(this, _boundEditorDivBlur)[_boundEditorDivBlur]);
            this.editorDiv.addEventListener("input", _classPrivateFieldLooseBase(this, _boundEditorDivInput)[_boundEditorDivInput]);
          }
        }, {
          key: "disableEditMode",
          value: function disableEditMode() {
            if (!this.isInEditMode()) {
              return;
            }
            this.parent.setEditingState(true);
            _superPropGet(FreeTextEditor, "disableEditMode", this, 3)([]);
            this.overlayDiv.classList.add("enabled");
            this.editorDiv.contentEditable = false;
            this.div.setAttribute("aria-activedescendant", _classPrivateFieldLooseBase(this, _editorDivId)[_editorDivId]);
            this.div.draggable = true;
            this.editorDiv.removeEventListener("keydown", _classPrivateFieldLooseBase(this, _boundEditorDivKeydown)[_boundEditorDivKeydown]);
            this.editorDiv.removeEventListener("focus", _classPrivateFieldLooseBase(this, _boundEditorDivFocus)[_boundEditorDivFocus]);
            this.editorDiv.removeEventListener("blur", _classPrivateFieldLooseBase(this, _boundEditorDivBlur)[_boundEditorDivBlur]);
            this.editorDiv.removeEventListener("input", _classPrivateFieldLooseBase(this, _boundEditorDivInput)[_boundEditorDivInput]);
            this.div.focus({
              preventScroll: true
            });
            this.isEditing = false;
            this.parent.div.classList.add("freeTextEditing");
          }
        }, {
          key: "focusin",
          value: function focusin(event) {
            _superPropGet(FreeTextEditor, "focusin", this, 3)([event]);
            if (event.target !== this.editorDiv) {
              this.editorDiv.focus();
            }
          }
        }, {
          key: "onceAdded",
          value: function onceAdded() {
            if (this.width) {
              return;
            }
            this.enableEditMode();
            this.editorDiv.focus();
          }
        }, {
          key: "isEmpty",
          value: function isEmpty() {
            return !this.editorDiv || this.editorDiv.innerText.trim() === "";
          }
        }, {
          key: "remove",
          value: function remove() {
            this.isEditing = false;
            this.parent.setEditingState(true);
            this.parent.div.classList.add("freeTextEditing");
            _superPropGet(FreeTextEditor, "remove", this, 3)([]);
          }
        }, {
          key: "commit",
          value: function commit() {
            if (!this.isInEditMode()) {
              return;
            }
            _superPropGet(FreeTextEditor, "commit", this, 3)([]);
            if (!_classPrivateFieldLooseBase(this, _hasAlreadyBeenCommitted)[_hasAlreadyBeenCommitted]) {
              _classPrivateFieldLooseBase(this, _hasAlreadyBeenCommitted)[_hasAlreadyBeenCommitted] = true;
              this.parent.addUndoableEditor(this);
            }
            this.disableEditMode();
            _classPrivateFieldLooseBase(this, _content)[_content] = _classPrivateFieldLooseBase(this, _extractText)[_extractText]().trimEnd();
            _classPrivateFieldLooseBase(this, _setEditorDimensions)[_setEditorDimensions]();
          }
        }, {
          key: "shouldGetKeyboardEvents",
          value: function shouldGetKeyboardEvents() {
            return this.isInEditMode();
          }
        }, {
          key: "dblclick",
          value: function dblclick(event) {
            this.enableEditMode();
            this.editorDiv.focus();
          }
        }, {
          key: "keydown",
          value: function keydown(event) {
            if (event.target === this.div && event.key === "Enter") {
              this.enableEditMode();
              this.editorDiv.focus();
            }
          }
        }, {
          key: "editorDivKeydown",
          value: function editorDivKeydown(event) {
            FreeTextEditor._keyboardManager.exec(this, event);
          }
        }, {
          key: "editorDivFocus",
          value: function editorDivFocus(event) {
            this.isEditing = true;
          }
        }, {
          key: "editorDivBlur",
          value: function editorDivBlur(event) {
            this.isEditing = false;
          }
        }, {
          key: "editorDivInput",
          value: function editorDivInput(event) {
            this.parent.div.classList.toggle("freeTextEditing", this.isEmpty());
          }
        }, {
          key: "disableEditing",
          value: function disableEditing() {
            this.editorDiv.setAttribute("role", "comment");
            this.editorDiv.removeAttribute("aria-multiline");
          }
        }, {
          key: "enableEditing",
          value: function enableEditing() {
            this.editorDiv.setAttribute("role", "textbox");
            this.editorDiv.setAttribute("aria-multiline", true);
          }
        }, {
          key: "render",
          value: function render() {
            var _this46 = this;
            if (this.div) {
              return this.div;
            }
            var baseX, baseY;
            if (this.width) {
              baseX = this.x;
              baseY = this.y;
            }
            _superPropGet(FreeTextEditor, "render", this, 3)([]);
            this.editorDiv = document.createElement("div");
            this.editorDiv.className = "internal";
            this.editorDiv.setAttribute("id", _classPrivateFieldLooseBase(this, _editorDivId)[_editorDivId]);
            this.enableEditing();
            FreeTextEditor._l10nPromise.get("editor_free_text2_aria_label").then(function (msg) {
              var _this46$editorDiv;
              return (_this46$editorDiv = _this46.editorDiv) === null || _this46$editorDiv === void 0 ? void 0 : _this46$editorDiv.setAttribute("aria-label", msg);
            });
            FreeTextEditor._l10nPromise.get("free_text2_default_content").then(function (msg) {
              var _this46$editorDiv2;
              return (_this46$editorDiv2 = _this46.editorDiv) === null || _this46$editorDiv2 === void 0 ? void 0 : _this46$editorDiv2.setAttribute("default-content", msg);
            });
            this.editorDiv.contentEditable = true;
            var style = this.editorDiv.style;
            style.fontSize = "calc(".concat(_classPrivateFieldLooseBase(this, _fontSize)[_fontSize], "px * var(--scale-factor))");
            style.color = _classPrivateFieldLooseBase(this, _color)[_color];
            this.div.append(this.editorDiv);
            this.overlayDiv = document.createElement("div");
            this.overlayDiv.classList.add("overlay", "enabled");
            this.div.append(this.overlayDiv);
            (0, _tools.bindEvents)(this, this.div, ["dblclick", "keydown"]);
            if (this.width) {
              var _this$parentDimension6 = _slicedToArray(this.parentDimensions, 2),
                parentWidth = _this$parentDimension6[0],
                parentHeight = _this$parentDimension6[1];
              this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
              var _iterator88 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _content)[_content].split("\n")),
                _step88;
              try {
                for (_iterator88.s(); !(_step88 = _iterator88.n()).done;) {
                  var line = _step88.value;
                  var div = document.createElement("div");
                  div.append(line ? document.createTextNode(line) : document.createElement("br"));
                  this.editorDiv.append(div);
                }
              } catch (err) {
                _iterator88.e(err);
              } finally {
                _iterator88.f();
              }
              this.div.draggable = true;
              this.editorDiv.contentEditable = false;
            } else {
              this.div.draggable = false;
              this.editorDiv.contentEditable = true;
            }
            return this.div;
          }
        }, {
          key: "contentDiv",
          get: function get() {
            return this.editorDiv;
          }
        }, {
          key: "serialize",
          value: function serialize() {
            if (this.isEmpty()) {
              return null;
            }
            var padding = FreeTextEditor._internalPadding * this.parentScale;
            var rect = this.getRect(padding, padding);
            var color = _editor.AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : _classPrivateFieldLooseBase(this, _color)[_color]);
            return {
              annotationType: _util.AnnotationEditorType.FREETEXT,
              color: color,
              fontSize: _classPrivateFieldLooseBase(this, _fontSize)[_fontSize],
              value: _classPrivateFieldLooseBase(this, _content)[_content],
              pageIndex: this.pageIndex,
              rect: rect,
              rotation: this.rotation
            };
          }
        }], [{
          key: "initialize",
          value: function initialize(l10n) {
            this._l10nPromise = new Map(["free_text2_default_content", "editor_free_text2_aria_label"].map(function (str) {
              return [str, l10n.get(str)];
            }));
            var style = getComputedStyle(document.documentElement);
            this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding"));
          }
        }, {
          key: "updateDefaultParams",
          value: function updateDefaultParams(type, value) {
            switch (type) {
              case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
                FreeTextEditor._defaultFontSize = value;
                break;
              case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
                FreeTextEditor._defaultColor = value;
                break;
            }
          }
        }, {
          key: "defaultPropertiesToUpdate",
          get: function get() {
            return [[_util.AnnotationEditorParamsType.FREETEXT_SIZE, FreeTextEditor._defaultFontSize], [_util.AnnotationEditorParamsType.FREETEXT_COLOR, FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor]];
          }
        }, {
          key: "deserialize",
          value: function deserialize(data, parent, uiManager) {
            var _util$Util2;
            var editor = _superPropGet(FreeTextEditor, "deserialize", this, 2)([data, parent, uiManager]);
            _classPrivateFieldLooseBase(editor, _fontSize)[_fontSize] = data.fontSize;
            _classPrivateFieldLooseBase(editor, _color)[_color] = (_util$Util2 = _util.Util).makeHexColor.apply(_util$Util2, _toConsumableArray(data.color));
            _classPrivateFieldLooseBase(editor, _content)[_content] = data.value;
            return editor;
          }
        }]);
      }(_editor.AnnotationEditor);
      _FreeTextEditor = FreeTextEditor;
      function _updateFontSize2(fontSize) {
        var _this47 = this;
        var setFontsize = function setFontsize(size) {
          _this47.editorDiv.style.fontSize = "calc(".concat(size, "px * var(--scale-factor))");
          _this47.translate(0, -(size - _classPrivateFieldLooseBase(_this47, _fontSize)[_fontSize]) * _this47.parentScale);
          _classPrivateFieldLooseBase(_this47, _fontSize)[_fontSize] = size;
          _classPrivateFieldLooseBase(_this47, _setEditorDimensions)[_setEditorDimensions]();
        };
        var savedFontsize = _classPrivateFieldLooseBase(this, _fontSize)[_fontSize];
        this.addCommands({
          cmd: function cmd() {
            setFontsize(fontSize);
          },
          undo: function undo() {
            setFontsize(savedFontsize);
          },
          mustExec: true,
          type: _util.AnnotationEditorParamsType.FREETEXT_SIZE,
          overwriteIfSameType: true,
          keepUndo: true
        });
      }
      function _updateColor2(color) {
        var _this48 = this;
        var savedColor = _classPrivateFieldLooseBase(this, _color)[_color];
        this.addCommands({
          cmd: function cmd() {
            _classPrivateFieldLooseBase(_this48, _color)[_color] = _this48.editorDiv.style.color = color;
          },
          undo: function undo() {
            _classPrivateFieldLooseBase(_this48, _color)[_color] = _this48.editorDiv.style.color = savedColor;
          },
          mustExec: true,
          type: _util.AnnotationEditorParamsType.FREETEXT_COLOR,
          overwriteIfSameType: true,
          keepUndo: true
        });
      }
      function _extractText2() {
        var divs = this.editorDiv.getElementsByTagName("div");
        if (divs.length === 0) {
          return this.editorDiv.innerText;
        }
        var buffer = [];
        var _iterator89 = _createForOfIteratorHelper(divs),
          _step89;
        try {
          for (_iterator89.s(); !(_step89 = _iterator89.n()).done;) {
            var div = _step89.value;
            buffer.push(div.innerText.replace(/\r\n?|\n/, ""));
          }
        } catch (err) {
          _iterator89.e(err);
        } finally {
          _iterator89.f();
        }
        return buffer.join("\n");
      }
      function _setEditorDimensions2() {
        var _this$parentDimension7 = _slicedToArray(this.parentDimensions, 2),
          parentWidth = _this$parentDimension7[0],
          parentHeight = _this$parentDimension7[1];
        var rect;
        if (this.isAttachedToDOM) {
          rect = this.div.getBoundingClientRect();
        } else {
          var currentLayer = this.currentLayer,
            div = this.div;
          var savedDisplay = div.style.display;
          div.style.display = "hidden";
          currentLayer.div.append(this.div);
          rect = div.getBoundingClientRect();
          div.remove();
          div.style.display = savedDisplay;
        }
        this.width = rect.width / parentWidth;
        this.height = rect.height / parentHeight;
      }
      FreeTextEditor._freeTextDefaultContent = "";
      FreeTextEditor._l10nPromise = void 0;
      FreeTextEditor._internalPadding = 0;
      FreeTextEditor._defaultColor = null;
      FreeTextEditor._defaultFontSize = 10;
      FreeTextEditor._keyboardManager = new _tools.KeyboardManager([[["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"], _FreeTextEditor.prototype.commitOrRemove]]);
      FreeTextEditor._type = "freetext";
      exports.FreeTextEditor = FreeTextEditor;

      /***/
    }), (/* 29 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      var _InkEditor;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.InkEditor = void 0;
      Object.defineProperty(exports, "fitCurve", {
        enumerable: true,
        get: function get() {
          return _pdfjsFitCurve.fitCurve;
        }
      });
      var _util = __w_pdfjs_require__(1);
      var _editor = __w_pdfjs_require__(4);
      var _pdfjsFitCurve = __w_pdfjs_require__(30);
      var _tools = __w_pdfjs_require__(5);
      var RESIZER_SIZE = 16;
      var TIME_TO_WAIT_BEFORE_FIXING_DIMS = 100;
      var _aspectRatio = /*#__PURE__*/_classPrivateFieldLooseKey("aspectRatio");
      var _baseHeight = /*#__PURE__*/_classPrivateFieldLooseKey("baseHeight");
      var _baseWidth = /*#__PURE__*/_classPrivateFieldLooseKey("baseWidth");
      var _boundCanvasPointermove = /*#__PURE__*/_classPrivateFieldLooseKey("boundCanvasPointermove");
      var _boundCanvasPointerleave = /*#__PURE__*/_classPrivateFieldLooseKey("boundCanvasPointerleave");
      var _boundCanvasPointerup = /*#__PURE__*/_classPrivateFieldLooseKey("boundCanvasPointerup");
      var _boundCanvasPointerdown = /*#__PURE__*/_classPrivateFieldLooseKey("boundCanvasPointerdown");
      var _disableEditing = /*#__PURE__*/_classPrivateFieldLooseKey("disableEditing");
      var _isCanvasInitialized = /*#__PURE__*/_classPrivateFieldLooseKey("isCanvasInitialized");
      var _lastPoint = /*#__PURE__*/_classPrivateFieldLooseKey("lastPoint");
      var _observer = /*#__PURE__*/_classPrivateFieldLooseKey("observer");
      var _realWidth = /*#__PURE__*/_classPrivateFieldLooseKey("realWidth");
      var _realHeight = /*#__PURE__*/_classPrivateFieldLooseKey("realHeight");
      var _requestFrameCallback = /*#__PURE__*/_classPrivateFieldLooseKey("requestFrameCallback");
      var _updateThickness = /*#__PURE__*/_classPrivateFieldLooseKey("updateThickness");
      var _updateColor3 = /*#__PURE__*/_classPrivateFieldLooseKey("updateColor");
      var _updateOpacity = /*#__PURE__*/_classPrivateFieldLooseKey("updateOpacity");
      var _getInitialBBox = /*#__PURE__*/_classPrivateFieldLooseKey("getInitialBBox");
      var _setStroke = /*#__PURE__*/_classPrivateFieldLooseKey("setStroke");
      var _startDrawing = /*#__PURE__*/_classPrivateFieldLooseKey("startDrawing");
      var _draw = /*#__PURE__*/_classPrivateFieldLooseKey("draw");
      var _stopDrawing = /*#__PURE__*/_classPrivateFieldLooseKey("stopDrawing");
      var _redraw = /*#__PURE__*/_classPrivateFieldLooseKey("redraw");
      var _endDrawing = /*#__PURE__*/_classPrivateFieldLooseKey("endDrawing");
      var _createCanvas2 = /*#__PURE__*/_classPrivateFieldLooseKey("createCanvas");
      var _createObserver = /*#__PURE__*/_classPrivateFieldLooseKey("createObserver");
      var _setCanvasDims = /*#__PURE__*/_classPrivateFieldLooseKey("setCanvasDims");
      var _setScaleFactor = /*#__PURE__*/_classPrivateFieldLooseKey("setScaleFactor");
      var _updateTransform = /*#__PURE__*/_classPrivateFieldLooseKey("updateTransform");
      var _buildPath2D = /*#__PURE__*/_classPrivateFieldLooseKey("buildPath2D");
      var _serializePaths = /*#__PURE__*/_classPrivateFieldLooseKey("serializePaths");
      var _extractPointsOnBezier = /*#__PURE__*/_classPrivateFieldLooseKey("extractPointsOnBezier");
      var _isAlmostFlat = /*#__PURE__*/_classPrivateFieldLooseKey("isAlmostFlat");
      var _getBbox = /*#__PURE__*/_classPrivateFieldLooseKey("getBbox");
      var _getPadding = /*#__PURE__*/_classPrivateFieldLooseKey("getPadding");
      var _fitToContent = /*#__PURE__*/_classPrivateFieldLooseKey("fitToContent");
      var _setMinDims = /*#__PURE__*/_classPrivateFieldLooseKey("setMinDims");
      var InkEditor = /*#__PURE__*/function (_editor$AnnotationEdi2) {
        function InkEditor(params) {
          var _this49;
          _classCallCheck(this, InkEditor);
          _this49 = _callSuper(this, InkEditor, [_objectSpread(_objectSpread({}, params), {}, {
            name: "inkEditor"
          })]);
          Object.defineProperty(_this49, _setMinDims, {
            value: _setMinDims2
          });
          Object.defineProperty(_this49, _fitToContent, {
            value: _fitToContent2
          });
          Object.defineProperty(_this49, _getPadding, {
            value: _getPadding2
          });
          Object.defineProperty(_this49, _getBbox, {
            value: _getBbox2
          });
          Object.defineProperty(_this49, _isAlmostFlat, {
            value: _isAlmostFlat2
          });
          Object.defineProperty(_this49, _extractPointsOnBezier, {
            value: _extractPointsOnBezier2
          });
          Object.defineProperty(_this49, _serializePaths, {
            value: _serializePaths2
          });
          Object.defineProperty(_this49, _updateTransform, {
            value: _updateTransform2
          });
          Object.defineProperty(_this49, _setScaleFactor, {
            value: _setScaleFactor2
          });
          Object.defineProperty(_this49, _setCanvasDims, {
            value: _setCanvasDims2
          });
          Object.defineProperty(_this49, _createObserver, {
            value: _createObserver2
          });
          Object.defineProperty(_this49, _createCanvas2, {
            value: _createCanvas3
          });
          Object.defineProperty(_this49, _endDrawing, {
            value: _endDrawing2
          });
          Object.defineProperty(_this49, _redraw, {
            value: _redraw2
          });
          Object.defineProperty(_this49, _stopDrawing, {
            value: _stopDrawing2
          });
          Object.defineProperty(_this49, _draw, {
            value: _draw2
          });
          Object.defineProperty(_this49, _startDrawing, {
            value: _startDrawing2
          });
          Object.defineProperty(_this49, _setStroke, {
            value: _setStroke2
          });
          Object.defineProperty(_this49, _getInitialBBox, {
            value: _getInitialBBox2
          });
          Object.defineProperty(_this49, _updateOpacity, {
            value: _updateOpacity2
          });
          Object.defineProperty(_this49, _updateColor3, {
            value: _updateColor4
          });
          Object.defineProperty(_this49, _updateThickness, {
            value: _updateThickness2
          });
          Object.defineProperty(_this49, _aspectRatio, {
            writable: true,
            value: 0
          });
          Object.defineProperty(_this49, _baseHeight, {
            writable: true,
            value: 0
          });
          Object.defineProperty(_this49, _baseWidth, {
            writable: true,
            value: 0
          });
          Object.defineProperty(_this49, _boundCanvasPointermove, {
            writable: true,
            value: _this49.canvasPointermove.bind(_this49)
          });
          Object.defineProperty(_this49, _boundCanvasPointerleave, {
            writable: true,
            value: _this49.canvasPointerleave.bind(_this49)
          });
          Object.defineProperty(_this49, _boundCanvasPointerup, {
            writable: true,
            value: _this49.canvasPointerup.bind(_this49)
          });
          Object.defineProperty(_this49, _boundCanvasPointerdown, {
            writable: true,
            value: _this49.canvasPointerdown.bind(_this49)
          });
          Object.defineProperty(_this49, _disableEditing, {
            writable: true,
            value: false
          });
          Object.defineProperty(_this49, _isCanvasInitialized, {
            writable: true,
            value: false
          });
          Object.defineProperty(_this49, _lastPoint, {
            writable: true,
            value: null
          });
          Object.defineProperty(_this49, _observer, {
            writable: true,
            value: null
          });
          Object.defineProperty(_this49, _realWidth, {
            writable: true,
            value: 0
          });
          Object.defineProperty(_this49, _realHeight, {
            writable: true,
            value: 0
          });
          Object.defineProperty(_this49, _requestFrameCallback, {
            writable: true,
            value: null
          });
          _this49.color = params.color || null;
          _this49.thickness = params.thickness || null;
          _this49.opacity = params.opacity || null;
          _this49.paths = [];
          _this49.bezierPath2D = [];
          _this49.currentPath = [];
          _this49.scaleFactor = 1;
          _this49.translationX = _this49.translationY = 0;
          _this49.x = 0;
          _this49.y = 0;
          return _this49;
        }
        _inherits(InkEditor, _editor$AnnotationEdi2);
        return _createClass(InkEditor, [{
          key: "updateParams",
          value: function updateParams(type, value) {
            switch (type) {
              case _util.AnnotationEditorParamsType.INK_THICKNESS:
                _classPrivateFieldLooseBase(this, _updateThickness)[_updateThickness](value);
                break;
              case _util.AnnotationEditorParamsType.INK_COLOR:
                _classPrivateFieldLooseBase(this, _updateColor3)[_updateColor3](value);
                break;
              case _util.AnnotationEditorParamsType.INK_OPACITY:
                _classPrivateFieldLooseBase(this, _updateOpacity)[_updateOpacity](value);
                break;
            }
          }
        }, {
          key: "propertiesToUpdate",
          get: function get() {
            var _this$opacity;
            return [[_util.AnnotationEditorParamsType.INK_THICKNESS, this.thickness || InkEditor._defaultThickness], [_util.AnnotationEditorParamsType.INK_COLOR, this.color || InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor], [_util.AnnotationEditorParamsType.INK_OPACITY, Math.round(100 * ((_this$opacity = this.opacity) !== null && _this$opacity !== void 0 ? _this$opacity : InkEditor._defaultOpacity))]];
          }
        }, {
          key: "rebuild",
          value: function rebuild() {
            _superPropGet(InkEditor, "rebuild", this, 3)([]);
            if (this.div === null) {
              return;
            }
            if (!this.canvas) {
              _classPrivateFieldLooseBase(this, _createCanvas2)[_createCanvas2]();
              _classPrivateFieldLooseBase(this, _createObserver)[_createObserver]();
            }
            if (!this.isAttachedToDOM) {
              this.parent.add(this);
              _classPrivateFieldLooseBase(this, _setCanvasDims)[_setCanvasDims]();
            }
            _classPrivateFieldLooseBase(this, _fitToContent)[_fitToContent]();
          }
        }, {
          key: "remove",
          value: function remove() {
            if (this.canvas === null) {
              return;
            }
            if (!this.isEmpty()) {
              this.commit();
            }
            this.canvas.width = this.canvas.height = 0;
            this.canvas.remove();
            this.canvas = null;
            _classPrivateFieldLooseBase(this, _observer)[_observer].disconnect();
            _classPrivateFieldLooseBase(this, _observer)[_observer] = null;
            _superPropGet(InkEditor, "remove", this, 3)([]);
          }
        }, {
          key: "setParent",
          value: function setParent(parent) {
            if (!this.parent && parent) {
              this._uiManager.removeShouldRescale(this);
            } else if (this.parent && parent === null) {
              this._uiManager.addShouldRescale(this);
            }
            _superPropGet(InkEditor, "setParent", this, 3)([parent]);
          }
        }, {
          key: "onScaleChanging",
          value: function onScaleChanging() {
            var _this$parentDimension8 = _slicedToArray(this.parentDimensions, 2),
              parentWidth = _this$parentDimension8[0],
              parentHeight = _this$parentDimension8[1];
            var width = this.width * parentWidth;
            var height = this.height * parentHeight;
            this.setDimensions(width, height);
          }
        }, {
          key: "enableEditMode",
          value: function enableEditMode() {
            if (_classPrivateFieldLooseBase(this, _disableEditing)[_disableEditing] || this.canvas === null) {
              return;
            }
            _superPropGet(InkEditor, "enableEditMode", this, 3)([]);
            this.div.draggable = false;
            this.canvas.addEventListener("pointerdown", _classPrivateFieldLooseBase(this, _boundCanvasPointerdown)[_boundCanvasPointerdown]);
            this.canvas.addEventListener("pointerup", _classPrivateFieldLooseBase(this, _boundCanvasPointerup)[_boundCanvasPointerup]);
          }
        }, {
          key: "disableEditMode",
          value: function disableEditMode() {
            if (!this.isInEditMode() || this.canvas === null) {
              return;
            }
            _superPropGet(InkEditor, "disableEditMode", this, 3)([]);
            this.div.draggable = !this.isEmpty();
            this.div.classList.remove("editing");
            this.canvas.removeEventListener("pointerdown", _classPrivateFieldLooseBase(this, _boundCanvasPointerdown)[_boundCanvasPointerdown]);
            this.canvas.removeEventListener("pointerup", _classPrivateFieldLooseBase(this, _boundCanvasPointerup)[_boundCanvasPointerup]);
          }
        }, {
          key: "onceAdded",
          value: function onceAdded() {
            this.div.draggable = !this.isEmpty();
          }
        }, {
          key: "isEmpty",
          value: function isEmpty() {
            return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
          }
        }, {
          key: "commit",
          value: function commit() {
            if (_classPrivateFieldLooseBase(this, _disableEditing)[_disableEditing]) {
              return;
            }
            _superPropGet(InkEditor, "commit", this, 3)([]);
            this.isEditing = false;
            this.disableEditMode();
            this.setInForeground();
            _classPrivateFieldLooseBase(this, _disableEditing)[_disableEditing] = true;
            this.div.classList.add("disabled");
            _classPrivateFieldLooseBase(this, _fitToContent)[_fitToContent](true);
            this.parent.addInkEditorIfNeeded(true);
            this.parent.moveEditorInDOM(this);
            this.div.focus({
              preventScroll: true
            });
          }
        }, {
          key: "focusin",
          value: function focusin(event) {
            _superPropGet(InkEditor, "focusin", this, 3)([event]);
            this.enableEditMode();
          }
        }, {
          key: "canvasPointerdown",
          value: function canvasPointerdown(event) {
            if (event.button !== 0 || !this.isInEditMode() || _classPrivateFieldLooseBase(this, _disableEditing)[_disableEditing]) {
              return;
            }
            this.setInForeground();
            if (event.type !== "mouse") {
              this.div.focus();
            }
            event.stopPropagation();
            this.canvas.addEventListener("pointerleave", _classPrivateFieldLooseBase(this, _boundCanvasPointerleave)[_boundCanvasPointerleave]);
            this.canvas.addEventListener("pointermove", _classPrivateFieldLooseBase(this, _boundCanvasPointermove)[_boundCanvasPointermove]);
            _classPrivateFieldLooseBase(this, _startDrawing)[_startDrawing](event.offsetX, event.offsetY);
          }
        }, {
          key: "canvasPointermove",
          value: function canvasPointermove(event) {
            event.stopPropagation();
            _classPrivateFieldLooseBase(this, _draw)[_draw](event.offsetX, event.offsetY);
          }
        }, {
          key: "canvasPointerup",
          value: function canvasPointerup(event) {
            if (event.button !== 0) {
              return;
            }
            if (this.isInEditMode() && this.currentPath.length !== 0) {
              event.stopPropagation();
              _classPrivateFieldLooseBase(this, _endDrawing)[_endDrawing](event);
              this.setInBackground();
            }
          }
        }, {
          key: "canvasPointerleave",
          value: function canvasPointerleave(event) {
            _classPrivateFieldLooseBase(this, _endDrawing)[_endDrawing](event);
            this.setInBackground();
          }
        }, {
          key: "render",
          value: function render() {
            var _this50 = this;
            if (this.div) {
              return this.div;
            }
            var baseX, baseY;
            if (this.width) {
              baseX = this.x;
              baseY = this.y;
            }
            _superPropGet(InkEditor, "render", this, 3)([]);
            InkEditor._l10nPromise.get("editor_ink2_aria_label").then(function (msg) {
              var _this50$div;
              return (_this50$div = _this50.div) === null || _this50$div === void 0 ? void 0 : _this50$div.setAttribute("aria-label", msg);
            });
            var _classPrivateFieldLoo8 = _classPrivateFieldLooseBase(this, _getInitialBBox)[_getInitialBBox](),
              _classPrivateFieldLoo9 = _slicedToArray(_classPrivateFieldLoo8, 4),
              x = _classPrivateFieldLoo9[0],
              y = _classPrivateFieldLoo9[1],
              w = _classPrivateFieldLoo9[2],
              h = _classPrivateFieldLoo9[3];
            this.setAt(x, y, 0, 0);
            this.setDims(w, h);
            _classPrivateFieldLooseBase(this, _createCanvas2)[_createCanvas2]();
            if (this.width) {
              var _this$parentDimension9 = _slicedToArray(this.parentDimensions, 2),
                parentWidth = _this$parentDimension9[0],
                parentHeight = _this$parentDimension9[1];
              this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
              _classPrivateFieldLooseBase(this, _isCanvasInitialized)[_isCanvasInitialized] = true;
              _classPrivateFieldLooseBase(this, _setCanvasDims)[_setCanvasDims]();
              this.setDims(this.width * parentWidth, this.height * parentHeight);
              _classPrivateFieldLooseBase(this, _redraw)[_redraw]();
              _classPrivateFieldLooseBase(this, _setMinDims)[_setMinDims]();
              this.div.classList.add("disabled");
            } else {
              this.div.classList.add("editing");
              this.enableEditMode();
            }
            _classPrivateFieldLooseBase(this, _createObserver)[_createObserver]();
            return this.div;
          }
        }, {
          key: "setDimensions",
          value: function setDimensions(width, height) {
            var roundedWidth = Math.round(width);
            var roundedHeight = Math.round(height);
            if (_classPrivateFieldLooseBase(this, _realWidth)[_realWidth] === roundedWidth && _classPrivateFieldLooseBase(this, _realHeight)[_realHeight] === roundedHeight) {
              return;
            }
            _classPrivateFieldLooseBase(this, _realWidth)[_realWidth] = roundedWidth;
            _classPrivateFieldLooseBase(this, _realHeight)[_realHeight] = roundedHeight;
            this.canvas.style.visibility = "hidden";
            if (_classPrivateFieldLooseBase(this, _aspectRatio)[_aspectRatio] && Math.abs(_classPrivateFieldLooseBase(this, _aspectRatio)[_aspectRatio] - width / height) > 1e-2) {
              height = Math.ceil(width / _classPrivateFieldLooseBase(this, _aspectRatio)[_aspectRatio]);
              this.setDims(width, height);
            }
            var _this$parentDimension0 = _slicedToArray(this.parentDimensions, 2),
              parentWidth = _this$parentDimension0[0],
              parentHeight = _this$parentDimension0[1];
            this.width = width / parentWidth;
            this.height = height / parentHeight;
            if (_classPrivateFieldLooseBase(this, _disableEditing)[_disableEditing]) {
              _classPrivateFieldLooseBase(this, _setScaleFactor)[_setScaleFactor](width, height);
            }
            _classPrivateFieldLooseBase(this, _setCanvasDims)[_setCanvasDims]();
            _classPrivateFieldLooseBase(this, _redraw)[_redraw]();
            this.canvas.style.visibility = "visible";
          }
        }, {
          key: "serialize",
          value: function serialize() {
            if (this.isEmpty()) {
              return null;
            }
            var rect = this.getRect(0, 0);
            var height = this.rotation % 180 === 0 ? rect[3] - rect[1] : rect[2] - rect[0];
            var color = _editor.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
            return {
              annotationType: _util.AnnotationEditorType.INK,
              color: color,
              thickness: this.thickness,
              opacity: this.opacity,
              paths: _classPrivateFieldLooseBase(this, _serializePaths)[_serializePaths](this.scaleFactor / this.parentScale, this.translationX, this.translationY, height),
              pageIndex: this.pageIndex,
              rect: rect,
              rotation: this.rotation
            };
          }
        }], [{
          key: "initialize",
          value: function initialize(l10n) {
            this._l10nPromise = new Map(["editor_ink_canvas_aria_label", "editor_ink2_aria_label"].map(function (str) {
              return [str, l10n.get(str)];
            }));
          }
        }, {
          key: "updateDefaultParams",
          value: function updateDefaultParams(type, value) {
            switch (type) {
              case _util.AnnotationEditorParamsType.INK_THICKNESS:
                InkEditor._defaultThickness = value;
                break;
              case _util.AnnotationEditorParamsType.INK_COLOR:
                InkEditor._defaultColor = value;
                break;
              case _util.AnnotationEditorParamsType.INK_OPACITY:
                InkEditor._defaultOpacity = value / 100;
                break;
            }
          }
        }, {
          key: "defaultPropertiesToUpdate",
          get: function get() {
            return [[_util.AnnotationEditorParamsType.INK_THICKNESS, InkEditor._defaultThickness], [_util.AnnotationEditorParamsType.INK_COLOR, InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor], [_util.AnnotationEditorParamsType.INK_OPACITY, Math.round(InkEditor._defaultOpacity * 100)]];
          }
        }, {
          key: "deserialize",
          value: function deserialize(data, parent, uiManager) {
            var _util$Util3;
            var editor = _superPropGet(InkEditor, "deserialize", this, 2)([data, parent, uiManager]);
            editor.thickness = data.thickness;
            editor.color = (_util$Util3 = _util.Util).makeHexColor.apply(_util$Util3, _toConsumableArray(data.color));
            editor.opacity = data.opacity;
            var _editor$pageDimension2 = _slicedToArray(editor.pageDimensions, 2),
              pageWidth = _editor$pageDimension2[0],
              pageHeight = _editor$pageDimension2[1];
            var width = editor.width * pageWidth;
            var height = editor.height * pageHeight;
            var scaleFactor = editor.parentScale;
            var padding = data.thickness / 2;
            _classPrivateFieldLooseBase(editor, _aspectRatio)[_aspectRatio] = width / height;
            _classPrivateFieldLooseBase(editor, _disableEditing)[_disableEditing] = true;
            _classPrivateFieldLooseBase(editor, _realWidth)[_realWidth] = Math.round(width);
            _classPrivateFieldLooseBase(editor, _realHeight)[_realHeight] = Math.round(height);
            var _iterator90 = _createForOfIteratorHelper(data.paths),
              _step90;
            try {
              for (_iterator90.s(); !(_step90 = _iterator90.n()).done;) {
                var _ref87 = _step90.value;
                var bezier = _ref87.bezier;
                var path = [];
                editor.paths.push(path);
                var p0 = scaleFactor * (bezier[0] - padding);
                var p1 = scaleFactor * (height - bezier[1] - padding);
                for (var i = 2, ii = bezier.length; i < ii; i += 6) {
                  var p10 = scaleFactor * (bezier[i] - padding);
                  var p11 = scaleFactor * (height - bezier[i + 1] - padding);
                  var p20 = scaleFactor * (bezier[i + 2] - padding);
                  var p21 = scaleFactor * (height - bezier[i + 3] - padding);
                  var p30 = scaleFactor * (bezier[i + 4] - padding);
                  var p31 = scaleFactor * (height - bezier[i + 5] - padding);
                  path.push([[p0, p1], [p10, p11], [p20, p21], [p30, p31]]);
                  p0 = p30;
                  p1 = p31;
                }
                var path2D = _classPrivateFieldLooseBase(this, _buildPath2D)[_buildPath2D](path);
                editor.bezierPath2D.push(path2D);
              }
            } catch (err) {
              _iterator90.e(err);
            } finally {
              _iterator90.f();
            }
            var bbox = _classPrivateFieldLooseBase(editor, _getBbox)[_getBbox]();
            _classPrivateFieldLooseBase(editor, _baseWidth)[_baseWidth] = Math.max(RESIZER_SIZE, bbox[2] - bbox[0]);
            _classPrivateFieldLooseBase(editor, _baseHeight)[_baseHeight] = Math.max(RESIZER_SIZE, bbox[3] - bbox[1]);
            _classPrivateFieldLooseBase(editor, _setScaleFactor)[_setScaleFactor](width, height);
            return editor;
          }
        }]);
      }(_editor.AnnotationEditor);
      _InkEditor = InkEditor;
      function _updateThickness2(thickness) {
        var _this51 = this;
        var savedThickness = this.thickness;
        this.addCommands({
          cmd: function cmd() {
            _this51.thickness = thickness;
            _classPrivateFieldLooseBase(_this51, _fitToContent)[_fitToContent]();
          },
          undo: function undo() {
            _this51.thickness = savedThickness;
            _classPrivateFieldLooseBase(_this51, _fitToContent)[_fitToContent]();
          },
          mustExec: true,
          type: _util.AnnotationEditorParamsType.INK_THICKNESS,
          overwriteIfSameType: true,
          keepUndo: true
        });
      }
      function _updateColor4(color) {
        var _this52 = this;
        var savedColor = this.color;
        this.addCommands({
          cmd: function cmd() {
            _this52.color = color;
            _classPrivateFieldLooseBase(_this52, _redraw)[_redraw]();
          },
          undo: function undo() {
            _this52.color = savedColor;
            _classPrivateFieldLooseBase(_this52, _redraw)[_redraw]();
          },
          mustExec: true,
          type: _util.AnnotationEditorParamsType.INK_COLOR,
          overwriteIfSameType: true,
          keepUndo: true
        });
      }
      function _updateOpacity2(opacity) {
        var _this53 = this;
        opacity /= 100;
        var savedOpacity = this.opacity;
        this.addCommands({
          cmd: function cmd() {
            _this53.opacity = opacity;
            _classPrivateFieldLooseBase(_this53, _redraw)[_redraw]();
          },
          undo: function undo() {
            _this53.opacity = savedOpacity;
            _classPrivateFieldLooseBase(_this53, _redraw)[_redraw]();
          },
          mustExec: true,
          type: _util.AnnotationEditorParamsType.INK_OPACITY,
          overwriteIfSameType: true,
          keepUndo: true
        });
      }
      function _getInitialBBox2() {
        var parentRotation = this.parentRotation,
          _this$parentDimension1 = _slicedToArray(this.parentDimensions, 2),
          width = _this$parentDimension1[0],
          height = _this$parentDimension1[1];
        switch (parentRotation) {
          case 90:
            return [0, height, height, width];
          case 180:
            return [width, height, width, height];
          case 270:
            return [width, 0, height, width];
          default:
            return [0, 0, width, height];
        }
      }
      function _setStroke2() {
        var ctx = this.ctx,
          color = this.color,
          opacity = this.opacity,
          thickness = this.thickness,
          parentScale = this.parentScale,
          scaleFactor = this.scaleFactor;
        ctx.lineWidth = thickness * parentScale / scaleFactor;
        ctx.lineCap = "round";
        ctx.lineJoin = "round";
        ctx.miterLimit = 10;
        ctx.strokeStyle = "".concat(color).concat((0, _tools.opacityToHex)(opacity));
      }
      function _startDrawing2(x, y) {
        var _this54 = this;
        this.isEditing = true;
        if (!_classPrivateFieldLooseBase(this, _isCanvasInitialized)[_isCanvasInitialized]) {
          var _this$opacity2;
          _classPrivateFieldLooseBase(this, _isCanvasInitialized)[_isCanvasInitialized] = true;
          _classPrivateFieldLooseBase(this, _setCanvasDims)[_setCanvasDims]();
          this.thickness || (this.thickness = _InkEditor._defaultThickness);
          this.color || (this.color = _InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor);
          (_this$opacity2 = this.opacity) !== null && _this$opacity2 !== void 0 ? _this$opacity2 : this.opacity = _InkEditor._defaultOpacity;
        }
        this.currentPath.push([x, y]);
        _classPrivateFieldLooseBase(this, _lastPoint)[_lastPoint] = null;
        _classPrivateFieldLooseBase(this, _setStroke)[_setStroke]();
        this.ctx.beginPath();
        this.ctx.moveTo(x, y);
        _classPrivateFieldLooseBase(this, _requestFrameCallback)[_requestFrameCallback] = function () {
          if (!_classPrivateFieldLooseBase(_this54, _requestFrameCallback)[_requestFrameCallback]) {
            return;
          }
          if (_classPrivateFieldLooseBase(_this54, _lastPoint)[_lastPoint]) {
            var _this54$ctx;
            if (_this54.isEmpty()) {
              _this54.ctx.setTransform(1, 0, 0, 1, 0, 0);
              _this54.ctx.clearRect(0, 0, _this54.canvas.width, _this54.canvas.height);
            } else {
              _classPrivateFieldLooseBase(_this54, _redraw)[_redraw]();
            }
            (_this54$ctx = _this54.ctx).lineTo.apply(_this54$ctx, _toConsumableArray(_classPrivateFieldLooseBase(_this54, _lastPoint)[_lastPoint]));
            _classPrivateFieldLooseBase(_this54, _lastPoint)[_lastPoint] = null;
            _this54.ctx.stroke();
          }
          window.requestAnimationFrame(_classPrivateFieldLooseBase(_this54, _requestFrameCallback)[_requestFrameCallback]);
        };
        window.requestAnimationFrame(_classPrivateFieldLooseBase(this, _requestFrameCallback)[_requestFrameCallback]);
      }
      function _draw2(x, y) {
        var _this$currentPath$at = this.currentPath.at(-1),
          _this$currentPath$at2 = _slicedToArray(_this$currentPath$at, 2),
          lastX = _this$currentPath$at2[0],
          lastY = _this$currentPath$at2[1];
        if (x === lastX && y === lastY) {
          return;
        }
        this.currentPath.push([x, y]);
        _classPrivateFieldLooseBase(this, _lastPoint)[_lastPoint] = [x, y];
      }
      function _stopDrawing2(x, y) {
        var _this55 = this;
        this.ctx.closePath();
        _classPrivateFieldLooseBase(this, _requestFrameCallback)[_requestFrameCallback] = null;
        x = Math.min(Math.max(x, 0), this.canvas.width);
        y = Math.min(Math.max(y, 0), this.canvas.height);
        var _this$currentPath$at3 = this.currentPath.at(-1),
          _this$currentPath$at4 = _slicedToArray(_this$currentPath$at3, 2),
          lastX = _this$currentPath$at4[0],
          lastY = _this$currentPath$at4[1];
        if (x !== lastX || y !== lastY) {
          this.currentPath.push([x, y]);
        }
        var bezier;
        if (this.currentPath.length !== 1) {
          bezier = (0, _pdfjsFitCurve.fitCurve)(this.currentPath, 30, null);
        } else {
          var xy = [x, y];
          bezier = [[xy, xy.slice(), xy.slice(), xy]];
        }
        var path2D = _classPrivateFieldLooseBase(_InkEditor, _buildPath2D)[_buildPath2D](bezier);
        this.currentPath.length = 0;
        var cmd = function cmd() {
          _this55.paths.push(bezier);
          _this55.bezierPath2D.push(path2D);
          _this55.rebuild();
        };
        var undo = function undo() {
          _this55.paths.pop();
          _this55.bezierPath2D.pop();
          if (_this55.paths.length === 0) {
            _this55.remove();
          } else {
            if (!_this55.canvas) {
              _classPrivateFieldLooseBase(_this55, _createCanvas2)[_createCanvas2]();
              _classPrivateFieldLooseBase(_this55, _createObserver)[_createObserver]();
            }
            _classPrivateFieldLooseBase(_this55, _fitToContent)[_fitToContent]();
          }
        };
        this.addCommands({
          cmd: cmd,
          undo: undo,
          mustExec: true
        });
      }
      function _redraw2() {
        if (this.isEmpty()) {
          _classPrivateFieldLooseBase(this, _updateTransform)[_updateTransform]();
          return;
        }
        _classPrivateFieldLooseBase(this, _setStroke)[_setStroke]();
        var canvas = this.canvas,
          ctx = this.ctx;
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        _classPrivateFieldLooseBase(this, _updateTransform)[_updateTransform]();
        var _iterator91 = _createForOfIteratorHelper(this.bezierPath2D),
          _step91;
        try {
          for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
            var path = _step91.value;
            ctx.stroke(path);
          }
        } catch (err) {
          _iterator91.e(err);
        } finally {
          _iterator91.f();
        }
      }
      function _endDrawing2(event) {
        _classPrivateFieldLooseBase(this, _stopDrawing)[_stopDrawing](event.offsetX, event.offsetY);
        this.canvas.removeEventListener("pointerleave", _classPrivateFieldLooseBase(this, _boundCanvasPointerleave)[_boundCanvasPointerleave]);
        this.canvas.removeEventListener("pointermove", _classPrivateFieldLooseBase(this, _boundCanvasPointermove)[_boundCanvasPointermove]);
        this.addToAnnotationStorage();
      }
      function _createCanvas3() {
        var _this56 = this;
        this.canvas = document.createElement("canvas");
        this.canvas.width = this.canvas.height = 0;
        this.canvas.className = "inkEditorCanvas";
        _InkEditor._l10nPromise.get("editor_ink_canvas_aria_label").then(function (msg) {
          var _this56$canvas;
          return (_this56$canvas = _this56.canvas) === null || _this56$canvas === void 0 ? void 0 : _this56$canvas.setAttribute("aria-label", msg);
        });
        this.div.append(this.canvas);
        this.ctx = this.canvas.getContext("2d");
      }
      function _createObserver2() {
        var _this57 = this;
        var timeoutId = null;
        _classPrivateFieldLooseBase(this, _observer)[_observer] = new ResizeObserver(function (entries) {
          var rect = entries[0].contentRect;
          if (rect.width && rect.height) {
            if (timeoutId !== null) {
              clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(function () {
              _this57.fixDims();
              timeoutId = null;
            }, TIME_TO_WAIT_BEFORE_FIXING_DIMS);
            _this57.setDimensions(rect.width, rect.height);
          }
        });
        _classPrivateFieldLooseBase(this, _observer)[_observer].observe(this.div);
      }
      function _setCanvasDims2() {
        if (!_classPrivateFieldLooseBase(this, _isCanvasInitialized)[_isCanvasInitialized]) {
          return;
        }
        var _this$parentDimension10 = _slicedToArray(this.parentDimensions, 2),
          parentWidth = _this$parentDimension10[0],
          parentHeight = _this$parentDimension10[1];
        this.canvas.width = Math.ceil(this.width * parentWidth);
        this.canvas.height = Math.ceil(this.height * parentHeight);
        _classPrivateFieldLooseBase(this, _updateTransform)[_updateTransform]();
      }
      function _setScaleFactor2(width, height) {
        var padding = _classPrivateFieldLooseBase(this, _getPadding)[_getPadding]();
        var scaleFactorW = (width - padding) / _classPrivateFieldLooseBase(this, _baseWidth)[_baseWidth];
        var scaleFactorH = (height - padding) / _classPrivateFieldLooseBase(this, _baseHeight)[_baseHeight];
        this.scaleFactor = Math.min(scaleFactorW, scaleFactorH);
      }
      function _updateTransform2() {
        var padding = _classPrivateFieldLooseBase(this, _getPadding)[_getPadding]() / 2;
        this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + padding, this.translationY * this.scaleFactor + padding);
      }
      function _buildPath2D2(bezier) {
        var path2D = new Path2D();
        for (var i = 0, ii = bezier.length; i < ii; i++) {
          var _bezier$i = _slicedToArray(bezier[i], 4),
            first = _bezier$i[0],
            control1 = _bezier$i[1],
            control2 = _bezier$i[2],
            second = _bezier$i[3];
          if (i === 0) {
            path2D.moveTo.apply(path2D, _toConsumableArray(first));
          }
          path2D.bezierCurveTo(control1[0], control1[1], control2[0], control2[1], second[0], second[1]);
        }
        return path2D;
      }
      function _serializePaths2(s, tx, ty, h) {
        var NUMBER_OF_POINTS_ON_BEZIER_CURVE = 4;
        var paths = [];
        var padding = this.thickness / 2;
        var buffer, points;
        var _iterator92 = _createForOfIteratorHelper(this.paths),
          _step92;
        try {
          for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
            var bezier = _step92.value;
            buffer = [];
            points = [];
            for (var i = 0, ii = bezier.length; i < ii; i++) {
              var _bezier$i2 = _slicedToArray(bezier[i], 4),
                first = _bezier$i2[0],
                control1 = _bezier$i2[1],
                control2 = _bezier$i2[2],
                second = _bezier$i2[3];
              var p10 = s * (first[0] + tx) + padding;
              var p11 = h - s * (first[1] + ty) - padding;
              var p20 = s * (control1[0] + tx) + padding;
              var p21 = h - s * (control1[1] + ty) - padding;
              var p30 = s * (control2[0] + tx) + padding;
              var p31 = h - s * (control2[1] + ty) - padding;
              var p40 = s * (second[0] + tx) + padding;
              var p41 = h - s * (second[1] + ty) - padding;
              if (i === 0) {
                buffer.push(p10, p11);
                points.push(p10, p11);
              }
              buffer.push(p20, p21, p30, p31, p40, p41);
              _classPrivateFieldLooseBase(this, _extractPointsOnBezier)[_extractPointsOnBezier](p10, p11, p20, p21, p30, p31, p40, p41, NUMBER_OF_POINTS_ON_BEZIER_CURVE, points);
            }
            paths.push({
              bezier: buffer,
              points: points
            });
          }
        } catch (err) {
          _iterator92.e(err);
        } finally {
          _iterator92.f();
        }
        return paths;
      }
      function _extractPointsOnBezier2(p10, p11, p20, p21, p30, p31, p40, p41, n, points) {
        if (_classPrivateFieldLooseBase(this, _isAlmostFlat)[_isAlmostFlat](p10, p11, p20, p21, p30, p31, p40, p41)) {
          points.push(p40, p41);
          return;
        }
        for (var i = 1; i < n - 1; i++) {
          var t = i / n;
          var mt = 1 - t;
          var q10 = t * p10 + mt * p20;
          var q11 = t * p11 + mt * p21;
          var q20 = t * p20 + mt * p30;
          var q21 = t * p21 + mt * p31;
          var q30 = t * p30 + mt * p40;
          var q31 = t * p31 + mt * p41;
          q10 = t * q10 + mt * q20;
          q11 = t * q11 + mt * q21;
          q20 = t * q20 + mt * q30;
          q21 = t * q21 + mt * q31;
          q10 = t * q10 + mt * q20;
          q11 = t * q11 + mt * q21;
          points.push(q10, q11);
        }
        points.push(p40, p41);
      }
      function _isAlmostFlat2(p10, p11, p20, p21, p30, p31, p40, p41) {
        var tol = 10;
        var ax = Math.pow(3 * p20 - 2 * p10 - p40, 2);
        var ay = Math.pow(3 * p21 - 2 * p11 - p41, 2);
        var bx = Math.pow(3 * p30 - p10 - 2 * p40, 2);
        var by = Math.pow(3 * p31 - p11 - 2 * p41, 2);
        return Math.max(ax, bx) + Math.max(ay, by) <= tol;
      }
      function _getBbox2() {
        var xMin = Infinity;
        var xMax = -Infinity;
        var yMin = Infinity;
        var yMax = -Infinity;
        var _iterator93 = _createForOfIteratorHelper(this.paths),
          _step93;
        try {
          for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
            var path = _step93.value;
            var _iterator94 = _createForOfIteratorHelper(path),
              _step94;
            try {
              for (_iterator94.s(); !(_step94 = _iterator94.n()).done;) {
                var _util$Util4;
                var _ref88 = _step94.value;
                var _ref89 = _slicedToArray(_ref88, 4);
                var first = _ref89[0];
                var control1 = _ref89[1];
                var control2 = _ref89[2];
                var second = _ref89[3];
                var bbox = (_util$Util4 = _util.Util).bezierBoundingBox.apply(_util$Util4, _toConsumableArray(first).concat(_toConsumableArray(control1), _toConsumableArray(control2), _toConsumableArray(second)));
                xMin = Math.min(xMin, bbox[0]);
                yMin = Math.min(yMin, bbox[1]);
                xMax = Math.max(xMax, bbox[2]);
                yMax = Math.max(yMax, bbox[3]);
              }
            } catch (err) {
              _iterator94.e(err);
            } finally {
              _iterator94.f();
            }
          }
        } catch (err) {
          _iterator93.e(err);
        } finally {
          _iterator93.f();
        }
        return [xMin, yMin, xMax, yMax];
      }
      function _getPadding2() {
        return _classPrivateFieldLooseBase(this, _disableEditing)[_disableEditing] ? Math.ceil(this.thickness * this.parentScale) : 0;
      }
      function _fitToContent2() {
        var firstTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (this.isEmpty()) {
          return;
        }
        if (!_classPrivateFieldLooseBase(this, _disableEditing)[_disableEditing]) {
          _classPrivateFieldLooseBase(this, _redraw)[_redraw]();
          return;
        }
        var bbox = _classPrivateFieldLooseBase(this, _getBbox)[_getBbox]();
        var padding = _classPrivateFieldLooseBase(this, _getPadding)[_getPadding]();
        _classPrivateFieldLooseBase(this, _baseWidth)[_baseWidth] = Math.max(RESIZER_SIZE, bbox[2] - bbox[0]);
        _classPrivateFieldLooseBase(this, _baseHeight)[_baseHeight] = Math.max(RESIZER_SIZE, bbox[3] - bbox[1]);
        var width = Math.ceil(padding + _classPrivateFieldLooseBase(this, _baseWidth)[_baseWidth] * this.scaleFactor);
        var height = Math.ceil(padding + _classPrivateFieldLooseBase(this, _baseHeight)[_baseHeight] * this.scaleFactor);
        var _this$parentDimension11 = _slicedToArray(this.parentDimensions, 2),
          parentWidth = _this$parentDimension11[0],
          parentHeight = _this$parentDimension11[1];
        this.width = width / parentWidth;
        this.height = height / parentHeight;
        _classPrivateFieldLooseBase(this, _aspectRatio)[_aspectRatio] = width / height;
        _classPrivateFieldLooseBase(this, _setMinDims)[_setMinDims]();
        var prevTranslationX = this.translationX;
        var prevTranslationY = this.translationY;
        this.translationX = -bbox[0];
        this.translationY = -bbox[1];
        _classPrivateFieldLooseBase(this, _setCanvasDims)[_setCanvasDims]();
        _classPrivateFieldLooseBase(this, _redraw)[_redraw]();
        _classPrivateFieldLooseBase(this, _realWidth)[_realWidth] = width;
        _classPrivateFieldLooseBase(this, _realHeight)[_realHeight] = height;
        this.setDims(width, height);
        var unscaledPadding = firstTime ? padding / this.scaleFactor / 2 : 0;
        this.translate(prevTranslationX - this.translationX - unscaledPadding, prevTranslationY - this.translationY - unscaledPadding);
      }
      function _setMinDims2() {
        var style = this.div.style;
        if (_classPrivateFieldLooseBase(this, _aspectRatio)[_aspectRatio] >= 1) {
          style.minHeight = "".concat(RESIZER_SIZE, "px");
          style.minWidth = "".concat(Math.round(_classPrivateFieldLooseBase(this, _aspectRatio)[_aspectRatio] * RESIZER_SIZE), "px");
        } else {
          style.minWidth = "".concat(RESIZER_SIZE, "px");
          style.minHeight = "".concat(Math.round(RESIZER_SIZE / _classPrivateFieldLooseBase(this, _aspectRatio)[_aspectRatio]), "px");
        }
      }
      Object.defineProperty(InkEditor, _buildPath2D, {
        value: _buildPath2D2
      });
      InkEditor._defaultColor = null;
      InkEditor._defaultOpacity = 1;
      InkEditor._defaultThickness = 1;
      InkEditor._l10nPromise = void 0;
      InkEditor._type = "ink";
      exports.InkEditor = InkEditor;

      /***/
    }), (/* 30 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.fitCurve = void 0;
      var fitCurve = __w_pdfjs_require__(31);
      exports.fitCurve = fitCurve;

      /***/
    }), (/* 31 */
    /***/function (module) {
      function fitCurve(points, maxError, progressCallback) {
        if (!Array.isArray(points)) {
          throw new TypeError("First argument should be an array");
        }
        points.forEach(function (point) {
          if (!Array.isArray(point) || point.some(function (item) {
            return typeof item !== 'number';
          }) || point.length !== points[0].length) {
            throw Error("Each point should be an array of numbers. Each point should have the same amount of numbers.");
          }
        });
        points = points.filter(function (point, i) {
          return i === 0 || !point.every(function (val, j) {
            return val === points[i - 1][j];
          });
        });
        if (points.length < 2) {
          return [];
        }
        var len = points.length;
        var leftTangent = createTangent(points[1], points[0]);
        var rightTangent = createTangent(points[len - 2], points[len - 1]);
        return fitCubic(points, leftTangent, rightTangent, maxError, progressCallback);
      }
      function fitCubic(points, leftTangent, rightTangent, error, progressCallback) {
        var MaxIterations = 20;
        var bezCurve, u, uPrime, maxError, prevErr, splitPoint, prevSplit, centerVector, toCenterTangent, fromCenterTangent, beziers, dist, i;
        if (points.length === 2) {
          dist = maths.vectorLen(maths.subtract(points[0], points[1])) / 3.0;
          bezCurve = [points[0], maths.addArrays(points[0], maths.mulItems(leftTangent, dist)), maths.addArrays(points[1], maths.mulItems(rightTangent, dist)), points[1]];
          return [bezCurve];
        }
        u = chordLengthParameterize(points);
        var _generateAndReport = generateAndReport(points, u, u, leftTangent, rightTangent, progressCallback);
        var _generateAndReport2 = _slicedToArray(_generateAndReport, 3);
        bezCurve = _generateAndReport2[0];
        maxError = _generateAndReport2[1];
        splitPoint = _generateAndReport2[2];
        if (maxError === 0 || maxError < error) {
          return [bezCurve];
        }
        if (maxError < error * error) {
          uPrime = u;
          prevErr = maxError;
          prevSplit = splitPoint;
          for (i = 0; i < MaxIterations; i++) {
            uPrime = reparameterize(bezCurve, points, uPrime);
            var _generateAndReport3 = generateAndReport(points, u, uPrime, leftTangent, rightTangent, progressCallback);
            var _generateAndReport4 = _slicedToArray(_generateAndReport3, 3);
            bezCurve = _generateAndReport4[0];
            maxError = _generateAndReport4[1];
            splitPoint = _generateAndReport4[2];
            if (maxError < error) {
              return [bezCurve];
            } else if (splitPoint === prevSplit) {
              var errChange = maxError / prevErr;
              if (errChange > .9999 && errChange < 1.0001) {
                break;
              }
            }
            prevErr = maxError;
            prevSplit = splitPoint;
          }
        }
        beziers = [];
        centerVector = maths.subtract(points[splitPoint - 1], points[splitPoint + 1]);
        if (centerVector.every(function (val) {
          return val === 0;
        })) {
          centerVector = maths.subtract(points[splitPoint - 1], points[splitPoint]);
          var _ref90 = [-centerVector[1], centerVector[0]];
          centerVector[0] = _ref90[0];
          centerVector[1] = _ref90[1];
        }
        toCenterTangent = maths.normalize(centerVector);
        fromCenterTangent = maths.mulItems(toCenterTangent, -1);
        beziers = beziers.concat(fitCubic(points.slice(0, splitPoint + 1), leftTangent, toCenterTangent, error, progressCallback));
        beziers = beziers.concat(fitCubic(points.slice(splitPoint), fromCenterTangent, rightTangent, error, progressCallback));
        return beziers;
      }
      ;
      function generateAndReport(points, paramsOrig, paramsPrime, leftTangent, rightTangent, progressCallback) {
        var bezCurve, maxError, splitPoint;
        bezCurve = generateBezier(points, paramsPrime, leftTangent, rightTangent, progressCallback);
        var _computeMaxError = computeMaxError(points, bezCurve, paramsOrig);
        var _computeMaxError2 = _slicedToArray(_computeMaxError, 2);
        maxError = _computeMaxError2[0];
        splitPoint = _computeMaxError2[1];
        if (progressCallback) {
          progressCallback({
            bez: bezCurve,
            points: points,
            params: paramsOrig,
            maxErr: maxError,
            maxPoint: splitPoint
          });
        }
        return [bezCurve, maxError, splitPoint];
      }
      function generateBezier(points, parameters, leftTangent, rightTangent) {
        var bezCurve,
          A,
          a,
          C,
          X,
          det_C0_C1,
          det_C0_X,
          det_X_C1,
          alpha_l,
          alpha_r,
          epsilon,
          segLength,
          i,
          len,
          tmp,
          u,
          ux,
          firstPoint = points[0],
          lastPoint = points[points.length - 1];
        bezCurve = [firstPoint, null, null, lastPoint];
        A = maths.zeros_Xx2x2(parameters.length);
        for (i = 0, len = parameters.length; i < len; i++) {
          u = parameters[i];
          ux = 1 - u;
          a = A[i];
          a[0] = maths.mulItems(leftTangent, 3 * u * (ux * ux));
          a[1] = maths.mulItems(rightTangent, 3 * ux * (u * u));
        }
        C = [[0, 0], [0, 0]];
        X = [0, 0];
        for (i = 0, len = points.length; i < len; i++) {
          u = parameters[i];
          a = A[i];
          C[0][0] += maths.dot(a[0], a[0]);
          C[0][1] += maths.dot(a[0], a[1]);
          C[1][0] += maths.dot(a[0], a[1]);
          C[1][1] += maths.dot(a[1], a[1]);
          tmp = maths.subtract(points[i], bezier.q([firstPoint, firstPoint, lastPoint, lastPoint], u));
          X[0] += maths.dot(a[0], tmp);
          X[1] += maths.dot(a[1], tmp);
        }
        det_C0_C1 = C[0][0] * C[1][1] - C[1][0] * C[0][1];
        det_C0_X = C[0][0] * X[1] - C[1][0] * X[0];
        det_X_C1 = X[0] * C[1][1] - X[1] * C[0][1];
        alpha_l = det_C0_C1 === 0 ? 0 : det_X_C1 / det_C0_C1;
        alpha_r = det_C0_C1 === 0 ? 0 : det_C0_X / det_C0_C1;
        segLength = maths.vectorLen(maths.subtract(firstPoint, lastPoint));
        epsilon = 1.0e-6 * segLength;
        if (alpha_l < epsilon || alpha_r < epsilon) {
          bezCurve[1] = maths.addArrays(firstPoint, maths.mulItems(leftTangent, segLength / 3.0));
          bezCurve[2] = maths.addArrays(lastPoint, maths.mulItems(rightTangent, segLength / 3.0));
        } else {
          bezCurve[1] = maths.addArrays(firstPoint, maths.mulItems(leftTangent, alpha_l));
          bezCurve[2] = maths.addArrays(lastPoint, maths.mulItems(rightTangent, alpha_r));
        }
        return bezCurve;
      }
      ;
      function reparameterize(bezier, points, parameters) {
        return parameters.map(function (p, i) {
          return newtonRaphsonRootFind(bezier, points[i], p);
        });
      }
      ;
      function newtonRaphsonRootFind(bez, point, u) {
        var d = maths.subtract(bezier.q(bez, u), point),
          qprime = bezier.qprime(bez, u),
          numerator = maths.mulMatrix(d, qprime),
          denominator = maths.sum(maths.squareItems(qprime)) + 2 * maths.mulMatrix(d, bezier.qprimeprime(bez, u));
        if (denominator === 0) {
          return u;
        } else {
          return u - numerator / denominator;
        }
      }
      ;
      function chordLengthParameterize(points) {
        var u = [],
          currU,
          prevU,
          prevP;
        points.forEach(function (p, i) {
          currU = i ? prevU + maths.vectorLen(maths.subtract(p, prevP)) : 0;
          u.push(currU);
          prevU = currU;
          prevP = p;
        });
        u = u.map(function (x) {
          return x / prevU;
        });
        return u;
      }
      ;
      function computeMaxError(points, bez, parameters) {
        var dist, maxDist, splitPoint, v, i, count, point, t;
        maxDist = 0;
        splitPoint = Math.floor(points.length / 2);
        var t_distMap = mapTtoRelativeDistances(bez, 10);
        for (i = 0, count = points.length; i < count; i++) {
          point = points[i];
          t = find_t(bez, parameters[i], t_distMap, 10);
          v = maths.subtract(bezier.q(bez, t), point);
          dist = v[0] * v[0] + v[1] * v[1];
          if (dist > maxDist) {
            maxDist = dist;
            splitPoint = i;
          }
        }
        return [maxDist, splitPoint];
      }
      ;
      var mapTtoRelativeDistances = function mapTtoRelativeDistances(bez, B_parts) {
        var B_t_curr;
        var B_t_dist = [0];
        var B_t_prev = bez[0];
        var sumLen = 0;
        for (var i = 1; i <= B_parts; i++) {
          B_t_curr = bezier.q(bez, i / B_parts);
          sumLen += maths.vectorLen(maths.subtract(B_t_curr, B_t_prev));
          B_t_dist.push(sumLen);
          B_t_prev = B_t_curr;
        }
        B_t_dist = B_t_dist.map(function (x) {
          return x / sumLen;
        });
        return B_t_dist;
      };
      function find_t(bez, param, t_distMap, B_parts) {
        if (param < 0) {
          return 0;
        }
        if (param > 1) {
          return 1;
        }
        var lenMax, lenMin, tMax, tMin, t;
        for (var i = 1; i <= B_parts; i++) {
          if (param <= t_distMap[i]) {
            tMin = (i - 1) / B_parts;
            tMax = i / B_parts;
            lenMin = t_distMap[i - 1];
            lenMax = t_distMap[i];
            t = (param - lenMin) / (lenMax - lenMin) * (tMax - tMin) + tMin;
            break;
          }
        }
        return t;
      }
      function createTangent(pointA, pointB) {
        return maths.normalize(maths.subtract(pointA, pointB));
      }
      var maths = /*#__PURE__*/function () {
        function maths() {
          _classCallCheck(this, maths);
        }
        return _createClass(maths, null, [{
          key: "zeros_Xx2x2",
          value: function zeros_Xx2x2(x) {
            var zs = [];
            while (x--) {
              zs.push([0, 0]);
            }
            return zs;
          }
        }, {
          key: "mulItems",
          value: function mulItems(items, multiplier) {
            return items.map(function (x) {
              return x * multiplier;
            });
          }
        }, {
          key: "mulMatrix",
          value: function mulMatrix(m1, m2) {
            return m1.reduce(function (sum, x1, i) {
              return sum + x1 * m2[i];
            }, 0);
          }
        }, {
          key: "subtract",
          value: function subtract(arr1, arr2) {
            return arr1.map(function (x1, i) {
              return x1 - arr2[i];
            });
          }
        }, {
          key: "addArrays",
          value: function addArrays(arr1, arr2) {
            return arr1.map(function (x1, i) {
              return x1 + arr2[i];
            });
          }
        }, {
          key: "addItems",
          value: function addItems(items, addition) {
            return items.map(function (x) {
              return x + addition;
            });
          }
        }, {
          key: "sum",
          value: function sum(items) {
            return items.reduce(function (sum, x) {
              return sum + x;
            });
          }
        }, {
          key: "dot",
          value: function dot(m1, m2) {
            return maths.mulMatrix(m1, m2);
          }
        }, {
          key: "vectorLen",
          value: function vectorLen(v) {
            return Math.hypot.apply(Math, _toConsumableArray(v));
          }
        }, {
          key: "divItems",
          value: function divItems(items, divisor) {
            return items.map(function (x) {
              return x / divisor;
            });
          }
        }, {
          key: "squareItems",
          value: function squareItems(items) {
            return items.map(function (x) {
              return x * x;
            });
          }
        }, {
          key: "normalize",
          value: function normalize(v) {
            return this.divItems(v, this.vectorLen(v));
          }
        }]);
      }();
      var bezier = /*#__PURE__*/function () {
        function bezier() {
          _classCallCheck(this, bezier);
        }
        return _createClass(bezier, null, [{
          key: "q",
          value: function q(ctrlPoly, t) {
            var tx = 1.0 - t;
            var pA = maths.mulItems(ctrlPoly[0], tx * tx * tx),
              pB = maths.mulItems(ctrlPoly[1], 3 * tx * tx * t),
              pC = maths.mulItems(ctrlPoly[2], 3 * tx * t * t),
              pD = maths.mulItems(ctrlPoly[3], t * t * t);
            return maths.addArrays(maths.addArrays(pA, pB), maths.addArrays(pC, pD));
          }
        }, {
          key: "qprime",
          value: function qprime(ctrlPoly, t) {
            var tx = 1.0 - t;
            var pA = maths.mulItems(maths.subtract(ctrlPoly[1], ctrlPoly[0]), 3 * tx * tx),
              pB = maths.mulItems(maths.subtract(ctrlPoly[2], ctrlPoly[1]), 6 * tx * t),
              pC = maths.mulItems(maths.subtract(ctrlPoly[3], ctrlPoly[2]), 3 * t * t);
            return maths.addArrays(maths.addArrays(pA, pB), pC);
          }
        }, {
          key: "qprimeprime",
          value: function qprimeprime(ctrlPoly, t) {
            return maths.addArrays(maths.mulItems(maths.addArrays(maths.subtract(ctrlPoly[2], maths.mulItems(ctrlPoly[1], 2)), ctrlPoly[0]), 6 * (1.0 - t)), maths.mulItems(maths.addArrays(maths.subtract(ctrlPoly[3], maths.mulItems(ctrlPoly[2], 2)), ctrlPoly[1]), 6 * t));
          }
        }]);
      }();
      module.exports = fitCurve;
      module.exports.fitCubic = fitCubic;
      module.exports.createTangent = createTangent;

      /***/
    }), (/* 32 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.AnnotationLayer = void 0;
      var _util = __w_pdfjs_require__(1);
      var _display_utils = __w_pdfjs_require__(6);
      var _annotation_storage = __w_pdfjs_require__(3);
      var _scripting_utils = __w_pdfjs_require__(33);
      var _xfa_layer = __w_pdfjs_require__(34);
      var DEFAULT_TAB_INDEX = 1000;
      var DEFAULT_FONT_SIZE = 9;
      var GetElementsByNameSet = new WeakSet();
      function getRectDims(rect) {
        return {
          width: rect[2] - rect[0],
          height: rect[3] - rect[1]
        };
      }
      var AnnotationElementFactory = /*#__PURE__*/function () {
        function AnnotationElementFactory() {
          _classCallCheck(this, AnnotationElementFactory);
        }
        return _createClass(AnnotationElementFactory, null, [{
          key: "create",
          value: function create(parameters) {
            var subtype = parameters.data.annotationType;
            switch (subtype) {
              case _util.AnnotationType.LINK:
                return new LinkAnnotationElement(parameters);
              case _util.AnnotationType.TEXT:
                return new TextAnnotationElement(parameters);
              case _util.AnnotationType.WIDGET:
                var fieldType = parameters.data.fieldType;
                switch (fieldType) {
                  case "Tx":
                    return new TextWidgetAnnotationElement(parameters);
                  case "Btn":
                    if (parameters.data.radioButton) {
                      return new RadioButtonWidgetAnnotationElement(parameters);
                    } else if (parameters.data.checkBox) {
                      return new CheckboxWidgetAnnotationElement(parameters);
                    }
                    return new PushButtonWidgetAnnotationElement(parameters);
                  case "Ch":
                    return new ChoiceWidgetAnnotationElement(parameters);
                }
                return new WidgetAnnotationElement(parameters);
              case _util.AnnotationType.POPUP:
                return new PopupAnnotationElement(parameters);
              case _util.AnnotationType.FREETEXT:
                return new FreeTextAnnotationElement(parameters);
              case _util.AnnotationType.LINE:
                return new LineAnnotationElement(parameters);
              case _util.AnnotationType.SQUARE:
                return new SquareAnnotationElement(parameters);
              case _util.AnnotationType.CIRCLE:
                return new CircleAnnotationElement(parameters);
              case _util.AnnotationType.POLYLINE:
                return new PolylineAnnotationElement(parameters);
              case _util.AnnotationType.CARET:
                return new CaretAnnotationElement(parameters);
              case _util.AnnotationType.INK:
                return new InkAnnotationElement(parameters);
              case _util.AnnotationType.POLYGON:
                return new PolygonAnnotationElement(parameters);
              case _util.AnnotationType.HIGHLIGHT:
                return new HighlightAnnotationElement(parameters);
              case _util.AnnotationType.UNDERLINE:
                return new UnderlineAnnotationElement(parameters);
              case _util.AnnotationType.SQUIGGLY:
                return new SquigglyAnnotationElement(parameters);
              case _util.AnnotationType.STRIKEOUT:
                return new StrikeOutAnnotationElement(parameters);
              case _util.AnnotationType.STAMP:
                return new StampAnnotationElement(parameters);
              case _util.AnnotationType.FILEATTACHMENT:
                return new FileAttachmentAnnotationElement(parameters);
              default:
                return new AnnotationElement(parameters);
            }
          }
        }]);
      }();
      var AnnotationElement = /*#__PURE__*/function () {
        function AnnotationElement(parameters) {
          var _ref91 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref91$isRenderable = _ref91.isRenderable,
            isRenderable = _ref91$isRenderable === void 0 ? false : _ref91$isRenderable,
            _ref91$ignoreBorder = _ref91.ignoreBorder,
            ignoreBorder = _ref91$ignoreBorder === void 0 ? false : _ref91$ignoreBorder,
            _ref91$createQuadrila = _ref91.createQuadrilaterals,
            createQuadrilaterals = _ref91$createQuadrila === void 0 ? false : _ref91$createQuadrila;
          _classCallCheck(this, AnnotationElement);
          this.isRenderable = isRenderable;
          this.data = parameters.data;
          this.layer = parameters.layer;
          this.page = parameters.page;
          this.viewport = parameters.viewport;
          this.linkService = parameters.linkService;
          this.downloadManager = parameters.downloadManager;
          this.imageResourcesPath = parameters.imageResourcesPath;
          this.renderForms = parameters.renderForms;
          this.svgFactory = parameters.svgFactory;
          this.annotationStorage = parameters.annotationStorage;
          this.enableScripting = parameters.enableScripting;
          this.hasJSActions = parameters.hasJSActions;
          this._fieldObjects = parameters.fieldObjects;
          if (isRenderable) {
            this.container = this._createContainer(ignoreBorder);
          }
          if (createQuadrilaterals) {
            this.quadrilaterals = this._createQuadrilaterals(ignoreBorder);
          }
        }
        return _createClass(AnnotationElement, [{
          key: "_createContainer",
          value: function _createContainer() {
            var ignoreBorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var data = this.data,
              page = this.page,
              viewport = this.viewport;
            var container = document.createElement("section");
            container.setAttribute("data-annotation-id", data.id);
            var _viewport$rawDims3 = viewport.rawDims,
              pageWidth = _viewport$rawDims3.pageWidth,
              pageHeight = _viewport$rawDims3.pageHeight,
              pageX = _viewport$rawDims3.pageX,
              pageY = _viewport$rawDims3.pageY;
            var _getRectDims = getRectDims(data.rect),
              width = _getRectDims.width,
              height = _getRectDims.height;
            var rect = _util.Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);
            if (!ignoreBorder && data.borderStyle.width > 0) {
              container.style.borderWidth = "".concat(data.borderStyle.width, "px");
              var horizontalRadius = data.borderStyle.horizontalCornerRadius;
              var verticalRadius = data.borderStyle.verticalCornerRadius;
              if (horizontalRadius > 0 || verticalRadius > 0) {
                var radius = "calc(".concat(horizontalRadius, "px * var(--scale-factor)) / calc(").concat(verticalRadius, "px * var(--scale-factor))");
                container.style.borderRadius = radius;
              } else if (this instanceof RadioButtonWidgetAnnotationElement) {
                var _radius = "calc(".concat(width, "px * var(--scale-factor)) / calc(").concat(height, "px * var(--scale-factor))");
                container.style.borderRadius = _radius;
              }
              switch (data.borderStyle.style) {
                case _util.AnnotationBorderStyleType.SOLID:
                  container.style.borderStyle = "solid";
                  break;
                case _util.AnnotationBorderStyleType.DASHED:
                  container.style.borderStyle = "dashed";
                  break;
                case _util.AnnotationBorderStyleType.BEVELED:
                  (0, _util.warn)("Unimplemented border style: beveled");
                  break;
                case _util.AnnotationBorderStyleType.INSET:
                  (0, _util.warn)("Unimplemented border style: inset");
                  break;
                case _util.AnnotationBorderStyleType.UNDERLINE:
                  container.style.borderBottomStyle = "solid";
                  break;
                default:
                  break;
              }
              var borderColor = data.borderColor || null;
              if (borderColor) {
                container.style.borderColor = _util.Util.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
              } else {
                container.style.borderWidth = 0;
              }
            }
            container.style.left = "".concat(100 * (rect[0] - pageX) / pageWidth, "%");
            container.style.top = "".concat(100 * (rect[1] - pageY) / pageHeight, "%");
            var rotation = data.rotation;
            if (data.hasOwnCanvas || rotation === 0) {
              container.style.width = "".concat(100 * width / pageWidth, "%");
              container.style.height = "".concat(100 * height / pageHeight, "%");
            } else {
              this.setRotation(rotation, container);
            }
            return container;
          }
        }, {
          key: "setRotation",
          value: function setRotation(angle) {
            var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.container;
            var _this$viewport$rawDim2 = this.viewport.rawDims,
              pageWidth = _this$viewport$rawDim2.pageWidth,
              pageHeight = _this$viewport$rawDim2.pageHeight;
            var _getRectDims2 = getRectDims(this.data.rect),
              width = _getRectDims2.width,
              height = _getRectDims2.height;
            var elementWidth, elementHeight;
            if (angle % 180 === 0) {
              elementWidth = 100 * width / pageWidth;
              elementHeight = 100 * height / pageHeight;
            } else {
              elementWidth = 100 * height / pageWidth;
              elementHeight = 100 * width / pageHeight;
            }
            container.style.width = "".concat(elementWidth, "%");
            container.style.height = "".concat(elementHeight, "%");
            container.setAttribute("data-main-rotation", (360 - angle) % 360);
          }
        }, {
          key: "_commonActions",
          get: function get() {
            var _this58 = this;
            var setColor = function setColor(jsName, styleName, event) {
              var color = event.detail[jsName];
              event.target.style[styleName] = _scripting_utils.ColorConverters["".concat(color[0], "_HTML")](color.slice(1));
            };
            return (0, _util.shadow)(this, "_commonActions", {
              display: function display(event) {
                var hidden = event.detail.display % 2 === 1;
                _this58.container.style.visibility = hidden ? "hidden" : "visible";
                _this58.annotationStorage.setValue(_this58.data.id, {
                  hidden: hidden,
                  print: event.detail.display === 0 || event.detail.display === 3
                });
              },
              print: function print(event) {
                _this58.annotationStorage.setValue(_this58.data.id, {
                  print: event.detail.print
                });
              },
              hidden: function hidden(event) {
                _this58.container.style.visibility = event.detail.hidden ? "hidden" : "visible";
                _this58.annotationStorage.setValue(_this58.data.id, {
                  hidden: event.detail.hidden
                });
              },
              focus: function focus(event) {
                setTimeout(function () {
                  return event.target.focus({
                    preventScroll: false
                  });
                }, 0);
              },
              userName: function userName(event) {
                event.target.title = event.detail.userName;
              },
              readonly: function readonly(event) {
                if (event.detail.readonly) {
                  event.target.setAttribute("readonly", "");
                } else {
                  event.target.removeAttribute("readonly");
                }
              },
              required: function required(event) {
                _this58._setRequired(event.target, event.detail.required);
              },
              bgColor: function bgColor(event) {
                setColor("bgColor", "backgroundColor", event);
              },
              fillColor: function fillColor(event) {
                setColor("fillColor", "backgroundColor", event);
              },
              fgColor: function fgColor(event) {
                setColor("fgColor", "color", event);
              },
              textColor: function textColor(event) {
                setColor("textColor", "color", event);
              },
              borderColor: function borderColor(event) {
                setColor("borderColor", "borderColor", event);
              },
              strokeColor: function strokeColor(event) {
                setColor("strokeColor", "borderColor", event);
              },
              rotation: function rotation(event) {
                var angle = event.detail.rotation;
                _this58.setRotation(angle);
                _this58.annotationStorage.setValue(_this58.data.id, {
                  rotation: angle
                });
              }
            });
          }
        }, {
          key: "_dispatchEventFromSandbox",
          value: function _dispatchEventFromSandbox(actions, jsEvent) {
            var commonActions = this._commonActions;
            for (var _i9 = 0, _Object$keys = Object.keys(jsEvent.detail); _i9 < _Object$keys.length; _i9++) {
              var name = _Object$keys[_i9];
              var action = actions[name] || commonActions[name];
              action === null || action === void 0 || action(jsEvent);
            }
          }
        }, {
          key: "_setDefaultPropertiesFromJS",
          value: function _setDefaultPropertiesFromJS(element) {
            if (!this.enableScripting) {
              return;
            }
            var storedData = this.annotationStorage.getRawValue(this.data.id);
            if (!storedData) {
              return;
            }
            var commonActions = this._commonActions;
            for (var _i0 = 0, _Object$entries3 = Object.entries(storedData); _i0 < _Object$entries3.length; _i0++) {
              var _ref92 = _Object$entries3[_i0];
              var _ref93 = _slicedToArray(_ref92, 2);
              var actionName = _ref93[0];
              var detail = _ref93[1];
              var action = commonActions[actionName];
              if (action) {
                var eventProxy = {
                  detail: _defineProperty({}, actionName, detail),
                  target: element
                };
                action(eventProxy);
                delete storedData[actionName];
              }
            }
          }
        }, {
          key: "_createQuadrilaterals",
          value: function _createQuadrilaterals() {
            var ignoreBorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            if (!this.data.quadPoints) {
              return null;
            }
            var quadrilaterals = [];
            var savedRect = this.data.rect;
            var _iterator95 = _createForOfIteratorHelper(this.data.quadPoints),
              _step95;
            try {
              for (_iterator95.s(); !(_step95 = _iterator95.n()).done;) {
                var quadPoint = _step95.value;
                this.data.rect = [quadPoint[2].x, quadPoint[2].y, quadPoint[1].x, quadPoint[1].y];
                quadrilaterals.push(this._createContainer(ignoreBorder));
              }
            } catch (err) {
              _iterator95.e(err);
            } finally {
              _iterator95.f();
            }
            this.data.rect = savedRect;
            return quadrilaterals;
          }
        }, {
          key: "_createPopup",
          value: function _createPopup(trigger, data) {
            var container = this.container;
            if (this.quadrilaterals) {
              trigger = trigger || this.quadrilaterals;
              container = this.quadrilaterals[0];
            }
            if (!trigger) {
              trigger = document.createElement("div");
              trigger.className = "popupTriggerArea";
              container.append(trigger);
            }
            var popupElement = new PopupElement({
              container: container,
              trigger: trigger,
              color: data.color,
              titleObj: data.titleObj,
              modificationDate: data.modificationDate,
              contentsObj: data.contentsObj,
              richText: data.richText,
              hideWrapper: true
            });
            var popup = popupElement.render();
            popup.style.left = "100%";
            container.append(popup);
          }
        }, {
          key: "_renderQuadrilaterals",
          value: function _renderQuadrilaterals(className) {
            var _iterator96 = _createForOfIteratorHelper(this.quadrilaterals),
              _step96;
            try {
              for (_iterator96.s(); !(_step96 = _iterator96.n()).done;) {
                var quadrilateral = _step96.value;
                quadrilateral.className = className;
              }
            } catch (err) {
              _iterator96.e(err);
            } finally {
              _iterator96.f();
            }
            return this.quadrilaterals;
          }
        }, {
          key: "render",
          value: function render() {
            (0, _util.unreachable)("Abstract method `AnnotationElement.render` called");
          }
        }, {
          key: "_getElementsByName",
          value: function _getElementsByName(name) {
            var skipId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var fields = [];
            if (this._fieldObjects) {
              var fieldObj = this._fieldObjects[name];
              if (fieldObj) {
                var _iterator97 = _createForOfIteratorHelper(fieldObj),
                  _step97;
                try {
                  for (_iterator97.s(); !(_step97 = _iterator97.n()).done;) {
                    var _ref94 = _step97.value;
                    var page = _ref94.page;
                    var _id8 = _ref94.id;
                    var exportValues = _ref94.exportValues;
                    if (page === -1) {
                      continue;
                    }
                    if (_id8 === skipId) {
                      continue;
                    }
                    var exportValue = typeof exportValues === "string" ? exportValues : null;
                    var domElement = document.querySelector("[data-element-id=\"".concat(_id8, "\"]"));
                    if (domElement && !GetElementsByNameSet.has(domElement)) {
                      (0, _util.warn)("_getElementsByName - element not allowed: ".concat(_id8));
                      continue;
                    }
                    fields.push({
                      id: _id8,
                      exportValue: exportValue,
                      domElement: domElement
                    });
                  }
                } catch (err) {
                  _iterator97.e(err);
                } finally {
                  _iterator97.f();
                }
              }
              return fields;
            }
            var _iterator98 = _createForOfIteratorHelper(document.getElementsByName(name)),
              _step98;
            try {
              for (_iterator98.s(); !(_step98 = _iterator98.n()).done;) {
                var _domElement = _step98.value;
                var _exportValue = _domElement.exportValue;
                var _id9 = _domElement.getAttribute("data-element-id");
                if (_id9 === skipId) {
                  continue;
                }
                if (!GetElementsByNameSet.has(_domElement)) {
                  continue;
                }
                fields.push({
                  id: _id9,
                  exportValue: _exportValue,
                  domElement: _domElement
                });
              }
            } catch (err) {
              _iterator98.e(err);
            } finally {
              _iterator98.f();
            }
            return fields;
          }
        }]);
      }();
      var _setInternalLink = /*#__PURE__*/_classPrivateFieldLooseKey("setInternalLink");
      var _bindSetOCGState = /*#__PURE__*/_classPrivateFieldLooseKey("bindSetOCGState");
      var LinkAnnotationElement = /*#__PURE__*/function (_AnnotationElement) {
        function LinkAnnotationElement(parameters) {
          var _this59;
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          _classCallCheck(this, LinkAnnotationElement);
          _this59 = _callSuper(this, LinkAnnotationElement, [parameters, {
            isRenderable: true,
            ignoreBorder: !!(options !== null && options !== void 0 && options.ignoreBorder),
            createQuadrilaterals: true
          }]);
          Object.defineProperty(_this59, _bindSetOCGState, {
            value: _bindSetOCGState2
          });
          Object.defineProperty(_this59, _setInternalLink, {
            value: _setInternalLink2
          });
          _this59.isTooltipOnly = parameters.data.isTooltipOnly;
          return _this59;
        }
        _inherits(LinkAnnotationElement, _AnnotationElement);
        return _createClass(LinkAnnotationElement, [{
          key: "render",
          value: function render() {
            var data = this.data,
              linkService = this.linkService;
            var link = document.createElement("a");
            link.setAttribute("data-element-id", data.id);
            var isBound = false;
            if (data.url) {
              linkService.addLinkAttributes(link, data.url, data.newWindow);
              isBound = true;
            } else if (data.action) {
              this._bindNamedAction(link, data.action);
              isBound = true;
            } else if (data.attachment) {
              this._bindAttachment(link, data.attachment);
              isBound = true;
            } else if (data.setOCGState) {
              _classPrivateFieldLooseBase(this, _bindSetOCGState)[_bindSetOCGState](link, data.setOCGState);
              isBound = true;
            } else if (data.dest) {
              this._bindLink(link, data.dest);
              isBound = true;
            } else {
              if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                this._bindJSAction(link, data);
                isBound = true;
              }
              if (data.resetForm) {
                this._bindResetFormAction(link, data.resetForm);
                isBound = true;
              } else if (this.isTooltipOnly && !isBound) {
                this._bindLink(link, "");
                isBound = true;
              }
            }
            if (this.quadrilaterals) {
              return this._renderQuadrilaterals("linkAnnotation").map(function (quadrilateral, index) {
                var linkElement = index === 0 ? link : link.cloneNode();
                quadrilateral.append(linkElement);
                return quadrilateral;
              });
            }
            this.container.className = "linkAnnotation";
            if (isBound) {
              this.container.append(link);
            }
            return this.container;
          }
        }, {
          key: "_bindLink",
          value: function _bindLink(link, destination) {
            var _this60 = this;
            link.href = this.linkService.getDestinationHash(destination);
            link.onclick = function () {
              if (destination) {
                _this60.linkService.goToDestination(destination);
              }
              return false;
            };
            if (destination || destination === "") {
              _classPrivateFieldLooseBase(this, _setInternalLink)[_setInternalLink]();
            }
          }
        }, {
          key: "_bindNamedAction",
          value: function _bindNamedAction(link, action) {
            var _this61 = this;
            link.href = this.linkService.getAnchorUrl("");
            link.onclick = function () {
              _this61.linkService.executeNamedAction(action);
              return false;
            };
            _classPrivateFieldLooseBase(this, _setInternalLink)[_setInternalLink]();
          }
        }, {
          key: "_bindAttachment",
          value: function _bindAttachment(link, attachment) {
            var _this62 = this;
            link.href = this.linkService.getAnchorUrl("");
            link.onclick = function () {
              var _this62$downloadManag;
              (_this62$downloadManag = _this62.downloadManager) === null || _this62$downloadManag === void 0 || _this62$downloadManag.openOrDownloadData(_this62.container, attachment.content, attachment.filename);
              return false;
            };
            _classPrivateFieldLooseBase(this, _setInternalLink)[_setInternalLink]();
          }
        }, {
          key: "_bindJSAction",
          value: function _bindJSAction(link, data) {
            var _this63 = this;
            link.href = this.linkService.getAnchorUrl("");
            var map = new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
            var _loop = function _loop() {
              var name = _Object$keys2[_i1];
              var jsName = map.get(name);
              if (!jsName) {
                return 1; // continue
              }
              link[jsName] = function () {
                var _this63$linkService$e;
                (_this63$linkService$e = _this63.linkService.eventBus) === null || _this63$linkService$e === void 0 || _this63$linkService$e.dispatch("dispatcheventinsandbox", {
                  source: _this63,
                  detail: {
                    id: data.id,
                    name: name
                  }
                });
                return false;
              };
            };
            for (var _i1 = 0, _Object$keys2 = Object.keys(data.actions); _i1 < _Object$keys2.length; _i1++) {
              if (_loop()) continue;
            }
            if (!link.onclick) {
              link.onclick = function () {
                return false;
              };
            }
            _classPrivateFieldLooseBase(this, _setInternalLink)[_setInternalLink]();
          }
        }, {
          key: "_bindResetFormAction",
          value: function _bindResetFormAction(link, resetForm) {
            var _this64 = this;
            var otherClickAction = link.onclick;
            if (!otherClickAction) {
              link.href = this.linkService.getAnchorUrl("");
            }
            _classPrivateFieldLooseBase(this, _setInternalLink)[_setInternalLink]();
            if (!this._fieldObjects) {
              (0, _util.warn)("_bindResetFormAction - \"resetForm\" action not supported, " + "ensure that the `fieldObjects` parameter is provided.");
              if (!otherClickAction) {
                link.onclick = function () {
                  return false;
                };
              }
              return;
            }
            link.onclick = function () {
              otherClickAction === null || otherClickAction === void 0 || otherClickAction();
              var resetFormFields = resetForm.fields,
                resetFormRefs = resetForm.refs,
                include = resetForm.include;
              var allFields = [];
              if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                var fieldIds = new Set(resetFormRefs);
                var _iterator99 = _createForOfIteratorHelper(resetFormFields),
                  _step99;
                try {
                  for (_iterator99.s(); !(_step99 = _iterator99.n()).done;) {
                    var fieldName = _step99.value;
                    var _fields = _this64._fieldObjects[fieldName] || [];
                    var _iterator101 = _createForOfIteratorHelper(_fields),
                      _step101;
                    try {
                      for (_iterator101.s(); !(_step101 = _iterator101.n()).done;) {
                        var _ref95 = _step101.value;
                        var _id0 = _ref95.id;
                        fieldIds.add(_id0);
                      }
                    } catch (err) {
                      _iterator101.e(err);
                    } finally {
                      _iterator101.f();
                    }
                  }
                } catch (err) {
                  _iterator99.e(err);
                } finally {
                  _iterator99.f();
                }
                for (var _i10 = 0, _Object$values = Object.values(_this64._fieldObjects); _i10 < _Object$values.length; _i10++) {
                  var fields = _Object$values[_i10];
                  var _iterator100 = _createForOfIteratorHelper(fields),
                    _step100;
                  try {
                    for (_iterator100.s(); !(_step100 = _iterator100.n()).done;) {
                      var field = _step100.value;
                      if (fieldIds.has(field.id) === include) {
                        allFields.push(field);
                      }
                    }
                  } catch (err) {
                    _iterator100.e(err);
                  } finally {
                    _iterator100.f();
                  }
                }
              } else {
                for (var _i11 = 0, _Object$values2 = Object.values(_this64._fieldObjects); _i11 < _Object$values2.length; _i11++) {
                  var _fields2 = _Object$values2[_i11];
                  allFields.push.apply(allFields, _toConsumableArray(_fields2));
                }
              }
              var storage = _this64.annotationStorage;
              var allIds = [];
              for (var _i12 = 0, _allFields = allFields; _i12 < _allFields.length; _i12++) {
                var _field = _allFields[_i12];
                var _id1 = _field.id;
                allIds.push(_id1);
                switch (_field.type) {
                  case "text":
                    {
                      var value = _field.defaultValue || "";
                      storage.setValue(_id1, {
                        value: value
                      });
                      break;
                    }
                  case "checkbox":
                  case "radiobutton":
                    {
                      var _value = _field.defaultValue === _field.exportValues;
                      storage.setValue(_id1, {
                        value: _value
                      });
                      break;
                    }
                  case "combobox":
                  case "listbox":
                    {
                      var _value2 = _field.defaultValue || "";
                      storage.setValue(_id1, {
                        value: _value2
                      });
                      break;
                    }
                  default:
                    continue;
                }
                var domElement = document.querySelector("[data-element-id=\"".concat(_id1, "\"]"));
                if (!domElement) {
                  continue;
                } else if (!GetElementsByNameSet.has(domElement)) {
                  (0, _util.warn)("_bindResetFormAction - element not allowed: ".concat(_id1));
                  continue;
                }
                domElement.dispatchEvent(new Event("resetform"));
              }
              if (_this64.enableScripting) {
                var _this64$linkService$e;
                (_this64$linkService$e = _this64.linkService.eventBus) === null || _this64$linkService$e === void 0 || _this64$linkService$e.dispatch("dispatcheventinsandbox", {
                  source: _this64,
                  detail: {
                    id: "app",
                    ids: allIds,
                    name: "ResetForm"
                  }
                });
              }
              return false;
            };
          }
        }]);
      }(AnnotationElement);
      function _setInternalLink2() {
        this.container.setAttribute("data-internal-link", "");
      }
      function _bindSetOCGState2(link, action) {
        var _this76 = this;
        link.href = this.linkService.getAnchorUrl("");
        link.onclick = function () {
          _this76.linkService.executeSetOCGState(action);
          return false;
        };
        _classPrivateFieldLooseBase(this, _setInternalLink)[_setInternalLink]();
      }
      var TextAnnotationElement = /*#__PURE__*/function (_AnnotationElement2) {
        function TextAnnotationElement(parameters) {
          var _parameters$data$titl, _parameters$data$cont, _parameters$data$rich;
          _classCallCheck(this, TextAnnotationElement);
          var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl = parameters.data.titleObj) !== null && _parameters$data$titl !== void 0 && _parameters$data$titl.str || (_parameters$data$cont = parameters.data.contentsObj) !== null && _parameters$data$cont !== void 0 && _parameters$data$cont.str || (_parameters$data$rich = parameters.data.richText) !== null && _parameters$data$rich !== void 0 && _parameters$data$rich.str);
          return _callSuper(this, TextAnnotationElement, [parameters, {
            isRenderable: isRenderable
          }]);
        }
        _inherits(TextAnnotationElement, _AnnotationElement2);
        return _createClass(TextAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "textAnnotation";
            var image = document.createElement("img");
            image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
            image.alt = "[{{type}} Annotation]";
            image.dataset.l10nId = "text_annotation_type";
            image.dataset.l10nArgs = JSON.stringify({
              type: this.data.name
            });
            if (!this.data.hasPopup) {
              this._createPopup(image, this.data);
            }
            this.container.append(image);
            return this.container;
          }
        }]);
      }(AnnotationElement);
      var WidgetAnnotationElement = /*#__PURE__*/function (_AnnotationElement3) {
        function WidgetAnnotationElement() {
          _classCallCheck(this, WidgetAnnotationElement);
          return _callSuper(this, WidgetAnnotationElement, arguments);
        }
        _inherits(WidgetAnnotationElement, _AnnotationElement3);
        return _createClass(WidgetAnnotationElement, [{
          key: "render",
          value: function render() {
            if (this.data.alternativeText) {
              this.container.title = this.data.alternativeText;
            }
            return this.container;
          }
        }, {
          key: "_getKeyModifier",
          value: function _getKeyModifier(event) {
            var _util$FeatureTest$pla = _util.FeatureTest.platform,
              isWin = _util$FeatureTest$pla.isWin,
              isMac = _util$FeatureTest$pla.isMac;
            return isWin && event.ctrlKey || isMac && event.metaKey;
          }
        }, {
          key: "_setEventListener",
          value: function _setEventListener(element, baseName, eventName, valueGetter) {
            var _this65 = this;
            if (baseName.includes("mouse")) {
              element.addEventListener(baseName, function (event) {
                var _this65$linkService$e;
                (_this65$linkService$e = _this65.linkService.eventBus) === null || _this65$linkService$e === void 0 || _this65$linkService$e.dispatch("dispatcheventinsandbox", {
                  source: _this65,
                  detail: {
                    id: _this65.data.id,
                    name: eventName,
                    value: valueGetter(event),
                    shift: event.shiftKey,
                    modifier: _this65._getKeyModifier(event)
                  }
                });
              });
            } else {
              element.addEventListener(baseName, function (event) {
                var _this65$linkService$e2;
                (_this65$linkService$e2 = _this65.linkService.eventBus) === null || _this65$linkService$e2 === void 0 || _this65$linkService$e2.dispatch("dispatcheventinsandbox", {
                  source: _this65,
                  detail: {
                    id: _this65.data.id,
                    name: eventName,
                    value: valueGetter(event)
                  }
                });
              });
            }
          }
        }, {
          key: "_setEventListeners",
          value: function _setEventListeners(element, names, getter) {
            var _iterator102 = _createForOfIteratorHelper(names),
              _step102;
            try {
              for (_iterator102.s(); !(_step102 = _iterator102.n()).done;) {
                var _this$data$actions;
                var _ref96 = _step102.value;
                var _ref97 = _slicedToArray(_ref96, 2);
                var baseName = _ref97[0];
                var eventName = _ref97[1];
                if (eventName === "Action" || (_this$data$actions = this.data.actions) !== null && _this$data$actions !== void 0 && _this$data$actions[eventName]) {
                  this._setEventListener(element, baseName, eventName, getter);
                }
              }
            } catch (err) {
              _iterator102.e(err);
            } finally {
              _iterator102.f();
            }
          }
        }, {
          key: "_setBackgroundColor",
          value: function _setBackgroundColor(element) {
            var color = this.data.backgroundColor || null;
            element.style.backgroundColor = color === null ? "transparent" : _util.Util.makeHexColor(color[0], color[1], color[2]);
          }
        }, {
          key: "_setTextStyle",
          value: function _setTextStyle(element) {
            var TEXT_ALIGNMENT = ["left", "center", "right"];
            var fontColor = this.data.defaultAppearanceData.fontColor;
            var fontSize = this.data.defaultAppearanceData.fontSize || DEFAULT_FONT_SIZE;
            var style = element.style;
            var computedFontSize;
            var BORDER_SIZE = 2;
            var roundToOneDecimal = function roundToOneDecimal(x) {
              return Math.round(10 * x) / 10;
            };
            if (this.data.multiLine) {
              var height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
              var numberOfLines = Math.round(height / (_util.LINE_FACTOR * fontSize)) || 1;
              var lineHeight = height / numberOfLines;
              computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / _util.LINE_FACTOR));
            } else {
              var _height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
              computedFontSize = Math.min(fontSize, roundToOneDecimal(_height / _util.LINE_FACTOR));
            }
            style.fontSize = "calc(".concat(computedFontSize, "px * var(--scale-factor))");
            style.color = _util.Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
            if (this.data.textAlignment !== null) {
              style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
            }
          }
        }, {
          key: "_setRequired",
          value: function _setRequired(element, isRequired) {
            if (isRequired) {
              element.setAttribute("required", true);
            } else {
              element.removeAttribute("required");
            }
            element.setAttribute("aria-required", isRequired);
          }
        }]);
      }(AnnotationElement);
      var TextWidgetAnnotationElement = /*#__PURE__*/function (_WidgetAnnotationElem) {
        function TextWidgetAnnotationElement(parameters) {
          _classCallCheck(this, TextWidgetAnnotationElement);
          var isRenderable = parameters.renderForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
          return _callSuper(this, TextWidgetAnnotationElement, [parameters, {
            isRenderable: isRenderable
          }]);
        }
        _inherits(TextWidgetAnnotationElement, _WidgetAnnotationElem);
        return _createClass(TextWidgetAnnotationElement, [{
          key: "setPropertyOnSiblings",
          value: function setPropertyOnSiblings(base, key, value, keyInStorage) {
            var storage = this.annotationStorage;
            var _iterator103 = _createForOfIteratorHelper(this._getElementsByName(base.name, base.id)),
              _step103;
            try {
              for (_iterator103.s(); !(_step103 = _iterator103.n()).done;) {
                var element = _step103.value;
                if (element.domElement) {
                  element.domElement[key] = value;
                }
                storage.setValue(element.id, _defineProperty({}, keyInStorage, value));
              }
            } catch (err) {
              _iterator103.e(err);
            } finally {
              _iterator103.f();
            }
          }
        }, {
          key: "render",
          value: function render() {
            var _this66 = this;
            var storage = this.annotationStorage;
            var id = this.data.id;
            this.container.className = "textWidgetAnnotation";
            var element = null;
            if (this.renderForms) {
              var storedData = storage.getValue(id, {
                value: this.data.fieldValue
              });
              var textContent = storedData.formattedValue || storedData.value || "";
              var maxLen = storage.getValue(id, {
                charLimit: this.data.maxLen
              }).charLimit;
              if (maxLen && textContent.length > maxLen) {
                textContent = textContent.slice(0, maxLen);
              }
              var elementData = {
                userValue: textContent,
                formattedValue: null,
                lastCommittedValue: null,
                commitKey: 1
              };
              if (this.data.multiLine) {
                element = document.createElement("textarea");
                element.textContent = textContent;
                if (this.data.doNotScroll) {
                  element.style.overflowY = "hidden";
                }
              } else {
                element = document.createElement("input");
                element.type = "text";
                element.setAttribute("value", textContent);
                if (this.data.doNotScroll) {
                  element.style.overflowX = "hidden";
                }
              }
              GetElementsByNameSet.add(element);
              element.setAttribute("data-element-id", id);
              element.disabled = this.data.readOnly;
              element.name = this.data.fieldName;
              element.tabIndex = DEFAULT_TAB_INDEX;
              this._setRequired(element, this.data.required);
              if (maxLen) {
                element.maxLength = maxLen;
              }
              element.addEventListener("input", function (event) {
                storage.setValue(id, {
                  value: event.target.value
                });
                _this66.setPropertyOnSiblings(element, "value", event.target.value, "value");
              });
              element.addEventListener("resetform", function (event) {
                var _this66$data$defaultF;
                var defaultValue = (_this66$data$defaultF = _this66.data.defaultFieldValue) !== null && _this66$data$defaultF !== void 0 ? _this66$data$defaultF : "";
                element.value = elementData.userValue = defaultValue;
                elementData.formattedValue = null;
              });
              var blurListener = function blurListener(event) {
                var formattedValue = elementData.formattedValue;
                if (formattedValue !== null && formattedValue !== undefined) {
                  event.target.value = formattedValue;
                }
                event.target.scrollLeft = 0;
              };
              if (this.enableScripting && this.hasJSActions) {
                var _this$data$actions2;
                element.addEventListener("focus", function (event) {
                  var target = event.target;
                  if (elementData.userValue) {
                    target.value = elementData.userValue;
                  }
                  elementData.lastCommittedValue = target.value;
                  elementData.commitKey = 1;
                });
                element.addEventListener("updatefromsandbox", function (jsEvent) {
                  var actions = {
                    value: function value(event) {
                      var _event$detail$value;
                      elementData.userValue = (_event$detail$value = event.detail.value) !== null && _event$detail$value !== void 0 ? _event$detail$value : "";
                      storage.setValue(id, {
                        value: elementData.userValue.toString()
                      });
                      event.target.value = elementData.userValue;
                    },
                    formattedValue: function formattedValue(event) {
                      var formattedValue = event.detail.formattedValue;
                      elementData.formattedValue = formattedValue;
                      if (formattedValue !== null && formattedValue !== undefined && event.target !== document.activeElement) {
                        event.target.value = formattedValue;
                      }
                      storage.setValue(id, {
                        formattedValue: formattedValue
                      });
                    },
                    selRange: function selRange(event) {
                      var _event$target;
                      (_event$target = event.target).setSelectionRange.apply(_event$target, _toConsumableArray(event.detail.selRange));
                    },
                    charLimit: function charLimit(event) {
                      var _this66$linkService$e;
                      var charLimit = event.detail.charLimit;
                      var target = event.target;
                      if (charLimit === 0) {
                        target.removeAttribute("maxLength");
                        return;
                      }
                      target.setAttribute("maxLength", charLimit);
                      var value = elementData.userValue;
                      if (!value || value.length <= charLimit) {
                        return;
                      }
                      value = value.slice(0, charLimit);
                      target.value = elementData.userValue = value;
                      storage.setValue(id, {
                        value: value
                      });
                      (_this66$linkService$e = _this66.linkService.eventBus) === null || _this66$linkService$e === void 0 || _this66$linkService$e.dispatch("dispatcheventinsandbox", {
                        source: _this66,
                        detail: {
                          id: id,
                          name: "Keystroke",
                          value: value,
                          willCommit: true,
                          commitKey: 1,
                          selStart: target.selectionStart,
                          selEnd: target.selectionEnd
                        }
                      });
                    }
                  };
                  _this66._dispatchEventFromSandbox(actions, jsEvent);
                });
                element.addEventListener("keydown", function (event) {
                  var _this66$linkService$e2;
                  elementData.commitKey = 1;
                  var commitKey = -1;
                  if (event.key === "Escape") {
                    commitKey = 0;
                  } else if (event.key === "Enter" && !_this66.data.multiLine) {
                    commitKey = 2;
                  } else if (event.key === "Tab") {
                    elementData.commitKey = 3;
                  }
                  if (commitKey === -1) {
                    return;
                  }
                  var value = event.target.value;
                  if (elementData.lastCommittedValue === value) {
                    return;
                  }
                  elementData.lastCommittedValue = value;
                  elementData.userValue = value;
                  (_this66$linkService$e2 = _this66.linkService.eventBus) === null || _this66$linkService$e2 === void 0 || _this66$linkService$e2.dispatch("dispatcheventinsandbox", {
                    source: _this66,
                    detail: {
                      id: id,
                      name: "Keystroke",
                      value: value,
                      willCommit: true,
                      commitKey: commitKey,
                      selStart: event.target.selectionStart,
                      selEnd: event.target.selectionEnd
                    }
                  });
                });
                var _blurListener = blurListener;
                blurListener = null;
                element.addEventListener("blur", function (event) {
                  if (!event.relatedTarget) {
                    return;
                  }
                  var value = event.target.value;
                  elementData.userValue = value;
                  if (elementData.lastCommittedValue !== value) {
                    var _this66$linkService$e3;
                    (_this66$linkService$e3 = _this66.linkService.eventBus) === null || _this66$linkService$e3 === void 0 || _this66$linkService$e3.dispatch("dispatcheventinsandbox", {
                      source: _this66,
                      detail: {
                        id: id,
                        name: "Keystroke",
                        value: value,
                        willCommit: true,
                        commitKey: elementData.commitKey,
                        selStart: event.target.selectionStart,
                        selEnd: event.target.selectionEnd
                      }
                    });
                  }
                  _blurListener(event);
                });
                if ((_this$data$actions2 = this.data.actions) !== null && _this$data$actions2 !== void 0 && _this$data$actions2.Keystroke) {
                  element.addEventListener("beforeinput", function (event) {
                    var _this66$linkService$e4;
                    elementData.lastCommittedValue = null;
                    var data = event.data,
                      target = event.target;
                    var value = target.value,
                      selectionStart = target.selectionStart,
                      selectionEnd = target.selectionEnd;
                    var selStart = selectionStart,
                      selEnd = selectionEnd;
                    switch (event.inputType) {
                      case "deleteWordBackward":
                        {
                          var match = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                          if (match) {
                            selStart -= match[0].length;
                          }
                          break;
                        }
                      case "deleteWordForward":
                        {
                          var _match3 = value.substring(selectionStart).match(/^[^\w]*\w*/);
                          if (_match3) {
                            selEnd += _match3[0].length;
                          }
                          break;
                        }
                      case "deleteContentBackward":
                        if (selectionStart === selectionEnd) {
                          selStart -= 1;
                        }
                        break;
                      case "deleteContentForward":
                        if (selectionStart === selectionEnd) {
                          selEnd += 1;
                        }
                        break;
                    }
                    event.preventDefault();
                    (_this66$linkService$e4 = _this66.linkService.eventBus) === null || _this66$linkService$e4 === void 0 || _this66$linkService$e4.dispatch("dispatcheventinsandbox", {
                      source: _this66,
                      detail: {
                        id: id,
                        name: "Keystroke",
                        value: value,
                        change: data || "",
                        willCommit: false,
                        selStart: selStart,
                        selEnd: selEnd
                      }
                    });
                  });
                }
                this._setEventListeners(element, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], function (event) {
                  return event.target.value;
                });
              }
              if (blurListener) {
                element.addEventListener("blur", blurListener);
              }
              if (this.data.comb) {
                var fieldWidth = this.data.rect[2] - this.data.rect[0];
                var combWidth = fieldWidth / maxLen;
                element.classList.add("comb");
                element.style.letterSpacing = "calc(".concat(combWidth, "px * var(--scale-factor) - 1ch)");
              }
            } else {
              element = document.createElement("div");
              element.textContent = this.data.fieldValue;
              element.style.verticalAlign = "middle";
              element.style.display = "table-cell";
            }
            this._setTextStyle(element);
            this._setBackgroundColor(element);
            this._setDefaultPropertiesFromJS(element);
            this.container.append(element);
            return this.container;
          }
        }]);
      }(WidgetAnnotationElement);
      var CheckboxWidgetAnnotationElement = /*#__PURE__*/function (_WidgetAnnotationElem2) {
        function CheckboxWidgetAnnotationElement(parameters) {
          _classCallCheck(this, CheckboxWidgetAnnotationElement);
          return _callSuper(this, CheckboxWidgetAnnotationElement, [parameters, {
            isRenderable: parameters.renderForms
          }]);
        }
        _inherits(CheckboxWidgetAnnotationElement, _WidgetAnnotationElem2);
        return _createClass(CheckboxWidgetAnnotationElement, [{
          key: "render",
          value: function render() {
            var _this67 = this;
            var storage = this.annotationStorage;
            var data = this.data;
            var id = data.id;
            var value = storage.getValue(id, {
              value: data.exportValue === data.fieldValue
            }).value;
            if (typeof value === "string") {
              value = value !== "Off";
              storage.setValue(id, {
                value: value
              });
            }
            this.container.className = "buttonWidgetAnnotation checkBox";
            var element = document.createElement("input");
            GetElementsByNameSet.add(element);
            element.setAttribute("data-element-id", id);
            element.disabled = data.readOnly;
            this._setRequired(element, this.data.required);
            element.type = "checkbox";
            element.name = data.fieldName;
            if (value) {
              element.setAttribute("checked", true);
            }
            element.setAttribute("exportValue", data.exportValue);
            element.tabIndex = DEFAULT_TAB_INDEX;
            element.addEventListener("change", function (event) {
              var _event$target2 = event.target,
                name = _event$target2.name,
                checked = _event$target2.checked;
              var _iterator104 = _createForOfIteratorHelper(_this67._getElementsByName(name, id)),
                _step104;
              try {
                for (_iterator104.s(); !(_step104 = _iterator104.n()).done;) {
                  var checkbox = _step104.value;
                  var curChecked = checked && checkbox.exportValue === data.exportValue;
                  if (checkbox.domElement) {
                    checkbox.domElement.checked = curChecked;
                  }
                  storage.setValue(checkbox.id, {
                    value: curChecked
                  });
                }
              } catch (err) {
                _iterator104.e(err);
              } finally {
                _iterator104.f();
              }
              storage.setValue(id, {
                value: checked
              });
            });
            element.addEventListener("resetform", function (event) {
              var defaultValue = data.defaultFieldValue || "Off";
              event.target.checked = defaultValue === data.exportValue;
            });
            if (this.enableScripting && this.hasJSActions) {
              element.addEventListener("updatefromsandbox", function (jsEvent) {
                var actions = {
                  value: function value(event) {
                    event.target.checked = event.detail.value !== "Off";
                    storage.setValue(id, {
                      value: event.target.checked
                    });
                  }
                };
                _this67._dispatchEventFromSandbox(actions, jsEvent);
              });
              this._setEventListeners(element, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], function (event) {
                return event.target.checked;
              });
            }
            this._setBackgroundColor(element);
            this._setDefaultPropertiesFromJS(element);
            this.container.append(element);
            return this.container;
          }
        }]);
      }(WidgetAnnotationElement);
      var RadioButtonWidgetAnnotationElement = /*#__PURE__*/function (_WidgetAnnotationElem3) {
        function RadioButtonWidgetAnnotationElement(parameters) {
          _classCallCheck(this, RadioButtonWidgetAnnotationElement);
          return _callSuper(this, RadioButtonWidgetAnnotationElement, [parameters, {
            isRenderable: parameters.renderForms
          }]);
        }
        _inherits(RadioButtonWidgetAnnotationElement, _WidgetAnnotationElem3);
        return _createClass(RadioButtonWidgetAnnotationElement, [{
          key: "render",
          value: function render() {
            var _this68 = this;
            this.container.className = "buttonWidgetAnnotation radioButton";
            var storage = this.annotationStorage;
            var data = this.data;
            var id = data.id;
            var value = storage.getValue(id, {
              value: data.fieldValue === data.buttonValue
            }).value;
            if (typeof value === "string") {
              value = value !== data.buttonValue;
              storage.setValue(id, {
                value: value
              });
            }
            var element = document.createElement("input");
            GetElementsByNameSet.add(element);
            element.setAttribute("data-element-id", id);
            element.disabled = data.readOnly;
            this._setRequired(element, this.data.required);
            element.type = "radio";
            element.name = data.fieldName;
            if (value) {
              element.setAttribute("checked", true);
            }
            element.tabIndex = DEFAULT_TAB_INDEX;
            element.addEventListener("change", function (event) {
              var _event$target3 = event.target,
                name = _event$target3.name,
                checked = _event$target3.checked;
              var _iterator105 = _createForOfIteratorHelper(_this68._getElementsByName(name, id)),
                _step105;
              try {
                for (_iterator105.s(); !(_step105 = _iterator105.n()).done;) {
                  var radio = _step105.value;
                  storage.setValue(radio.id, {
                    value: false
                  });
                }
              } catch (err) {
                _iterator105.e(err);
              } finally {
                _iterator105.f();
              }
              storage.setValue(id, {
                value: checked
              });
            });
            element.addEventListener("resetform", function (event) {
              var defaultValue = data.defaultFieldValue;
              event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
            });
            if (this.enableScripting && this.hasJSActions) {
              var pdfButtonValue = data.buttonValue;
              element.addEventListener("updatefromsandbox", function (jsEvent) {
                var actions = {
                  value: function value(event) {
                    var checked = pdfButtonValue === event.detail.value;
                    var _iterator106 = _createForOfIteratorHelper(_this68._getElementsByName(event.target.name)),
                      _step106;
                    try {
                      for (_iterator106.s(); !(_step106 = _iterator106.n()).done;) {
                        var radio = _step106.value;
                        var curChecked = checked && radio.id === id;
                        if (radio.domElement) {
                          radio.domElement.checked = curChecked;
                        }
                        storage.setValue(radio.id, {
                          value: curChecked
                        });
                      }
                    } catch (err) {
                      _iterator106.e(err);
                    } finally {
                      _iterator106.f();
                    }
                  }
                };
                _this68._dispatchEventFromSandbox(actions, jsEvent);
              });
              this._setEventListeners(element, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], function (event) {
                return event.target.checked;
              });
            }
            this._setBackgroundColor(element);
            this._setDefaultPropertiesFromJS(element);
            this.container.append(element);
            return this.container;
          }
        }]);
      }(WidgetAnnotationElement);
      var PushButtonWidgetAnnotationElement = /*#__PURE__*/function (_LinkAnnotationElemen) {
        function PushButtonWidgetAnnotationElement(parameters) {
          _classCallCheck(this, PushButtonWidgetAnnotationElement);
          return _callSuper(this, PushButtonWidgetAnnotationElement, [parameters, {
            ignoreBorder: parameters.data.hasAppearance
          }]);
        }
        _inherits(PushButtonWidgetAnnotationElement, _LinkAnnotationElemen);
        return _createClass(PushButtonWidgetAnnotationElement, [{
          key: "render",
          value: function render() {
            var _this69 = this;
            var container = _superPropGet(PushButtonWidgetAnnotationElement, "render", this, 3)([]);
            container.className = "buttonWidgetAnnotation pushButton";
            if (this.data.alternativeText) {
              container.title = this.data.alternativeText;
            }
            var linkElement = container.lastChild;
            if (this.enableScripting && this.hasJSActions && linkElement) {
              this._setDefaultPropertiesFromJS(linkElement);
              linkElement.addEventListener("updatefromsandbox", function (jsEvent) {
                _this69._dispatchEventFromSandbox({}, jsEvent);
              });
            }
            return container;
          }
        }]);
      }(LinkAnnotationElement);
      var ChoiceWidgetAnnotationElement = /*#__PURE__*/function (_WidgetAnnotationElem4) {
        function ChoiceWidgetAnnotationElement(parameters) {
          _classCallCheck(this, ChoiceWidgetAnnotationElement);
          return _callSuper(this, ChoiceWidgetAnnotationElement, [parameters, {
            isRenderable: parameters.renderForms
          }]);
        }
        _inherits(ChoiceWidgetAnnotationElement, _WidgetAnnotationElem4);
        return _createClass(ChoiceWidgetAnnotationElement, [{
          key: "render",
          value: function render() {
            var _this70 = this;
            this.container.className = "choiceWidgetAnnotation";
            var storage = this.annotationStorage;
            var id = this.data.id;
            var storedData = storage.getValue(id, {
              value: this.data.fieldValue
            });
            var selectElement = document.createElement("select");
            GetElementsByNameSet.add(selectElement);
            selectElement.setAttribute("data-element-id", id);
            selectElement.disabled = this.data.readOnly;
            this._setRequired(selectElement, this.data.required);
            selectElement.name = this.data.fieldName;
            selectElement.tabIndex = DEFAULT_TAB_INDEX;
            var addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
            if (!this.data.combo) {
              selectElement.size = this.data.options.length;
              if (this.data.multiSelect) {
                selectElement.multiple = true;
              }
            }
            selectElement.addEventListener("resetform", function (event) {
              var defaultValue = _this70.data.defaultFieldValue;
              var _iterator107 = _createForOfIteratorHelper(selectElement.options),
                _step107;
              try {
                for (_iterator107.s(); !(_step107 = _iterator107.n()).done;) {
                  var option = _step107.value;
                  option.selected = option.value === defaultValue;
                }
              } catch (err) {
                _iterator107.e(err);
              } finally {
                _iterator107.f();
              }
            });
            var _iterator108 = _createForOfIteratorHelper(this.data.options),
              _step108;
            try {
              for (_iterator108.s(); !(_step108 = _iterator108.n()).done;) {
                var option = _step108.value;
                var optionElement = document.createElement("option");
                optionElement.textContent = option.displayValue;
                optionElement.value = option.exportValue;
                if (storedData.value.includes(option.exportValue)) {
                  optionElement.setAttribute("selected", true);
                  addAnEmptyEntry = false;
                }
                selectElement.append(optionElement);
              }
            } catch (err) {
              _iterator108.e(err);
            } finally {
              _iterator108.f();
            }
            var _removeEmptyEntry = null;
            if (addAnEmptyEntry) {
              var noneOptionElement = document.createElement("option");
              noneOptionElement.value = " ";
              noneOptionElement.setAttribute("hidden", true);
              noneOptionElement.setAttribute("selected", true);
              selectElement.prepend(noneOptionElement);
              _removeEmptyEntry = function removeEmptyEntry() {
                noneOptionElement.remove();
                selectElement.removeEventListener("input", _removeEmptyEntry);
                _removeEmptyEntry = null;
              };
              selectElement.addEventListener("input", _removeEmptyEntry);
            }
            var getValue = function getValue(isExport) {
              var name = isExport ? "value" : "textContent";
              var options = selectElement.options,
                multiple = selectElement.multiple;
              if (!multiple) {
                return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
              }
              return Array.prototype.filter.call(options, function (option) {
                return option.selected;
              }).map(function (option) {
                return option[name];
              });
            };
            var selectedValues = getValue(false);
            var getItems = function getItems(event) {
              var options = event.target.options;
              return Array.prototype.map.call(options, function (option) {
                return {
                  displayValue: option.textContent,
                  exportValue: option.value
                };
              });
            };
            if (this.enableScripting && this.hasJSActions) {
              selectElement.addEventListener("updatefromsandbox", function (jsEvent) {
                var actions = {
                  value: function value(event) {
                    var _removeEmptyEntry2;
                    (_removeEmptyEntry2 = _removeEmptyEntry) === null || _removeEmptyEntry2 === void 0 || _removeEmptyEntry2();
                    var value = event.detail.value;
                    var values = new Set(Array.isArray(value) ? value : [value]);
                    var _iterator109 = _createForOfIteratorHelper(selectElement.options),
                      _step109;
                    try {
                      for (_iterator109.s(); !(_step109 = _iterator109.n()).done;) {
                        var option = _step109.value;
                        option.selected = values.has(option.value);
                      }
                    } catch (err) {
                      _iterator109.e(err);
                    } finally {
                      _iterator109.f();
                    }
                    storage.setValue(id, {
                      value: getValue(true)
                    });
                    selectedValues = getValue(false);
                  },
                  multipleSelection: function multipleSelection(event) {
                    selectElement.multiple = true;
                  },
                  remove: function remove(event) {
                    var options = selectElement.options;
                    var index = event.detail.remove;
                    options[index].selected = false;
                    selectElement.remove(index);
                    if (options.length > 0) {
                      var i = Array.prototype.findIndex.call(options, function (option) {
                        return option.selected;
                      });
                      if (i === -1) {
                        options[0].selected = true;
                      }
                    }
                    storage.setValue(id, {
                      value: getValue(true),
                      items: getItems(event)
                    });
                    selectedValues = getValue(false);
                  },
                  clear: function clear(event) {
                    while (selectElement.length !== 0) {
                      selectElement.remove(0);
                    }
                    storage.setValue(id, {
                      value: null,
                      items: []
                    });
                    selectedValues = getValue(false);
                  },
                  insert: function insert(event) {
                    var _event$detail$insert = event.detail.insert,
                      index = _event$detail$insert.index,
                      displayValue = _event$detail$insert.displayValue,
                      exportValue = _event$detail$insert.exportValue;
                    var selectChild = selectElement.children[index];
                    var optionElement = document.createElement("option");
                    optionElement.textContent = displayValue;
                    optionElement.value = exportValue;
                    if (selectChild) {
                      selectChild.before(optionElement);
                    } else {
                      selectElement.append(optionElement);
                    }
                    storage.setValue(id, {
                      value: getValue(true),
                      items: getItems(event)
                    });
                    selectedValues = getValue(false);
                  },
                  items: function items(event) {
                    var items = event.detail.items;
                    while (selectElement.length !== 0) {
                      selectElement.remove(0);
                    }
                    var _iterator110 = _createForOfIteratorHelper(items),
                      _step110;
                    try {
                      for (_iterator110.s(); !(_step110 = _iterator110.n()).done;) {
                        var item = _step110.value;
                        var displayValue = item.displayValue,
                          exportValue = item.exportValue;
                        var optionElement = document.createElement("option");
                        optionElement.textContent = displayValue;
                        optionElement.value = exportValue;
                        selectElement.append(optionElement);
                      }
                    } catch (err) {
                      _iterator110.e(err);
                    } finally {
                      _iterator110.f();
                    }
                    if (selectElement.options.length > 0) {
                      selectElement.options[0].selected = true;
                    }
                    storage.setValue(id, {
                      value: getValue(true),
                      items: getItems(event)
                    });
                    selectedValues = getValue(false);
                  },
                  indices: function indices(event) {
                    var indices = new Set(event.detail.indices);
                    var _iterator111 = _createForOfIteratorHelper(event.target.options),
                      _step111;
                    try {
                      for (_iterator111.s(); !(_step111 = _iterator111.n()).done;) {
                        var option = _step111.value;
                        option.selected = indices.has(option.index);
                      }
                    } catch (err) {
                      _iterator111.e(err);
                    } finally {
                      _iterator111.f();
                    }
                    storage.setValue(id, {
                      value: getValue(true)
                    });
                    selectedValues = getValue(false);
                  },
                  editable: function editable(event) {
                    event.target.disabled = !event.detail.editable;
                  }
                };
                _this70._dispatchEventFromSandbox(actions, jsEvent);
              });
              selectElement.addEventListener("input", function (event) {
                var _this70$linkService$e;
                var exportValue = getValue(true);
                storage.setValue(id, {
                  value: exportValue
                });
                event.preventDefault();
                (_this70$linkService$e = _this70.linkService.eventBus) === null || _this70$linkService$e === void 0 || _this70$linkService$e.dispatch("dispatcheventinsandbox", {
                  source: _this70,
                  detail: {
                    id: id,
                    name: "Keystroke",
                    value: selectedValues,
                    changeEx: exportValue,
                    willCommit: false,
                    commitKey: 1,
                    keyDown: false
                  }
                });
              });
              this._setEventListeners(selectElement, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"], ["input", "Validate"]], function (event) {
                return event.target.value;
              });
            } else {
              selectElement.addEventListener("input", function (event) {
                storage.setValue(id, {
                  value: getValue(true)
                });
              });
            }
            if (this.data.combo) {
              this._setTextStyle(selectElement);
            } else {}
            this._setBackgroundColor(selectElement);
            this._setDefaultPropertiesFromJS(selectElement);
            this.container.append(selectElement);
            return this.container;
          }
        }]);
      }(WidgetAnnotationElement);
      var PopupAnnotationElement = /*#__PURE__*/function (_AnnotationElement4) {
        function PopupAnnotationElement(parameters) {
          var _data$titleObj, _data$contentsObj, _data$richText;
          _classCallCheck(this, PopupAnnotationElement);
          var data = parameters.data;
          var isRenderable = !PopupAnnotationElement.IGNORE_TYPES.has(data.parentType) && !!((_data$titleObj = data.titleObj) !== null && _data$titleObj !== void 0 && _data$titleObj.str || (_data$contentsObj = data.contentsObj) !== null && _data$contentsObj !== void 0 && _data$contentsObj.str || (_data$richText = data.richText) !== null && _data$richText !== void 0 && _data$richText.str);
          return _callSuper(this, PopupAnnotationElement, [parameters, {
            isRenderable: isRenderable
          }]);
        }
        _inherits(PopupAnnotationElement, _AnnotationElement4);
        return _createClass(PopupAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "popupAnnotation";
            var parentElements = this.layer.querySelectorAll("[data-annotation-id=\"".concat(this.data.parentId, "\"]"));
            if (parentElements.length === 0) {
              return this.container;
            }
            var popup = new PopupElement({
              container: this.container,
              trigger: Array.from(parentElements),
              color: this.data.color,
              titleObj: this.data.titleObj,
              modificationDate: this.data.modificationDate,
              contentsObj: this.data.contentsObj,
              richText: this.data.richText
            });
            var page = this.page;
            var rect = _util.Util.normalizeRect([this.data.parentRect[0], page.view[3] - this.data.parentRect[1] + page.view[1], this.data.parentRect[2], page.view[3] - this.data.parentRect[3] + page.view[1]]);
            var popupLeft = rect[0] + this.data.parentRect[2] - this.data.parentRect[0];
            var popupTop = rect[1];
            var _this$viewport$rawDim3 = this.viewport.rawDims,
              pageWidth = _this$viewport$rawDim3.pageWidth,
              pageHeight = _this$viewport$rawDim3.pageHeight,
              pageX = _this$viewport$rawDim3.pageX,
              pageY = _this$viewport$rawDim3.pageY;
            this.container.style.left = "".concat(100 * (popupLeft - pageX) / pageWidth, "%");
            this.container.style.top = "".concat(100 * (popupTop - pageY) / pageHeight, "%");
            this.container.append(popup.render());
            return this.container;
          }
        }]);
      }(AnnotationElement);
      PopupAnnotationElement.IGNORE_TYPES = new Set(["Line", "Square", "Circle", "PolyLine", "Polygon", "Ink"]);
      var PopupElement = /*#__PURE__*/function () {
        function PopupElement(parameters) {
          _classCallCheck(this, PopupElement);
          this.container = parameters.container;
          this.trigger = parameters.trigger;
          this.color = parameters.color;
          this.titleObj = parameters.titleObj;
          this.modificationDate = parameters.modificationDate;
          this.contentsObj = parameters.contentsObj;
          this.richText = parameters.richText;
          this.hideWrapper = parameters.hideWrapper || false;
          this.pinned = false;
        }
        return _createClass(PopupElement, [{
          key: "render",
          value: function render() {
            var _this$richText, _this$contentsObj;
            var BACKGROUND_ENLIGHT = 0.7;
            var wrapper = document.createElement("div");
            wrapper.className = "popupWrapper";
            this.hideElement = this.hideWrapper ? wrapper : this.container;
            this.hideElement.hidden = true;
            var popup = document.createElement("div");
            popup.className = "popup";
            var color = this.color;
            if (color) {
              var r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
              var g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
              var b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
              popup.style.backgroundColor = _util.Util.makeHexColor(r | 0, g | 0, b | 0);
            }
            var title = document.createElement("h1");
            title.dir = this.titleObj.dir;
            title.textContent = this.titleObj.str;
            popup.append(title);
            var dateObject = _display_utils.PDFDateString.toDateObject(this.modificationDate);
            if (dateObject) {
              var modificationDate = document.createElement("span");
              modificationDate.className = "popupDate";
              modificationDate.textContent = "{{date}}, {{time}}";
              modificationDate.dataset.l10nId = "annotation_date_string";
              modificationDate.dataset.l10nArgs = JSON.stringify({
                date: dateObject.toLocaleDateString(),
                time: dateObject.toLocaleTimeString()
              });
              popup.append(modificationDate);
            }
            if ((_this$richText = this.richText) !== null && _this$richText !== void 0 && _this$richText.str && (!((_this$contentsObj = this.contentsObj) !== null && _this$contentsObj !== void 0 && _this$contentsObj.str) || this.contentsObj.str === this.richText.str)) {
              _xfa_layer.XfaLayer.render({
                xfaHtml: this.richText.html,
                intent: "richText",
                div: popup
              });
              popup.lastChild.className = "richText popupContent";
            } else {
              var contents = this._formatContents(this.contentsObj);
              popup.append(contents);
            }
            if (!Array.isArray(this.trigger)) {
              this.trigger = [this.trigger];
            }
            var _iterator112 = _createForOfIteratorHelper(this.trigger),
              _step112;
            try {
              for (_iterator112.s(); !(_step112 = _iterator112.n()).done;) {
                var element = _step112.value;
                element.addEventListener("click", this._toggle.bind(this));
                element.addEventListener("mouseover", this._show.bind(this, false));
                element.addEventListener("mouseout", this._hide.bind(this, false));
              }
            } catch (err) {
              _iterator112.e(err);
            } finally {
              _iterator112.f();
            }
            popup.addEventListener("click", this._hide.bind(this, true));
            wrapper.append(popup);
            return wrapper;
          }
        }, {
          key: "_formatContents",
          value: function _formatContents(_ref98) {
            var str = _ref98.str,
              dir = _ref98.dir;
            var p = document.createElement("p");
            p.className = "popupContent";
            p.dir = dir;
            var lines = str.split(/(?:\r\n?|\n)/);
            for (var i = 0, ii = lines.length; i < ii; ++i) {
              var line = lines[i];
              p.append(document.createTextNode(line));
              if (i < ii - 1) {
                p.append(document.createElement("br"));
              }
            }
            return p;
          }
        }, {
          key: "_toggle",
          value: function _toggle() {
            if (this.pinned) {
              this._hide(true);
            } else {
              this._show(true);
            }
          }
        }, {
          key: "_show",
          value: function _show() {
            var pin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            if (pin) {
              this.pinned = true;
            }
            if (this.hideElement.hidden) {
              this.hideElement.hidden = false;
              this.container.style.zIndex = parseInt(this.container.style.zIndex) + 1000;
            }
          }
        }, {
          key: "_hide",
          value: function _hide() {
            var unpin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            if (unpin) {
              this.pinned = false;
            }
            if (!this.hideElement.hidden && !this.pinned) {
              this.hideElement.hidden = true;
              this.container.style.zIndex = parseInt(this.container.style.zIndex) - 1000;
            }
          }
        }]);
      }();
      var FreeTextAnnotationElement = /*#__PURE__*/function (_AnnotationElement5) {
        function FreeTextAnnotationElement(parameters) {
          var _parameters$data$titl2, _parameters$data$cont2, _parameters$data$rich2;
          var _this71;
          _classCallCheck(this, FreeTextAnnotationElement);
          var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl2 = parameters.data.titleObj) !== null && _parameters$data$titl2 !== void 0 && _parameters$data$titl2.str || (_parameters$data$cont2 = parameters.data.contentsObj) !== null && _parameters$data$cont2 !== void 0 && _parameters$data$cont2.str || (_parameters$data$rich2 = parameters.data.richText) !== null && _parameters$data$rich2 !== void 0 && _parameters$data$rich2.str);
          _this71 = _callSuper(this, FreeTextAnnotationElement, [parameters, {
            isRenderable: isRenderable,
            ignoreBorder: true
          }]);
          _this71.textContent = parameters.data.textContent;
          return _this71;
        }
        _inherits(FreeTextAnnotationElement, _AnnotationElement5);
        return _createClass(FreeTextAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "freeTextAnnotation";
            if (this.textContent) {
              var content = document.createElement("div");
              content.className = "annotationTextContent";
              content.setAttribute("role", "comment");
              var _iterator113 = _createForOfIteratorHelper(this.textContent),
                _step113;
              try {
                for (_iterator113.s(); !(_step113 = _iterator113.n()).done;) {
                  var line = _step113.value;
                  var lineSpan = document.createElement("span");
                  lineSpan.textContent = line;
                  content.append(lineSpan);
                }
              } catch (err) {
                _iterator113.e(err);
              } finally {
                _iterator113.f();
              }
              this.container.append(content);
            }
            if (!this.data.hasPopup) {
              this._createPopup(null, this.data);
            }
            return this.container;
          }
        }]);
      }(AnnotationElement);
      var LineAnnotationElement = /*#__PURE__*/function (_AnnotationElement6) {
        function LineAnnotationElement(parameters) {
          var _parameters$data$titl3, _parameters$data$cont3, _parameters$data$rich3;
          _classCallCheck(this, LineAnnotationElement);
          var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl3 = parameters.data.titleObj) !== null && _parameters$data$titl3 !== void 0 && _parameters$data$titl3.str || (_parameters$data$cont3 = parameters.data.contentsObj) !== null && _parameters$data$cont3 !== void 0 && _parameters$data$cont3.str || (_parameters$data$rich3 = parameters.data.richText) !== null && _parameters$data$rich3 !== void 0 && _parameters$data$rich3.str);
          return _callSuper(this, LineAnnotationElement, [parameters, {
            isRenderable: isRenderable,
            ignoreBorder: true
          }]);
        }
        _inherits(LineAnnotationElement, _AnnotationElement6);
        return _createClass(LineAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "lineAnnotation";
            var data = this.data;
            var _getRectDims3 = getRectDims(data.rect),
              width = _getRectDims3.width,
              height = _getRectDims3.height;
            var svg = this.svgFactory.create(width, height, true);
            var line = this.svgFactory.createElement("svg:line");
            line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
            line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
            line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
            line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
            line.setAttribute("stroke-width", data.borderStyle.width || 1);
            line.setAttribute("stroke", "transparent");
            line.setAttribute("fill", "transparent");
            svg.append(line);
            this.container.append(svg);
            this._createPopup(line, data);
            return this.container;
          }
        }]);
      }(AnnotationElement);
      var SquareAnnotationElement = /*#__PURE__*/function (_AnnotationElement7) {
        function SquareAnnotationElement(parameters) {
          var _parameters$data$titl4, _parameters$data$cont4, _parameters$data$rich4;
          _classCallCheck(this, SquareAnnotationElement);
          var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl4 = parameters.data.titleObj) !== null && _parameters$data$titl4 !== void 0 && _parameters$data$titl4.str || (_parameters$data$cont4 = parameters.data.contentsObj) !== null && _parameters$data$cont4 !== void 0 && _parameters$data$cont4.str || (_parameters$data$rich4 = parameters.data.richText) !== null && _parameters$data$rich4 !== void 0 && _parameters$data$rich4.str);
          return _callSuper(this, SquareAnnotationElement, [parameters, {
            isRenderable: isRenderable,
            ignoreBorder: true
          }]);
        }
        _inherits(SquareAnnotationElement, _AnnotationElement7);
        return _createClass(SquareAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "squareAnnotation";
            var data = this.data;
            var _getRectDims4 = getRectDims(data.rect),
              width = _getRectDims4.width,
              height = _getRectDims4.height;
            var svg = this.svgFactory.create(width, height, true);
            var borderWidth = data.borderStyle.width;
            var square = this.svgFactory.createElement("svg:rect");
            square.setAttribute("x", borderWidth / 2);
            square.setAttribute("y", borderWidth / 2);
            square.setAttribute("width", width - borderWidth);
            square.setAttribute("height", height - borderWidth);
            square.setAttribute("stroke-width", borderWidth || 1);
            square.setAttribute("stroke", "transparent");
            square.setAttribute("fill", "transparent");
            svg.append(square);
            this.container.append(svg);
            this._createPopup(square, data);
            return this.container;
          }
        }]);
      }(AnnotationElement);
      var CircleAnnotationElement = /*#__PURE__*/function (_AnnotationElement8) {
        function CircleAnnotationElement(parameters) {
          var _parameters$data$titl5, _parameters$data$cont5, _parameters$data$rich5;
          _classCallCheck(this, CircleAnnotationElement);
          var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl5 = parameters.data.titleObj) !== null && _parameters$data$titl5 !== void 0 && _parameters$data$titl5.str || (_parameters$data$cont5 = parameters.data.contentsObj) !== null && _parameters$data$cont5 !== void 0 && _parameters$data$cont5.str || (_parameters$data$rich5 = parameters.data.richText) !== null && _parameters$data$rich5 !== void 0 && _parameters$data$rich5.str);
          return _callSuper(this, CircleAnnotationElement, [parameters, {
            isRenderable: isRenderable,
            ignoreBorder: true
          }]);
        }
        _inherits(CircleAnnotationElement, _AnnotationElement8);
        return _createClass(CircleAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "circleAnnotation";
            var data = this.data;
            var _getRectDims5 = getRectDims(data.rect),
              width = _getRectDims5.width,
              height = _getRectDims5.height;
            var svg = this.svgFactory.create(width, height, true);
            var borderWidth = data.borderStyle.width;
            var circle = this.svgFactory.createElement("svg:ellipse");
            circle.setAttribute("cx", width / 2);
            circle.setAttribute("cy", height / 2);
            circle.setAttribute("rx", width / 2 - borderWidth / 2);
            circle.setAttribute("ry", height / 2 - borderWidth / 2);
            circle.setAttribute("stroke-width", borderWidth || 1);
            circle.setAttribute("stroke", "transparent");
            circle.setAttribute("fill", "transparent");
            svg.append(circle);
            this.container.append(svg);
            this._createPopup(circle, data);
            return this.container;
          }
        }]);
      }(AnnotationElement);
      var PolylineAnnotationElement = /*#__PURE__*/function (_AnnotationElement9) {
        function PolylineAnnotationElement(parameters) {
          var _parameters$data$titl6, _parameters$data$cont6, _parameters$data$rich6;
          var _this72;
          _classCallCheck(this, PolylineAnnotationElement);
          var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl6 = parameters.data.titleObj) !== null && _parameters$data$titl6 !== void 0 && _parameters$data$titl6.str || (_parameters$data$cont6 = parameters.data.contentsObj) !== null && _parameters$data$cont6 !== void 0 && _parameters$data$cont6.str || (_parameters$data$rich6 = parameters.data.richText) !== null && _parameters$data$rich6 !== void 0 && _parameters$data$rich6.str);
          _this72 = _callSuper(this, PolylineAnnotationElement, [parameters, {
            isRenderable: isRenderable,
            ignoreBorder: true
          }]);
          _this72.containerClassName = "polylineAnnotation";
          _this72.svgElementName = "svg:polyline";
          return _this72;
        }
        _inherits(PolylineAnnotationElement, _AnnotationElement9);
        return _createClass(PolylineAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = this.containerClassName;
            var data = this.data;
            var _getRectDims6 = getRectDims(data.rect),
              width = _getRectDims6.width,
              height = _getRectDims6.height;
            var svg = this.svgFactory.create(width, height, true);
            var points = [];
            var _iterator114 = _createForOfIteratorHelper(data.vertices),
              _step114;
            try {
              for (_iterator114.s(); !(_step114 = _iterator114.n()).done;) {
                var coordinate = _step114.value;
                var x = coordinate.x - data.rect[0];
                var y = data.rect[3] - coordinate.y;
                points.push(x + "," + y);
              }
            } catch (err) {
              _iterator114.e(err);
            } finally {
              _iterator114.f();
            }
            points = points.join(" ");
            var polyline = this.svgFactory.createElement(this.svgElementName);
            polyline.setAttribute("points", points);
            polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
            polyline.setAttribute("stroke", "transparent");
            polyline.setAttribute("fill", "transparent");
            svg.append(polyline);
            this.container.append(svg);
            this._createPopup(polyline, data);
            return this.container;
          }
        }]);
      }(AnnotationElement);
      var PolygonAnnotationElement = /*#__PURE__*/function (_PolylineAnnotationEl) {
        function PolygonAnnotationElement(parameters) {
          var _this73;
          _classCallCheck(this, PolygonAnnotationElement);
          _this73 = _callSuper(this, PolygonAnnotationElement, [parameters]);
          _this73.containerClassName = "polygonAnnotation";
          _this73.svgElementName = "svg:polygon";
          return _this73;
        }
        _inherits(PolygonAnnotationElement, _PolylineAnnotationEl);
        return _createClass(PolygonAnnotationElement);
      }(PolylineAnnotationElement);
      var CaretAnnotationElement = /*#__PURE__*/function (_AnnotationElement0) {
        function CaretAnnotationElement(parameters) {
          var _parameters$data$titl7, _parameters$data$cont7, _parameters$data$rich7;
          _classCallCheck(this, CaretAnnotationElement);
          var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl7 = parameters.data.titleObj) !== null && _parameters$data$titl7 !== void 0 && _parameters$data$titl7.str || (_parameters$data$cont7 = parameters.data.contentsObj) !== null && _parameters$data$cont7 !== void 0 && _parameters$data$cont7.str || (_parameters$data$rich7 = parameters.data.richText) !== null && _parameters$data$rich7 !== void 0 && _parameters$data$rich7.str);
          return _callSuper(this, CaretAnnotationElement, [parameters, {
            isRenderable: isRenderable,
            ignoreBorder: true
          }]);
        }
        _inherits(CaretAnnotationElement, _AnnotationElement0);
        return _createClass(CaretAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "caretAnnotation";
            if (!this.data.hasPopup) {
              this._createPopup(null, this.data);
            }
            return this.container;
          }
        }]);
      }(AnnotationElement);
      var InkAnnotationElement = /*#__PURE__*/function (_AnnotationElement1) {
        function InkAnnotationElement(parameters) {
          var _parameters$data$titl8, _parameters$data$cont8, _parameters$data$rich8;
          var _this74;
          _classCallCheck(this, InkAnnotationElement);
          var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl8 = parameters.data.titleObj) !== null && _parameters$data$titl8 !== void 0 && _parameters$data$titl8.str || (_parameters$data$cont8 = parameters.data.contentsObj) !== null && _parameters$data$cont8 !== void 0 && _parameters$data$cont8.str || (_parameters$data$rich8 = parameters.data.richText) !== null && _parameters$data$rich8 !== void 0 && _parameters$data$rich8.str);
          _this74 = _callSuper(this, InkAnnotationElement, [parameters, {
            isRenderable: isRenderable,
            ignoreBorder: true
          }]);
          _this74.containerClassName = "inkAnnotation";
          _this74.svgElementName = "svg:polyline";
          return _this74;
        }
        _inherits(InkAnnotationElement, _AnnotationElement1);
        return _createClass(InkAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = this.containerClassName;
            var data = this.data;
            var _getRectDims7 = getRectDims(data.rect),
              width = _getRectDims7.width,
              height = _getRectDims7.height;
            var svg = this.svgFactory.create(width, height, true);
            var _iterator115 = _createForOfIteratorHelper(data.inkLists),
              _step115;
            try {
              for (_iterator115.s(); !(_step115 = _iterator115.n()).done;) {
                var inkList = _step115.value;
                var points = [];
                var _iterator116 = _createForOfIteratorHelper(inkList),
                  _step116;
                try {
                  for (_iterator116.s(); !(_step116 = _iterator116.n()).done;) {
                    var coordinate = _step116.value;
                    var x = coordinate.x - data.rect[0];
                    var y = data.rect[3] - coordinate.y;
                    points.push("".concat(x, ",").concat(y));
                  }
                } catch (err) {
                  _iterator116.e(err);
                } finally {
                  _iterator116.f();
                }
                points = points.join(" ");
                var polyline = this.svgFactory.createElement(this.svgElementName);
                polyline.setAttribute("points", points);
                polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                polyline.setAttribute("stroke", "transparent");
                polyline.setAttribute("fill", "transparent");
                this._createPopup(polyline, data);
                svg.append(polyline);
              }
            } catch (err) {
              _iterator115.e(err);
            } finally {
              _iterator115.f();
            }
            this.container.append(svg);
            return this.container;
          }
        }]);
      }(AnnotationElement);
      var HighlightAnnotationElement = /*#__PURE__*/function (_AnnotationElement10) {
        function HighlightAnnotationElement(parameters) {
          var _parameters$data$titl9, _parameters$data$cont9, _parameters$data$rich9;
          _classCallCheck(this, HighlightAnnotationElement);
          var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl9 = parameters.data.titleObj) !== null && _parameters$data$titl9 !== void 0 && _parameters$data$titl9.str || (_parameters$data$cont9 = parameters.data.contentsObj) !== null && _parameters$data$cont9 !== void 0 && _parameters$data$cont9.str || (_parameters$data$rich9 = parameters.data.richText) !== null && _parameters$data$rich9 !== void 0 && _parameters$data$rich9.str);
          return _callSuper(this, HighlightAnnotationElement, [parameters, {
            isRenderable: isRenderable,
            ignoreBorder: true,
            createQuadrilaterals: true
          }]);
        }
        _inherits(HighlightAnnotationElement, _AnnotationElement10);
        return _createClass(HighlightAnnotationElement, [{
          key: "render",
          value: function render() {
            if (!this.data.hasPopup) {
              this._createPopup(null, this.data);
            }
            if (this.quadrilaterals) {
              return this._renderQuadrilaterals("highlightAnnotation");
            }
            this.container.className = "highlightAnnotation";
            return this.container;
          }
        }]);
      }(AnnotationElement);
      var UnderlineAnnotationElement = /*#__PURE__*/function (_AnnotationElement11) {
        function UnderlineAnnotationElement(parameters) {
          var _parameters$data$titl0, _parameters$data$cont0, _parameters$data$rich0;
          _classCallCheck(this, UnderlineAnnotationElement);
          var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl0 = parameters.data.titleObj) !== null && _parameters$data$titl0 !== void 0 && _parameters$data$titl0.str || (_parameters$data$cont0 = parameters.data.contentsObj) !== null && _parameters$data$cont0 !== void 0 && _parameters$data$cont0.str || (_parameters$data$rich0 = parameters.data.richText) !== null && _parameters$data$rich0 !== void 0 && _parameters$data$rich0.str);
          return _callSuper(this, UnderlineAnnotationElement, [parameters, {
            isRenderable: isRenderable,
            ignoreBorder: true,
            createQuadrilaterals: true
          }]);
        }
        _inherits(UnderlineAnnotationElement, _AnnotationElement11);
        return _createClass(UnderlineAnnotationElement, [{
          key: "render",
          value: function render() {
            if (!this.data.hasPopup) {
              this._createPopup(null, this.data);
            }
            if (this.quadrilaterals) {
              return this._renderQuadrilaterals("underlineAnnotation");
            }
            this.container.className = "underlineAnnotation";
            return this.container;
          }
        }]);
      }(AnnotationElement);
      var SquigglyAnnotationElement = /*#__PURE__*/function (_AnnotationElement12) {
        function SquigglyAnnotationElement(parameters) {
          var _parameters$data$titl1, _parameters$data$cont1, _parameters$data$rich1;
          _classCallCheck(this, SquigglyAnnotationElement);
          var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl1 = parameters.data.titleObj) !== null && _parameters$data$titl1 !== void 0 && _parameters$data$titl1.str || (_parameters$data$cont1 = parameters.data.contentsObj) !== null && _parameters$data$cont1 !== void 0 && _parameters$data$cont1.str || (_parameters$data$rich1 = parameters.data.richText) !== null && _parameters$data$rich1 !== void 0 && _parameters$data$rich1.str);
          return _callSuper(this, SquigglyAnnotationElement, [parameters, {
            isRenderable: isRenderable,
            ignoreBorder: true,
            createQuadrilaterals: true
          }]);
        }
        _inherits(SquigglyAnnotationElement, _AnnotationElement12);
        return _createClass(SquigglyAnnotationElement, [{
          key: "render",
          value: function render() {
            if (!this.data.hasPopup) {
              this._createPopup(null, this.data);
            }
            if (this.quadrilaterals) {
              return this._renderQuadrilaterals("squigglyAnnotation");
            }
            this.container.className = "squigglyAnnotation";
            return this.container;
          }
        }]);
      }(AnnotationElement);
      var StrikeOutAnnotationElement = /*#__PURE__*/function (_AnnotationElement13) {
        function StrikeOutAnnotationElement(parameters) {
          var _parameters$data$titl10, _parameters$data$cont10, _parameters$data$rich10;
          _classCallCheck(this, StrikeOutAnnotationElement);
          var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl10 = parameters.data.titleObj) !== null && _parameters$data$titl10 !== void 0 && _parameters$data$titl10.str || (_parameters$data$cont10 = parameters.data.contentsObj) !== null && _parameters$data$cont10 !== void 0 && _parameters$data$cont10.str || (_parameters$data$rich10 = parameters.data.richText) !== null && _parameters$data$rich10 !== void 0 && _parameters$data$rich10.str);
          return _callSuper(this, StrikeOutAnnotationElement, [parameters, {
            isRenderable: isRenderable,
            ignoreBorder: true,
            createQuadrilaterals: true
          }]);
        }
        _inherits(StrikeOutAnnotationElement, _AnnotationElement13);
        return _createClass(StrikeOutAnnotationElement, [{
          key: "render",
          value: function render() {
            if (!this.data.hasPopup) {
              this._createPopup(null, this.data);
            }
            if (this.quadrilaterals) {
              return this._renderQuadrilaterals("strikeoutAnnotation");
            }
            this.container.className = "strikeoutAnnotation";
            return this.container;
          }
        }]);
      }(AnnotationElement);
      var StampAnnotationElement = /*#__PURE__*/function (_AnnotationElement14) {
        function StampAnnotationElement(parameters) {
          var _parameters$data$titl11, _parameters$data$cont11, _parameters$data$rich11;
          _classCallCheck(this, StampAnnotationElement);
          var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl11 = parameters.data.titleObj) !== null && _parameters$data$titl11 !== void 0 && _parameters$data$titl11.str || (_parameters$data$cont11 = parameters.data.contentsObj) !== null && _parameters$data$cont11 !== void 0 && _parameters$data$cont11.str || (_parameters$data$rich11 = parameters.data.richText) !== null && _parameters$data$rich11 !== void 0 && _parameters$data$rich11.str);
          return _callSuper(this, StampAnnotationElement, [parameters, {
            isRenderable: isRenderable,
            ignoreBorder: true
          }]);
        }
        _inherits(StampAnnotationElement, _AnnotationElement14);
        return _createClass(StampAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "stampAnnotation";
            if (!this.data.hasPopup) {
              this._createPopup(null, this.data);
            }
            return this.container;
          }
        }]);
      }(AnnotationElement);
      var FileAttachmentAnnotationElement = /*#__PURE__*/function (_AnnotationElement15) {
        function FileAttachmentAnnotationElement(parameters) {
          var _this75$linkService$e;
          var _this75;
          _classCallCheck(this, FileAttachmentAnnotationElement);
          _this75 = _callSuper(this, FileAttachmentAnnotationElement, [parameters, {
            isRenderable: true
          }]);
          var _this75$data$file = _this75.data.file,
            filename = _this75$data$file.filename,
            content = _this75$data$file.content;
          _this75.filename = (0, _display_utils.getFilenameFromUrl)(filename, true);
          _this75.content = content;
          (_this75$linkService$e = _this75.linkService.eventBus) === null || _this75$linkService$e === void 0 || _this75$linkService$e.dispatch("fileattachmentannotation", {
            source: _this75,
            filename: filename,
            content: content
          });
          return _this75;
        }
        _inherits(FileAttachmentAnnotationElement, _AnnotationElement15);
        return _createClass(FileAttachmentAnnotationElement, [{
          key: "render",
          value: function render() {
            var _this$data$titleObj, _this$data$contentsOb;
            this.container.className = "fileAttachmentAnnotation";
            var trigger;
            if (this.data.hasAppearance) {
              trigger = document.createElement("div");
            } else {
              trigger = document.createElement("img");
              trigger.src = "".concat(this.imageResourcesPath, "annotation-").concat(/paperclip/i.test(this.data.name) ? "paperclip" : "pushpin", ".svg");
            }
            trigger.className = "popupTriggerArea";
            trigger.addEventListener("dblclick", this._download.bind(this));
            if (!this.data.hasPopup && ((_this$data$titleObj = this.data.titleObj) !== null && _this$data$titleObj !== void 0 && _this$data$titleObj.str || (_this$data$contentsOb = this.data.contentsObj) !== null && _this$data$contentsOb !== void 0 && _this$data$contentsOb.str || this.data.richText)) {
              this._createPopup(trigger, this.data);
            }
            this.container.append(trigger);
            return this.container;
          }
        }, {
          key: "_download",
          value: function _download() {
            var _this$downloadManager;
            (_this$downloadManager = this.downloadManager) === null || _this$downloadManager === void 0 || _this$downloadManager.openOrDownloadData(this.container, this.content, this.filename);
          }
        }]);
      }(AnnotationElement);
      var _appendElement = /*#__PURE__*/_classPrivateFieldLooseKey("appendElement");
      var _setAnnotationCanvasMap = /*#__PURE__*/_classPrivateFieldLooseKey("setAnnotationCanvasMap");
      var AnnotationLayer = /*#__PURE__*/function () {
        function AnnotationLayer() {
          _classCallCheck(this, AnnotationLayer);
        }
        return _createClass(AnnotationLayer, null, [{
          key: "render",
          value: function render(params) {
            var annotations = params.annotations,
              div = params.div,
              viewport = params.viewport,
              accessibilityManager = params.accessibilityManager;
            (0, _display_utils.setLayerDimensions)(div, viewport);
            var elementParams = {
              data: null,
              layer: div,
              page: params.page,
              viewport: viewport,
              linkService: params.linkService,
              downloadManager: params.downloadManager,
              imageResourcesPath: params.imageResourcesPath || "",
              renderForms: params.renderForms !== false,
              svgFactory: new _display_utils.DOMSVGFactory(),
              annotationStorage: params.annotationStorage || new _annotation_storage.AnnotationStorage(),
              enableScripting: params.enableScripting === true,
              hasJSActions: params.hasJSActions,
              fieldObjects: params.fieldObjects
            };
            var zIndex = 0;
            var _iterator117 = _createForOfIteratorHelper(annotations),
              _step117;
            try {
              for (_iterator117.s(); !(_step117 = _iterator117.n()).done;) {
                var data = _step117.value;
                if (data.annotationType !== _util.AnnotationType.POPUP) {
                  var _getRectDims8 = getRectDims(data.rect),
                    width = _getRectDims8.width,
                    height = _getRectDims8.height;
                  if (width <= 0 || height <= 0) {
                    continue;
                  }
                }
                elementParams.data = data;
                var element = AnnotationElementFactory.create(elementParams);
                if (!element.isRenderable) {
                  continue;
                }
                var rendered = element.render();
                if (data.hidden) {
                  rendered.style.visibility = "hidden";
                }
                if (Array.isArray(rendered)) {
                  var _iterator118 = _createForOfIteratorHelper(rendered),
                    _step118;
                  try {
                    for (_iterator118.s(); !(_step118 = _iterator118.n()).done;) {
                      var renderedElement = _step118.value;
                      renderedElement.style.zIndex = zIndex++;
                      _classPrivateFieldLooseBase(AnnotationLayer, _appendElement)[_appendElement](renderedElement, data.id, div, accessibilityManager);
                    }
                  } catch (err) {
                    _iterator118.e(err);
                  } finally {
                    _iterator118.f();
                  }
                } else {
                  rendered.style.zIndex = zIndex++;
                  if (element instanceof PopupAnnotationElement) {
                    div.prepend(rendered);
                  } else {
                    _classPrivateFieldLooseBase(AnnotationLayer, _appendElement)[_appendElement](rendered, data.id, div, accessibilityManager);
                  }
                }
              }
            } catch (err) {
              _iterator117.e(err);
            } finally {
              _iterator117.f();
            }
            _classPrivateFieldLooseBase(this, _setAnnotationCanvasMap)[_setAnnotationCanvasMap](div, params.annotationCanvasMap);
          }
        }, {
          key: "update",
          value: function update(params) {
            var annotationCanvasMap = params.annotationCanvasMap,
              div = params.div,
              viewport = params.viewport;
            (0, _display_utils.setLayerDimensions)(div, {
              rotation: viewport.rotation
            });
            _classPrivateFieldLooseBase(this, _setAnnotationCanvasMap)[_setAnnotationCanvasMap](div, annotationCanvasMap);
            div.hidden = false;
          }
        }]);
      }();
      function _appendElement2(element, id, div, accessibilityManager) {
        var contentElement = element.firstChild || element;
        contentElement.id = "".concat(_display_utils.AnnotationPrefix).concat(id);
        div.append(element);
        accessibilityManager === null || accessibilityManager === void 0 || accessibilityManager.moveElementInDOM(div, element, contentElement, false);
      }
      function _setAnnotationCanvasMap2(div, annotationCanvasMap) {
        if (!annotationCanvasMap) {
          return;
        }
        var _iterator119 = _createForOfIteratorHelper(annotationCanvasMap),
          _step119;
        try {
          for (_iterator119.s(); !(_step119 = _iterator119.n()).done;) {
            var _ref99 = _step119.value;
            var _ref100 = _slicedToArray(_ref99, 2);
            var _id10 = _ref100[0];
            var canvas = _ref100[1];
            var element = div.querySelector("[data-annotation-id=\"".concat(_id10, "\"]"));
            if (!element) {
              continue;
            }
            var firstChild = element.firstChild;
            if (!firstChild) {
              element.append(canvas);
            } else if (firstChild.nodeName === "CANVAS") {
              firstChild.replaceWith(canvas);
            } else {
              firstChild.before(canvas);
            }
          }
        } catch (err) {
          _iterator119.e(err);
        } finally {
          _iterator119.f();
        }
        annotationCanvasMap.clear();
      }
      Object.defineProperty(AnnotationLayer, _setAnnotationCanvasMap, {
        value: _setAnnotationCanvasMap2
      });
      Object.defineProperty(AnnotationLayer, _appendElement, {
        value: _appendElement2
      });
      exports.AnnotationLayer = AnnotationLayer;

      /***/
    }), (/* 33 */
    /***/function (__unused_webpack_module, exports) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.ColorConverters = void 0;
      function makeColorComp(n) {
        return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
      }
      var ColorConverters = /*#__PURE__*/function () {
        function ColorConverters() {
          _classCallCheck(this, ColorConverters);
        }
        return _createClass(ColorConverters, null, [{
          key: "CMYK_G",
          value: function CMYK_G(_ref101) {
            var _ref102 = _slicedToArray(_ref101, 4),
              c = _ref102[0],
              y = _ref102[1],
              m = _ref102[2],
              k = _ref102[3];
            return ["G", 1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)];
          }
        }, {
          key: "G_CMYK",
          value: function G_CMYK(_ref103) {
            var _ref104 = _slicedToArray(_ref103, 1),
              g = _ref104[0];
            return ["CMYK", 0, 0, 0, 1 - g];
          }
        }, {
          key: "G_RGB",
          value: function G_RGB(_ref105) {
            var _ref106 = _slicedToArray(_ref105, 1),
              g = _ref106[0];
            return ["RGB", g, g, g];
          }
        }, {
          key: "G_HTML",
          value: function G_HTML(_ref107) {
            var _ref108 = _slicedToArray(_ref107, 1),
              g = _ref108[0];
            var G = makeColorComp(g);
            return "#".concat(G).concat(G).concat(G);
          }
        }, {
          key: "RGB_G",
          value: function RGB_G(_ref109) {
            var _ref110 = _slicedToArray(_ref109, 3),
              r = _ref110[0],
              g = _ref110[1],
              b = _ref110[2];
            return ["G", 0.3 * r + 0.59 * g + 0.11 * b];
          }
        }, {
          key: "RGB_HTML",
          value: function RGB_HTML(_ref111) {
            var _ref112 = _slicedToArray(_ref111, 3),
              r = _ref112[0],
              g = _ref112[1],
              b = _ref112[2];
            var R = makeColorComp(r);
            var G = makeColorComp(g);
            var B = makeColorComp(b);
            return "#".concat(R).concat(G).concat(B);
          }
        }, {
          key: "T_HTML",
          value: function T_HTML() {
            return "#00000000";
          }
        }, {
          key: "CMYK_RGB",
          value: function CMYK_RGB(_ref113) {
            var _ref114 = _slicedToArray(_ref113, 4),
              c = _ref114[0],
              y = _ref114[1],
              m = _ref114[2],
              k = _ref114[3];
            return ["RGB", 1 - Math.min(1, c + k), 1 - Math.min(1, m + k), 1 - Math.min(1, y + k)];
          }
        }, {
          key: "CMYK_HTML",
          value: function CMYK_HTML(components) {
            var rgb = this.CMYK_RGB(components).slice(1);
            return this.RGB_HTML(rgb);
          }
        }, {
          key: "RGB_CMYK",
          value: function RGB_CMYK(_ref115) {
            var _ref116 = _slicedToArray(_ref115, 3),
              r = _ref116[0],
              g = _ref116[1],
              b = _ref116[2];
            var c = 1 - r;
            var m = 1 - g;
            var y = 1 - b;
            var k = Math.min(c, m, y);
            return ["CMYK", c, m, y, k];
          }
        }]);
      }();
      exports.ColorConverters = ColorConverters;

      /***/
    }), (/* 34 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.XfaLayer = void 0;
      var _xfa_text = __w_pdfjs_require__(19);
      var XfaLayer = /*#__PURE__*/function () {
        function XfaLayer() {
          _classCallCheck(this, XfaLayer);
        }
        return _createClass(XfaLayer, null, [{
          key: "setupStorage",
          value: function setupStorage(html, id, element, storage, intent) {
            var storedData = storage.getValue(id, {
              value: null
            });
            switch (element.name) {
              case "textarea":
                if (storedData.value !== null) {
                  html.textContent = storedData.value;
                }
                if (intent === "print") {
                  break;
                }
                html.addEventListener("input", function (event) {
                  storage.setValue(id, {
                    value: event.target.value
                  });
                });
                break;
              case "input":
                if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                  if (storedData.value === element.attributes.xfaOn) {
                    html.setAttribute("checked", true);
                  } else if (storedData.value === element.attributes.xfaOff) {
                    html.removeAttribute("checked");
                  }
                  if (intent === "print") {
                    break;
                  }
                  html.addEventListener("change", function (event) {
                    storage.setValue(id, {
                      value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                    });
                  });
                } else {
                  if (storedData.value !== null) {
                    html.setAttribute("value", storedData.value);
                  }
                  if (intent === "print") {
                    break;
                  }
                  html.addEventListener("input", function (event) {
                    storage.setValue(id, {
                      value: event.target.value
                    });
                  });
                }
                break;
              case "select":
                if (storedData.value !== null) {
                  var _iterator120 = _createForOfIteratorHelper(element.children),
                    _step120;
                  try {
                    for (_iterator120.s(); !(_step120 = _iterator120.n()).done;) {
                      var option = _step120.value;
                      if (option.attributes.value === storedData.value) {
                        option.attributes.selected = true;
                      }
                    }
                  } catch (err) {
                    _iterator120.e(err);
                  } finally {
                    _iterator120.f();
                  }
                }
                html.addEventListener("input", function (event) {
                  var options = event.target.options;
                  var value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                  storage.setValue(id, {
                    value: value
                  });
                });
                break;
            }
          }
        }, {
          key: "setAttributes",
          value: function setAttributes(_ref117) {
            var html = _ref117.html,
              element = _ref117.element,
              _ref117$storage = _ref117.storage,
              storage = _ref117$storage === void 0 ? null : _ref117$storage,
              intent = _ref117.intent,
              linkService = _ref117.linkService;
            var attributes = element.attributes;
            var isHTMLAnchorElement = html instanceof HTMLAnchorElement;
            if (attributes.type === "radio") {
              attributes.name = "".concat(attributes.name, "-").concat(intent);
            }
            for (var _i13 = 0, _Object$entries4 = Object.entries(attributes); _i13 < _Object$entries4.length; _i13++) {
              var _ref118 = _Object$entries4[_i13];
              var _ref119 = _slicedToArray(_ref118, 2);
              var key = _ref119[0];
              var value = _ref119[1];
              if (value === null || value === undefined) {
                continue;
              }
              switch (key) {
                case "class":
                  if (value.length) {
                    html.setAttribute(key, value.join(" "));
                  }
                  break;
                case "dataId":
                  break;
                case "id":
                  html.setAttribute("data-element-id", value);
                  break;
                case "style":
                  Object.assign(html.style, value);
                  break;
                case "textContent":
                  html.textContent = value;
                  break;
                default:
                  if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") {
                    html.setAttribute(key, value);
                  }
              }
            }
            if (isHTMLAnchorElement) {
              linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
            }
            if (storage && attributes.dataId) {
              this.setupStorage(html, attributes.dataId, element, storage);
            }
          }
        }, {
          key: "render",
          value: function render(parameters) {
            var storage = parameters.annotationStorage;
            var linkService = parameters.linkService;
            var root = parameters.xfaHtml;
            var intent = parameters.intent || "display";
            var rootHtml = document.createElement(root.name);
            if (root.attributes) {
              this.setAttributes({
                html: rootHtml,
                element: root,
                intent: intent,
                linkService: linkService
              });
            }
            var stack = [[root, -1, rootHtml]];
            var rootDiv = parameters.div;
            rootDiv.append(rootHtml);
            if (parameters.viewport) {
              var transform = "matrix(".concat(parameters.viewport.transform.join(","), ")");
              rootDiv.style.transform = transform;
            }
            if (intent !== "richText") {
              rootDiv.setAttribute("class", "xfaLayer xfaFont");
            }
            var textDivs = [];
            while (stack.length > 0) {
              var _child$attributes;
              var _stack$at = stack.at(-1),
                _stack$at2 = _slicedToArray(_stack$at, 3),
                parent = _stack$at2[0],
                i = _stack$at2[1],
                html = _stack$at2[2];
              if (i + 1 === parent.children.length) {
                stack.pop();
                continue;
              }
              var child = parent.children[++stack.at(-1)[1]];
              if (child === null) {
                continue;
              }
              var name = child.name;
              if (name === "#text") {
                var node = document.createTextNode(child.value);
                textDivs.push(node);
                html.append(node);
                continue;
              }
              var childHtml = void 0;
              if (child !== null && child !== void 0 && (_child$attributes = child.attributes) !== null && _child$attributes !== void 0 && _child$attributes.xmlns) {
                childHtml = document.createElementNS(child.attributes.xmlns, name);
              } else {
                childHtml = document.createElement(name);
              }
              html.append(childHtml);
              if (child.attributes) {
                this.setAttributes({
                  html: childHtml,
                  element: child,
                  storage: storage,
                  intent: intent,
                  linkService: linkService
                });
              }
              if (child.children && child.children.length > 0) {
                stack.push([child, -1, childHtml]);
              } else if (child.value) {
                var _node = document.createTextNode(child.value);
                if (_xfa_text.XfaText.shouldBuildText(name)) {
                  textDivs.push(_node);
                }
                childHtml.append(_node);
              }
            }
            var _iterator121 = _createForOfIteratorHelper(rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea")),
              _step121;
            try {
              for (_iterator121.s(); !(_step121 = _iterator121.n()).done;) {
                var el = _step121.value;
                el.setAttribute("readOnly", true);
              }
            } catch (err) {
              _iterator121.e(err);
            } finally {
              _iterator121.f();
            }
            return {
              textDivs: textDivs
            };
          }
        }, {
          key: "update",
          value: function update(parameters) {
            var transform = "matrix(".concat(parameters.viewport.transform.join(","), ")");
            parameters.div.style.transform = transform;
            parameters.div.hidden = false;
          }
        }]);
      }();
      exports.XfaLayer = XfaLayer;

      /***/
    }), (/* 35 */
    /***/function (__unused_webpack_module, exports, __w_pdfjs_require__) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.SVGGraphics = void 0;
      var _display_utils = __w_pdfjs_require__(6);
      var _util = __w_pdfjs_require__(1);
      var _is_node = __w_pdfjs_require__(10);
      var SVGGraphics = /*#__PURE__*/_createClass(function SVGGraphics() {
        _classCallCheck(this, SVGGraphics);
        (0, _util.unreachable)("Not implemented: SVGGraphics");
      });
      exports.SVGGraphics = SVGGraphics;
      {
        var SVG_DEFAULTS = {
          fontStyle: "normal",
          fontWeight: "normal",
          fillColor: "#000000"
        };
        var XML_NS = "http://www.w3.org/XML/1998/namespace";
        var XLINK_NS = "http://www.w3.org/1999/xlink";
        var LINE_CAP_STYLES = ["butt", "round", "square"];
        var LINE_JOIN_STYLES = ["miter", "round", "bevel"];
        var createObjectURL = function createObjectURL(data) {
          var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
          var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          if (URL.createObjectURL && typeof Blob !== "undefined" && !forceDataSchema) {
            return URL.createObjectURL(new Blob([data], {
              type: contentType
            }));
          }
          var digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          var buffer = "data:".concat(contentType, ";base64,");
          for (var i = 0, ii = data.length; i < ii; i += 3) {
            var b1 = data[i] & 0xff;
            var b2 = data[i + 1] & 0xff;
            var b3 = data[i + 2] & 0xff;
            var d1 = b1 >> 2,
              d2 = (b1 & 3) << 4 | b2 >> 4;
            var d3 = i + 1 < ii ? (b2 & 0xf) << 2 | b3 >> 6 : 64;
            var d4 = i + 2 < ii ? b3 & 0x3f : 64;
            buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
          }
          return buffer;
        };
        var convertImgDataToPng = function () {
          var PNG_HEADER = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);
          var CHUNK_WRAPPER_SIZE = 12;
          var crcTable = new Int32Array(256);
          for (var i = 0; i < 256; i++) {
            var c = i;
            for (var h = 0; h < 8; h++) {
              if (c & 1) {
                c = 0xedb88320 ^ c >> 1 & 0x7fffffff;
              } else {
                c = c >> 1 & 0x7fffffff;
              }
            }
            crcTable[i] = c;
          }
          function crc32(data, start, end) {
            var crc = -1;
            for (var _i14 = start; _i14 < end; _i14++) {
              var a = (crc ^ data[_i14]) & 0xff;
              var b = crcTable[a];
              crc = crc >>> 8 ^ b;
            }
            return crc ^ -1;
          }
          function writePngChunk(type, body, data, offset) {
            var p = offset;
            var len = body.length;
            data[p] = len >> 24 & 0xff;
            data[p + 1] = len >> 16 & 0xff;
            data[p + 2] = len >> 8 & 0xff;
            data[p + 3] = len & 0xff;
            p += 4;
            data[p] = type.charCodeAt(0) & 0xff;
            data[p + 1] = type.charCodeAt(1) & 0xff;
            data[p + 2] = type.charCodeAt(2) & 0xff;
            data[p + 3] = type.charCodeAt(3) & 0xff;
            p += 4;
            data.set(body, p);
            p += body.length;
            var crc = crc32(data, offset + 4, p);
            data[p] = crc >> 24 & 0xff;
            data[p + 1] = crc >> 16 & 0xff;
            data[p + 2] = crc >> 8 & 0xff;
            data[p + 3] = crc & 0xff;
          }
          function adler32(data, start, end) {
            var a = 1;
            var b = 0;
            for (var _i15 = start; _i15 < end; ++_i15) {
              a = (a + (data[_i15] & 0xff)) % 65521;
              b = (b + a) % 65521;
            }
            return b << 16 | a;
          }
          function deflateSync(literals) {
            if (!_is_node.isNodeJS) {
              return deflateSyncUncompressed(literals);
            }
            try {
              var input;
              if (parseInt(process.versions.node) >= 8) {
                input = literals;
              } else {
                input = Buffer.from(literals);
              }
              var output = require("zlib").deflateSync(input, {
                level: 9
              });
              return output instanceof Uint8Array ? output : new Uint8Array(output);
            } catch (e) {
              (0, _util.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e);
            }
            return deflateSyncUncompressed(literals);
          }
          function deflateSyncUncompressed(literals) {
            var len = literals.length;
            var maxBlockLength = 0xffff;
            var deflateBlocks = Math.ceil(len / maxBlockLength);
            var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
            var pi = 0;
            idat[pi++] = 0x78;
            idat[pi++] = 0x9c;
            var pos = 0;
            while (len > maxBlockLength) {
              idat[pi++] = 0x00;
              idat[pi++] = 0xff;
              idat[pi++] = 0xff;
              idat[pi++] = 0x00;
              idat[pi++] = 0x00;
              idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
              pi += maxBlockLength;
              pos += maxBlockLength;
              len -= maxBlockLength;
            }
            idat[pi++] = 0x01;
            idat[pi++] = len & 0xff;
            idat[pi++] = len >> 8 & 0xff;
            idat[pi++] = ~len & 0xffff & 0xff;
            idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
            idat.set(literals.subarray(pos), pi);
            pi += literals.length - pos;
            var adler = adler32(literals, 0, literals.length);
            idat[pi++] = adler >> 24 & 0xff;
            idat[pi++] = adler >> 16 & 0xff;
            idat[pi++] = adler >> 8 & 0xff;
            idat[pi++] = adler & 0xff;
            return idat;
          }
          function encode(imgData, kind, forceDataSchema, isMask) {
            var width = imgData.width;
            var height = imgData.height;
            var bitDepth, colorType, lineSize;
            var bytes = imgData.data;
            switch (kind) {
              case _util.ImageKind.GRAYSCALE_1BPP:
                colorType = 0;
                bitDepth = 1;
                lineSize = width + 7 >> 3;
                break;
              case _util.ImageKind.RGB_24BPP:
                colorType = 2;
                bitDepth = 8;
                lineSize = width * 3;
                break;
              case _util.ImageKind.RGBA_32BPP:
                colorType = 6;
                bitDepth = 8;
                lineSize = width * 4;
                break;
              default:
                throw new Error("invalid format");
            }
            var literals = new Uint8Array((1 + lineSize) * height);
            var offsetLiterals = 0,
              offsetBytes = 0;
            for (var y = 0; y < height; ++y) {
              literals[offsetLiterals++] = 0;
              literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
              offsetBytes += lineSize;
              offsetLiterals += lineSize;
            }
            if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
              offsetLiterals = 0;
              for (var _y = 0; _y < height; _y++) {
                offsetLiterals++;
                for (var _i16 = 0; _i16 < lineSize; _i16++) {
                  literals[offsetLiterals++] ^= 0xff;
                }
              }
            }
            var ihdr = new Uint8Array([width >> 24 & 0xff, width >> 16 & 0xff, width >> 8 & 0xff, width & 0xff, height >> 24 & 0xff, height >> 16 & 0xff, height >> 8 & 0xff, height & 0xff, bitDepth, colorType, 0x00, 0x00, 0x00]);
            var idat = deflateSync(literals);
            var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
            var data = new Uint8Array(pngLength);
            var offset = 0;
            data.set(PNG_HEADER, offset);
            offset += PNG_HEADER.length;
            writePngChunk("IHDR", ihdr, data, offset);
            offset += CHUNK_WRAPPER_SIZE + ihdr.length;
            writePngChunk("IDATA", idat, data, offset);
            offset += CHUNK_WRAPPER_SIZE + idat.length;
            writePngChunk("IEND", new Uint8Array(0), data, offset);
            return createObjectURL(data, "image/png", forceDataSchema);
          }
          return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
            var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
            return encode(imgData, kind, forceDataSchema, isMask);
          };
        }();
        var SVGExtraState = /*#__PURE__*/function () {
          function SVGExtraState() {
            _classCallCheck(this, SVGExtraState);
            this.fontSizeScale = 1;
            this.fontWeight = SVG_DEFAULTS.fontWeight;
            this.fontSize = 0;
            this.textMatrix = _util.IDENTITY_MATRIX;
            this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
            this.leading = 0;
            this.textRenderingMode = _util.TextRenderingMode.FILL;
            this.textMatrixScale = 1;
            this.x = 0;
            this.y = 0;
            this.lineX = 0;
            this.lineY = 0;
            this.charSpacing = 0;
            this.wordSpacing = 0;
            this.textHScale = 1;
            this.textRise = 0;
            this.fillColor = SVG_DEFAULTS.fillColor;
            this.strokeColor = "#000000";
            this.fillAlpha = 1;
            this.strokeAlpha = 1;
            this.lineWidth = 1;
            this.lineJoin = "";
            this.lineCap = "";
            this.miterLimit = 0;
            this.dashArray = [];
            this.dashPhase = 0;
            this.dependencies = [];
            this.activeClipUrl = null;
            this.clipGroup = null;
            this.maskId = "";
          }
          return _createClass(SVGExtraState, [{
            key: "clone",
            value: function clone() {
              return Object.create(this);
            }
          }, {
            key: "setCurrentPoint",
            value: function setCurrentPoint(x, y) {
              this.x = x;
              this.y = y;
            }
          }]);
        }();
        function opListToTree(opList) {
          var opTree = [];
          var tmp = [];
          var _iterator122 = _createForOfIteratorHelper(opList),
            _step122;
          try {
            for (_iterator122.s(); !(_step122 = _iterator122.n()).done;) {
              var opListElement = _step122.value;
              if (opListElement.fn === "save") {
                opTree.push({
                  fnId: 92,
                  fn: "group",
                  items: []
                });
                tmp.push(opTree);
                opTree = opTree.at(-1).items;
                continue;
              }
              if (opListElement.fn === "restore") {
                opTree = tmp.pop();
              } else {
                opTree.push(opListElement);
              }
            }
          } catch (err) {
            _iterator122.e(err);
          } finally {
            _iterator122.f();
          }
          return opTree;
        }
        function pf(value) {
          if (Number.isInteger(value)) {
            return value.toString();
          }
          var s = value.toFixed(10);
          var i = s.length - 1;
          if (s[i] !== "0") {
            return s;
          }
          do {
            i--;
          } while (s[i] === "0");
          return s.substring(0, s[i] === "." ? i : i + 1);
        }
        function pm(m) {
          if (m[4] === 0 && m[5] === 0) {
            if (m[1] === 0 && m[2] === 0) {
              if (m[0] === 1 && m[3] === 1) {
                return "";
              }
              return "scale(".concat(pf(m[0]), " ").concat(pf(m[3]), ")");
            }
            if (m[0] === m[3] && m[1] === -m[2]) {
              var a = Math.acos(m[0]) * 180 / Math.PI;
              return "rotate(".concat(pf(a), ")");
            }
          } else {
            if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
              return "translate(".concat(pf(m[4]), " ").concat(pf(m[5]), ")");
            }
          }
          return "matrix(".concat(pf(m[0]), " ").concat(pf(m[1]), " ").concat(pf(m[2]), " ").concat(pf(m[3]), " ").concat(pf(m[4]), " ") + "".concat(pf(m[5]), ")");
        }
        var clipCount = 0;
        var maskCount = 0;
        var shadingCount = 0;
        exports.SVGGraphics = SVGGraphics = /*#__PURE__*/function () {
          function SVGGraphics(commonObjs, objs) {
            var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            _classCallCheck(this, SVGGraphics);
            (0, _display_utils.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future.");
            this.svgFactory = new _display_utils.DOMSVGFactory();
            this.current = new SVGExtraState();
            this.transformMatrix = _util.IDENTITY_MATRIX;
            this.transformStack = [];
            this.extraStack = [];
            this.commonObjs = commonObjs;
            this.objs = objs;
            this.pendingClip = null;
            this.pendingEOFill = false;
            this.embedFonts = false;
            this.embeddedFonts = Object.create(null);
            this.cssStyle = null;
            this.forceDataSchema = !!forceDataSchema;
            this._operatorIdMapping = [];
            for (var op in _util.OPS) {
              this._operatorIdMapping[_util.OPS[op]] = op;
            }
          }
          return _createClass(SVGGraphics, [{
            key: "getObject",
            value: function getObject(data) {
              var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              if (typeof data === "string") {
                return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
              }
              return fallback;
            }
          }, {
            key: "save",
            value: function save() {
              this.transformStack.push(this.transformMatrix);
              var old = this.current;
              this.extraStack.push(old);
              this.current = old.clone();
            }
          }, {
            key: "restore",
            value: function restore() {
              this.transformMatrix = this.transformStack.pop();
              this.current = this.extraStack.pop();
              this.pendingClip = null;
              this.tgrp = null;
            }
          }, {
            key: "group",
            value: function group(items) {
              this.save();
              this.executeOpTree(items);
              this.restore();
            }
          }, {
            key: "loadDependencies",
            value: function loadDependencies(operatorList) {
              var _this77 = this;
              var fnArray = operatorList.fnArray;
              var argsArray = operatorList.argsArray;
              for (var i = 0, ii = fnArray.length; i < ii; i++) {
                if (fnArray[i] !== _util.OPS.dependency) {
                  continue;
                }
                var _iterator123 = _createForOfIteratorHelper(argsArray[i]),
                  _step123;
                try {
                  var _loop2 = function _loop2() {
                    var obj = _step123.value;
                    var objsPool = obj.startsWith("g_") ? _this77.commonObjs : _this77.objs;
                    var promise = new Promise(function (resolve) {
                      objsPool.get(obj, resolve);
                    });
                    _this77.current.dependencies.push(promise);
                  };
                  for (_iterator123.s(); !(_step123 = _iterator123.n()).done;) {
                    _loop2();
                  }
                } catch (err) {
                  _iterator123.e(err);
                } finally {
                  _iterator123.f();
                }
              }
              return Promise.all(this.current.dependencies);
            }
          }, {
            key: "transform",
            value: function transform(a, b, c, d, e, f) {
              var transformMatrix = [a, b, c, d, e, f];
              this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
              this.tgrp = null;
            }
          }, {
            key: "getSVG",
            value: function getSVG(operatorList, viewport) {
              var _this78 = this;
              this.viewport = viewport;
              var svgElement = this._initialize(viewport);
              return this.loadDependencies(operatorList).then(function () {
                _this78.transformMatrix = _util.IDENTITY_MATRIX;
                _this78.executeOpTree(_this78.convertOpList(operatorList));
                return svgElement;
              });
            }
          }, {
            key: "convertOpList",
            value: function convertOpList(operatorList) {
              var operatorIdMapping = this._operatorIdMapping;
              var argsArray = operatorList.argsArray;
              var fnArray = operatorList.fnArray;
              var opList = [];
              for (var i = 0, ii = fnArray.length; i < ii; i++) {
                var fnId = fnArray[i];
                opList.push({
                  fnId: fnId,
                  fn: operatorIdMapping[fnId],
                  args: argsArray[i]
                });
              }
              return opListToTree(opList);
            }
          }, {
            key: "executeOpTree",
            value: function executeOpTree(opTree) {
              var _iterator124 = _createForOfIteratorHelper(opTree),
                _step124;
              try {
                for (_iterator124.s(); !(_step124 = _iterator124.n()).done;) {
                  var opTreeElement = _step124.value;
                  var fn = opTreeElement.fn;
                  var fnId = opTreeElement.fnId;
                  var args = opTreeElement.args;
                  switch (fnId | 0) {
                    case _util.OPS.beginText:
                      this.beginText();
                      break;
                    case _util.OPS.dependency:
                      break;
                    case _util.OPS.setLeading:
                      this.setLeading(args);
                      break;
                    case _util.OPS.setLeadingMoveText:
                      this.setLeadingMoveText(args[0], args[1]);
                      break;
                    case _util.OPS.setFont:
                      this.setFont(args);
                      break;
                    case _util.OPS.showText:
                      this.showText(args[0]);
                      break;
                    case _util.OPS.showSpacedText:
                      this.showText(args[0]);
                      break;
                    case _util.OPS.endText:
                      this.endText();
                      break;
                    case _util.OPS.moveText:
                      this.moveText(args[0], args[1]);
                      break;
                    case _util.OPS.setCharSpacing:
                      this.setCharSpacing(args[0]);
                      break;
                    case _util.OPS.setWordSpacing:
                      this.setWordSpacing(args[0]);
                      break;
                    case _util.OPS.setHScale:
                      this.setHScale(args[0]);
                      break;
                    case _util.OPS.setTextMatrix:
                      this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                      break;
                    case _util.OPS.setTextRise:
                      this.setTextRise(args[0]);
                      break;
                    case _util.OPS.setTextRenderingMode:
                      this.setTextRenderingMode(args[0]);
                      break;
                    case _util.OPS.setLineWidth:
                      this.setLineWidth(args[0]);
                      break;
                    case _util.OPS.setLineJoin:
                      this.setLineJoin(args[0]);
                      break;
                    case _util.OPS.setLineCap:
                      this.setLineCap(args[0]);
                      break;
                    case _util.OPS.setMiterLimit:
                      this.setMiterLimit(args[0]);
                      break;
                    case _util.OPS.setFillRGBColor:
                      this.setFillRGBColor(args[0], args[1], args[2]);
                      break;
                    case _util.OPS.setStrokeRGBColor:
                      this.setStrokeRGBColor(args[0], args[1], args[2]);
                      break;
                    case _util.OPS.setStrokeColorN:
                      this.setStrokeColorN(args);
                      break;
                    case _util.OPS.setFillColorN:
                      this.setFillColorN(args);
                      break;
                    case _util.OPS.shadingFill:
                      this.shadingFill(args[0]);
                      break;
                    case _util.OPS.setDash:
                      this.setDash(args[0], args[1]);
                      break;
                    case _util.OPS.setRenderingIntent:
                      this.setRenderingIntent(args[0]);
                      break;
                    case _util.OPS.setFlatness:
                      this.setFlatness(args[0]);
                      break;
                    case _util.OPS.setGState:
                      this.setGState(args[0]);
                      break;
                    case _util.OPS.fill:
                      this.fill();
                      break;
                    case _util.OPS.eoFill:
                      this.eoFill();
                      break;
                    case _util.OPS.stroke:
                      this.stroke();
                      break;
                    case _util.OPS.fillStroke:
                      this.fillStroke();
                      break;
                    case _util.OPS.eoFillStroke:
                      this.eoFillStroke();
                      break;
                    case _util.OPS.clip:
                      this.clip("nonzero");
                      break;
                    case _util.OPS.eoClip:
                      this.clip("evenodd");
                      break;
                    case _util.OPS.paintSolidColorImageMask:
                      this.paintSolidColorImageMask();
                      break;
                    case _util.OPS.paintImageXObject:
                      this.paintImageXObject(args[0]);
                      break;
                    case _util.OPS.paintInlineImageXObject:
                      this.paintInlineImageXObject(args[0]);
                      break;
                    case _util.OPS.paintImageMaskXObject:
                      this.paintImageMaskXObject(args[0]);
                      break;
                    case _util.OPS.paintFormXObjectBegin:
                      this.paintFormXObjectBegin(args[0], args[1]);
                      break;
                    case _util.OPS.paintFormXObjectEnd:
                      this.paintFormXObjectEnd();
                      break;
                    case _util.OPS.closePath:
                      this.closePath();
                      break;
                    case _util.OPS.closeStroke:
                      this.closeStroke();
                      break;
                    case _util.OPS.closeFillStroke:
                      this.closeFillStroke();
                      break;
                    case _util.OPS.closeEOFillStroke:
                      this.closeEOFillStroke();
                      break;
                    case _util.OPS.nextLine:
                      this.nextLine();
                      break;
                    case _util.OPS.transform:
                      this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
                      break;
                    case _util.OPS.constructPath:
                      this.constructPath(args[0], args[1]);
                      break;
                    case _util.OPS.endPath:
                      this.endPath();
                      break;
                    case 92:
                      this.group(opTreeElement.items);
                      break;
                    default:
                      (0, _util.warn)("Unimplemented operator ".concat(fn));
                      break;
                  }
                }
              } catch (err) {
                _iterator124.e(err);
              } finally {
                _iterator124.f();
              }
            }
          }, {
            key: "setWordSpacing",
            value: function setWordSpacing(wordSpacing) {
              this.current.wordSpacing = wordSpacing;
            }
          }, {
            key: "setCharSpacing",
            value: function setCharSpacing(charSpacing) {
              this.current.charSpacing = charSpacing;
            }
          }, {
            key: "nextLine",
            value: function nextLine() {
              this.moveText(0, this.current.leading);
            }
          }, {
            key: "setTextMatrix",
            value: function setTextMatrix(a, b, c, d, e, f) {
              var current = this.current;
              current.textMatrix = current.lineMatrix = [a, b, c, d, e, f];
              current.textMatrixScale = Math.hypot(a, b);
              current.x = current.lineX = 0;
              current.y = current.lineY = 0;
              current.xcoords = [];
              current.ycoords = [];
              current.tspan = this.svgFactory.createElement("svg:tspan");
              current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
              current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));
              current.tspan.setAttributeNS(null, "y", pf(-current.y));
              current.txtElement = this.svgFactory.createElement("svg:text");
              current.txtElement.append(current.tspan);
            }
          }, {
            key: "beginText",
            value: function beginText() {
              var current = this.current;
              current.x = current.lineX = 0;
              current.y = current.lineY = 0;
              current.textMatrix = _util.IDENTITY_MATRIX;
              current.lineMatrix = _util.IDENTITY_MATRIX;
              current.textMatrixScale = 1;
              current.tspan = this.svgFactory.createElement("svg:tspan");
              current.txtElement = this.svgFactory.createElement("svg:text");
              current.txtgrp = this.svgFactory.createElement("svg:g");
              current.xcoords = [];
              current.ycoords = [];
            }
          }, {
            key: "moveText",
            value: function moveText(x, y) {
              var current = this.current;
              current.x = current.lineX += x;
              current.y = current.lineY += y;
              current.xcoords = [];
              current.ycoords = [];
              current.tspan = this.svgFactory.createElement("svg:tspan");
              current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
              current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));
              current.tspan.setAttributeNS(null, "y", pf(-current.y));
            }
          }, {
            key: "showText",
            value: function showText(glyphs) {
              var current = this.current;
              var font = current.font;
              var fontSize = current.fontSize;
              if (fontSize === 0) {
                return;
              }
              var fontSizeScale = current.fontSizeScale;
              var charSpacing = current.charSpacing;
              var wordSpacing = current.wordSpacing;
              var fontDirection = current.fontDirection;
              var textHScale = current.textHScale * fontDirection;
              var vertical = font.vertical;
              var spacingDir = vertical ? 1 : -1;
              var defaultVMetrics = font.defaultVMetrics;
              var widthAdvanceScale = fontSize * current.fontMatrix[0];
              var x = 0;
              var _iterator125 = _createForOfIteratorHelper(glyphs),
                _step125;
              try {
                for (_iterator125.s(); !(_step125 = _iterator125.n()).done;) {
                  var glyph = _step125.value;
                  if (glyph === null) {
                    x += fontDirection * wordSpacing;
                    continue;
                  } else if (typeof glyph === "number") {
                    x += spacingDir * glyph * fontSize / 1000;
                    continue;
                  }
                  var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                  var character = glyph.fontChar;
                  var scaledX = void 0,
                    scaledY = void 0;
                  var width = glyph.width;
                  if (vertical) {
                    var vx = void 0;
                    var vmetric = glyph.vmetric || defaultVMetrics;
                    vx = glyph.vmetric ? vmetric[1] : width * 0.5;
                    vx = -vx * widthAdvanceScale;
                    var vy = vmetric[2] * widthAdvanceScale;
                    width = vmetric ? -vmetric[0] : width;
                    scaledX = vx / fontSizeScale;
                    scaledY = (x + vy) / fontSizeScale;
                  } else {
                    scaledX = x / fontSizeScale;
                    scaledY = 0;
                  }
                  if (glyph.isInFont || font.missingFile) {
                    current.xcoords.push(current.x + scaledX);
                    if (vertical) {
                      current.ycoords.push(-current.y + scaledY);
                    }
                    current.tspan.textContent += character;
                  } else {}
                  var charWidth = void 0;
                  if (vertical) {
                    charWidth = width * widthAdvanceScale - spacing * fontDirection;
                  } else {
                    charWidth = width * widthAdvanceScale + spacing * fontDirection;
                  }
                  x += charWidth;
                }
              } catch (err) {
                _iterator125.e(err);
              } finally {
                _iterator125.f();
              }
              current.tspan.setAttributeNS(null, "x", current.xcoords.map(pf).join(" "));
              if (vertical) {
                current.tspan.setAttributeNS(null, "y", current.ycoords.map(pf).join(" "));
              } else {
                current.tspan.setAttributeNS(null, "y", pf(-current.y));
              }
              if (vertical) {
                current.y -= x;
              } else {
                current.x += x * textHScale;
              }
              current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
              current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));
              if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
                current.tspan.setAttributeNS(null, "font-style", current.fontStyle);
              }
              if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
                current.tspan.setAttributeNS(null, "font-weight", current.fontWeight);
              }
              var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
              if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                if (current.fillColor !== SVG_DEFAULTS.fillColor) {
                  current.tspan.setAttributeNS(null, "fill", current.fillColor);
                }
                if (current.fillAlpha < 1) {
                  current.tspan.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                }
              } else if (current.textRenderingMode === _util.TextRenderingMode.ADD_TO_PATH) {
                current.tspan.setAttributeNS(null, "fill", "transparent");
              } else {
                current.tspan.setAttributeNS(null, "fill", "none");
              }
              if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                var lineWidthScale = 1 / (current.textMatrixScale || 1);
                this._setStrokeAttributes(current.tspan, lineWidthScale);
              }
              var textMatrix = current.textMatrix;
              if (current.textRise !== 0) {
                textMatrix = textMatrix.slice();
                textMatrix[5] += current.textRise;
              }
              current.txtElement.setAttributeNS(null, "transform", "".concat(pm(textMatrix), " scale(").concat(pf(textHScale), ", -1)"));
              current.txtElement.setAttributeNS(XML_NS, "xml:space", "preserve");
              current.txtElement.append(current.tspan);
              current.txtgrp.append(current.txtElement);
              this._ensureTransformGroup().append(current.txtElement);
            }
          }, {
            key: "setLeadingMoveText",
            value: function setLeadingMoveText(x, y) {
              this.setLeading(-y);
              this.moveText(x, y);
            }
          }, {
            key: "addFontStyle",
            value: function addFontStyle(fontObj) {
              if (!fontObj.data) {
                throw new Error("addFontStyle: No font data available, " + 'ensure that the "fontExtraProperties" API parameter is set.');
              }
              if (!this.cssStyle) {
                this.cssStyle = this.svgFactory.createElement("svg:style");
                this.cssStyle.setAttributeNS(null, "type", "text/css");
                this.defs.append(this.cssStyle);
              }
              var url = createObjectURL(fontObj.data, fontObj.mimetype, this.forceDataSchema);
              this.cssStyle.textContent += "@font-face { font-family: \"".concat(fontObj.loadedName, "\";") + " src: url(".concat(url, "); }\n");
            }
          }, {
            key: "setFont",
            value: function setFont(details) {
              var current = this.current;
              var fontObj = this.commonObjs.get(details[0]);
              var size = details[1];
              current.font = fontObj;
              if (this.embedFonts && !fontObj.missingFile && !this.embeddedFonts[fontObj.loadedName]) {
                this.addFontStyle(fontObj);
                this.embeddedFonts[fontObj.loadedName] = fontObj;
              }
              current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
              var bold = "normal";
              if (fontObj.black) {
                bold = "900";
              } else if (fontObj.bold) {
                bold = "bold";
              }
              var italic = fontObj.italic ? "italic" : "normal";
              if (size < 0) {
                size = -size;
                current.fontDirection = -1;
              } else {
                current.fontDirection = 1;
              }
              current.fontSize = size;
              current.fontFamily = fontObj.loadedName;
              current.fontWeight = bold;
              current.fontStyle = italic;
              current.tspan = this.svgFactory.createElement("svg:tspan");
              current.tspan.setAttributeNS(null, "y", pf(-current.y));
              current.xcoords = [];
              current.ycoords = [];
            }
          }, {
            key: "endText",
            value: function endText() {
              var _current$txtElement;
              var current = this.current;
              if (current.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG && (_current$txtElement = current.txtElement) !== null && _current$txtElement !== void 0 && _current$txtElement.hasChildNodes()) {
                current.element = current.txtElement;
                this.clip("nonzero");
                this.endPath();
              }
            }
          }, {
            key: "setLineWidth",
            value: function setLineWidth(width) {
              if (width > 0) {
                this.current.lineWidth = width;
              }
            }
          }, {
            key: "setLineCap",
            value: function setLineCap(style) {
              this.current.lineCap = LINE_CAP_STYLES[style];
            }
          }, {
            key: "setLineJoin",
            value: function setLineJoin(style) {
              this.current.lineJoin = LINE_JOIN_STYLES[style];
            }
          }, {
            key: "setMiterLimit",
            value: function setMiterLimit(limit) {
              this.current.miterLimit = limit;
            }
          }, {
            key: "setStrokeAlpha",
            value: function setStrokeAlpha(strokeAlpha) {
              this.current.strokeAlpha = strokeAlpha;
            }
          }, {
            key: "setStrokeRGBColor",
            value: function setStrokeRGBColor(r, g, b) {
              this.current.strokeColor = _util.Util.makeHexColor(r, g, b);
            }
          }, {
            key: "setFillAlpha",
            value: function setFillAlpha(fillAlpha) {
              this.current.fillAlpha = fillAlpha;
            }
          }, {
            key: "setFillRGBColor",
            value: function setFillRGBColor(r, g, b) {
              this.current.fillColor = _util.Util.makeHexColor(r, g, b);
              this.current.tspan = this.svgFactory.createElement("svg:tspan");
              this.current.xcoords = [];
              this.current.ycoords = [];
            }
          }, {
            key: "setStrokeColorN",
            value: function setStrokeColorN(args) {
              this.current.strokeColor = this._makeColorN_Pattern(args);
            }
          }, {
            key: "setFillColorN",
            value: function setFillColorN(args) {
              this.current.fillColor = this._makeColorN_Pattern(args);
            }
          }, {
            key: "shadingFill",
            value: function shadingFill(args) {
              var width = this.viewport.width;
              var height = this.viewport.height;
              var inv = _util.Util.inverseTransform(this.transformMatrix);
              var bl = _util.Util.applyTransform([0, 0], inv);
              var br = _util.Util.applyTransform([0, height], inv);
              var ul = _util.Util.applyTransform([width, 0], inv);
              var ur = _util.Util.applyTransform([width, height], inv);
              var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
              var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
              var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
              var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
              var rect = this.svgFactory.createElement("svg:rect");
              rect.setAttributeNS(null, "x", x0);
              rect.setAttributeNS(null, "y", y0);
              rect.setAttributeNS(null, "width", x1 - x0);
              rect.setAttributeNS(null, "height", y1 - y0);
              rect.setAttributeNS(null, "fill", this._makeShadingPattern(args));
              if (this.current.fillAlpha < 1) {
                rect.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
              }
              this._ensureTransformGroup().append(rect);
            }
          }, {
            key: "_makeColorN_Pattern",
            value: function _makeColorN_Pattern(args) {
              if (args[0] === "TilingPattern") {
                return this._makeTilingPattern(args);
              }
              return this._makeShadingPattern(args);
            }
          }, {
            key: "_makeTilingPattern",
            value: function _makeTilingPattern(args) {
              var color = args[1];
              var operatorList = args[2];
              var matrix = args[3] || _util.IDENTITY_MATRIX;
              var _args$ = _slicedToArray(args[4], 4),
                x0 = _args$[0],
                y0 = _args$[1],
                x1 = _args$[2],
                y1 = _args$[3];
              var xstep = args[5];
              var ystep = args[6];
              var paintType = args[7];
              var tilingId = "shading".concat(shadingCount++);
              var _util$Util$normalizeR = _util.Util.normalizeRect([].concat(_toConsumableArray(_util.Util.applyTransform([x0, y0], matrix)), _toConsumableArray(_util.Util.applyTransform([x1, y1], matrix)))),
                _util$Util$normalizeR2 = _slicedToArray(_util$Util$normalizeR, 4),
                tx0 = _util$Util$normalizeR2[0],
                ty0 = _util$Util$normalizeR2[1],
                tx1 = _util$Util$normalizeR2[2],
                ty1 = _util$Util$normalizeR2[3];
              var _util$Util$singularVa3 = _util.Util.singularValueDecompose2dScale(matrix),
                _util$Util$singularVa4 = _slicedToArray(_util$Util$singularVa3, 2),
                xscale = _util$Util$singularVa4[0],
                yscale = _util$Util$singularVa4[1];
              var txstep = xstep * xscale;
              var tystep = ystep * yscale;
              var tiling = this.svgFactory.createElement("svg:pattern");
              tiling.setAttributeNS(null, "id", tilingId);
              tiling.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
              tiling.setAttributeNS(null, "width", txstep);
              tiling.setAttributeNS(null, "height", tystep);
              tiling.setAttributeNS(null, "x", "".concat(tx0));
              tiling.setAttributeNS(null, "y", "".concat(ty0));
              var svg = this.svg;
              var transformMatrix = this.transformMatrix;
              var fillColor = this.current.fillColor;
              var strokeColor = this.current.strokeColor;
              var bbox = this.svgFactory.create(tx1 - tx0, ty1 - ty0);
              this.svg = bbox;
              this.transformMatrix = matrix;
              if (paintType === 2) {
                var _util$Util5;
                var cssColor = (_util$Util5 = _util.Util).makeHexColor.apply(_util$Util5, _toConsumableArray(color));
                this.current.fillColor = cssColor;
                this.current.strokeColor = cssColor;
              }
              this.executeOpTree(this.convertOpList(operatorList));
              this.svg = svg;
              this.transformMatrix = transformMatrix;
              this.current.fillColor = fillColor;
              this.current.strokeColor = strokeColor;
              tiling.append(bbox.childNodes[0]);
              this.defs.append(tiling);
              return "url(#".concat(tilingId, ")");
            }
          }, {
            key: "_makeShadingPattern",
            value: function _makeShadingPattern(args) {
              if (typeof args === "string") {
                args = this.objs.get(args);
              }
              switch (args[0]) {
                case "RadialAxial":
                  var shadingId = "shading".concat(shadingCount++);
                  var colorStops = args[3];
                  var gradient;
                  switch (args[1]) {
                    case "axial":
                      var point0 = args[4];
                      var point1 = args[5];
                      gradient = this.svgFactory.createElement("svg:linearGradient");
                      gradient.setAttributeNS(null, "id", shadingId);
                      gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                      gradient.setAttributeNS(null, "x1", point0[0]);
                      gradient.setAttributeNS(null, "y1", point0[1]);
                      gradient.setAttributeNS(null, "x2", point1[0]);
                      gradient.setAttributeNS(null, "y2", point1[1]);
                      break;
                    case "radial":
                      var focalPoint = args[4];
                      var circlePoint = args[5];
                      var focalRadius = args[6];
                      var circleRadius = args[7];
                      gradient = this.svgFactory.createElement("svg:radialGradient");
                      gradient.setAttributeNS(null, "id", shadingId);
                      gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                      gradient.setAttributeNS(null, "cx", circlePoint[0]);
                      gradient.setAttributeNS(null, "cy", circlePoint[1]);
                      gradient.setAttributeNS(null, "r", circleRadius);
                      gradient.setAttributeNS(null, "fx", focalPoint[0]);
                      gradient.setAttributeNS(null, "fy", focalPoint[1]);
                      gradient.setAttributeNS(null, "fr", focalRadius);
                      break;
                    default:
                      throw new Error("Unknown RadialAxial type: ".concat(args[1]));
                  }
                  var _iterator126 = _createForOfIteratorHelper(colorStops),
                    _step126;
                  try {
                    for (_iterator126.s(); !(_step126 = _iterator126.n()).done;) {
                      var colorStop = _step126.value;
                      var stop = this.svgFactory.createElement("svg:stop");
                      stop.setAttributeNS(null, "offset", colorStop[0]);
                      stop.setAttributeNS(null, "stop-color", colorStop[1]);
                      gradient.append(stop);
                    }
                  } catch (err) {
                    _iterator126.e(err);
                  } finally {
                    _iterator126.f();
                  }
                  this.defs.append(gradient);
                  return "url(#".concat(shadingId, ")");
                case "Mesh":
                  (0, _util.warn)("Unimplemented pattern Mesh");
                  return null;
                case "Dummy":
                  return "hotpink";
                default:
                  throw new Error("Unknown IR type: ".concat(args[0]));
              }
            }
          }, {
            key: "setDash",
            value: function setDash(dashArray, dashPhase) {
              this.current.dashArray = dashArray;
              this.current.dashPhase = dashPhase;
            }
          }, {
            key: "constructPath",
            value: function constructPath(ops, args) {
              var current = this.current;
              var x = current.x,
                y = current.y;
              var d = [];
              var j = 0;
              var _iterator127 = _createForOfIteratorHelper(ops),
                _step127;
              try {
                for (_iterator127.s(); !(_step127 = _iterator127.n()).done;) {
                  var op = _step127.value;
                  switch (op | 0) {
                    case _util.OPS.rectangle:
                      x = args[j++];
                      y = args[j++];
                      var width = args[j++];
                      var height = args[j++];
                      var xw = x + width;
                      var yh = y + height;
                      d.push("M", pf(x), pf(y), "L", pf(xw), pf(y), "L", pf(xw), pf(yh), "L", pf(x), pf(yh), "Z");
                      break;
                    case _util.OPS.moveTo:
                      x = args[j++];
                      y = args[j++];
                      d.push("M", pf(x), pf(y));
                      break;
                    case _util.OPS.lineTo:
                      x = args[j++];
                      y = args[j++];
                      d.push("L", pf(x), pf(y));
                      break;
                    case _util.OPS.curveTo:
                      x = args[j + 4];
                      y = args[j + 5];
                      d.push("C", pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
                      j += 6;
                      break;
                    case _util.OPS.curveTo2:
                      d.push("C", pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
                      x = args[j + 2];
                      y = args[j + 3];
                      j += 4;
                      break;
                    case _util.OPS.curveTo3:
                      x = args[j + 2];
                      y = args[j + 3];
                      d.push("C", pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
                      j += 4;
                      break;
                    case _util.OPS.closePath:
                      d.push("Z");
                      break;
                  }
                }
              } catch (err) {
                _iterator127.e(err);
              } finally {
                _iterator127.f();
              }
              d = d.join(" ");
              if (current.path && ops.length > 0 && ops[0] !== _util.OPS.rectangle && ops[0] !== _util.OPS.moveTo) {
                d = current.path.getAttributeNS(null, "d") + d;
              } else {
                current.path = this.svgFactory.createElement("svg:path");
                this._ensureTransformGroup().append(current.path);
              }
              current.path.setAttributeNS(null, "d", d);
              current.path.setAttributeNS(null, "fill", "none");
              current.element = current.path;
              current.setCurrentPoint(x, y);
            }
          }, {
            key: "endPath",
            value: function endPath() {
              var current = this.current;
              current.path = null;
              if (!this.pendingClip) {
                return;
              }
              if (!current.element) {
                this.pendingClip = null;
                return;
              }
              var clipId = "clippath".concat(clipCount++);
              var clipPath = this.svgFactory.createElement("svg:clipPath");
              clipPath.setAttributeNS(null, "id", clipId);
              clipPath.setAttributeNS(null, "transform", pm(this.transformMatrix));
              var clipElement = current.element.cloneNode(true);
              if (this.pendingClip === "evenodd") {
                clipElement.setAttributeNS(null, "clip-rule", "evenodd");
              } else {
                clipElement.setAttributeNS(null, "clip-rule", "nonzero");
              }
              this.pendingClip = null;
              clipPath.append(clipElement);
              this.defs.append(clipPath);
              if (current.activeClipUrl) {
                current.clipGroup = null;
                var _iterator128 = _createForOfIteratorHelper(this.extraStack),
                  _step128;
                try {
                  for (_iterator128.s(); !(_step128 = _iterator128.n()).done;) {
                    var prev = _step128.value;
                    prev.clipGroup = null;
                  }
                } catch (err) {
                  _iterator128.e(err);
                } finally {
                  _iterator128.f();
                }
                clipPath.setAttributeNS(null, "clip-path", current.activeClipUrl);
              }
              current.activeClipUrl = "url(#".concat(clipId, ")");
              this.tgrp = null;
            }
          }, {
            key: "clip",
            value: function clip(type) {
              this.pendingClip = type;
            }
          }, {
            key: "closePath",
            value: function closePath() {
              var current = this.current;
              if (current.path) {
                var d = "".concat(current.path.getAttributeNS(null, "d"), "Z");
                current.path.setAttributeNS(null, "d", d);
              }
            }
          }, {
            key: "setLeading",
            value: function setLeading(leading) {
              this.current.leading = -leading;
            }
          }, {
            key: "setTextRise",
            value: function setTextRise(textRise) {
              this.current.textRise = textRise;
            }
          }, {
            key: "setTextRenderingMode",
            value: function setTextRenderingMode(textRenderingMode) {
              this.current.textRenderingMode = textRenderingMode;
            }
          }, {
            key: "setHScale",
            value: function setHScale(scale) {
              this.current.textHScale = scale / 100;
            }
          }, {
            key: "setRenderingIntent",
            value: function setRenderingIntent(intent) {}
          }, {
            key: "setFlatness",
            value: function setFlatness(flatness) {}
          }, {
            key: "setGState",
            value: function setGState(states) {
              var _iterator129 = _createForOfIteratorHelper(states),
                _step129;
              try {
                for (_iterator129.s(); !(_step129 = _iterator129.n()).done;) {
                  var _ref120 = _step129.value;
                  var _ref121 = _slicedToArray(_ref120, 2);
                  var key = _ref121[0];
                  var value = _ref121[1];
                  switch (key) {
                    case "LW":
                      this.setLineWidth(value);
                      break;
                    case "LC":
                      this.setLineCap(value);
                      break;
                    case "LJ":
                      this.setLineJoin(value);
                      break;
                    case "ML":
                      this.setMiterLimit(value);
                      break;
                    case "D":
                      this.setDash(value[0], value[1]);
                      break;
                    case "RI":
                      this.setRenderingIntent(value);
                      break;
                    case "FL":
                      this.setFlatness(value);
                      break;
                    case "Font":
                      this.setFont(value);
                      break;
                    case "CA":
                      this.setStrokeAlpha(value);
                      break;
                    case "ca":
                      this.setFillAlpha(value);
                      break;
                    default:
                      (0, _util.warn)("Unimplemented graphic state operator ".concat(key));
                      break;
                  }
                }
              } catch (err) {
                _iterator129.e(err);
              } finally {
                _iterator129.f();
              }
            }
          }, {
            key: "fill",
            value: function fill() {
              var current = this.current;
              if (current.element) {
                current.element.setAttributeNS(null, "fill", current.fillColor);
                current.element.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                this.endPath();
              }
            }
          }, {
            key: "stroke",
            value: function stroke() {
              var current = this.current;
              if (current.element) {
                this._setStrokeAttributes(current.element);
                current.element.setAttributeNS(null, "fill", "none");
                this.endPath();
              }
            }
          }, {
            key: "_setStrokeAttributes",
            value: function _setStrokeAttributes(element) {
              var lineWidthScale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var current = this.current;
              var dashArray = current.dashArray;
              if (lineWidthScale !== 1 && dashArray.length > 0) {
                dashArray = dashArray.map(function (value) {
                  return lineWidthScale * value;
                });
              }
              element.setAttributeNS(null, "stroke", current.strokeColor);
              element.setAttributeNS(null, "stroke-opacity", current.strokeAlpha);
              element.setAttributeNS(null, "stroke-miterlimit", pf(current.miterLimit));
              element.setAttributeNS(null, "stroke-linecap", current.lineCap);
              element.setAttributeNS(null, "stroke-linejoin", current.lineJoin);
              element.setAttributeNS(null, "stroke-width", pf(lineWidthScale * current.lineWidth) + "px");
              element.setAttributeNS(null, "stroke-dasharray", dashArray.map(pf).join(" "));
              element.setAttributeNS(null, "stroke-dashoffset", pf(lineWidthScale * current.dashPhase) + "px");
            }
          }, {
            key: "eoFill",
            value: function eoFill() {
              var _this$current$element;
              (_this$current$element = this.current.element) === null || _this$current$element === void 0 || _this$current$element.setAttributeNS(null, "fill-rule", "evenodd");
              this.fill();
            }
          }, {
            key: "fillStroke",
            value: function fillStroke() {
              this.stroke();
              this.fill();
            }
          }, {
            key: "eoFillStroke",
            value: function eoFillStroke() {
              var _this$current$element2;
              (_this$current$element2 = this.current.element) === null || _this$current$element2 === void 0 || _this$current$element2.setAttributeNS(null, "fill-rule", "evenodd");
              this.fillStroke();
            }
          }, {
            key: "closeStroke",
            value: function closeStroke() {
              this.closePath();
              this.stroke();
            }
          }, {
            key: "closeFillStroke",
            value: function closeFillStroke() {
              this.closePath();
              this.fillStroke();
            }
          }, {
            key: "closeEOFillStroke",
            value: function closeEOFillStroke() {
              this.closePath();
              this.eoFillStroke();
            }
          }, {
            key: "paintSolidColorImageMask",
            value: function paintSolidColorImageMask() {
              var rect = this.svgFactory.createElement("svg:rect");
              rect.setAttributeNS(null, "x", "0");
              rect.setAttributeNS(null, "y", "0");
              rect.setAttributeNS(null, "width", "1px");
              rect.setAttributeNS(null, "height", "1px");
              rect.setAttributeNS(null, "fill", this.current.fillColor);
              this._ensureTransformGroup().append(rect);
            }
          }, {
            key: "paintImageXObject",
            value: function paintImageXObject(objId) {
              var imgData = this.getObject(objId);
              if (!imgData) {
                (0, _util.warn)("Dependent image with object ID ".concat(objId, " is not ready yet"));
                return;
              }
              this.paintInlineImageXObject(imgData);
            }
          }, {
            key: "paintInlineImageXObject",
            value: function paintInlineImageXObject(imgData, mask) {
              var width = imgData.width;
              var height = imgData.height;
              var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
              var cliprect = this.svgFactory.createElement("svg:rect");
              cliprect.setAttributeNS(null, "x", "0");
              cliprect.setAttributeNS(null, "y", "0");
              cliprect.setAttributeNS(null, "width", pf(width));
              cliprect.setAttributeNS(null, "height", pf(height));
              this.current.element = cliprect;
              this.clip("nonzero");
              var imgEl = this.svgFactory.createElement("svg:image");
              imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgSrc);
              imgEl.setAttributeNS(null, "x", "0");
              imgEl.setAttributeNS(null, "y", pf(-height));
              imgEl.setAttributeNS(null, "width", pf(width) + "px");
              imgEl.setAttributeNS(null, "height", pf(height) + "px");
              imgEl.setAttributeNS(null, "transform", "scale(".concat(pf(1 / width), " ").concat(pf(-1 / height), ")"));
              if (mask) {
                mask.append(imgEl);
              } else {
                this._ensureTransformGroup().append(imgEl);
              }
            }
          }, {
            key: "paintImageMaskXObject",
            value: function paintImageMaskXObject(img) {
              var imgData = this.getObject(img.data, img);
              if (imgData.bitmap) {
                (0, _util.warn)("paintImageMaskXObject: ImageBitmap support is not implemented, " + "ensure that the `isOffscreenCanvasSupported` API parameter is disabled.");
                return;
              }
              var current = this.current;
              var width = imgData.width;
              var height = imgData.height;
              var fillColor = current.fillColor;
              current.maskId = "mask".concat(maskCount++);
              var mask = this.svgFactory.createElement("svg:mask");
              mask.setAttributeNS(null, "id", current.maskId);
              var rect = this.svgFactory.createElement("svg:rect");
              rect.setAttributeNS(null, "x", "0");
              rect.setAttributeNS(null, "y", "0");
              rect.setAttributeNS(null, "width", pf(width));
              rect.setAttributeNS(null, "height", pf(height));
              rect.setAttributeNS(null, "fill", fillColor);
              rect.setAttributeNS(null, "mask", "url(#".concat(current.maskId, ")"));
              this.defs.append(mask);
              this._ensureTransformGroup().append(rect);
              this.paintInlineImageXObject(imgData, mask);
            }
          }, {
            key: "paintFormXObjectBegin",
            value: function paintFormXObjectBegin(matrix, bbox) {
              if (Array.isArray(matrix) && matrix.length === 6) {
                this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
              }
              if (bbox) {
                var width = bbox[2] - bbox[0];
                var height = bbox[3] - bbox[1];
                var cliprect = this.svgFactory.createElement("svg:rect");
                cliprect.setAttributeNS(null, "x", bbox[0]);
                cliprect.setAttributeNS(null, "y", bbox[1]);
                cliprect.setAttributeNS(null, "width", pf(width));
                cliprect.setAttributeNS(null, "height", pf(height));
                this.current.element = cliprect;
                this.clip("nonzero");
                this.endPath();
              }
            }
          }, {
            key: "paintFormXObjectEnd",
            value: function paintFormXObjectEnd() {}
          }, {
            key: "_initialize",
            value: function _initialize(viewport) {
              var svg = this.svgFactory.create(viewport.width, viewport.height);
              var definitions = this.svgFactory.createElement("svg:defs");
              svg.append(definitions);
              this.defs = definitions;
              var rootGroup = this.svgFactory.createElement("svg:g");
              rootGroup.setAttributeNS(null, "transform", pm(viewport.transform));
              svg.append(rootGroup);
              this.svg = rootGroup;
              return svg;
            }
          }, {
            key: "_ensureClipGroup",
            value: function _ensureClipGroup() {
              if (!this.current.clipGroup) {
                var clipGroup = this.svgFactory.createElement("svg:g");
                clipGroup.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                this.svg.append(clipGroup);
                this.current.clipGroup = clipGroup;
              }
              return this.current.clipGroup;
            }
          }, {
            key: "_ensureTransformGroup",
            value: function _ensureTransformGroup() {
              if (!this.tgrp) {
                this.tgrp = this.svgFactory.createElement("svg:g");
                this.tgrp.setAttributeNS(null, "transform", pm(this.transformMatrix));
                if (this.current.activeClipUrl) {
                  this._ensureClipGroup().append(this.tgrp);
                } else {
                  this.svg.append(this.tgrp);
                }
              }
              return this.tgrp;
            }
          }]);
        }();
      }

      /***/
    }
    /******/)];
    /************************************************************************/
    /******/ // The module cache
    /******/
    var __webpack_module_cache__ = {};
    /******/
    /******/ // The require function
    /******/
    function __w_pdfjs_require__(moduleId) {
      /******/ // Check if module is in cache
      /******/var cachedModule = __webpack_module_cache__[moduleId];
      /******/
      if (cachedModule !== undefined) {
        /******/return cachedModule.exports;
        /******/
      }
      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = __webpack_module_cache__[moduleId] = {
        /******/ // no module.id needed
        /******/ // no module.loaded needed
        /******/exports: {}
        /******/
      };
      /******/
      /******/ // Execute the module function
      /******/
      __webpack_modules__[moduleId](module, module.exports, __w_pdfjs_require__);
      /******/
      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }
    /******/
    /************************************************************************/
    var __webpack_exports__ = {};
    // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
    (function () {
      var exports = __webpack_exports__;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      Object.defineProperty(exports, "AbortException", {
        enumerable: true,
        get: function get() {
          return _util.AbortException;
        }
      });
      Object.defineProperty(exports, "AnnotationEditorLayer", {
        enumerable: true,
        get: function get() {
          return _annotation_editor_layer.AnnotationEditorLayer;
        }
      });
      Object.defineProperty(exports, "AnnotationEditorParamsType", {
        enumerable: true,
        get: function get() {
          return _util.AnnotationEditorParamsType;
        }
      });
      Object.defineProperty(exports, "AnnotationEditorType", {
        enumerable: true,
        get: function get() {
          return _util.AnnotationEditorType;
        }
      });
      Object.defineProperty(exports, "AnnotationEditorUIManager", {
        enumerable: true,
        get: function get() {
          return _tools.AnnotationEditorUIManager;
        }
      });
      Object.defineProperty(exports, "AnnotationLayer", {
        enumerable: true,
        get: function get() {
          return _annotation_layer.AnnotationLayer;
        }
      });
      Object.defineProperty(exports, "AnnotationMode", {
        enumerable: true,
        get: function get() {
          return _util.AnnotationMode;
        }
      });
      Object.defineProperty(exports, "CMapCompressionType", {
        enumerable: true,
        get: function get() {
          return _util.CMapCompressionType;
        }
      });
      Object.defineProperty(exports, "FeatureTest", {
        enumerable: true,
        get: function get() {
          return _util.FeatureTest;
        }
      });
      Object.defineProperty(exports, "GlobalWorkerOptions", {
        enumerable: true,
        get: function get() {
          return _worker_options.GlobalWorkerOptions;
        }
      });
      Object.defineProperty(exports, "InvalidPDFException", {
        enumerable: true,
        get: function get() {
          return _util.InvalidPDFException;
        }
      });
      Object.defineProperty(exports, "MissingPDFException", {
        enumerable: true,
        get: function get() {
          return _util.MissingPDFException;
        }
      });
      Object.defineProperty(exports, "OPS", {
        enumerable: true,
        get: function get() {
          return _util.OPS;
        }
      });
      Object.defineProperty(exports, "PDFDataRangeTransport", {
        enumerable: true,
        get: function get() {
          return _api.PDFDataRangeTransport;
        }
      });
      Object.defineProperty(exports, "PDFDateString", {
        enumerable: true,
        get: function get() {
          return _display_utils.PDFDateString;
        }
      });
      Object.defineProperty(exports, "PDFWorker", {
        enumerable: true,
        get: function get() {
          return _api.PDFWorker;
        }
      });
      Object.defineProperty(exports, "PasswordResponses", {
        enumerable: true,
        get: function get() {
          return _util.PasswordResponses;
        }
      });
      Object.defineProperty(exports, "PermissionFlag", {
        enumerable: true,
        get: function get() {
          return _util.PermissionFlag;
        }
      });
      Object.defineProperty(exports, "PixelsPerInch", {
        enumerable: true,
        get: function get() {
          return _display_utils.PixelsPerInch;
        }
      });
      Object.defineProperty(exports, "RenderingCancelledException", {
        enumerable: true,
        get: function get() {
          return _display_utils.RenderingCancelledException;
        }
      });
      Object.defineProperty(exports, "SVGGraphics", {
        enumerable: true,
        get: function get() {
          return _svg.SVGGraphics;
        }
      });
      Object.defineProperty(exports, "UNSUPPORTED_FEATURES", {
        enumerable: true,
        get: function get() {
          return _util.UNSUPPORTED_FEATURES;
        }
      });
      Object.defineProperty(exports, "UnexpectedResponseException", {
        enumerable: true,
        get: function get() {
          return _util.UnexpectedResponseException;
        }
      });
      Object.defineProperty(exports, "Util", {
        enumerable: true,
        get: function get() {
          return _util.Util;
        }
      });
      Object.defineProperty(exports, "VerbosityLevel", {
        enumerable: true,
        get: function get() {
          return _util.VerbosityLevel;
        }
      });
      Object.defineProperty(exports, "XfaLayer", {
        enumerable: true,
        get: function get() {
          return _xfa_layer.XfaLayer;
        }
      });
      Object.defineProperty(exports, "build", {
        enumerable: true,
        get: function get() {
          return _api.build;
        }
      });
      Object.defineProperty(exports, "createPromiseCapability", {
        enumerable: true,
        get: function get() {
          return _util.createPromiseCapability;
        }
      });
      Object.defineProperty(exports, "createValidAbsoluteUrl", {
        enumerable: true,
        get: function get() {
          return _util.createValidAbsoluteUrl;
        }
      });
      Object.defineProperty(exports, "getDocument", {
        enumerable: true,
        get: function get() {
          return _api.getDocument;
        }
      });
      Object.defineProperty(exports, "getFilenameFromUrl", {
        enumerable: true,
        get: function get() {
          return _display_utils.getFilenameFromUrl;
        }
      });
      Object.defineProperty(exports, "getPdfFilenameFromUrl", {
        enumerable: true,
        get: function get() {
          return _display_utils.getPdfFilenameFromUrl;
        }
      });
      Object.defineProperty(exports, "getXfaPageViewport", {
        enumerable: true,
        get: function get() {
          return _display_utils.getXfaPageViewport;
        }
      });
      Object.defineProperty(exports, "isDataScheme", {
        enumerable: true,
        get: function get() {
          return _display_utils.isDataScheme;
        }
      });
      Object.defineProperty(exports, "isPdfFile", {
        enumerable: true,
        get: function get() {
          return _display_utils.isPdfFile;
        }
      });
      Object.defineProperty(exports, "loadScript", {
        enumerable: true,
        get: function get() {
          return _display_utils.loadScript;
        }
      });
      Object.defineProperty(exports, "renderTextLayer", {
        enumerable: true,
        get: function get() {
          return _text_layer.renderTextLayer;
        }
      });
      Object.defineProperty(exports, "setLayerDimensions", {
        enumerable: true,
        get: function get() {
          return _display_utils.setLayerDimensions;
        }
      });
      Object.defineProperty(exports, "shadow", {
        enumerable: true,
        get: function get() {
          return _util.shadow;
        }
      });
      Object.defineProperty(exports, "updateTextLayer", {
        enumerable: true,
        get: function get() {
          return _text_layer.updateTextLayer;
        }
      });
      Object.defineProperty(exports, "version", {
        enumerable: true,
        get: function get() {
          return _api.version;
        }
      });
      var _util = __w_pdfjs_require__(1);
      var _api = __w_pdfjs_require__(2);
      var _display_utils = __w_pdfjs_require__(6);
      var _text_layer = __w_pdfjs_require__(26);
      var _annotation_editor_layer = __w_pdfjs_require__(27);
      var _tools = __w_pdfjs_require__(5);
      var _annotation_layer = __w_pdfjs_require__(32);
      var _worker_options = __w_pdfjs_require__(14);
      var _svg = __w_pdfjs_require__(35);
      var _xfa_layer = __w_pdfjs_require__(34);
      var pdfjsVersion = '3.4.120';
      var pdfjsBuild = 'af6414988';
    })();

    /******/
    return __webpack_exports__;
    /******/
  }();
});